import { r as e, t } from "./rolldown-runtime-B0aSnxlc.js";
//#endregion
//#region src/ConnectionState.ts
var n = (/* @__PURE__ */ t(((e, t) => {
	(function(e, n) {
		typeof define == "function" && define.amd ? define(n) : typeof t == "object" && t.exports ? t.exports = n() : e.log = n();
	})(e, function() {
		var e = function() {}, t = "undefined", n = typeof window !== t && typeof window.navigator !== t && /Trident\/|MSIE /.test(window.navigator.userAgent), r = [
			"trace",
			"debug",
			"info",
			"warn",
			"error"
		], i = {}, a = null;
		function o(e, t) {
			var n = e[t];
			if (typeof n.bind == "function") return n.bind(e);
			try {
				return Function.prototype.bind.call(n, e);
			} catch {
				return function() {
					return Function.prototype.apply.apply(n, [e, arguments]);
				};
			}
		}
		function s() {
			console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
		}
		function c(r) {
			return r === "debug" && (r = "log"), typeof console === t ? !1 : r === "trace" && n ? s : console[r] === void 0 ? console.log === void 0 ? e : o(console, "log") : o(console, r);
		}
		function l() {
			for (var n = this.getLevel(), i = 0; i < r.length; i++) {
				var a = r[i];
				this[a] = i < n ? e : this.methodFactory(a, n, this.name);
			}
			if (this.log = this.debug, typeof console === t && n < this.levels.SILENT) return "No console available for logging";
		}
		function u(e) {
			return function() {
				typeof console !== t && (l.call(this), this[e].apply(this, arguments));
			};
		}
		function d(e, t, n) {
			return c(e) || u.apply(this, arguments);
		}
		function f(e, n) {
			var o = this, s, c, u, f = "loglevel";
			typeof e == "string" ? f += ":" + e : typeof e == "symbol" && (f = void 0);
			function p(e) {
				var n = (r[e] || "silent").toUpperCase();
				if (typeof window !== t && f) {
					try {
						window.localStorage[f] = n;
						return;
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=" + n + ";";
					} catch {}
				}
			}
			function m() {
				var e;
				if (typeof window !== t && f) {
					try {
						e = window.localStorage[f];
					} catch {}
					if (typeof e === t) try {
						var n = window.document.cookie, r = encodeURIComponent(f), i = n.indexOf(r + "=");
						i !== -1 && (e = /^([^;]+)/.exec(n.slice(i + r.length + 1))[1]);
					} catch {}
					return o.levels[e] === void 0 && (e = void 0), e;
				}
			}
			function h() {
				if (typeof window !== t && f) {
					try {
						window.localStorage.removeItem(f);
					} catch {}
					try {
						window.document.cookie = encodeURIComponent(f) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
					} catch {}
				}
			}
			function g(e) {
				var t = e;
				if (typeof t == "string" && o.levels[t.toUpperCase()] !== void 0 && (t = o.levels[t.toUpperCase()]), typeof t == "number" && t >= 0 && t <= o.levels.SILENT) return t;
				throw TypeError("log.setLevel() called with invalid level: " + e);
			}
			o.name = e, o.levels = {
				TRACE: 0,
				DEBUG: 1,
				INFO: 2,
				WARN: 3,
				ERROR: 4,
				SILENT: 5
			}, o.methodFactory = n || d, o.getLevel = function() {
				return u ?? c ?? s;
			}, o.setLevel = function(e, t) {
				return u = g(e), t !== !1 && p(u), l.call(o);
			}, o.setDefaultLevel = function(e) {
				c = g(e), m() || o.setLevel(e, !1);
			}, o.resetLevel = function() {
				u = null, h(), l.call(o);
			}, o.enableAll = function(e) {
				o.setLevel(o.levels.TRACE, e);
			}, o.disableAll = function(e) {
				o.setLevel(o.levels.SILENT, e);
			}, o.rebuild = function() {
				if (a !== o && (s = g(a.getLevel())), l.call(o), a === o) for (var e in i) i[e].rebuild();
			}, s = g(a ? a.getLevel() : "WARN");
			var _ = m();
			_ != null && (u = g(_)), l.call(o);
		}
		a = new f(), a.getLogger = function(e) {
			if (typeof e != "symbol" && typeof e != "string" || e === "") throw TypeError("You must supply a name when creating a logger.");
			var t = i[e];
			return t ||= i[e] = new f(e, a.methodFactory), t;
		};
		var p = typeof window === t ? void 0 : window.log;
		return a.noConflict = function() {
			return typeof window !== t && window.log === a && (window.log = p), a;
		}, a.getLoggers = function() {
			return i;
		}, a.default = a, a;
	});
})))(), r = /* @__PURE__ */ function(e) {
	return e.CONNECTED = "CONNECTED", e.DISCONNECTED_FOREVER = "DISCONNECTED_FOREVER", e.INITIAL = "INITIAL", e.PINGING_SERVER = "PINGING_SERVER", e.CONNECTING = "CONNECTING", e.STATIC_CONNECTING = "STATIC_CONNECTING", e.STATIC_CONNECTED = "STATIC_CONNECTED", e;
}({}), i = "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS", a = "_stcore/stream", o = "_stcore/health", s = "_stcore/host-config", c = 4e3, l = 4e3, u = typeof navigator < "u" && /Android/i.test(navigator.userAgent) ? 6e4 : 15e3, d = 15e3, f = !1, p = /* @__PURE__ */ t(((e, t) => {
	t.exports = n;
	function n(e, t) {
		for (var n = Array(arguments.length - 1), r = 0, i = 2, a = !0; i < arguments.length;) n[r++] = arguments[i++];
		return new Promise(function(i, o) {
			n[r] = function(e) {
				if (a) {
					if (a = !1, e) o(e);
					else {
						for (var t = Array(arguments.length - 1), n = 0; n < t.length;) t[n++] = arguments[n];
						i.apply(null, t);
					}
				}
			};
			try {
				e.apply(t || null, n);
			} catch (e) {
				a && (a = !1, o(e));
			}
		});
	}
})), m = /* @__PURE__ */ t(((e) => {
	var t = e;
	t.length = function(e) {
		var t = e.length;
		if (!t) return 0;
		for (; t > 0 && e.charAt(t - 1) === "=";) --t;
		return Math.floor(t * 3 / 4);
	};
	for (var n = Array(64), r = Array(123), i = 0; i < 64;) r[n[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
	r[45] = 62, r[95] = 63, t.encode = function(e, t, r) {
		for (var i = null, a = [], o = 0, s = 0, c; t < r;) {
			var l = e[t++];
			switch (s) {
				case 0:
					a[o++] = n[l >> 2], c = (l & 3) << 4, s = 1;
					break;
				case 1:
					a[o++] = n[c | l >> 4], c = (l & 15) << 2, s = 2;
					break;
				case 2: a[o++] = n[c | l >> 6], a[o++] = n[l & 63], s = 0;
			}
			o > 8191 && ((i ||= []).push(String.fromCharCode.apply(String, a)), o = 0);
		}
		return s && (a[o++] = n[c], a[o++] = 61, s === 1 && (a[o++] = 61)), i ? (o && i.push(String.fromCharCode.apply(String, a.slice(0, o))), i.join("")) : String.fromCharCode.apply(String, a.slice(0, o));
	};
	var a = "invalid encoding";
	t.decode = function(e, t, n) {
		for (var i = n, o = 0, s, c = 0; c < e.length;) {
			var l = e.charCodeAt(c++);
			if (l === 61 && o > 1) break;
			if ((l = r[l]) === void 0) throw Error(a);
			switch (o) {
				case 0:
					s = l, o = 1;
					break;
				case 1:
					t[n++] = s << 2 | (l & 48) >> 4, s = l, o = 2;
					break;
				case 2:
					t[n++] = (s & 15) << 4 | (l & 60) >> 2, s = l, o = 3;
					break;
				case 3: t[n++] = (s & 3) << 6 | l, o = 0;
			}
		}
		if (o === 1) throw Error(a);
		return n - i;
	};
	var o = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/, s = /[-_]/, c = /^(?:[A-Za-z0-9_-]{4})*(?:[A-Za-z0-9_-]{2}(?:==)?|[A-Za-z0-9_-]{3}=?)?$/;
	t.test = function(e) {
		return o.test(e) || s.test(e) && c.test(e);
	};
})), h = /* @__PURE__ */ t(((e, t) => {
	t.exports = n;
	function n() {
		this._listeners = Object.create(null);
	}
	n.prototype.on = function(e, t, n) {
		return (this._listeners[e] || (this._listeners[e] = [])).push({
			fn: t,
			ctx: n || this
		}), this;
	}, n.prototype.off = function(e, t) {
		if (e === void 0) this._listeners = Object.create(null);
		else if (t === void 0) this._listeners[e] = [];
		else {
			var n = this._listeners[e];
			if (!n) return this;
			for (var r = 0; r < n.length;) n[r].fn === t ? n.splice(r, 1) : ++r;
		}
		return this;
	}, n.prototype.emit = function(e) {
		var t = this._listeners[e];
		if (t) {
			for (var n = [], r = 1; r < arguments.length;) n.push(arguments[r++]);
			for (r = 0; r < t.length;) t[r].fn.apply(t[r++].ctx, n);
		}
		return this;
	};
})), g = /* @__PURE__ */ t(((e, t) => {
	t.exports = n(n);
	function n(e) {
		return typeof Float32Array < "u" ? (function() {
			var t = new Float32Array([-0]), n = new Uint8Array(t.buffer), r = n[3] === 128;
			function i(e, r, i) {
				t[0] = e, r[i] = n[0], r[i + 1] = n[1], r[i + 2] = n[2], r[i + 3] = n[3];
			}
			function a(e, r, i) {
				t[0] = e, r[i] = n[3], r[i + 1] = n[2], r[i + 2] = n[1], r[i + 3] = n[0];
			}
			/* istanbul ignore next */
			e.writeFloatLE = r ? i : a, e.writeFloatBE = r ? a : i;
			function o(e, r) {
				return n[0] = e[r], n[1] = e[r + 1], n[2] = e[r + 2], n[3] = e[r + 3], t[0];
			}
			function s(e, r) {
				return n[3] = e[r], n[2] = e[r + 1], n[1] = e[r + 2], n[0] = e[r + 3], t[0];
			}
			/* istanbul ignore next */
			e.readFloatLE = r ? o : s, e.readFloatBE = r ? s : o;
		})() : (function() {
			function t(e, t, n, r) {
				var i = +(t < 0);
				if (i && (t = -t), t === 0) e(1 / t > 0 ? 0 : 2147483648, n, r);
				else if (isNaN(t)) e(2143289344, n, r);
				else if (t > 34028234663852886e22) e((i << 31 | 2139095040) >>> 0, n, r);
				else if (t < 11754943508222875e-54) e((i << 31 | Math.round(t / 1401298464324817e-60)) >>> 0, n, r);
				else {
					var a = Math.floor(Math.log(t) / Math.LN2), o = Math.round(t * 2 ** -a * 8388608) & 8388607;
					e((i << 31 | a + 127 << 23 | o) >>> 0, n, r);
				}
			}
			e.writeFloatLE = t.bind(null, r), e.writeFloatBE = t.bind(null, i);
			function n(e, t, n) {
				var r = e(t, n), i = (r >> 31) * 2 + 1, a = r >>> 23 & 255, o = r & 8388607;
				return a === 255 ? o ? NaN : i * Infinity : a === 0 ? i * 1401298464324817e-60 * o : i * 2 ** (a - 150) * (o + 8388608);
			}
			e.readFloatLE = n.bind(null, a), e.readFloatBE = n.bind(null, o);
		})(), typeof Float64Array < "u" ? (function() {
			var t = new Float64Array([-0]), n = new Uint8Array(t.buffer), r = n[7] === 128;
			function i(e, r, i) {
				t[0] = e, r[i] = n[0], r[i + 1] = n[1], r[i + 2] = n[2], r[i + 3] = n[3], r[i + 4] = n[4], r[i + 5] = n[5], r[i + 6] = n[6], r[i + 7] = n[7];
			}
			function a(e, r, i) {
				t[0] = e, r[i] = n[7], r[i + 1] = n[6], r[i + 2] = n[5], r[i + 3] = n[4], r[i + 4] = n[3], r[i + 5] = n[2], r[i + 6] = n[1], r[i + 7] = n[0];
			}
			/* istanbul ignore next */
			e.writeDoubleLE = r ? i : a, e.writeDoubleBE = r ? a : i;
			function o(e, r) {
				return n[0] = e[r], n[1] = e[r + 1], n[2] = e[r + 2], n[3] = e[r + 3], n[4] = e[r + 4], n[5] = e[r + 5], n[6] = e[r + 6], n[7] = e[r + 7], t[0];
			}
			function s(e, r) {
				return n[7] = e[r], n[6] = e[r + 1], n[5] = e[r + 2], n[4] = e[r + 3], n[3] = e[r + 4], n[2] = e[r + 5], n[1] = e[r + 6], n[0] = e[r + 7], t[0];
			}
			/* istanbul ignore next */
			e.readDoubleLE = r ? o : s, e.readDoubleBE = r ? s : o;
		})() : (function() {
			function t(e, t, n, r, i, a) {
				var o = +(r < 0);
				if (o && (r = -r), r === 0) e(0, i, a + t), e(1 / r > 0 ? 0 : 2147483648, i, a + n);
				else if (isNaN(r)) e(0, i, a + t), e(2146959360, i, a + n);
				else if (r > 17976931348623157e292) e(0, i, a + t), e((o << 31 | 2146435072) >>> 0, i, a + n);
				else {
					var s;
					if (r < 22250738585072014e-324) s = r / 5e-324, e(s >>> 0, i, a + t), e((o << 31 | s / 4294967296) >>> 0, i, a + n);
					else {
						var c = Math.floor(Math.log(r) / Math.LN2);
						c === 1024 && (c = 1023), s = r * 2 ** -c, e(s * 4503599627370496 >>> 0, i, a + t), e((o << 31 | c + 1023 << 20 | s * 1048576 & 1048575) >>> 0, i, a + n);
					}
				}
			}
			e.writeDoubleLE = t.bind(null, r, 0, 4), e.writeDoubleBE = t.bind(null, i, 4, 0);
			function n(e, t, n, r, i) {
				var a = e(r, i + t), o = e(r, i + n), s = (o >> 31) * 2 + 1, c = o >>> 20 & 2047, l = 4294967296 * (o & 1048575) + a;
				return c === 2047 ? l ? NaN : s * Infinity : c === 0 ? s * 5e-324 * l : s * 2 ** (c - 1075) * (l + 4503599627370496);
			}
			e.readDoubleLE = n.bind(null, a, 0, 4), e.readDoubleBE = n.bind(null, o, 4, 0);
		})(), e;
	}
	function r(e, t, n) {
		t[n] = e & 255, t[n + 1] = e >>> 8 & 255, t[n + 2] = e >>> 16 & 255, t[n + 3] = e >>> 24;
	}
	function i(e, t, n) {
		t[n] = e >>> 24, t[n + 1] = e >>> 16 & 255, t[n + 2] = e >>> 8 & 255, t[n + 3] = e & 255;
	}
	function a(e, t) {
		return (e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
	}
	function o(e, t) {
		return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
	}
})), _ = /* @__PURE__ */ t(((e) => {
	var t = e, n = new TextDecoder("utf-8", { ignoreBOM: !0 }), r, i = 64;
	try {
		r = new TextDecoder("utf-8", {
			fatal: !0,
			ignoreBOM: !0
		});
	} catch {
		r = n;
	}
	t.length = function(e) {
		for (var t = 0, n = 0, r = 0; r < e.length; ++r) n = e.charCodeAt(r), n < 128 ? t += 1 : n < 2048 ? t += 2 : (n & 64512) == 55296 && (e.charCodeAt(r + 1) & 64512) == 56320 ? (++r, t += 4) : t += 3;
		return t;
	};
	function a(e, t, n, r) {
		var i = n === 0 && r === t.length ? t : t.subarray(n, r);
		return e.decode(i);
	}
	t.read = function(e, t, r) {
		if (r - t < 1) return "";
		if (r - t >= i) return a(n, e, t, r);
		for (var o = "", s = t, c, l, u, d, f, p, m, h; s + 7 < r; s += 8) {
			if (c = e[s], l = e[s + 1], u = e[s + 2], d = e[s + 3], f = e[s + 4], p = e[s + 5], m = e[s + 6], h = e[s + 7], (c | l | u | d | f | p | m | h) & 128) return o + a(n, e, s, r);
			o += String.fromCharCode(c, l, u, d, f, p, m, h);
		}
		for (; s < r; ++s) {
			if (c = e[s], c & 128) return o + a(n, e, s, r);
			o += String.fromCharCode(c);
		}
		return o;
	}, t.readStrict = function(e, t, n) {
		if (n - t < 1) return "";
		if (n - t >= i) return a(r, e, t, n);
		for (var o = "", s = t, c, l, u, d, f, p, m, h; s + 7 < n; s += 8) {
			if (c = e[s], l = e[s + 1], u = e[s + 2], d = e[s + 3], f = e[s + 4], p = e[s + 5], m = e[s + 6], h = e[s + 7], (c | l | u | d | f | p | m | h) & 128) return o + a(r, e, s, n);
			o += String.fromCharCode(c, l, u, d, f, p, m, h);
		}
		for (; s < n; ++s) {
			if (c = e[s], c & 128) return o + a(r, e, s, n);
			o += String.fromCharCode(c);
		}
		return o;
	}, t.write = function(e, t, n) {
		for (var r = n, i, a, o = 0; o < e.length; ++o) i = e.charCodeAt(o), i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) == 55296 && ((a = e.charCodeAt(o + 1)) & 64512) == 56320 ? (i = 65536 + ((i & 1023) << 10) + (a & 1023), ++o, t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
		return n - r;
	};
})), v = /* @__PURE__ */ t(((e, t) => {
	t.exports = n;
	function n(e, t, n) {
		var r = n || 8192, i = r >>> 1, a = null, o = r;
		return function(n) {
			if (n < 1 || n > i) return e(n);
			o + n > r && (a = e(r), o = 0);
			var s = t.call(a, o, o += n);
			return o & 7 && (o = (o | 7) + 1), s;
		};
	}
})), y = /* @__PURE__ */ t(((e, t) => {
	t.exports = r;
	var n;
	function r(e, t) {
		this.lo = e >>> 0, this.hi = t >>> 0;
	}
	var i = r.zero = new r(0, 0);
	i.toNumber = function() {
		return 0;
	}, i.zzEncode = i.zzDecode = function() {
		return this;
	}, i.length = function() {
		return 1;
	};
	var a = r.zeroHash = "\0\0\0\0\0\0\0\0";
	r.fromNumber = function(e) {
		if (e === 0) return i;
		var t = e < 0;
		t && (e = -e);
		var n = e >>> 0, a = (e - n) / 4294967296 >>> 0;
		return t && (a = ~a >>> 0, n = ~n >>> 0, ++n > 4294967295 && (n = 0, ++a > 4294967295 && (a = 0))), new r(n, a);
	}, r.from = function(e) {
		if (typeof e == "number") return r.fromNumber(e);
		if (typeof e == "string" || e instanceof String) {
			/* istanbul ignore else */
			if (n) e = n.fromString(e);
			else return r.fromNumber(parseInt(e, 10));
		}
		return e.low || e.high ? new r(e.low >>> 0, e.high >>> 0) : i;
	}, r.prototype.toNumber = function(e) {
		if (!e && this.hi >>> 31) {
			var t = ~this.lo + 1 >>> 0, n = ~this.hi >>> 0;
			return t || (n = n + 1 >>> 0), -(t + n * 4294967296);
		}
		return this.lo + this.hi * 4294967296;
	}, r.prototype.toLong = function(e) {
		return n ? new n(this.lo | 0, this.hi | 0, !!e) : {
			low: this.lo | 0,
			high: this.hi | 0,
			unsigned: !!e
		};
	};
	var o = String.prototype.charCodeAt;
	r.fromHash = function(e) {
		return e === a ? i : new r((o.call(e, 0) | o.call(e, 1) << 8 | o.call(e, 2) << 16 | o.call(e, 3) << 24) >>> 0, (o.call(e, 4) | o.call(e, 5) << 8 | o.call(e, 6) << 16 | o.call(e, 7) << 24) >>> 0);
	}, r.prototype.toHash = function() {
		return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
	}, r.prototype.zzEncode = function() {
		var e = this.hi >> 31;
		return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ e) >>> 0, this.lo = (this.lo << 1 ^ e) >>> 0, this;
	}, r.prototype.zzDecode = function() {
		var e = -(this.lo & 1);
		return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ e) >>> 0, this.hi = (this.hi >>> 1 ^ e) >>> 0, this;
	}, r.prototype.length = function() {
		var e = this.lo, t = (this.lo >>> 28 | this.hi << 4) >>> 0, n = this.hi >>> 24;
		return n === 0 ? t === 0 ? e < 16384 ? e < 128 ? 1 : 2 : e < 2097152 ? 3 : 4 : t < 16384 ? t < 128 ? 5 : 6 : t < 2097152 ? 7 : 8 : n < 128 ? 9 : 10;
	}, r._configure = function(e) {
		n = e;
	};
})), b = /* @__PURE__ */ t(((e, t) => {
	(function(n, r) {
		function i(e) {
			return e.default || e;
		}
		typeof define == "function" && define.amd ? define([], function() {
			var e = {};
			return r(e), i(e);
		}) : typeof e == "object" ? (r(e), typeof t == "object" && (t.exports = i(e))) : (function() {
			var e = {};
			r(e), n.Long = i(e);
		})();
	})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : e, function(e) {
		Object.defineProperty(e, "__esModule", { value: !0 }), e.default = void 0;
		var t = null;
		try {
			t = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
				0,
				97,
				115,
				109,
				1,
				0,
				0,
				0,
				1,
				13,
				2,
				96,
				0,
				1,
				127,
				96,
				4,
				127,
				127,
				127,
				127,
				1,
				127,
				3,
				7,
				6,
				0,
				1,
				1,
				1,
				1,
				1,
				6,
				6,
				1,
				127,
				1,
				65,
				0,
				11,
				7,
				50,
				6,
				3,
				109,
				117,
				108,
				0,
				1,
				5,
				100,
				105,
				118,
				95,
				115,
				0,
				2,
				5,
				100,
				105,
				118,
				95,
				117,
				0,
				3,
				5,
				114,
				101,
				109,
				95,
				115,
				0,
				4,
				5,
				114,
				101,
				109,
				95,
				117,
				0,
				5,
				8,
				103,
				101,
				116,
				95,
				104,
				105,
				103,
				104,
				0,
				0,
				10,
				191,
				1,
				6,
				4,
				0,
				35,
				0,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				126,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				127,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				128,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				129,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11,
				36,
				1,
				1,
				126,
				32,
				0,
				173,
				32,
				1,
				173,
				66,
				32,
				134,
				132,
				32,
				2,
				173,
				32,
				3,
				173,
				66,
				32,
				134,
				132,
				130,
				34,
				4,
				66,
				32,
				135,
				167,
				36,
				0,
				32,
				4,
				167,
				11
			])), {}).exports;
		} catch {}
		function n(e, t, n) {
			this.low = e | 0, this.high = t | 0, this.unsigned = !!n;
		}
		n.prototype.__isLong__, Object.defineProperty(n.prototype, "__isLong__", { value: !0 });
		function r(e) {
			return (e && e.__isLong__) === !0;
		}
		function i(e) {
			var t = Math.clz32(e & -e);
			return e ? 31 - t : t;
		}
		n.isLong = r;
		var a = {}, o = {};
		function s(e, t) {
			var n, r, i;
			return t ? (e >>>= 0, (i = 0 <= e && e < 256) && (r = o[e], r) ? r : (n = l(e, 0, !0), i && (o[e] = n), n)) : (e |= 0, (i = -128 <= e && e < 128) && (r = a[e], r) ? r : (n = l(e, e < 0 ? -1 : 0, !1), i && (a[e] = n), n));
		}
		n.fromInt = s;
		function c(e, t) {
			if (isNaN(e)) return t ? b : y;
			if (t) {
				if (e < 0) return b;
				if (e >= g) return ee;
			} else {
				if (e <= -_) return T;
				if (e + 1 >= _) return w;
			}
			return e < 0 ? c(-e, t).neg() : l(e % h | 0, e / h | 0, t);
		}
		n.fromNumber = c;
		function l(e, t, r) {
			return new n(e, t, r);
		}
		n.fromBits = l;
		var u = Math.pow;
		function d(e, t, n) {
			if (e.length === 0) throw Error("empty string");
			if (typeof t == "number" ? (n = t, t = !1) : t = !!t, e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity") return t ? b : y;
			if (n ||= 10, n < 2 || 36 < n) throw RangeError("radix");
			var r;
			if ((r = e.indexOf("-")) > 0) throw Error("interior hyphen");
			if (r === 0) return d(e.substring(1), t, n).neg();
			for (var i = c(u(n, 8)), a = y, o = 0; o < e.length; o += 8) {
				var s = Math.min(8, e.length - o), l = parseInt(e.substring(o, o + s), n);
				if (s < 8) {
					var f = c(u(n, s));
					a = a.mul(f).add(c(l));
				} else a = a.mul(i), a = a.add(c(l));
			}
			return a.unsigned = t, a;
		}
		n.fromString = d;
		function f(e, t) {
			return typeof e == "number" ? c(e, t) : typeof e == "string" ? d(e, t) : l(e.low, e.high, typeof t == "boolean" ? t : e.unsigned);
		}
		n.fromValue = f;
		var p = 65536, m = 1 << 24, h = p * p, g = h * h, _ = g / 2, v = s(m), y = s(0);
		n.ZERO = y;
		var b = s(0, !0);
		n.UZERO = b;
		var x = s(1);
		n.ONE = x;
		var S = s(1, !0);
		n.UONE = S;
		var C = s(-1);
		n.NEG_ONE = C;
		var w = l(-1, 2147483647, !1);
		n.MAX_VALUE = w;
		var ee = l(-1, -1, !0);
		n.MAX_UNSIGNED_VALUE = ee;
		var T = l(0, -2147483648, !1);
		n.MIN_VALUE = T;
		var E = n.prototype;
		E.toInt = function() {
			return this.unsigned ? this.low >>> 0 : this.low;
		}, E.toNumber = function() {
			return this.unsigned ? (this.high >>> 0) * h + (this.low >>> 0) : this.high * h + (this.low >>> 0);
		}, E.toString = function(e) {
			if (e ||= 10, e < 2 || 36 < e) throw RangeError("radix");
			if (this.isZero()) return "0";
			if (this.isNegative()) {
				if (this.eq(T)) {
					var t = c(e), n = this.div(t), r = n.mul(t).sub(this);
					return n.toString(e) + r.toInt().toString(e);
				}
				return "-" + this.neg().toString(e);
			}
			for (var i = c(u(e, 6), this.unsigned), a = this, o = "";;) {
				var s = a.div(i), l = (a.sub(s.mul(i)).toInt() >>> 0).toString(e);
				if (a = s, a.isZero()) return l + o;
				for (; l.length < 6;) l = "0" + l;
				o = "" + l + o;
			}
		}, E.getHighBits = function() {
			return this.high;
		}, E.getHighBitsUnsigned = function() {
			return this.high >>> 0;
		}, E.getLowBits = function() {
			return this.low;
		}, E.getLowBitsUnsigned = function() {
			return this.low >>> 0;
		}, E.getNumBitsAbs = function() {
			if (this.isNegative()) return this.eq(T) ? 64 : this.neg().getNumBitsAbs();
			for (var e = this.high == 0 ? this.low : this.high, t = 31; t > 0 && !(e & 1 << t); t--);
			return this.high == 0 ? t + 1 : t + 33;
		}, E.isSafeInteger = function() {
			var e = this.high >> 21;
			return !e || !this.unsigned && e === -1 && (this.low !== 0 || this.high !== -2097152);
		}, E.isZero = function() {
			return this.high === 0 && this.low === 0;
		}, E.eqz = E.isZero, E.isNegative = function() {
			return !this.unsigned && this.high < 0;
		}, E.isPositive = function() {
			return this.unsigned || this.high >= 0;
		}, E.isOdd = function() {
			return (this.low & 1) == 1;
		}, E.isEven = function() {
			return !(this.low & 1);
		}, E.equals = function(e) {
			return r(e) || (e = f(e)), this.unsigned !== e.unsigned && this.high >>> 31 == 1 && e.high >>> 31 == 1 ? !1 : this.high === e.high && this.low === e.low;
		}, E.eq = E.equals, E.notEquals = function(e) {
			return !this.eq(e);
		}, E.neq = E.notEquals, E.ne = E.notEquals, E.lessThan = function(e) {
			return this.comp(e) < 0;
		}, E.lt = E.lessThan, E.lessThanOrEqual = function(e) {
			return this.comp(e) <= 0;
		}, E.lte = E.lessThanOrEqual, E.le = E.lessThanOrEqual, E.greaterThan = function(e) {
			return this.comp(e) > 0;
		}, E.gt = E.greaterThan, E.greaterThanOrEqual = function(e) {
			return this.comp(e) >= 0;
		}, E.gte = E.greaterThanOrEqual, E.ge = E.greaterThanOrEqual, E.compare = function(e) {
			if (r(e) || (e = f(e)), this.eq(e)) return 0;
			var t = this.isNegative(), n = e.isNegative();
			return t && !n ? -1 : !t && n ? 1 : this.unsigned ? e.high >>> 0 > this.high >>> 0 || e.high === this.high && e.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(e).isNegative() ? -1 : 1;
		}, E.comp = E.compare, E.negate = function() {
			return !this.unsigned && this.eq(T) ? T : this.not().add(x);
		}, E.neg = E.negate, E.add = function(e) {
			r(e) || (e = f(e));
			var t = this.high >>> 16, n = this.high & 65535, i = this.low >>> 16, a = this.low & 65535, o = e.high >>> 16, s = e.high & 65535, c = e.low >>> 16, u = e.low & 65535, d = 0, p = 0, m = 0, h = 0;
			return h += a + u, m += h >>> 16, h &= 65535, m += i + c, p += m >>> 16, m &= 65535, p += n + s, d += p >>> 16, p &= 65535, d += t + o, d &= 65535, l(m << 16 | h, d << 16 | p, this.unsigned);
		}, E.subtract = function(e) {
			return r(e) || (e = f(e)), this.add(e.neg());
		}, E.sub = E.subtract, E.multiply = function(e) {
			if (this.isZero()) return this;
			if (r(e) || (e = f(e)), t) return l(t.mul(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned);
			if (e.isZero()) return this.unsigned ? b : y;
			if (this.eq(T)) return e.isOdd() ? T : y;
			if (e.eq(T)) return this.isOdd() ? T : y;
			if (this.isNegative()) return e.isNegative() ? this.neg().mul(e.neg()) : this.neg().mul(e).neg();
			if (e.isNegative()) return this.mul(e.neg()).neg();
			if (this.lt(v) && e.lt(v)) return c(this.toNumber() * e.toNumber(), this.unsigned);
			var n = this.high >>> 16, i = this.high & 65535, a = this.low >>> 16, o = this.low & 65535, s = e.high >>> 16, u = e.high & 65535, d = e.low >>> 16, p = e.low & 65535, m = 0, h = 0, g = 0, _ = 0;
			return _ += o * p, g += _ >>> 16, _ &= 65535, g += a * p, h += g >>> 16, g &= 65535, g += o * d, h += g >>> 16, g &= 65535, h += i * p, m += h >>> 16, h &= 65535, h += a * d, m += h >>> 16, h &= 65535, h += o * u, m += h >>> 16, h &= 65535, m += n * p + i * d + a * u + o * s, m &= 65535, l(g << 16 | _, m << 16 | h, this.unsigned);
		}, E.mul = E.multiply, E.divide = function(e) {
			if (r(e) || (e = f(e)), e.isZero()) throw Error("division by zero");
			if (t) return !this.unsigned && this.high === -2147483648 && e.low === -1 && e.high === -1 ? this : l((this.unsigned ? t.div_u : t.div_s)(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned);
			if (this.isZero()) return this.unsigned ? b : y;
			var n, i, a;
			if (this.unsigned) {
				if (e.unsigned || (e = e.toUnsigned()), e.gt(this)) return b;
				if (e.gt(this.shru(1))) return S;
				a = b;
			} else {
				if (this.eq(T)) return e.eq(x) || e.eq(C) ? T : e.eq(T) ? x : (n = this.shr(1).div(e).shl(1), n.eq(y) ? e.isNegative() ? x : C : (i = this.sub(e.mul(n)), a = n.add(i.div(e)), a));
				if (e.eq(T)) return this.unsigned ? b : y;
				if (this.isNegative()) return e.isNegative() ? this.neg().div(e.neg()) : this.neg().div(e).neg();
				if (e.isNegative()) return this.div(e.neg()).neg();
				a = y;
			}
			for (i = this; i.gte(e);) {
				n = Math.max(1, Math.floor(i.toNumber() / e.toNumber()));
				for (var o = Math.ceil(Math.log(n) / Math.LN2), s = o <= 48 ? 1 : u(2, o - 48), d = c(n), p = d.mul(e); p.isNegative() || p.gt(i);) n -= s, d = c(n, this.unsigned), p = d.mul(e);
				d.isZero() && (d = x), a = a.add(d), i = i.sub(p);
			}
			return a;
		}, E.div = E.divide, E.modulo = function(e) {
			return r(e) || (e = f(e)), t ? l((this.unsigned ? t.rem_u : t.rem_s)(this.low, this.high, e.low, e.high), t.get_high(), this.unsigned) : this.sub(this.div(e).mul(e));
		}, E.mod = E.modulo, E.rem = E.modulo, E.not = function() {
			return l(~this.low, ~this.high, this.unsigned);
		}, E.countLeadingZeros = function() {
			return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
		}, E.clz = E.countLeadingZeros, E.countTrailingZeros = function() {
			return this.low ? i(this.low) : i(this.high) + 32;
		}, E.ctz = E.countTrailingZeros, E.and = function(e) {
			return r(e) || (e = f(e)), l(this.low & e.low, this.high & e.high, this.unsigned);
		}, E.or = function(e) {
			return r(e) || (e = f(e)), l(this.low | e.low, this.high | e.high, this.unsigned);
		}, E.xor = function(e) {
			return r(e) || (e = f(e)), l(this.low ^ e.low, this.high ^ e.high, this.unsigned);
		}, E.shiftLeft = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low << e, this.high << e | this.low >>> 32 - e, this.unsigned) : l(0, this.low << e - 32, this.unsigned);
		}, E.shl = E.shiftLeft, E.shiftRight = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low >>> e | this.high << 32 - e, this.high >> e, this.unsigned) : l(this.high >> e - 32, this.high >= 0 ? 0 : -1, this.unsigned);
		}, E.shr = E.shiftRight, E.shiftRightUnsigned = function(e) {
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e < 32 ? l(this.low >>> e | this.high << 32 - e, this.high >>> e, this.unsigned) : l(e === 32 ? this.high : this.high >>> e - 32, 0, this.unsigned);
		}, E.shru = E.shiftRightUnsigned, E.shr_u = E.shiftRightUnsigned, E.rotateLeft = function(e) {
			var t;
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e === 32 ? l(this.high, this.low, this.unsigned) : e < 32 ? (t = 32 - e, l(this.low << e | this.high >>> t, this.high << e | this.low >>> t, this.unsigned)) : (e -= 32, t = 32 - e, l(this.high << e | this.low >>> t, this.low << e | this.high >>> t, this.unsigned));
		}, E.rotl = E.rotateLeft, E.rotateRight = function(e) {
			var t;
			return r(e) && (e = e.toInt()), (e &= 63) == 0 ? this : e === 32 ? l(this.high, this.low, this.unsigned) : e < 32 ? (t = 32 - e, l(this.high << t | this.low >>> e, this.low << t | this.high >>> e, this.unsigned)) : (e -= 32, t = 32 - e, l(this.low << t | this.high >>> e, this.high << t | this.low >>> e, this.unsigned));
		}, E.rotr = E.rotateRight, E.toSigned = function() {
			return this.unsigned ? l(this.low, this.high, !1) : this;
		}, E.toUnsigned = function() {
			return this.unsigned ? this : l(this.low, this.high, !0);
		}, E.toBytes = function(e) {
			return e ? this.toBytesLE() : this.toBytesBE();
		}, E.toBytesLE = function() {
			var e = this.high, t = this.low;
			return [
				t & 255,
				t >>> 8 & 255,
				t >>> 16 & 255,
				t >>> 24,
				e & 255,
				e >>> 8 & 255,
				e >>> 16 & 255,
				e >>> 24
			];
		}, E.toBytesBE = function() {
			var e = this.high, t = this.low;
			return [
				e >>> 24,
				e >>> 16 & 255,
				e >>> 8 & 255,
				e & 255,
				t >>> 24,
				t >>> 16 & 255,
				t >>> 8 & 255,
				t & 255
			];
		}, n.fromBytes = function(e, t, r) {
			return r ? n.fromBytesLE(e, t) : n.fromBytesBE(e, t);
		}, n.fromBytesLE = function(e, t) {
			return new n(e[0] | e[1] << 8 | e[2] << 16 | e[3] << 24, e[4] | e[5] << 8 | e[6] << 16 | e[7] << 24, t);
		}, n.fromBytesBE = function(e, t) {
			return new n(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7], e[0] << 24 | e[1] << 16 | e[2] << 8 | e[3], t);
		}, typeof BigInt == "function" && (n.fromBigInt = function(e, t) {
			return l(Number(BigInt.asIntN(32, e)), Number(BigInt.asIntN(32, e >> BigInt(32))), t);
		}, n.fromValue = function(e, t) {
			return typeof e == "bigint" ? n.fromBigInt(e, t) : f(e, t);
		}, E.toBigInt = function() {
			var e = BigInt(this.low >>> 0);
			return BigInt(this.unsigned ? this.high >>> 0 : this.high) << BigInt(32) | e;
		}), e.default = n;
	});
})), x = /* @__PURE__ */ t(((e) => {
	var t = e;
	t.asPromise = p(), t.base64 = m(), t.EventEmitter = h(), t.float = g(), t.utf8 = _(), t.pool = v(), t.LongBits = y();
	function n(e) {
		return e === "__proto__" || e === "prototype" || e === "constructor";
	}
	t.isUnsafeProperty = n, t.isNode = !!(typeof global < "u" && global && global.process && global.process.versions && global.process.versions.node), t.global = t.isNode && global || typeof window < "u" && window || typeof self < "u" && self || typeof globalThis < "u" && globalThis || e, t.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ [], t.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}, t.isInteger = Number.isInteger || /* istanbul ignore next */ function(e) {
		return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
	}, t.isString = function(e) {
		return typeof e == "string" || e instanceof String;
	}, t.isObject = function(e) {
		return e && typeof e == "object";
	}, t.isset = t.isSet = function(e, t) {
		var n = e[t];
		return n != null && Object.hasOwnProperty.call(e, t) ? typeof n != "object" || (Array.isArray(n) ? n.length : Object.keys(n).length) > 0 : !1;
	}, t.Buffer = (function() {
		try {
			var e = t.global.Buffer;
			return e.prototype.utf8Write || t.isNode ? e : /* istanbul ignore next */ null;
		} catch {
			/* istanbul ignore next */
			return null;
		}
	})(), t.newBuffer = function(e) {
		var n = t.Buffer;
		/* istanbul ignore next */
		return typeof e == "number" ? n ? n.allocUnsafe(e) : new Uint8Array(e) : n ? n.from(e) : new Uint8Array(e);
	}, t.rawField = function(e, n, r) {
		var i = [], a = e << 3 | n;
		for (a >>>= 0; a > 127;) i.push(a & 127 | 128), a >>>= 7;
		i.push(a);
		for (var o = 0; o < r.length; ++o) i.push(r[o]);
		return t.newBuffer(i);
	}, t.Array = Uint8Array, t.Long = t.global.dcodeIO && /* istanbul ignore next */ t.global.dcodeIO.Long || /* istanbul ignore next */ t.global.Long || (function() {
		try {
			var e = b();
			return e && e.isLong ? e : null;
		} catch {
			/* istanbul ignore next */
			return null;
		}
	})(), t.key2Re = /^(?:true|false|0|1)$/, t.key32Re = /^-?(?:0|[1-9][0-9]*)$/, t.key64Re = /^(?:[\x00-\xff]{8}|-?(?:0|[1-9][0-9]*))$/, t.longToHash = function(e) {
		return e ? t.LongBits.from(e).toHash() : t.LongBits.zeroHash;
	}, t.longFromHash = function(e, n) {
		var r = t.LongBits.fromHash(e);
		return t.Long ? t.Long.fromBits(r.lo, r.hi, n) : r.toNumber(!!n);
	}, t.longFromKey = function(e, n) {
		return t.key64Re.test(e) && !t.key32Re.test(e) ? t.longFromHash(e, n) : e;
	}, t.boolFromKey = function(e) {
		return e === "true" || e === "1";
	};
	function r(e) {
		var t = typeof arguments[arguments.length - 1] == "boolean", r = t ? arguments.length - 1 : arguments.length;
		t &&= arguments[arguments.length - 1];
		for (var i = 1; i < r; ++i) {
			var a = arguments[i];
			if (a) for (var o = Object.keys(a), s = 0; s < o.length; ++s) !n(o[s]) && (!t || !Object.prototype.hasOwnProperty.call(e, o[s]) || e[o[s]] === void 0) && (e[o[s]] = a[o[s]]);
		}
		return e;
	}
	t.merge = r, t.nestingLimit = 32, t.recursionLimit = 100, t.makeProp = function(e, t, n) {
		Object.prototype.hasOwnProperty.call(e, t) || Object.defineProperty(e, t, {
			enumerable: n === void 0 || n,
			configurable: !0,
			writable: !0
		});
	}, t.lcFirst = function(e) {
		return e.charAt(0).toLowerCase() + e.substring(1);
	};
	function i(e) {
		function t(e, n) {
			if (!(this instanceof t)) return new t(e, n);
			Object.defineProperty(this, "message", { get: function() {
				return e;
			} }), Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", { value: (/* @__PURE__ */ Error()).stack || "" }), n && r(this, n);
		}
		return t.prototype = Object.create(Error.prototype, {
			constructor: {
				value: t,
				writable: !0,
				enumerable: !1,
				configurable: !0
			},
			name: {
				get: function() {
					return e;
				},
				set: void 0,
				enumerable: !1,
				configurable: !0
			},
			toString: {
				value: function() {
					return this.name + ": " + this.message;
				},
				writable: !0,
				enumerable: !1,
				configurable: !0
			}
		}), t;
	}
	t.newError = i, t.ProtocolError = i("ProtocolError"), t.oneOfGetter = function(e) {
		for (var t = {}, n = 0; n < e.length; ++n) t[e[n]] = 1;
		return function() {
			for (var e = Object.keys(this), n = e.length - 1; n > -1; --n) if (t[e[n]] === 1 && this[e[n]] !== void 0 && this[e[n]] !== null) return e[n];
		};
	}, t.oneOfSetter = function(e) {
		return function(t) {
			for (var n = 0; n < e.length; ++n) e[n] !== t && delete this[e[n]];
		};
	}, t.toJSONOptions = {
		longs: String,
		enums: String,
		bytes: String,
		json: !0
	};
})), S = /* @__PURE__ */ t(((e, t) => {
	t.exports = s;
	var n = x(), r, i = n.LongBits, a = n.base64, o = n.utf8;
	function s() {
		this.pos = 0, this.buf = this.constructor.alloc(s.initialBufferSize), this.view = null, this.states = null;
	}
	s.initialBufferSize = 128, Object.defineProperty(s.prototype, "len", {
		configurable: !0,
		enumerable: !0,
		get: function() {
			return this.pos;
		}
	});
	var c = function() {
		return n.Buffer ? function() {
			return (s.create = function() {
				return new r();
			})();
		} : function() {
			return new s();
		};
	};
	s.create = c(), s.alloc = function(e) {
		return new Uint8Array(e);
	}, s.alloc = n.pool(s.alloc, Uint8Array.prototype.subarray);
	function l(e) {
		return e < 128 ? 1 : e < 16384 ? 2 : e < 2097152 ? 3 : e < 268435456 ? 4 : 5;
	}
	s.prototype._reserve = function(e) {
		var t = this.pos + e;
		if (t > this.buf.length) {
			var n = this.buf.length << 1;
			n < t && (n = t);
			var r = this.constructor.alloc(n);
			r.set(this.buf.subarray(0, this.pos), 0), this.buf = r, this.view = null;
		}
	};
	function u(e, t, n) {
		for (var r = 0; r < e.length;) t[n++] = e.charCodeAt(r++);
	}
	function d(e, t, n) {
		for (; e > 127;) t[n++] = e & 127 | 128, e >>>= 7;
		return t[n] = e, n + 1;
	}
	s.prototype.uint32 = function(e) {
		e >>>= 0, this._reserve(5);
		var t = this.pos;
		return this.pos = d(e, this.buf, t), this;
	}, s.prototype.int32 = function(e) {
		return (e |= 0) < 0 ? (this._reserve(10), f(i.fromNumber(e), this.buf, this.pos), this.pos += 10, this) : this.uint32(e);
	}, s.prototype.sint32 = function(e) {
		return this.uint32((e << 1 ^ e >> 31) >>> 0);
	};
	function f(e, t, n) {
		for (var r = e.lo, i = e.hi; i;) t[n++] = r & 127 | 128, r = (r >>> 7 | i << 25) >>> 0, i >>>= 7;
		for (; r > 127;) t[n++] = r & 127 | 128, r >>>= 7;
		return t[n] = r, n + 1;
	}
	s.prototype.uint64 = function(e) {
		var t = i.from(e);
		this._reserve(10);
		var n = this.pos;
		return this.pos = f(t, this.buf, n), this;
	}, s.prototype.int64 = s.prototype.uint64, s.prototype.sint64 = function(e) {
		var t = i.from(e).zzEncode();
		this._reserve(10);
		var n = this.pos;
		return this.pos = f(t, this.buf, n), this;
	}, s.prototype.bool = function(e) {
		return this._reserve(1), this.buf[this.pos++] = +!!e, this;
	};
	function p(e, t, n) {
		t[n] = e & 255, t[n + 1] = e >>> 8 & 255, t[n + 2] = e >>> 16 & 255, t[n + 3] = e >>> 24;
	}
	s.prototype.fixed32 = function(e) {
		return this._reserve(4), p(e >>> 0, this.buf, this.pos), this.pos += 4, this;
	}, s.prototype.sfixed32 = s.prototype.fixed32, s.prototype.fixed64 = function(e) {
		var t = i.from(e);
		return this._reserve(8), p(t.lo, this.buf, this.pos), p(t.hi, this.buf, this.pos + 4), this.pos += 8, this;
	}, s.prototype.sfixed64 = s.prototype.fixed64, s.prototype.float = function(e) {
		return this._reserve(4), n.float.writeFloatLE(e, this.buf, this.pos), this.pos += 4, this;
	}, s.prototype.double = function(e) {
		return this._reserve(8), n.float.writeDoubleLE(e, this.buf, this.pos), this.pos += 8, this;
	}, s.prototype.bytes = function(e) {
		var t = e.length >>> 0;
		if (!t) return this._reserve(1), this.buf[this.pos++] = 0, this;
		if (n.isString(e)) {
			var r = s.alloc(t = a.length(e));
			a.decode(e, r, 0), e = r;
		}
		return this.uint32(t), this._reserve(t), this.buf.set(e, this.pos), this.pos += t, this;
	}, s.prototype.raw = function(e) {
		var t = e.length >>> 0;
		return t ? (this._reserve(t), this.buf.set(e, this.pos), this.pos += t, this) : this;
	}, s.prototype._delim = function(e, t) {
		var n = l(t);
		return n > 1 && this.buf.copyWithin(e + n, e + 1, e + 1 + t), d(t, this.buf, e), this.pos = e + n + t, this;
	}, s.prototype.string = function(e) {
		var t = e.length;
		if (!t) return this._reserve(1), this.buf[this.pos++] = 0, this;
		if (t < 128) {
			this._reserve(t * 3 + 5);
			var n = this.pos;
			return this._delim(n, o.write(e, this.buf, n + 1));
		}
		var r = o.length(e);
		return this.uint32(r), this._reserve(r), r === e.length ? u(e, this.buf, this.pos) : o.write(e, this.buf, this.pos), this.pos += r, this;
	}, s.prototype.uint32s = function(e) {
		var t = e.length;
		this._reserve(t * 5 + 5);
		for (var n = this.buf, r = this.pos, i = r + 1, a = 0; a < t; ++a) i = d(e[a] >>> 0, n, i);
		return this._delim(r, i - r - 1);
	}, s.prototype.int32s = function(e) {
		var t = e.length;
		this._reserve(t * 10 + 5);
		for (var n = this.buf, r = this.pos, a = r + 1, o, s = 0; s < t; ++s) a = (o = e[s] | 0) < 0 ? f(i.fromNumber(o), n, a) : d(o, n, a);
		return this._delim(r, a - r - 1);
	}, s.prototype.sint32s = function(e) {
		var t = e.length;
		this._reserve(t * 5 + 5);
		for (var n = this.buf, r = this.pos, i = r + 1, a = 0; a < t; ++a) i = d((e[a] << 1 ^ e[a] >> 31) >>> 0, n, i);
		return this._delim(r, i - r - 1);
	}, s.prototype.uint64s = function(e) {
		var t = e.length;
		this._reserve(t * 10 + 5);
		for (var n = this.buf, r = this.pos, a = r + 1, o = 0; o < t; ++o) a = f(i.from(e[o]), n, a);
		return this._delim(r, a - r - 1);
	}, s.prototype.int64s = s.prototype.uint64s, s.prototype.sint64s = function(e) {
		var t = e.length;
		this._reserve(t * 10 + 5);
		for (var n = this.buf, r = this.pos, a = r + 1, o = 0; o < t; ++o) a = f(i.from(e[o]).zzEncode(), n, a);
		return this._delim(r, a - r - 1);
	}, s.prototype.bools = function(e) {
		var t = e.length;
		this.uint32(t), this._reserve(t);
		for (var n = this.buf, r = this.pos, i = 0; i < t; ++i) n[r++] = +!!e[i];
		return this.pos += t, this;
	};
	var m = 16, h = 128;
	function g(e, t, n) {
		var r = e.view;
		if (r || t < n) return r;
		var i = e.buf;
		return e.view = new DataView(i.buffer, i.byteOffset, i.byteLength);
	}
	s.prototype.fixed32s = function(e) {
		var t = e.length, n = t * 4;
		this.uint32(n), this._reserve(n);
		var r = this.pos, i, a = g(this, t, h);
		if (a) for (i = 0; i < t; ++i) a.setUint32(r, e[i] >>> 0, !0), r += 4;
		else {
			var o = this.buf;
			for (i = 0; i < t; ++i) p(e[i] >>> 0, o, r), r += 4;
		}
		return this.pos += n, this;
	}, s.prototype.sfixed32s = s.prototype.fixed32s, s.prototype.fixed64s = function(e) {
		var t = e.length, n = t * 8;
		this.uint32(n), this._reserve(n);
		var r = this.pos, a, o, s = g(this, t, h);
		if (s) for (a = 0; a < t; ++a) o = i.from(e[a]), s.setUint32(r, o.lo, !0), s.setUint32(r + 4, o.hi, !0), r += 8;
		else {
			var c = this.buf;
			for (a = 0; a < t; ++a) o = i.from(e[a]), p(o.lo, c, r), p(o.hi, c, r + 4), r += 8;
		}
		return this.pos += n, this;
	}, s.prototype.sfixed64s = s.prototype.fixed64s, s.prototype.floats = function(e) {
		var t = e.length, r = t * 4;
		this.uint32(r), this._reserve(r);
		var i = this.pos, a, o = g(this, t, m);
		if (o) for (a = 0; a < t; ++a) o.setFloat32(i, e[a], !0), i += 4;
		else {
			var s = this.buf;
			for (a = 0; a < t; ++a) n.float.writeFloatLE(e[a], s, i), i += 4;
		}
		return this.pos += r, this;
	}, s.prototype.doubles = function(e) {
		var t = e.length, r = t * 8;
		this.uint32(r), this._reserve(r);
		var i = this.pos, a, o = g(this, t, m);
		if (o) for (a = 0; a < t; ++a) o.setFloat64(i, e[a], !0), i += 8;
		else {
			var s = this.buf;
			for (a = 0; a < t; ++a) n.float.writeDoubleLE(e[a], s, i), i += 8;
		}
		return this.pos += r, this;
	}, s.prototype.fork = function() {
		return this._reserve(1), (this.states ||= []).push(this.pos), this.pos += 1, this;
	}, s.prototype.reset = function() {
		var e = this.states;
		return this.pos = e && e.length ? e.pop() : 0, this;
	}, s.prototype.ldelim = function() {
		var e = this.states, t, n;
		if (e && e.length) {
			var r = e.pop();
			t = this.pos - r - 1, n = l(t), n > 1 ? (this._reserve(n - 1), this.buf.copyWithin(r + n, r + 1, r + 1 + t), this.pos += n - 1, d(t, this.buf, r)) : this.buf[r] = t;
		} else t = this.pos, n = l(t), this._reserve(n), this.buf.copyWithin(n, 0, t), d(t, this.buf, 0), this.pos += n;
		return this;
	}, s.prototype.finish = function(e) {
		if (e) return this.buf.subarray(0, this.pos);
		var t = this.constructor.alloc(this.pos);
		return t.set(this.buf.subarray(0, this.pos), 0), t;
	}, s.prototype.finishInto = function(e, t) {
		return t === void 0 && (t = 0), e.set(this.buf.subarray(0, this.pos), t), e;
	}, s._configure = function(e) {
		r = e, s.create = c(), r._configure();
	};
})), C = /* @__PURE__ */ t(((e, t) => {
	t.exports = i;
	var n = S();
	i.prototype = Object.create(n.prototype, { constructor: {
		value: i,
		writable: !0,
		enumerable: !1,
		configurable: !0
	} });
	var r = x();
	function i() {
		n.call(this);
	}
	var a;
	i._configure = function() {
		i.alloc = r.Buffer && r.Buffer.allocUnsafe, a = r.Buffer && r.Buffer.prototype.utf8Write ? function(e, t, n) {
			return t.utf8Write(e, n);
		} : function(e, t, n) {
			return t.write(e, n);
		};
	}, i.prototype.bytes = function(e) {
		r.isString(e) && (e = r.Buffer.from(e, "base64"));
		var t = e.length >>> 0;
		return this.uint32(t), t && (this._reserve(t), this.buf.set(e, this.pos), this.pos += t), this;
	}, i.prototype.string = function(e) {
		var t = e.length;
		if (!t) return this._reserve(1), this.buf[this.pos++] = 0, this;
		if (t < 128) {
			this._reserve(t * 3 + 5);
			var n = this.pos, i = this.buf;
			return this._delim(n, t < 40 ? r.utf8.write(e, i, n + 1) : a(e, i, n + 1));
		}
		var o = r.Buffer.byteLength(e);
		return this.uint32(o), this._reserve(o), a(e, this.buf, this.pos), this.pos += o, this;
	}, i._configure();
})), w = /* @__PURE__ */ t(((e, t) => {
	t.exports = s;
	var n = x(), r, i = n.LongBits, a = n.utf8;
	/* istanbul ignore next */
	function o(e, t) {
		return RangeError("index out of range: " + e.pos + " + " + (t || 1) + " > " + e.len);
	}
	function s(e) {
		this.buf = e, this.pos = 0, this.len = e.length, this.view = null, this.discardUnknown = s.discardUnknown;
	}
	function c(e) {
		if (Array.isArray(e) && (e = new Uint8Array(e)), e instanceof Uint8Array) return new s(e);
		throw Error("illegal buffer");
	}
	var l = function() {
		return n.Buffer ? function(e) {
			return (s.create = function(e) {
				return n.Buffer.isBuffer(e) ? new r(e) : c(e);
			})(e);
		} : c;
	};
	s.create = l(), s.prototype.raw = function(e, t) {
		return this.buf.subarray(e, t);
	};
	function u(e) {
		for (var t = 0, n = 0; n < 4; ++n) {
			if (e.pos >= e.len) throw o(e);
			var r = e.buf[e.pos++];
			if (t = (t | (r & 127) << n * 7) >>> 0, r < 128) return t;
		}
		throw o(e);
	}
	s.prototype.uint32 = function() {
		if (this.len - this.pos < 5) {
			if (this.pos >= this.len) throw o(this);
			if (this.buf[this.pos] >= 128) return u(this);
		}
		var e = this.buf, t = this.pos, n = (e[t] & 127) >>> 0;
		if (e[t++] < 128 || (n = (n | (e[t] & 127) << 7) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 14) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 21) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 15) << 28) >>> 0, e[t++] < 128)) return this.pos = t, n;
		for (var r = 0; r < 5; ++r) {
			/* istanbul ignore if */
			if (t >= this.len) throw this.pos = t, o(this);
			if (e[t++] < 128) return this.pos = t, n;
		}
		throw this.pos = t, Error("invalid varint encoding");
	}, s.prototype.tag = function() {
		if (this.len - this.pos < 5) {
			if (this.pos >= this.len) throw o(this);
			if (this.buf[this.pos] >= 128) return u(this);
		}
		var e = this.buf, t = this.pos, n = (e[t] & 127) >>> 0;
		if (e[t++] < 128 || (n = (n | (e[t] & 127) << 7) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 14) >>> 0, e[t++] < 128) || (n = (n | (e[t] & 127) << 21) >>> 0, e[t++] < 128)) return this.pos = t, n;
		if (n = (n | (e[t] & 15) << 28) >>> 0, e[t] < 128 && !(e[t] & 112)) return this.pos = t + 1, n;
		throw this.pos = t + 1, Error("invalid tag encoding");
	}, s.prototype.int32 = function() {
		return this.uint32() | 0;
	}, s.prototype.sint32 = function() {
		var e = this.uint32();
		return e >>> 1 ^ -(e & 1) | 0;
	};
	function d() {
		var e = new i(0, 0), t = 0;
		if (this.len - this.pos > 4) {
			for (; t < 4; ++t) if (e.lo = (e.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128) return e;
			if (e.lo = (e.lo | (this.buf[this.pos] & 127) << 28) >>> 0, e.hi = (e.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128) return e;
			t = 0;
		} else {
			for (; t < 4; ++t) {
				/* istanbul ignore if */
				if (this.pos >= this.len) throw o(this);
				if (e.lo = (e.lo | (this.buf[this.pos] & 127) << t * 7) >>> 0, this.buf[this.pos++] < 128) return e;
			}
			throw o(this);
		}
		if (this.len - this.pos > 4) {
			for (; t < 5; ++t) if (e.hi = (e.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return e;
		} else for (; t < 5; ++t) {
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
			if (e.hi = (e.hi | (this.buf[this.pos] & 127) << t * 7 + 3) >>> 0, this.buf[this.pos++] < 128) return e;
		}
		/* istanbul ignore next */
		throw Error("invalid varint encoding");
	}
	s.prototype.bool = function() {
		for (var e = !1, t, n = 0; n < 10; ++n) {
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
			if (t = this.buf[this.pos++], t & 127 && (e = !0), t < 128) return e;
		}
		/* istanbul ignore next */
		throw Error("invalid varint encoding");
	};
	function f(e, t) {
		return (e[t - 4] | e[t - 3] << 8 | e[t - 2] << 16 | e[t - 1] << 24) >>> 0;
	}
	s.prototype.fixed32 = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		return f(this.buf, this.pos += 4);
	}, s.prototype.sfixed32 = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		return f(this.buf, this.pos += 4) | 0;
	};
	function p() {
		/* istanbul ignore if */
		if (this.pos + 8 > this.len) throw o(this, 8);
		return new i(f(this.buf, this.pos += 4), f(this.buf, this.pos += 4));
	}
	s.prototype.float = function() {
		/* istanbul ignore if */
		if (this.pos + 4 > this.len) throw o(this, 4);
		var e = n.float.readFloatLE(this.buf, this.pos);
		return this.pos += 4, e;
	}, s.prototype.double = function() {
		/* istanbul ignore if */
		if (this.pos + 8 > this.len) throw o(this, 4);
		var e = n.float.readDoubleLE(this.buf, this.pos);
		return this.pos += 8, e;
	}, s.prototype.uint32s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len, r = this.buf, i = this.pos, a;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; i < t;) a = r[i++], a < 128 ? e.push(a) : (this.pos = i - 1, e.push(this.uint32()), i = this.pos);
		if (this.pos = i, i !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.int32s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len, r = this.buf, i = this.pos, a;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; i < t;) a = r[i++], a < 128 ? e.push(a) : (this.pos = i - 1, e.push(this.int32()), i = this.pos);
		if (this.pos = i, i !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.sint32s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; this.pos < t;) e.push(this.sint32());
		if (this.pos !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.bools = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len, r = this.buf, i = this.pos, a;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; i < t;) a = r[i++], a < 128 ? e.push(a !== 0) : (this.pos = i - 1, e.push(this.bool()), i = this.pos);
		if (this.pos = i, i !== t) throw RangeError("index out of range");
		return this.len = n, e;
	};
	var m = 8, h = 128;
	function g(e, t, n) {
		var r = e.view;
		if (r || t < n) return r;
		var i = e.buf;
		return e.view = new DataView(i.buffer, i.byteOffset, i.byteLength);
	}
	s.prototype.fixed32s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), n = this.pos + t;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, t);
		var r = t >>> 2, i = e.length, a = this.pos;
		e.length = i + r;
		var s = g(this, r, h);
		if (s) for (var c = 0; c < r; ++c, a += 4) e[i++] = s.getUint32(a, !0);
		else for (var l = this.buf, u = 0; u < r; ++u, a += 4) e[i++] = f(l, a + 4);
		if (this.pos = a, a !== n) throw o(this, 4);
		return e;
	}, s.prototype.sfixed32s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), n = this.pos + t;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, t);
		var r = t >>> 2, i = e.length, a = this.pos;
		e.length = i + r;
		var s = g(this, r, h);
		if (s) for (var c = 0; c < r; ++c, a += 4) e[i++] = s.getInt32(a, !0);
		else for (var l = this.buf, u = 0; u < r; ++u, a += 4) e[i++] = f(l, a + 4) | 0;
		if (this.pos = a, a !== n) throw o(this, 4);
		return e;
	}, s.prototype.floats = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), r = this.pos + t;
		/* istanbul ignore if */
		if (r > this.len) throw o(this, t);
		var i = t >>> 2, a = e.length, s = this.pos;
		e.length = a + i;
		var c = g(this, i, m);
		if (c) for (var l = 0; l < i; ++l, s += 4) e[a++] = c.getFloat32(s, !0);
		else for (var u = this.buf, d = 0; d < i; ++d, s += 4) e[a++] = n.float.readFloatLE(u, s);
		if (this.pos = s, s !== r) throw o(this, 4);
		return e;
	}, s.prototype.doubles = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), r = this.pos + t;
		/* istanbul ignore if */
		if (r > this.len) throw o(this, t);
		var i = t >>> 3, a = e.length, s = this.pos;
		e.length = a + i;
		var c = g(this, i, m);
		if (c) for (var l = 0; l < i; ++l, s += 8) e[a++] = c.getFloat64(s, !0);
		else for (var u = this.buf, d = 0; d < i; ++d, s += 8) e[a++] = n.float.readDoubleLE(u, s);
		if (this.pos = s, s !== r) throw o(this, 8);
		return e;
	}, s.prototype.uint64s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; this.pos < t;) e.push(this.uint64());
		if (this.pos !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.int64s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; this.pos < t;) e.push(this.int64());
		if (this.pos !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.sint64s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32() + this.pos, n = this.len;
		if (t > n) throw o(this, t - this.pos);
		for (this.len = t; this.pos < t;) e.push(this.sint64());
		if (this.pos !== t) throw RangeError("index out of range");
		return this.len = n, e;
	}, s.prototype.fixed64s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), n = this.pos + t, r = e.length;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, t);
		var i = t >>> 3;
		e.length = r + i;
		for (var a = 0; a < i; ++a) e[r++] = this.fixed64();
		if (this.pos !== n) throw o(this, 8);
		return e;
	}, s.prototype.sfixed64s = function(e) {
		e === void 0 && (e = []);
		var t = this.uint32(), n = this.pos + t, r = e.length;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, t);
		var i = t >>> 3;
		e.length = r + i;
		for (var a = 0; a < i; ++a) e[r++] = this.sfixed64();
		if (this.pos !== n) throw o(this, 8);
		return e;
	}, s.prototype.bytes = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, e);
		return this.pos = n, this.raw(t, n);
	}, s.prototype.string = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, e);
		return this.pos = n, a.read(this.buf, t, n);
	}, s.prototype.stringVerify = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw o(this, e);
		return this.pos = n, a.readStrict(this.buf, t, n);
	}, s.prototype.skip = function(e) {
		if (typeof e == "number") {
			/* istanbul ignore if */
			if (this.pos + e > this.len) throw o(this, e);
			this.pos += e;
		} else do
			/* istanbul ignore if */
			if (this.pos >= this.len) throw o(this);
		while (this.buf[this.pos++] & 128);
		return this;
	}, s.recursionLimit = n.recursionLimit, s.discardUnknown = !0, s.prototype.skipType = function(e, t, n) {
		if (t === void 0 && (t = 0), t > s.recursionLimit) throw Error("max depth exceeded");
		if (n === 0) throw Error("illegal tag: field number 0");
		switch (e) {
			case 0:
				this.skip();
				break;
			case 1:
				this.skip(8);
				break;
			case 2:
				this.skip(this.uint32());
				break;
			case 3:
				for (;;) {
					var r = this.tag(), i = r >>> 3;
					if (e = r & 7, !i) throw Error("illegal tag: field number 0");
					if (e === 4) {
						if (n !== void 0 && i !== n) throw Error("invalid end group tag");
						break;
					}
					this.skipType(e, t + 1, i);
				}
				break;
			case 5:
				this.skip(4);
				break;
			/* istanbul ignore next */
			default: throw Error("invalid wire type " + e + " at offset " + this.pos);
		}
		return this;
	}, s._configure = function(e) {
		r = e, s.create = l(), r._configure();
		var t = n.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
		n.merge(s.prototype, {
			int64: function() {
				return d.call(this)[t](!1);
			},
			uint64: function() {
				return d.call(this)[t](!0);
			},
			sint64: function() {
				return d.call(this).zzDecode()[t](!1);
			},
			fixed64: function() {
				return p.call(this)[t](!0);
			},
			sfixed64: function() {
				return p.call(this)[t](!1);
			}
		});
	};
})), ee = /* @__PURE__ */ t(((e, t) => {
	t.exports = i;
	var n = w();
	i.prototype = Object.create(n.prototype, { constructor: {
		value: i,
		writable: !0,
		enumerable: !1,
		configurable: !0
	} });
	var r = x();
	function i(e) {
		n.call(this, e);
	}
	i._configure = function() {
		/* istanbul ignore else */
		r.Buffer && (i.prototype._slice = r.Buffer.prototype.slice);
	}, i.prototype.raw = function(e, t) {
		return this._slice.call(this.buf, e, t);
	}, i.prototype.string = function() {
		var e = this.uint32(), t = this.pos, n = this.pos + e;
		/* istanbul ignore if */
		if (n > this.len) throw RangeError("index out of range: " + this.pos + " + " + e + " > " + this.len);
		return this.pos = n, this.buf.utf8Slice ? this.buf.utf8Slice(t, n) : this.buf.toString("utf-8", t, n);
	}, i._configure();
})), T = /* @__PURE__ */ t(((e, t) => {
	t.exports = r;
	var n = x();
	r.prototype = Object.create(n.EventEmitter.prototype, { constructor: {
		value: r,
		writable: !0,
		enumerable: !1,
		configurable: !0
	} });
	function r(e, t, r) {
		if (typeof e != "function") throw TypeError("rpcImpl must be a function");
		n.EventEmitter.call(this), this.rpcImpl = e, this.requestDelimited = !!t, this.responseDelimited = !!r;
	}
	r.prototype.rpcCall = function e(t, r, i, a, o) {
		if (!a) throw TypeError("request must be specified");
		var s = this;
		if (!o) return n.asPromise(e, s, t, r, i, a);
		if (!s.rpcImpl) {
			setTimeout(function() {
				o(Error("already ended"));
			}, 0);
			return;
		}
		try {
			return s.rpcImpl(t, r[s.requestDelimited ? "encodeDelimited" : "encode"](a).finish(), function(e, n) {
				if (e) return s.emit("error", e, t), o(e);
				if (n === null) {
					s.end(!0);
					return;
				}
				if (!(n instanceof i)) try {
					n = i[s.responseDelimited ? "decodeDelimited" : "decode"](n);
				} catch (e) {
					return s.emit("error", e, t), o(e);
				}
				return s.emit("data", n, t), o(null, n);
			});
		} catch (e) {
			s.emit("error", e, t), setTimeout(function() {
				o(e);
			}, 0);
			return;
		}
	}, r.prototype.end = function(e) {
		return this.rpcImpl && (e || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
	};
})), E = /* @__PURE__ */ t(((e) => {
	var t = e;
	t.Service = T();
})), te = /* @__PURE__ */ t(((e, t) => {
	t.exports = Object.create(null);
})), ne = /* @__PURE__ */ t(((e) => {
	e.build = "minimal", e.Writer = S(), e.BufferWriter = C(), e.Reader = w(), e.BufferReader = ee(), e.util = x(), e.rpc = E(), e.roots = te(), e.configure = t;
	/* istanbul ignore next */
	function t() {
		e.util.LongBits._configure(e.util.Long), e.Writer._configure(e.BufferWriter), e.Reader._configure(e.BufferReader);
	}
	t();
})), D = /* @__PURE__ */ e((/* @__PURE__ */ t(((e, t) => {
	t.exports = ne();
})))(), 1), O = D.Reader, k = D.Writer, A = D.util, j = A.global.Object, M = A.global.undefined, N = A.global.Error, P = A.global.RangeError, F = A.global.TypeError, I = A.global.String, L = A.global.Boolean, R = A.global.Number, z = A.global.isFinite, B = A.global.Array, V = A.global.parseInt, H = A.global.BigInt, U = D.roots.default || (D.roots.default = {});
U.Alert = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.body = "", e.prototype.format = 0, e.prototype.icon = "", e.prototype.widthConfig = null, e.prototype.title = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== 0 && t.uint32(16).int32(e.format), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(26).string(e.icon), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(34).fork(), n + 1).ldelim(), e.title != null && j.hasOwnProperty.call(e, "title") && e.title !== "" && t.uint32(42).string(e.title), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Alert(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.format = s : delete o.format;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig);
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.title = s : delete o.title;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Alert) return e;
		if (!A.isObject(e)) throw F(".Alert: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Alert();
		if (e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.format !== 0 && (typeof e.format != "string" || U.Alert.Format[e.format] !== 0)) switch (e.format) {
			case "UNUSED":
			case 0:
				n.format = 0;
				break;
			case "ERROR":
			case 1:
				n.format = 1;
				break;
			case "WARNING":
			case 2:
				n.format = 2;
				break;
			case "INFO":
			case 3:
				n.format = 3;
				break;
			case "SUCCESS":
			case 4:
				n.format = 4;
				break;
			default: typeof e.format == "number" && (e.format | 0) === e.format && (n.format = e.format);
		}
		if (e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Alert.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = I(e.title)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.format = t.enums === I ? "UNUSED" : 0, r.icon = "", r.widthConfig = null, r.title = ""), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = t.enums === I ? U.Alert.Format[e.format] === M ? e.format : U.Alert.Format[e.format] : e.format), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.title != null && j.hasOwnProperty.call(e, "title") && (r.title = e.title), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Alert";
	}, e.Format = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "UNUSED"] = 0, t[e[1] = "ERROR"] = 1, t[e[2] = "WARNING"] = 2, t[e[3] = "INFO"] = 3, t[e[4] = "SUCCESS"] = 4, t;
	})(), e;
})(), U.streamlit = (() => {
	let e = {};
	return e.WidthConfig = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.useStretch = null, e.prototype.useContent = null, e.prototype.pixelWidth = null, e.prototype.remWidth = null;
		let t;
		return j.defineProperty(e.prototype, "widthSpec", {
			get: A.oneOfGetter(t = [
				"useStretch",
				"useContent",
				"pixelWidth",
				"remWidth"
			]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.useStretch != null && j.hasOwnProperty.call(e, "useStretch") && t.uint32(8).bool(e.useStretch), e.useContent != null && j.hasOwnProperty.call(e, "useContent") && t.uint32(16).bool(e.useContent), e.pixelWidth != null && j.hasOwnProperty.call(e, "pixelWidth") && t.uint32(24).uint32(e.pixelWidth), e.remWidth != null && j.hasOwnProperty.call(e, "remWidth") && t.uint32(37).float(e.remWidth), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.streamlit.WidthConfig(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.useStretch = e.bool(), o.widthSpec = "useStretch";
						continue;
					case 2:
						if (a !== 0) break;
						o.useContent = e.bool(), o.widthSpec = "useContent";
						continue;
					case 3:
						if (a !== 0) break;
						o.pixelWidth = e.uint32(), o.widthSpec = "pixelWidth";
						continue;
					case 4:
						if (a !== 5) break;
						o.remWidth = e.float(), o.widthSpec = "remWidth";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.streamlit.WidthConfig) return e;
			if (!A.isObject(e)) throw F(".streamlit.WidthConfig: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.streamlit.WidthConfig();
			return e.useStretch != null && (n.useStretch = L(e.useStretch)), e.useContent != null && (n.useContent = L(e.useContent)), e.pixelWidth != null && (n.pixelWidth = e.pixelWidth >>> 0), e.remWidth != null && (n.remWidth = R(e.remWidth)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.useStretch != null && j.hasOwnProperty.call(e, "useStretch") && (r.useStretch = e.useStretch, t.oneofs && (r.widthSpec = "useStretch")), e.useContent != null && j.hasOwnProperty.call(e, "useContent") && (r.useContent = e.useContent, t.oneofs && (r.widthSpec = "useContent")), e.pixelWidth != null && j.hasOwnProperty.call(e, "pixelWidth") && (r.pixelWidth = e.pixelWidth, t.oneofs && (r.widthSpec = "pixelWidth")), e.remWidth != null && j.hasOwnProperty.call(e, "remWidth") && (r.remWidth = t.json && !z(e.remWidth) ? I(e.remWidth) : e.remWidth, t.oneofs && (r.widthSpec = "remWidth")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/streamlit.WidthConfig";
		}, e;
	})(), e.GapSize = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "GAP_UNDEFINED"] = 0, t[e[1] = "SMALL"] = 1, t[e[2] = "MEDIUM"] = 2, t[e[3] = "LARGE"] = 3, t[e[4] = "NONE"] = 4, t[e[5] = "XXSMALL"] = 5, t[e[6] = "XSMALL"] = 6, t[e[7] = "XLARGE"] = 7, t[e[8] = "XXLARGE"] = 8, t;
	})(), e.GapConfig = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.gapSize = null, e.prototype.pixelGap = null;
		let t;
		return j.defineProperty(e.prototype, "gapSpec", {
			get: A.oneOfGetter(t = ["gapSize", "pixelGap"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.gapSize != null && j.hasOwnProperty.call(e, "gapSize") && t.uint32(8).int32(e.gapSize), e.pixelGap != null && j.hasOwnProperty.call(e, "pixelGap") && t.uint32(16).uint32(e.pixelGap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.streamlit.GapConfig(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.gapSize = e.int32(), o.gapSpec = "gapSize";
						continue;
					case 2:
						if (a !== 0) break;
						o.pixelGap = e.uint32(), o.gapSpec = "pixelGap";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.streamlit.GapConfig) return e;
			if (!A.isObject(e)) throw F(".streamlit.GapConfig: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.streamlit.GapConfig();
			switch (e.gapSize) {
				case "GAP_UNDEFINED":
				case 0:
					n.gapSize = 0;
					break;
				case "SMALL":
				case 1:
					n.gapSize = 1;
					break;
				case "MEDIUM":
				case 2:
					n.gapSize = 2;
					break;
				case "LARGE":
				case 3:
					n.gapSize = 3;
					break;
				case "NONE":
				case 4:
					n.gapSize = 4;
					break;
				case "XXSMALL":
				case 5:
					n.gapSize = 5;
					break;
				case "XSMALL":
				case 6:
					n.gapSize = 6;
					break;
				case "XLARGE":
				case 7:
					n.gapSize = 7;
					break;
				case "XXLARGE":
				case 8:
					n.gapSize = 8;
					break;
				default: typeof e.gapSize == "number" && (e.gapSize | 0) === e.gapSize && (n.gapSize = e.gapSize);
			}
			return e.pixelGap != null && (n.pixelGap = e.pixelGap >>> 0), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.gapSize != null && j.hasOwnProperty.call(e, "gapSize") && (r.gapSize = t.enums === I ? U.streamlit.GapSize[e.gapSize] === M ? e.gapSize : U.streamlit.GapSize[e.gapSize] : e.gapSize, t.oneofs && (r.gapSpec = "gapSize")), e.pixelGap != null && j.hasOwnProperty.call(e, "pixelGap") && (r.pixelGap = e.pixelGap, t.oneofs && (r.gapSpec = "pixelGap")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/streamlit.GapConfig";
		}, e;
	})(), e.HeightConfig = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.useStretch = null, e.prototype.useContent = null, e.prototype.pixelHeight = null, e.prototype.remHeight = null;
		let t;
		return j.defineProperty(e.prototype, "heightSpec", {
			get: A.oneOfGetter(t = [
				"useStretch",
				"useContent",
				"pixelHeight",
				"remHeight"
			]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.useStretch != null && j.hasOwnProperty.call(e, "useStretch") && t.uint32(8).bool(e.useStretch), e.useContent != null && j.hasOwnProperty.call(e, "useContent") && t.uint32(16).bool(e.useContent), e.pixelHeight != null && j.hasOwnProperty.call(e, "pixelHeight") && t.uint32(24).uint32(e.pixelHeight), e.remHeight != null && j.hasOwnProperty.call(e, "remHeight") && t.uint32(37).float(e.remHeight), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.streamlit.HeightConfig(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.useStretch = e.bool(), o.heightSpec = "useStretch";
						continue;
					case 2:
						if (a !== 0) break;
						o.useContent = e.bool(), o.heightSpec = "useContent";
						continue;
					case 3:
						if (a !== 0) break;
						o.pixelHeight = e.uint32(), o.heightSpec = "pixelHeight";
						continue;
					case 4:
						if (a !== 5) break;
						o.remHeight = e.float(), o.heightSpec = "remHeight";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.streamlit.HeightConfig) return e;
			if (!A.isObject(e)) throw F(".streamlit.HeightConfig: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.streamlit.HeightConfig();
			return e.useStretch != null && (n.useStretch = L(e.useStretch)), e.useContent != null && (n.useContent = L(e.useContent)), e.pixelHeight != null && (n.pixelHeight = e.pixelHeight >>> 0), e.remHeight != null && (n.remHeight = R(e.remHeight)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.useStretch != null && j.hasOwnProperty.call(e, "useStretch") && (r.useStretch = e.useStretch, t.oneofs && (r.heightSpec = "useStretch")), e.useContent != null && j.hasOwnProperty.call(e, "useContent") && (r.useContent = e.useContent, t.oneofs && (r.heightSpec = "useContent")), e.pixelHeight != null && j.hasOwnProperty.call(e, "pixelHeight") && (r.pixelHeight = e.pixelHeight, t.oneofs && (r.heightSpec = "pixelHeight")), e.remHeight != null && j.hasOwnProperty.call(e, "remHeight") && (r.remHeight = t.json && !z(e.remHeight) ? I(e.remHeight) : e.remHeight, t.oneofs && (r.heightSpec = "remHeight")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/streamlit.HeightConfig";
		}, e;
	})(), e.ButtonLikeIconPosition = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "LEFT"] = 0, t[e[1] = "RIGHT"] = 1, t;
	})(), e.SelectWidgetFilterMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "FILTER_MODE_FUZZY"] = 0, t[e[1] = "FILTER_MODE_CONTAINS"] = 1, t[e[2] = "FILTER_MODE_PREFIX"] = 2, t[e[3] = "FILTER_MODE_NONE"] = 3, t;
	})(), e.TextAlignmentConfig = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.alignment = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.alignment != null && j.hasOwnProperty.call(e, "alignment") && e.alignment !== 0 && t.uint32(8).int32(e.alignment), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.streamlit.TextAlignmentConfig(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.int32()) ? o.alignment = s : delete o.alignment;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.streamlit.TextAlignmentConfig) return e;
			if (!A.isObject(e)) throw F(".streamlit.TextAlignmentConfig: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.streamlit.TextAlignmentConfig();
			if (e.alignment !== 0 && (typeof e.alignment != "string" || U.streamlit.TextAlignmentConfig.Alignment[e.alignment] !== 0)) switch (e.alignment) {
				case "UNSPECIFIED":
				case 0:
					n.alignment = 0;
					break;
				case "LEFT":
				case 1:
					n.alignment = 1;
					break;
				case "CENTER":
				case 2:
					n.alignment = 2;
					break;
				case "RIGHT":
				case 3:
					n.alignment = 3;
					break;
				case "JUSTIFY":
				case 4:
					n.alignment = 4;
					break;
				default: typeof e.alignment == "number" && (e.alignment | 0) === e.alignment && (n.alignment = e.alignment);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.alignment = t.enums === I ? "UNSPECIFIED" : 0), e.alignment != null && j.hasOwnProperty.call(e, "alignment") && (r.alignment = t.enums === I ? U.streamlit.TextAlignmentConfig.Alignment[e.alignment] === M ? e.alignment : U.streamlit.TextAlignmentConfig.Alignment[e.alignment] : e.alignment), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/streamlit.TextAlignmentConfig";
		}, e.Alignment = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "LEFT"] = 1, t[e[2] = "CENTER"] = 2, t[e[3] = "RIGHT"] = 3, t[e[4] = "JUSTIFY"] = 4, t;
		})(), e;
	})(), e;
})(), U.AppPage = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.pageScriptHash = "", e.prototype.pageName = "", e.prototype.icon = "", e.prototype.isDefault = !1, e.prototype.sectionHeader = "", e.prototype.urlPathname = "", e.prototype.isHidden = !1, e.prototype.externalUrl = null;
	let t;
	return j.defineProperty(e.prototype, "_externalUrl", {
		get: A.oneOfGetter(t = ["externalUrl"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(10).string(e.pageScriptHash), e.pageName != null && j.hasOwnProperty.call(e, "pageName") && e.pageName !== "" && t.uint32(18).string(e.pageName), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(26).string(e.icon), e.isDefault != null && j.hasOwnProperty.call(e, "isDefault") && e.isDefault !== !1 && t.uint32(32).bool(e.isDefault), e.sectionHeader != null && j.hasOwnProperty.call(e, "sectionHeader") && e.sectionHeader !== "" && t.uint32(42).string(e.sectionHeader), e.urlPathname != null && j.hasOwnProperty.call(e, "urlPathname") && e.urlPathname !== "" && t.uint32(50).string(e.urlPathname), e.isHidden != null && j.hasOwnProperty.call(e, "isHidden") && e.isHidden !== !1 && t.uint32(56).bool(e.isHidden), e.externalUrl != null && j.hasOwnProperty.call(e, "externalUrl") && t.uint32(66).string(e.externalUrl), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.AppPage(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageName = s : delete o.pageName;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.isDefault = s : delete o.isDefault;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sectionHeader = s : delete o.sectionHeader;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.urlPathname = s : delete o.urlPathname;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHidden = s : delete o.isHidden;
					continue;
				case 8:
					if (a !== 2) break;
					o.externalUrl = e.stringVerify(), o._externalUrl = "externalUrl";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.AppPage) return e;
		if (!A.isObject(e)) throw F(".AppPage: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.AppPage();
		return e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = I(e.pageName)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.isDefault != null && e.isDefault && (n.isDefault = L(e.isDefault)), e.sectionHeader != null && (typeof e.sectionHeader != "string" || e.sectionHeader.length) && (n.sectionHeader = I(e.sectionHeader)), e.urlPathname != null && (typeof e.urlPathname != "string" || e.urlPathname.length) && (n.urlPathname = I(e.urlPathname)), e.isHidden != null && e.isHidden && (n.isHidden = L(e.isHidden)), e.externalUrl != null && (n.externalUrl = I(e.externalUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.pageScriptHash = "", r.pageName = "", r.icon = "", r.isDefault = !1, r.sectionHeader = "", r.urlPathname = "", r.isHidden = !1), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.pageName != null && j.hasOwnProperty.call(e, "pageName") && (r.pageName = e.pageName), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.isDefault != null && j.hasOwnProperty.call(e, "isDefault") && (r.isDefault = e.isDefault), e.sectionHeader != null && j.hasOwnProperty.call(e, "sectionHeader") && (r.sectionHeader = e.sectionHeader), e.urlPathname != null && j.hasOwnProperty.call(e, "urlPathname") && (r.urlPathname = e.urlPathname), e.isHidden != null && j.hasOwnProperty.call(e, "isHidden") && (r.isHidden = e.isHidden), e.externalUrl != null && j.hasOwnProperty.call(e, "externalUrl") && (r.externalUrl = e.externalUrl), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/AppPage";
	}, e;
})(), U.ArrowData = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.newBuffer([]), e.prototype.styler = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && j.hasOwnProperty.call(e, "data") && e.data.length && t.uint32(10).bytes(e.data), e.styler != null && j.hasOwnProperty.call(e, "styler") && U.ArrowData.PandasStyler.encode(e.styler, t.uint32(18).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ArrowData(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.data = s : delete o.data;
					continue;
				case 2:
					if (a !== 2) break;
					o.styler = U.ArrowData.PandasStyler.decode(e, e.uint32(), M, r + 1, o.styler);
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ArrowData) return e;
		if (!A.isObject(e)) throw F(".ArrowData: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ArrowData();
		if (e.data != null && e.data.length && (typeof e.data == "string" ? A.base64.decode(e.data, n.data = A.newBuffer(A.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.styler != null) {
			if (!A.isObject(e.styler)) throw F(".ArrowData.styler: object expected");
			n.styler = U.ArrowData.PandasStyler.fromObject(e.styler, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (t.bytes === I ? r.data = "" : (r.data = [], t.bytes !== B && (r.data = A.newBuffer(r.data))), r.styler = null), e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = t.bytes === I ? A.base64.encode(e.data, 0, e.data.length) : t.bytes === B ? B.prototype.slice.call(e.data) : e.data), e.styler != null && j.hasOwnProperty.call(e, "styler") && (r.styler = U.ArrowData.PandasStyler.toObject(e.styler, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ArrowData";
	}, e.PandasStyler = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.uuid = "", e.prototype.caption = "", e.prototype.styles = "", e.prototype.displayValues = A.newBuffer([]), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.uuid != null && j.hasOwnProperty.call(e, "uuid") && e.uuid !== "" && t.uint32(10).string(e.uuid), e.caption != null && j.hasOwnProperty.call(e, "caption") && e.caption !== "" && t.uint32(18).string(e.caption), e.styles != null && j.hasOwnProperty.call(e, "styles") && e.styles !== "" && t.uint32(26).string(e.styles), e.displayValues != null && j.hasOwnProperty.call(e, "displayValues") && e.displayValues.length && t.uint32(34).bytes(e.displayValues), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.ArrowData.PandasStyler(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.uuid = s : delete o.uuid;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.caption = s : delete o.caption;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.styles = s : delete o.styles;
						continue;
					case 4:
						if (a !== 2) break;
						(s = e.bytes()).length ? o.displayValues = s : delete o.displayValues;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.ArrowData.PandasStyler) return e;
			if (!A.isObject(e)) throw F(".ArrowData.PandasStyler: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.ArrowData.PandasStyler();
			return e.uuid != null && (typeof e.uuid != "string" || e.uuid.length) && (n.uuid = I(e.uuid)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = I(e.caption)), e.styles != null && (typeof e.styles != "string" || e.styles.length) && (n.styles = I(e.styles)), e.displayValues != null && e.displayValues.length && (typeof e.displayValues == "string" ? A.base64.decode(e.displayValues, n.displayValues = A.newBuffer(A.base64.length(e.displayValues)), 0) : e.displayValues.length >= 0 && (n.displayValues = e.displayValues)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.uuid = "", r.caption = "", r.styles = "", t.bytes === I ? r.displayValues = "" : (r.displayValues = [], t.bytes !== B && (r.displayValues = A.newBuffer(r.displayValues)))), e.uuid != null && j.hasOwnProperty.call(e, "uuid") && (r.uuid = e.uuid), e.caption != null && j.hasOwnProperty.call(e, "caption") && (r.caption = e.caption), e.styles != null && j.hasOwnProperty.call(e, "styles") && (r.styles = e.styles), e.displayValues != null && j.hasOwnProperty.call(e, "displayValues") && (r.displayValues = t.bytes === I ? A.base64.encode(e.displayValues, 0, e.displayValues.length) : t.bytes === B ? B.prototype.slice.call(e.displayValues) : e.displayValues), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/ArrowData.PandasStyler";
		}, e;
	})(), e;
})(), U.ArrowNamedDataSet = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.name = "", e.prototype.hasName = !1, e.prototype.data = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.data != null && j.hasOwnProperty.call(e, "data") && U.ArrowData.encode(e.data, t.uint32(18).fork(), n + 1).ldelim(), e.hasName != null && j.hasOwnProperty.call(e, "hasName") && e.hasName !== !1 && t.uint32(24).bool(e.hasName), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ArrowNamedDataSet(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasName = s : delete o.hasName;
					continue;
				case 2:
					if (a !== 2) break;
					o.data = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.data);
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ArrowNamedDataSet) return e;
		if (!A.isObject(e)) throw F(".ArrowNamedDataSet: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ArrowNamedDataSet();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.hasName != null && e.hasName && (n.hasName = L(e.hasName)), e.data != null) {
			if (!A.isObject(e.data)) throw F(".ArrowNamedDataSet.data: object expected");
			n.data = U.ArrowData.fromObject(e.data, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.name = "", r.data = null, r.hasName = !1), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = U.ArrowData.toObject(e.data, t, n + 1)), e.hasName != null && j.hasOwnProperty.call(e, "hasName") && (r.hasName = e.hasName), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ArrowNamedDataSet";
	}, e;
})(), U.Audio = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.url = "", e.prototype.startTime = 0, e.prototype.endTime = 0, e.prototype.loop = !1, e.prototype.autoplay = !1, e.prototype.id = "", e.prototype.widthConfig = null, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_widthConfig", {
		get: A.oneOfGetter(t = ["widthConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.startTime != null && j.hasOwnProperty.call(e, "startTime") && e.startTime !== 0 && t.uint32(24).int32(e.startTime), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(42).string(e.url), e.endTime != null && j.hasOwnProperty.call(e, "endTime") && e.endTime !== 0 && t.uint32(48).int32(e.endTime), e.loop != null && j.hasOwnProperty.call(e, "loop") && e.loop !== !1 && t.uint32(56).bool(e.loop), e.autoplay != null && j.hasOwnProperty.call(e, "autoplay") && e.autoplay !== !1 && t.uint32(64).bool(e.autoplay), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(74).string(e.id), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(82).fork(), n + 1).ldelim(), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(90).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Audio(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.startTime = s : delete o.startTime;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.endTime = s : delete o.endTime;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.loop = s : delete o.loop;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.autoplay = s : delete o.autoplay;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 10:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 11:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Audio) return e;
		if (!A.isObject(e)) throw F(".Audio: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Audio();
		if (e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.startTime != null && R(e.startTime) !== 0 && (n.startTime = e.startTime | 0), e.endTime != null && R(e.endTime) !== 0 && (n.endTime = e.endTime | 0), e.loop != null && e.loop && (n.loop = L(e.loop)), e.autoplay != null && e.autoplay && (n.autoplay = L(e.autoplay)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Audio.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.startTime = 0, r.url = "", r.endTime = 0, r.loop = !1, r.autoplay = !1, r.id = ""), e.startTime != null && j.hasOwnProperty.call(e, "startTime") && (r.startTime = e.startTime), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.endTime != null && j.hasOwnProperty.call(e, "endTime") && (r.endTime = e.endTime), e.loop != null && j.hasOwnProperty.call(e, "loop") && (r.loop = e.loop), e.autoplay != null && j.hasOwnProperty.call(e, "autoplay") && (r.autoplay = e.autoplay), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Audio";
	}, e;
})(), U.AudioInput = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.sampleRate = null;
	let t;
	return j.defineProperty(e.prototype, "_sampleRate", {
		get: A.oneOfGetter(t = ["sampleRate"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(26).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(34).string(e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(40).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(50).fork(), n + 1).ldelim(), e.sampleRate != null && j.hasOwnProperty.call(e, "sampleRate") && t.uint32(56).int32(e.sampleRate), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.AudioInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 7:
					if (a !== 0) break;
					o.sampleRate = e.int32(), o._sampleRate = "sampleRate";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.AudioInput) return e;
		if (!A.isObject(e)) throw F(".AudioInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.AudioInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".AudioInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.sampleRate != null && (n.sampleRate = e.sampleRate | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.sampleRate != null && j.hasOwnProperty.call(e, "sampleRate") && (r.sampleRate = e.sampleRate), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/AudioInput";
	}, e;
})(), U.LabelVisibility = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.value = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== 0 && t.uint32(8).int32(e.value), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.LabelVisibility(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.int32()) ? o.value = s : delete o.value;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.LabelVisibility) return e;
		if (!A.isObject(e)) throw F(".LabelVisibility: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.LabelVisibility();
		if (e.value !== 0 && (typeof e.value != "string" || U.LabelVisibility.LabelVisibilityOptions[e.value] !== 0)) switch (e.value) {
			case "VISIBLE":
			case 0:
				n.value = 0;
				break;
			case "HIDDEN":
			case 1:
				n.value = 1;
				break;
			case "COLLAPSED":
			case 2:
				n.value = 2;
				break;
			default: typeof e.value == "number" && (e.value | 0) === e.value && (n.value = e.value);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.value = t.enums === I ? "VISIBLE" : 0), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = t.enums === I ? U.LabelVisibility.LabelVisibilityOptions[e.value] === M ? e.value : U.LabelVisibility.LabelVisibilityOptions[e.value] : e.value), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/LabelVisibility";
	}, e.LabelVisibilityOptions = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "VISIBLE"] = 0, t[e[1] = "HIDDEN"] = 1, t[e[2] = "COLLAPSED"] = 2, t;
	})(), e;
})(), U.AuthRedirect = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(10).string(e.url), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.AuthRedirect(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.AuthRedirect) return e;
		if (!A.isObject(e)) throw F(".AuthRedirect: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.AuthRedirect();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = ""), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/AuthRedirect";
	}, e;
})(), U.AutoRerun = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.interval = 0, e.prototype.fragmentId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.interval != null && j.hasOwnProperty.call(e, "interval") && !j.is(e.interval, 0) && t.uint32(13).float(e.interval), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && e.fragmentId !== "" && t.uint32(18).string(e.fragmentId), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.AutoRerun(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 5) break;
					j.is(s = e.float(), 0) ? delete o.interval : o.interval = s;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.AutoRerun) return e;
		if (!A.isObject(e)) throw F(".AutoRerun: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.AutoRerun();
		return e.interval != null && (j.is(R(e.interval), 0) || (n.interval = R(e.interval))), e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = I(e.fragmentId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.interval = 0, r.fragmentId = ""), e.interval != null && j.hasOwnProperty.call(e, "interval") && (r.interval = t.json && !z(e.interval) ? I(e.interval) : e.interval), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && (r.fragmentId = e.fragmentId), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/AutoRerun";
	}, e;
})(), U.StopAutoRerun = (() => {
	let e = function(e) {
		if (this.fragmentIds = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.fragmentIds = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.fragmentIds != null && e.fragmentIds.length) for (let n = 0; n < e.fragmentIds.length; ++n) t.uint32(10).string(e.fragmentIds[n]);
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.StopAutoRerun(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.fragmentIds && o.fragmentIds.length || (o.fragmentIds = []), o.fragmentIds.push(e.stringVerify());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.StopAutoRerun) return e;
		if (!A.isObject(e)) throw F(".StopAutoRerun: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.StopAutoRerun();
		if (e.fragmentIds) {
			if (!B.isArray(e.fragmentIds)) throw F(".StopAutoRerun.fragmentIds: array expected");
			n.fragmentIds = B(e.fragmentIds.length);
			for (let t = 0; t < e.fragmentIds.length; ++t) n.fragmentIds[t] = I(e.fragmentIds[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fragmentIds = []), e.fragmentIds && e.fragmentIds.length) {
			r.fragmentIds = B(e.fragmentIds.length);
			for (let t = 0; t < e.fragmentIds.length; ++t) r.fragmentIds[t] = e.fragmentIds[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/StopAutoRerun";
	}, e;
})();
var re = U.BackMsg = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.clearCache = null, e.prototype.setRunOnSave = null, e.prototype.stopScript = null, e.prototype.rerunScript = null, e.prototype.loadGitInfo = null, e.prototype.debugDisconnectWebsocket = null, e.prototype.debugShutdownRuntime = null, e.prototype.fileUrlsRequest = null, e.prototype.appHeartbeat = null, e.prototype.backendOperationRequest = null, e.prototype.debugLastBackmsgId = "";
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = [
			"clearCache",
			"setRunOnSave",
			"stopScript",
			"rerunScript",
			"loadGitInfo",
			"debugDisconnectWebsocket",
			"debugShutdownRuntime",
			"fileUrlsRequest",
			"appHeartbeat",
			"backendOperationRequest"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.clearCache != null && j.hasOwnProperty.call(e, "clearCache") && t.uint32(40).bool(e.clearCache), e.setRunOnSave != null && j.hasOwnProperty.call(e, "setRunOnSave") && t.uint32(48).bool(e.setRunOnSave), e.stopScript != null && j.hasOwnProperty.call(e, "stopScript") && t.uint32(56).bool(e.stopScript), e.rerunScript != null && j.hasOwnProperty.call(e, "rerunScript") && U.ClientState.encode(e.rerunScript, t.uint32(90).fork(), n + 1).ldelim(), e.loadGitInfo != null && j.hasOwnProperty.call(e, "loadGitInfo") && t.uint32(96).bool(e.loadGitInfo), e.debugLastBackmsgId != null && j.hasOwnProperty.call(e, "debugLastBackmsgId") && e.debugLastBackmsgId !== "" && t.uint32(106).string(e.debugLastBackmsgId), e.debugDisconnectWebsocket != null && j.hasOwnProperty.call(e, "debugDisconnectWebsocket") && t.uint32(112).bool(e.debugDisconnectWebsocket), e.debugShutdownRuntime != null && j.hasOwnProperty.call(e, "debugShutdownRuntime") && t.uint32(120).bool(e.debugShutdownRuntime), e.fileUrlsRequest != null && j.hasOwnProperty.call(e, "fileUrlsRequest") && U.FileURLsRequest.encode(e.fileUrlsRequest, t.uint32(130).fork(), n + 1).ldelim(), e.appHeartbeat != null && j.hasOwnProperty.call(e, "appHeartbeat") && t.uint32(136).bool(e.appHeartbeat), e.backendOperationRequest != null && j.hasOwnProperty.call(e, "backendOperationRequest") && U.BackendOperationRequest.encode(e.backendOperationRequest, t.uint32(154).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.BackMsg(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 5:
					if (a !== 0) break;
					o.clearCache = e.bool(), o.type = "clearCache";
					continue;
				case 6:
					if (a !== 0) break;
					o.setRunOnSave = e.bool(), o.type = "setRunOnSave";
					continue;
				case 7:
					if (a !== 0) break;
					o.stopScript = e.bool(), o.type = "stopScript";
					continue;
				case 11:
					if (a !== 2) break;
					o.rerunScript = U.ClientState.decode(e, e.uint32(), M, r + 1, o.rerunScript), o.type = "rerunScript";
					continue;
				case 12:
					if (a !== 0) break;
					o.loadGitInfo = e.bool(), o.type = "loadGitInfo";
					continue;
				case 14:
					if (a !== 0) break;
					o.debugDisconnectWebsocket = e.bool(), o.type = "debugDisconnectWebsocket";
					continue;
				case 15:
					if (a !== 0) break;
					o.debugShutdownRuntime = e.bool(), o.type = "debugShutdownRuntime";
					continue;
				case 16:
					if (a !== 2) break;
					o.fileUrlsRequest = U.FileURLsRequest.decode(e, e.uint32(), M, r + 1, o.fileUrlsRequest), o.type = "fileUrlsRequest";
					continue;
				case 17:
					if (a !== 0) break;
					o.appHeartbeat = e.bool(), o.type = "appHeartbeat";
					continue;
				case 19:
					if (a !== 2) break;
					o.backendOperationRequest = U.BackendOperationRequest.decode(e, e.uint32(), M, r + 1, o.backendOperationRequest), o.type = "backendOperationRequest";
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.debugLastBackmsgId = s : delete o.debugLastBackmsgId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.BackMsg) return e;
		if (!A.isObject(e)) throw F(".BackMsg: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.BackMsg();
		if (e.clearCache != null && (n.clearCache = L(e.clearCache)), e.setRunOnSave != null && (n.setRunOnSave = L(e.setRunOnSave)), e.stopScript != null && (n.stopScript = L(e.stopScript)), e.rerunScript != null) {
			if (!A.isObject(e.rerunScript)) throw F(".BackMsg.rerunScript: object expected");
			n.rerunScript = U.ClientState.fromObject(e.rerunScript, t + 1);
		}
		if (e.loadGitInfo != null && (n.loadGitInfo = L(e.loadGitInfo)), e.debugDisconnectWebsocket != null && (n.debugDisconnectWebsocket = L(e.debugDisconnectWebsocket)), e.debugShutdownRuntime != null && (n.debugShutdownRuntime = L(e.debugShutdownRuntime)), e.fileUrlsRequest != null) {
			if (!A.isObject(e.fileUrlsRequest)) throw F(".BackMsg.fileUrlsRequest: object expected");
			n.fileUrlsRequest = U.FileURLsRequest.fromObject(e.fileUrlsRequest, t + 1);
		}
		if (e.appHeartbeat != null && (n.appHeartbeat = L(e.appHeartbeat)), e.backendOperationRequest != null) {
			if (!A.isObject(e.backendOperationRequest)) throw F(".BackMsg.backendOperationRequest: object expected");
			n.backendOperationRequest = U.BackendOperationRequest.fromObject(e.backendOperationRequest, t + 1);
		}
		return e.debugLastBackmsgId != null && (typeof e.debugLastBackmsgId != "string" || e.debugLastBackmsgId.length) && (n.debugLastBackmsgId = I(e.debugLastBackmsgId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.debugLastBackmsgId = ""), e.clearCache != null && j.hasOwnProperty.call(e, "clearCache") && (r.clearCache = e.clearCache, t.oneofs && (r.type = "clearCache")), e.setRunOnSave != null && j.hasOwnProperty.call(e, "setRunOnSave") && (r.setRunOnSave = e.setRunOnSave, t.oneofs && (r.type = "setRunOnSave")), e.stopScript != null && j.hasOwnProperty.call(e, "stopScript") && (r.stopScript = e.stopScript, t.oneofs && (r.type = "stopScript")), e.rerunScript != null && j.hasOwnProperty.call(e, "rerunScript") && (r.rerunScript = U.ClientState.toObject(e.rerunScript, t, n + 1), t.oneofs && (r.type = "rerunScript")), e.loadGitInfo != null && j.hasOwnProperty.call(e, "loadGitInfo") && (r.loadGitInfo = e.loadGitInfo, t.oneofs && (r.type = "loadGitInfo")), e.debugLastBackmsgId != null && j.hasOwnProperty.call(e, "debugLastBackmsgId") && (r.debugLastBackmsgId = e.debugLastBackmsgId), e.debugDisconnectWebsocket != null && j.hasOwnProperty.call(e, "debugDisconnectWebsocket") && (r.debugDisconnectWebsocket = e.debugDisconnectWebsocket, t.oneofs && (r.type = "debugDisconnectWebsocket")), e.debugShutdownRuntime != null && j.hasOwnProperty.call(e, "debugShutdownRuntime") && (r.debugShutdownRuntime = e.debugShutdownRuntime, t.oneofs && (r.type = "debugShutdownRuntime")), e.fileUrlsRequest != null && j.hasOwnProperty.call(e, "fileUrlsRequest") && (r.fileUrlsRequest = U.FileURLsRequest.toObject(e.fileUrlsRequest, t, n + 1), t.oneofs && (r.type = "fileUrlsRequest")), e.appHeartbeat != null && j.hasOwnProperty.call(e, "appHeartbeat") && (r.appHeartbeat = e.appHeartbeat, t.oneofs && (r.type = "appHeartbeat")), e.backendOperationRequest != null && j.hasOwnProperty.call(e, "backendOperationRequest") && (r.backendOperationRequest = U.BackendOperationRequest.toObject(e.backendOperationRequest, t, n + 1), t.oneofs && (r.type = "backendOperationRequest")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/BackMsg";
	}, e;
})();
U.BackendOperationRequest = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.requestId = "", e.prototype.sessionId = "", e.prototype.deferredFile = null, e.prototype.installSkills = null, e.prototype.dismissSkillsNudge = null, e.prototype.dataframeChunk = null;
	let t;
	return j.defineProperty(e.prototype, "payload", {
		get: A.oneOfGetter(t = [
			"deferredFile",
			"installSkills",
			"dismissSkillsNudge",
			"dataframeChunk"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.requestId != null && j.hasOwnProperty.call(e, "requestId") && e.requestId !== "" && t.uint32(10).string(e.requestId), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && e.sessionId !== "" && t.uint32(18).string(e.sessionId), e.deferredFile != null && j.hasOwnProperty.call(e, "deferredFile") && U.DeferredFileRequestPayload.encode(e.deferredFile, t.uint32(26).fork(), n + 1).ldelim(), e.installSkills != null && j.hasOwnProperty.call(e, "installSkills") && U.InstallSkillsRequestPayload.encode(e.installSkills, t.uint32(34).fork(), n + 1).ldelim(), e.dismissSkillsNudge != null && j.hasOwnProperty.call(e, "dismissSkillsNudge") && U.DismissSkillsNudgeRequestPayload.encode(e.dismissSkillsNudge, t.uint32(42).fork(), n + 1).ldelim(), e.dataframeChunk != null && j.hasOwnProperty.call(e, "dataframeChunk") && U.DataframeChunkRequestPayload.encode(e.dataframeChunk, t.uint32(50).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.BackendOperationRequest(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.requestId = s : delete o.requestId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sessionId = s : delete o.sessionId;
					continue;
				case 3:
					if (a !== 2) break;
					o.deferredFile = U.DeferredFileRequestPayload.decode(e, e.uint32(), M, r + 1, o.deferredFile), o.payload = "deferredFile";
					continue;
				case 4:
					if (a !== 2) break;
					o.installSkills = U.InstallSkillsRequestPayload.decode(e, e.uint32(), M, r + 1, o.installSkills), o.payload = "installSkills";
					continue;
				case 5:
					if (a !== 2) break;
					o.dismissSkillsNudge = U.DismissSkillsNudgeRequestPayload.decode(e, e.uint32(), M, r + 1, o.dismissSkillsNudge), o.payload = "dismissSkillsNudge";
					continue;
				case 6:
					if (a !== 2) break;
					o.dataframeChunk = U.DataframeChunkRequestPayload.decode(e, e.uint32(), M, r + 1, o.dataframeChunk), o.payload = "dataframeChunk";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.BackendOperationRequest) return e;
		if (!A.isObject(e)) throw F(".BackendOperationRequest: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.BackendOperationRequest();
		if (e.requestId != null && (typeof e.requestId != "string" || e.requestId.length) && (n.requestId = I(e.requestId)), e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = I(e.sessionId)), e.deferredFile != null) {
			if (!A.isObject(e.deferredFile)) throw F(".BackendOperationRequest.deferredFile: object expected");
			n.deferredFile = U.DeferredFileRequestPayload.fromObject(e.deferredFile, t + 1);
		}
		if (e.installSkills != null) {
			if (!A.isObject(e.installSkills)) throw F(".BackendOperationRequest.installSkills: object expected");
			n.installSkills = U.InstallSkillsRequestPayload.fromObject(e.installSkills, t + 1);
		}
		if (e.dismissSkillsNudge != null) {
			if (!A.isObject(e.dismissSkillsNudge)) throw F(".BackendOperationRequest.dismissSkillsNudge: object expected");
			n.dismissSkillsNudge = U.DismissSkillsNudgeRequestPayload.fromObject(e.dismissSkillsNudge, t + 1);
		}
		if (e.dataframeChunk != null) {
			if (!A.isObject(e.dataframeChunk)) throw F(".BackendOperationRequest.dataframeChunk: object expected");
			n.dataframeChunk = U.DataframeChunkRequestPayload.fromObject(e.dataframeChunk, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.requestId = "", r.sessionId = ""), e.requestId != null && j.hasOwnProperty.call(e, "requestId") && (r.requestId = e.requestId), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && (r.sessionId = e.sessionId), e.deferredFile != null && j.hasOwnProperty.call(e, "deferredFile") && (r.deferredFile = U.DeferredFileRequestPayload.toObject(e.deferredFile, t, n + 1), t.oneofs && (r.payload = "deferredFile")), e.installSkills != null && j.hasOwnProperty.call(e, "installSkills") && (r.installSkills = U.InstallSkillsRequestPayload.toObject(e.installSkills, t, n + 1), t.oneofs && (r.payload = "installSkills")), e.dismissSkillsNudge != null && j.hasOwnProperty.call(e, "dismissSkillsNudge") && (r.dismissSkillsNudge = U.DismissSkillsNudgeRequestPayload.toObject(e.dismissSkillsNudge, t, n + 1), t.oneofs && (r.payload = "dismissSkillsNudge")), e.dataframeChunk != null && j.hasOwnProperty.call(e, "dataframeChunk") && (r.dataframeChunk = U.DataframeChunkRequestPayload.toObject(e.dataframeChunk, t, n + 1), t.oneofs && (r.payload = "dataframeChunk")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/BackendOperationRequest";
	}, e;
})(), U.DeferredFileRequestPayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.fileId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.fileId != null && j.hasOwnProperty.call(e, "fileId") && e.fileId !== "" && t.uint32(10).string(e.fileId), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DeferredFileRequestPayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fileId = s : delete o.fileId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DeferredFileRequestPayload) return e;
		if (!A.isObject(e)) throw F(".DeferredFileRequestPayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DeferredFileRequestPayload();
		return e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = I(e.fileId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.fileId = ""), e.fileId != null && j.hasOwnProperty.call(e, "fileId") && (r.fileId = e.fileId), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DeferredFileRequestPayload";
	}, e;
})(), U.InstallSkillsRequestPayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.InstallSkillsRequestPayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.InstallSkillsRequestPayload) return e;
		if (!A.isObject(e)) throw F(".InstallSkillsRequestPayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		return new U.InstallSkillsRequestPayload();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/InstallSkillsRequestPayload";
	}, e;
})(), U.DismissSkillsNudgeRequestPayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DismissSkillsNudgeRequestPayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DismissSkillsNudgeRequestPayload) return e;
		if (!A.isObject(e)) throw F(".DismissSkillsNudgeRequestPayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		return new U.DismissSkillsNudgeRequestPayload();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DismissSkillsNudgeRequestPayload";
	}, e;
})(), U.DataframeChunkRequestPayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.sourceId = "", e.prototype.offset = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.limit = 0, e.prototype.sort = null;
	let t;
	return j.defineProperty(e.prototype, "_sort", {
		get: A.oneOfGetter(t = ["sort"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && e.sourceId !== "" && t.uint32(10).string(e.sourceId), e.offset != null && j.hasOwnProperty.call(e, "offset") && (typeof e.offset == "object" ? e.offset.low || e.offset.high : e.offset !== 0) && t.uint32(16).uint64(e.offset), e.limit != null && j.hasOwnProperty.call(e, "limit") && e.limit !== 0 && t.uint32(24).uint32(e.limit), e.sort != null && j.hasOwnProperty.call(e, "sort") && U.SortState.encode(e.sort, t.uint32(34).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DataframeChunkRequestPayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sourceId = s : delete o.sourceId;
					continue;
				case 2:
					if (a !== 0) break;
					(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.offset = s : delete o.offset;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.limit = s : delete o.limit;
					continue;
				case 4:
					if (a !== 2) break;
					o.sort = U.SortState.decode(e, e.uint32(), M, r + 1, o.sort), o._sort = "sort";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DataframeChunkRequestPayload) return e;
		if (!A.isObject(e)) throw F(".DataframeChunkRequestPayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DataframeChunkRequestPayload();
		if (e.sourceId != null && (typeof e.sourceId != "string" || e.sourceId.length) && (n.sourceId = I(e.sourceId)), e.offset != null && (typeof e.offset == "object" ? e.offset.low || e.offset.high : R(e.offset) !== 0) && (A.Long ? n.offset = A.Long.fromValue(e.offset, !0) : typeof e.offset == "string" ? n.offset = V(e.offset, 10) : typeof e.offset == "number" ? n.offset = e.offset : typeof e.offset == "object" && (n.offset = new A.LongBits(e.offset.low >>> 0, e.offset.high >>> 0).toNumber(!0))), e.limit != null && R(e.limit) !== 0 && (n.limit = e.limit >>> 0), e.sort != null) {
			if (!A.isObject(e.sort)) throw F(".DataframeChunkRequestPayload.sort: object expected");
			n.sort = U.SortState.fromObject(e.sort, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if (t.defaults) {
			if (r.sourceId = "", A.Long) {
				let e = new A.Long(0, 0, !0);
				r.offset = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.offset = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.limit = 0;
		}
		return e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && (r.sourceId = e.sourceId), e.offset != null && j.hasOwnProperty.call(e, "offset") && (r.offset = H !== void 0 && t.longs === H ? typeof e.offset == "number" ? H(e.offset) : A.Long.fromBits(e.offset.low >>> 0, e.offset.high >>> 0, !0).toBigInt() : typeof e.offset == "number" ? t.longs === I ? I(e.offset) : e.offset : t.longs === I ? A.Long.prototype.toString.call(e.offset) : t.longs === R ? new A.LongBits(e.offset.low >>> 0, e.offset.high >>> 0).toNumber(!0) : e.offset), e.limit != null && j.hasOwnProperty.call(e, "limit") && (r.limit = e.limit), e.sort != null && j.hasOwnProperty.call(e, "sort") && (r.sort = U.SortState.toObject(e.sort, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DataframeChunkRequestPayload";
	}, e;
})(), U.ContextInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.timezone = null, e.prototype.timezoneOffset = null, e.prototype.locale = null, e.prototype.url = null, e.prototype.isEmbedded = null, e.prototype.colorScheme = null;
	let t;
	return j.defineProperty(e.prototype, "_timezone", {
		get: A.oneOfGetter(t = ["timezone"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_timezoneOffset", {
		get: A.oneOfGetter(t = ["timezoneOffset"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_locale", {
		get: A.oneOfGetter(t = ["locale"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_url", {
		get: A.oneOfGetter(t = ["url"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_isEmbedded", {
		get: A.oneOfGetter(t = ["isEmbedded"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_colorScheme", {
		get: A.oneOfGetter(t = ["colorScheme"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.timezone != null && j.hasOwnProperty.call(e, "timezone") && t.uint32(10).string(e.timezone), e.timezoneOffset != null && j.hasOwnProperty.call(e, "timezoneOffset") && t.uint32(16).int32(e.timezoneOffset), e.locale != null && j.hasOwnProperty.call(e, "locale") && t.uint32(26).string(e.locale), e.url != null && j.hasOwnProperty.call(e, "url") && t.uint32(34).string(e.url), e.isEmbedded != null && j.hasOwnProperty.call(e, "isEmbedded") && t.uint32(40).bool(e.isEmbedded), e.colorScheme != null && j.hasOwnProperty.call(e, "colorScheme") && t.uint32(50).string(e.colorScheme), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ContextInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.timezone = e.stringVerify(), o._timezone = "timezone";
					continue;
				case 2:
					if (a !== 0) break;
					o.timezoneOffset = e.int32(), o._timezoneOffset = "timezoneOffset";
					continue;
				case 3:
					if (a !== 2) break;
					o.locale = e.stringVerify(), o._locale = "locale";
					continue;
				case 4:
					if (a !== 2) break;
					o.url = e.stringVerify(), o._url = "url";
					continue;
				case 5:
					if (a !== 0) break;
					o.isEmbedded = e.bool(), o._isEmbedded = "isEmbedded";
					continue;
				case 6:
					if (a !== 2) break;
					o.colorScheme = e.stringVerify(), o._colorScheme = "colorScheme";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ContextInfo) return e;
		if (!A.isObject(e)) throw F(".ContextInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ContextInfo();
		return e.timezone != null && (n.timezone = I(e.timezone)), e.timezoneOffset != null && (n.timezoneOffset = e.timezoneOffset | 0), e.locale != null && (n.locale = I(e.locale)), e.url != null && (n.url = I(e.url)), e.isEmbedded != null && (n.isEmbedded = L(e.isEmbedded)), e.colorScheme != null && (n.colorScheme = I(e.colorScheme)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return e.timezone != null && j.hasOwnProperty.call(e, "timezone") && (r.timezone = e.timezone), e.timezoneOffset != null && j.hasOwnProperty.call(e, "timezoneOffset") && (r.timezoneOffset = e.timezoneOffset), e.locale != null && j.hasOwnProperty.call(e, "locale") && (r.locale = e.locale), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.isEmbedded != null && j.hasOwnProperty.call(e, "isEmbedded") && (r.isEmbedded = e.isEmbedded), e.colorScheme != null && j.hasOwnProperty.call(e, "colorScheme") && (r.colorScheme = e.colorScheme), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ContextInfo";
	}, e;
})(), U.ClientState = (() => {
	let e = function(e) {
		if (this.cachedMessageHashes = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.queryString = "", e.prototype.widgetStates = null, e.prototype.pageScriptHash = "", e.prototype.pageName = "", e.prototype.fragmentId = "", e.prototype.isAutoRerun = !1, e.prototype.cachedMessageHashes = A.emptyArray, e.prototype.contextInfo = null, e.prototype.isHistoryNavigation = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.queryString != null && j.hasOwnProperty.call(e, "queryString") && e.queryString !== "" && t.uint32(10).string(e.queryString), e.widgetStates != null && j.hasOwnProperty.call(e, "widgetStates") && U.WidgetStates.encode(e.widgetStates, t.uint32(18).fork(), n + 1).ldelim(), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(26).string(e.pageScriptHash), e.pageName != null && j.hasOwnProperty.call(e, "pageName") && e.pageName !== "" && t.uint32(34).string(e.pageName), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && e.fragmentId !== "" && t.uint32(42).string(e.fragmentId), e.isAutoRerun != null && j.hasOwnProperty.call(e, "isAutoRerun") && e.isAutoRerun !== !1 && t.uint32(48).bool(e.isAutoRerun), e.cachedMessageHashes != null && e.cachedMessageHashes.length) for (let n = 0; n < e.cachedMessageHashes.length; ++n) t.uint32(58).string(e.cachedMessageHashes[n]);
		if (e.contextInfo != null && j.hasOwnProperty.call(e, "contextInfo") && U.ContextInfo.encode(e.contextInfo, t.uint32(66).fork(), n + 1).ldelim(), e.isHistoryNavigation != null && j.hasOwnProperty.call(e, "isHistoryNavigation") && e.isHistoryNavigation !== !1 && t.uint32(72).bool(e.isHistoryNavigation), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ClientState(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.queryString = s : delete o.queryString;
					continue;
				case 2:
					if (a !== 2) break;
					o.widgetStates = U.WidgetStates.decode(e, e.uint32(), M, r + 1, o.widgetStates);
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageName = s : delete o.pageName;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isAutoRerun = s : delete o.isAutoRerun;
					continue;
				case 7:
					if (a !== 2) break;
					o.cachedMessageHashes && o.cachedMessageHashes.length || (o.cachedMessageHashes = []), o.cachedMessageHashes.push(e.stringVerify());
					continue;
				case 8:
					if (a !== 2) break;
					o.contextInfo = U.ContextInfo.decode(e, e.uint32(), M, r + 1, o.contextInfo);
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHistoryNavigation = s : delete o.isHistoryNavigation;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ClientState) return e;
		if (!A.isObject(e)) throw F(".ClientState: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ClientState();
		if (e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = I(e.queryString)), e.widgetStates != null) {
			if (!A.isObject(e.widgetStates)) throw F(".ClientState.widgetStates: object expected");
			n.widgetStates = U.WidgetStates.fromObject(e.widgetStates, t + 1);
		}
		if (e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = I(e.pageName)), e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = I(e.fragmentId)), e.isAutoRerun != null && e.isAutoRerun && (n.isAutoRerun = L(e.isAutoRerun)), e.cachedMessageHashes) {
			if (!B.isArray(e.cachedMessageHashes)) throw F(".ClientState.cachedMessageHashes: array expected");
			n.cachedMessageHashes = B(e.cachedMessageHashes.length);
			for (let t = 0; t < e.cachedMessageHashes.length; ++t) n.cachedMessageHashes[t] = I(e.cachedMessageHashes[t]);
		}
		if (e.contextInfo != null) {
			if (!A.isObject(e.contextInfo)) throw F(".ClientState.contextInfo: object expected");
			n.contextInfo = U.ContextInfo.fromObject(e.contextInfo, t + 1);
		}
		return e.isHistoryNavigation != null && e.isHistoryNavigation && (n.isHistoryNavigation = L(e.isHistoryNavigation)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.cachedMessageHashes = []), t.defaults && (r.queryString = "", r.widgetStates = null, r.pageScriptHash = "", r.pageName = "", r.fragmentId = "", r.isAutoRerun = !1, r.contextInfo = null, r.isHistoryNavigation = !1), e.queryString != null && j.hasOwnProperty.call(e, "queryString") && (r.queryString = e.queryString), e.widgetStates != null && j.hasOwnProperty.call(e, "widgetStates") && (r.widgetStates = U.WidgetStates.toObject(e.widgetStates, t, n + 1)), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.pageName != null && j.hasOwnProperty.call(e, "pageName") && (r.pageName = e.pageName), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && (r.fragmentId = e.fragmentId), e.isAutoRerun != null && j.hasOwnProperty.call(e, "isAutoRerun") && (r.isAutoRerun = e.isAutoRerun), e.cachedMessageHashes && e.cachedMessageHashes.length) {
			r.cachedMessageHashes = B(e.cachedMessageHashes.length);
			for (let t = 0; t < e.cachedMessageHashes.length; ++t) r.cachedMessageHashes[t] = e.cachedMessageHashes[t];
		}
		return e.contextInfo != null && j.hasOwnProperty.call(e, "contextInfo") && (r.contextInfo = U.ContextInfo.toObject(e.contextInfo, t, n + 1)), e.isHistoryNavigation != null && j.hasOwnProperty.call(e, "isHistoryNavigation") && (r.isHistoryNavigation = e.isHistoryNavigation), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ClientState";
	}, e;
})(), U.WidgetStates = (() => {
	let e = function(e) {
		if (this.widgets = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.widgets = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.widgets != null && e.widgets.length) for (let r = 0; r < e.widgets.length; ++r) U.WidgetState.encode(e.widgets[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.WidgetStates(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.widgets && o.widgets.length || (o.widgets = []), o.widgets.push(U.WidgetState.decode(e, e.uint32(), M, r + 1));
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.WidgetStates) return e;
		if (!A.isObject(e)) throw F(".WidgetStates: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.WidgetStates();
		if (e.widgets) {
			if (!B.isArray(e.widgets)) throw F(".WidgetStates.widgets: array expected");
			n.widgets = B(e.widgets.length);
			for (let r = 0; r < e.widgets.length; ++r) {
				if (!A.isObject(e.widgets[r])) throw F(".WidgetStates.widgets: object expected");
				n.widgets[r] = U.WidgetState.fromObject(e.widgets[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.widgets = []), e.widgets && e.widgets.length) {
			r.widgets = B(e.widgets.length);
			for (let i = 0; i < e.widgets.length; ++i) r.widgets[i] = U.WidgetState.toObject(e.widgets[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/WidgetStates";
	}, e;
})(), U.WidgetState = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.triggerValue = null, e.prototype.boolValue = null, e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.stringValue = null, e.prototype.doubleArrayValue = null, e.prototype.intArrayValue = null, e.prototype.stringArrayValue = null, e.prototype.jsonValue = null, e.prototype.arrowValue = null, e.prototype.bytesValue = null, e.prototype.fileUploaderStateValue = null, e.prototype.stringTriggerValue = null, e.prototype.chatInputValue = null, e.prototype.jsonTriggerValue = null;
	let t;
	return j.defineProperty(e.prototype, "value", {
		get: A.oneOfGetter(t = [
			"triggerValue",
			"boolValue",
			"doubleValue",
			"intValue",
			"stringValue",
			"doubleArrayValue",
			"intArrayValue",
			"stringArrayValue",
			"jsonValue",
			"arrowValue",
			"bytesValue",
			"fileUploaderStateValue",
			"stringTriggerValue",
			"chatInputValue",
			"jsonTriggerValue"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.triggerValue != null && j.hasOwnProperty.call(e, "triggerValue") && t.uint32(16).bool(e.triggerValue), e.boolValue != null && j.hasOwnProperty.call(e, "boolValue") && t.uint32(24).bool(e.boolValue), e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(33).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(40).sint64(e.intValue), e.stringValue != null && j.hasOwnProperty.call(e, "stringValue") && t.uint32(50).string(e.stringValue), e.doubleArrayValue != null && j.hasOwnProperty.call(e, "doubleArrayValue") && U.DoubleArray.encode(e.doubleArrayValue, t.uint32(58).fork(), n + 1).ldelim(), e.intArrayValue != null && j.hasOwnProperty.call(e, "intArrayValue") && U.SInt64Array.encode(e.intArrayValue, t.uint32(66).fork(), n + 1).ldelim(), e.stringArrayValue != null && j.hasOwnProperty.call(e, "stringArrayValue") && U.StringArray.encode(e.stringArrayValue, t.uint32(74).fork(), n + 1).ldelim(), e.jsonValue != null && j.hasOwnProperty.call(e, "jsonValue") && t.uint32(82).string(e.jsonValue), e.arrowValue != null && j.hasOwnProperty.call(e, "arrowValue") && U.ArrowTable.encode(e.arrowValue, t.uint32(90).fork(), n + 1).ldelim(), e.bytesValue != null && j.hasOwnProperty.call(e, "bytesValue") && t.uint32(98).bytes(e.bytesValue), e.fileUploaderStateValue != null && j.hasOwnProperty.call(e, "fileUploaderStateValue") && U.FileUploaderState.encode(e.fileUploaderStateValue, t.uint32(106).fork(), n + 1).ldelim(), e.stringTriggerValue != null && j.hasOwnProperty.call(e, "stringTriggerValue") && U.StringTriggerValue.encode(e.stringTriggerValue, t.uint32(114).fork(), n + 1).ldelim(), e.chatInputValue != null && j.hasOwnProperty.call(e, "chatInputValue") && U.ChatInputValue.encode(e.chatInputValue, t.uint32(122).fork(), n + 1).ldelim(), e.jsonTriggerValue != null && j.hasOwnProperty.call(e, "jsonTriggerValue") && t.uint32(130).string(e.jsonTriggerValue), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.WidgetState(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 0) break;
					o.triggerValue = e.bool(), o.value = "triggerValue";
					continue;
				case 3:
					if (a !== 0) break;
					o.boolValue = e.bool(), o.value = "boolValue";
					continue;
				case 4:
					if (a !== 1) break;
					o.doubleValue = e.double(), o.value = "doubleValue";
					continue;
				case 5:
					if (a !== 0) break;
					o.intValue = e.sint64(), o.value = "intValue";
					continue;
				case 6:
					if (a !== 2) break;
					o.stringValue = e.stringVerify(), o.value = "stringValue";
					continue;
				case 7:
					if (a !== 2) break;
					o.doubleArrayValue = U.DoubleArray.decode(e, e.uint32(), M, r + 1, o.doubleArrayValue), o.value = "doubleArrayValue";
					continue;
				case 8:
					if (a !== 2) break;
					o.intArrayValue = U.SInt64Array.decode(e, e.uint32(), M, r + 1, o.intArrayValue), o.value = "intArrayValue";
					continue;
				case 9:
					if (a !== 2) break;
					o.stringArrayValue = U.StringArray.decode(e, e.uint32(), M, r + 1, o.stringArrayValue), o.value = "stringArrayValue";
					continue;
				case 10:
					if (a !== 2) break;
					o.jsonValue = e.stringVerify(), o.value = "jsonValue";
					continue;
				case 11:
					if (a !== 2) break;
					o.arrowValue = U.ArrowTable.decode(e, e.uint32(), M, r + 1, o.arrowValue), o.value = "arrowValue";
					continue;
				case 12:
					if (a !== 2) break;
					o.bytesValue = e.bytes(), o.value = "bytesValue";
					continue;
				case 13:
					if (a !== 2) break;
					o.fileUploaderStateValue = U.FileUploaderState.decode(e, e.uint32(), M, r + 1, o.fileUploaderStateValue), o.value = "fileUploaderStateValue";
					continue;
				case 14:
					if (a !== 2) break;
					o.stringTriggerValue = U.StringTriggerValue.decode(e, e.uint32(), M, r + 1, o.stringTriggerValue), o.value = "stringTriggerValue";
					continue;
				case 15:
					if (a !== 2) break;
					o.chatInputValue = U.ChatInputValue.decode(e, e.uint32(), M, r + 1, o.chatInputValue), o.value = "chatInputValue";
					continue;
				case 16:
					if (a !== 2) break;
					o.jsonTriggerValue = e.stringVerify(), o.value = "jsonTriggerValue";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.WidgetState) return e;
		if (!A.isObject(e)) throw F(".WidgetState: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.WidgetState();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.triggerValue != null && (n.triggerValue = L(e.triggerValue)), e.boolValue != null && (n.boolValue = L(e.boolValue)), e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.stringValue != null && (n.stringValue = I(e.stringValue)), e.doubleArrayValue != null) {
			if (!A.isObject(e.doubleArrayValue)) throw F(".WidgetState.doubleArrayValue: object expected");
			n.doubleArrayValue = U.DoubleArray.fromObject(e.doubleArrayValue, t + 1);
		}
		if (e.intArrayValue != null) {
			if (!A.isObject(e.intArrayValue)) throw F(".WidgetState.intArrayValue: object expected");
			n.intArrayValue = U.SInt64Array.fromObject(e.intArrayValue, t + 1);
		}
		if (e.stringArrayValue != null) {
			if (!A.isObject(e.stringArrayValue)) throw F(".WidgetState.stringArrayValue: object expected");
			n.stringArrayValue = U.StringArray.fromObject(e.stringArrayValue, t + 1);
		}
		if (e.jsonValue != null && (n.jsonValue = I(e.jsonValue)), e.arrowValue != null) {
			if (!A.isObject(e.arrowValue)) throw F(".WidgetState.arrowValue: object expected");
			n.arrowValue = U.ArrowTable.fromObject(e.arrowValue, t + 1);
		}
		if (e.bytesValue != null && (typeof e.bytesValue == "string" ? A.base64.decode(e.bytesValue, n.bytesValue = A.newBuffer(A.base64.length(e.bytesValue)), 0) : e.bytesValue.length >= 0 && (n.bytesValue = e.bytesValue)), e.fileUploaderStateValue != null) {
			if (!A.isObject(e.fileUploaderStateValue)) throw F(".WidgetState.fileUploaderStateValue: object expected");
			n.fileUploaderStateValue = U.FileUploaderState.fromObject(e.fileUploaderStateValue, t + 1);
		}
		if (e.stringTriggerValue != null) {
			if (!A.isObject(e.stringTriggerValue)) throw F(".WidgetState.stringTriggerValue: object expected");
			n.stringTriggerValue = U.StringTriggerValue.fromObject(e.stringTriggerValue, t + 1);
		}
		if (e.chatInputValue != null) {
			if (!A.isObject(e.chatInputValue)) throw F(".WidgetState.chatInputValue: object expected");
			n.chatInputValue = U.ChatInputValue.fromObject(e.chatInputValue, t + 1);
		}
		return e.jsonTriggerValue != null && (n.jsonTriggerValue = I(e.jsonTriggerValue)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = ""), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.triggerValue != null && j.hasOwnProperty.call(e, "triggerValue") && (r.triggerValue = e.triggerValue, t.oneofs && (r.value = "triggerValue")), e.boolValue != null && j.hasOwnProperty.call(e, "boolValue") && (r.boolValue = e.boolValue, t.oneofs && (r.value = "boolValue")), e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), e.stringValue != null && j.hasOwnProperty.call(e, "stringValue") && (r.stringValue = e.stringValue, t.oneofs && (r.value = "stringValue")), e.doubleArrayValue != null && j.hasOwnProperty.call(e, "doubleArrayValue") && (r.doubleArrayValue = U.DoubleArray.toObject(e.doubleArrayValue, t, n + 1), t.oneofs && (r.value = "doubleArrayValue")), e.intArrayValue != null && j.hasOwnProperty.call(e, "intArrayValue") && (r.intArrayValue = U.SInt64Array.toObject(e.intArrayValue, t, n + 1), t.oneofs && (r.value = "intArrayValue")), e.stringArrayValue != null && j.hasOwnProperty.call(e, "stringArrayValue") && (r.stringArrayValue = U.StringArray.toObject(e.stringArrayValue, t, n + 1), t.oneofs && (r.value = "stringArrayValue")), e.jsonValue != null && j.hasOwnProperty.call(e, "jsonValue") && (r.jsonValue = e.jsonValue, t.oneofs && (r.value = "jsonValue")), e.arrowValue != null && j.hasOwnProperty.call(e, "arrowValue") && (r.arrowValue = U.ArrowTable.toObject(e.arrowValue, t, n + 1), t.oneofs && (r.value = "arrowValue")), e.bytesValue != null && j.hasOwnProperty.call(e, "bytesValue") && (r.bytesValue = t.bytes === I ? A.base64.encode(e.bytesValue, 0, e.bytesValue.length) : t.bytes === B ? B.prototype.slice.call(e.bytesValue) : e.bytesValue, t.oneofs && (r.value = "bytesValue")), e.fileUploaderStateValue != null && j.hasOwnProperty.call(e, "fileUploaderStateValue") && (r.fileUploaderStateValue = U.FileUploaderState.toObject(e.fileUploaderStateValue, t, n + 1), t.oneofs && (r.value = "fileUploaderStateValue")), e.stringTriggerValue != null && j.hasOwnProperty.call(e, "stringTriggerValue") && (r.stringTriggerValue = U.StringTriggerValue.toObject(e.stringTriggerValue, t, n + 1), t.oneofs && (r.value = "stringTriggerValue")), e.chatInputValue != null && j.hasOwnProperty.call(e, "chatInputValue") && (r.chatInputValue = U.ChatInputValue.toObject(e.chatInputValue, t, n + 1), t.oneofs && (r.value = "chatInputValue")), e.jsonTriggerValue != null && j.hasOwnProperty.call(e, "jsonTriggerValue") && (r.jsonTriggerValue = e.jsonTriggerValue, t.oneofs && (r.value = "jsonTriggerValue")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/WidgetState";
	}, e;
})(), U.StringArray = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length) for (let n = 0; n < e.data.length; ++n) t.uint32(10).string(e.data[n]);
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.StringArray(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.stringVerify());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.StringArray) return e;
		if (!A.isObject(e)) throw F(".StringArray: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.StringArray();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".StringArray.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = I(e.data[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/StringArray";
	}, e;
})(), U.DoubleArray = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length && t.uint32(10).doubles(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DoubleArray(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []), e.doubles(o.data);
						continue;
					}
					if (a !== 1) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.double());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DoubleArray) return e;
		if (!A.isObject(e)) throw F(".DoubleArray: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DoubleArray();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".DoubleArray.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = R(e.data[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let n = 0; n < e.data.length; ++n) r.data[n] = t.json && !z(e.data[n]) ? I(e.data[n]) : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DoubleArray";
	}, e;
})(), U.Int32Array = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length && t.uint32(10).int32s(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Int32Array(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []), e.int32s(o.data);
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.int32());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Int32Array) return e;
		if (!A.isObject(e)) throw F(".Int32Array: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Int32Array();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".Int32Array.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = e.data[t] | 0;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Int32Array";
	}, e;
})(), U.Int64Array = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length && t.uint32(10).int64s(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Int64Array(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []), e.int64s(o.data);
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.int64());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Int64Array) return e;
		if (!A.isObject(e)) throw F(".Int64Array: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Int64Array();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".Int64Array.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) A.Long ? n.data[t] = A.Long.fromValue(e.data[t], !1) : typeof e.data[t] == "string" ? n.data[t] = V(e.data[t], 10) : typeof e.data[t] == "number" ? n.data[t] = e.data[t] : typeof e.data[t] == "object" && (n.data[t] = new A.LongBits(e.data[t].low >>> 0, e.data[t].high >>> 0).toNumber());
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let n = 0; n < e.data.length; ++n) H !== void 0 && t.longs === H ? r.data[n] = typeof e.data[n] == "number" ? H(e.data[n]) : A.Long.fromBits(e.data[n].low >>> 0, e.data[n].high >>> 0, !1).toBigInt() : typeof e.data[n] == "number" ? r.data[n] = t.longs === I ? I(e.data[n]) : e.data[n] : r.data[n] = t.longs === I ? A.Long.prototype.toString.call(e.data[n]) : t.longs === R ? new A.LongBits(e.data[n].low >>> 0, e.data[n].high >>> 0).toNumber() : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Int64Array";
	}, e;
})(), U.SInt64Array = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length && t.uint32(10).sint64s(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SInt64Array(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []), e.sint64s(o.data);
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.sint64());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SInt64Array) return e;
		if (!A.isObject(e)) throw F(".SInt64Array: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SInt64Array();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".SInt64Array.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) A.Long ? n.data[t] = A.Long.fromValue(e.data[t], !1) : typeof e.data[t] == "string" ? n.data[t] = V(e.data[t], 10) : typeof e.data[t] == "number" ? n.data[t] = e.data[t] : typeof e.data[t] == "object" && (n.data[t] = new A.LongBits(e.data[t].low >>> 0, e.data[t].high >>> 0).toNumber());
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let n = 0; n < e.data.length; ++n) H !== void 0 && t.longs === H ? r.data[n] = typeof e.data[n] == "number" ? H(e.data[n]) : A.Long.fromBits(e.data[n].low >>> 0, e.data[n].high >>> 0, !1).toBigInt() : typeof e.data[n] == "number" ? r.data[n] = t.longs === I ? I(e.data[n]) : e.data[n] : r.data[n] = t.longs === I ? A.Long.prototype.toString.call(e.data[n]) : t.longs === R ? new A.LongBits(e.data[n].low >>> 0, e.data[n].high >>> 0).toNumber() : e.data[n];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SInt64Array";
	}, e;
})(), U.UInt32Array = (() => {
	let e = function(e) {
		if (this.data = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && e.data.length && t.uint32(10).uint32s(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.UInt32Array(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a === 2) {
						o.data && o.data.length || (o.data = []), e.uint32s(o.data);
						continue;
					}
					if (a !== 0) break;
					o.data && o.data.length || (o.data = []), o.data.push(e.uint32());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.UInt32Array) return e;
		if (!A.isObject(e)) throw F(".UInt32Array: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.UInt32Array();
		if (e.data) {
			if (!B.isArray(e.data)) throw F(".UInt32Array.data: array expected");
			n.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) n.data[t] = e.data[t] >>> 0;
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.data = []), e.data && e.data.length) {
			r.data = B(e.data.length);
			for (let t = 0; t < e.data.length; ++t) r.data[t] = e.data[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/UInt32Array";
	}, e;
})(), U.StringTriggerValue = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.data = null;
	let t;
	return j.defineProperty(e.prototype, "_data", {
		get: A.oneOfGetter(t = ["data"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && j.hasOwnProperty.call(e, "data") && t.uint32(10).string(e.data), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.StringTriggerValue(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = e.stringVerify(), o._data = "data";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.StringTriggerValue) return e;
		if (!A.isObject(e)) throw F(".StringTriggerValue: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.StringTriggerValue();
		return e.data != null && (n.data = I(e.data)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = e.data), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/StringTriggerValue";
	}, e;
})(), U.FileURLsRequest = (() => {
	let e = function(e) {
		if (this.fileNames = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.requestId = "", e.prototype.fileNames = A.emptyArray, e.prototype.sessionId = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.requestId != null && j.hasOwnProperty.call(e, "requestId") && e.requestId !== "" && t.uint32(10).string(e.requestId), e.fileNames != null && e.fileNames.length) for (let n = 0; n < e.fileNames.length; ++n) t.uint32(18).string(e.fileNames[n]);
		if (e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && e.sessionId !== "" && t.uint32(26).string(e.sessionId), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FileURLsRequest(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.requestId = s : delete o.requestId;
					continue;
				case 2:
					if (a !== 2) break;
					o.fileNames && o.fileNames.length || (o.fileNames = []), o.fileNames.push(e.stringVerify());
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sessionId = s : delete o.sessionId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FileURLsRequest) return e;
		if (!A.isObject(e)) throw F(".FileURLsRequest: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FileURLsRequest();
		if (e.requestId != null && (typeof e.requestId != "string" || e.requestId.length) && (n.requestId = I(e.requestId)), e.fileNames) {
			if (!B.isArray(e.fileNames)) throw F(".FileURLsRequest.fileNames: array expected");
			n.fileNames = B(e.fileNames.length);
			for (let t = 0; t < e.fileNames.length; ++t) n.fileNames[t] = I(e.fileNames[t]);
		}
		return e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = I(e.sessionId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileNames = []), t.defaults && (r.requestId = "", r.sessionId = ""), e.requestId != null && j.hasOwnProperty.call(e, "requestId") && (r.requestId = e.requestId), e.fileNames && e.fileNames.length) {
			r.fileNames = B(e.fileNames.length);
			for (let t = 0; t < e.fileNames.length; ++t) r.fileNames[t] = e.fileNames[t];
		}
		return e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && (r.sessionId = e.sessionId), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FileURLsRequest";
	}, e;
})(), U.FileURLs = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.fileId = "", e.prototype.uploadUrl = "", e.prototype.deleteUrl = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.fileId != null && j.hasOwnProperty.call(e, "fileId") && e.fileId !== "" && t.uint32(10).string(e.fileId), e.uploadUrl != null && j.hasOwnProperty.call(e, "uploadUrl") && e.uploadUrl !== "" && t.uint32(18).string(e.uploadUrl), e.deleteUrl != null && j.hasOwnProperty.call(e, "deleteUrl") && e.deleteUrl !== "" && t.uint32(26).string(e.deleteUrl), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FileURLs(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.uploadUrl = s : delete o.uploadUrl;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.deleteUrl = s : delete o.deleteUrl;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FileURLs) return e;
		if (!A.isObject(e)) throw F(".FileURLs: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FileURLs();
		return e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = I(e.fileId)), e.uploadUrl != null && (typeof e.uploadUrl != "string" || e.uploadUrl.length) && (n.uploadUrl = I(e.uploadUrl)), e.deleteUrl != null && (typeof e.deleteUrl != "string" || e.deleteUrl.length) && (n.deleteUrl = I(e.deleteUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.fileId = "", r.uploadUrl = "", r.deleteUrl = ""), e.fileId != null && j.hasOwnProperty.call(e, "fileId") && (r.fileId = e.fileId), e.uploadUrl != null && j.hasOwnProperty.call(e, "uploadUrl") && (r.uploadUrl = e.uploadUrl), e.deleteUrl != null && j.hasOwnProperty.call(e, "deleteUrl") && (r.deleteUrl = e.deleteUrl), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FileURLs";
	}, e;
})(), U.FileURLsResponse = (() => {
	let e = function(e) {
		if (this.fileUrls = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.responseId = "", e.prototype.fileUrls = A.emptyArray, e.prototype.errorMsg = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.responseId != null && j.hasOwnProperty.call(e, "responseId") && e.responseId !== "" && t.uint32(10).string(e.responseId), e.fileUrls != null && e.fileUrls.length) for (let r = 0; r < e.fileUrls.length; ++r) U.FileURLs.encode(e.fileUrls[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.errorMsg != null && j.hasOwnProperty.call(e, "errorMsg") && e.errorMsg !== "" && t.uint32(26).string(e.errorMsg), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FileURLsResponse(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.responseId = s : delete o.responseId;
					continue;
				case 2:
					if (a !== 2) break;
					o.fileUrls && o.fileUrls.length || (o.fileUrls = []), o.fileUrls.push(U.FileURLs.decode(e, e.uint32(), M, r + 1));
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.errorMsg = s : delete o.errorMsg;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FileURLsResponse) return e;
		if (!A.isObject(e)) throw F(".FileURLsResponse: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FileURLsResponse();
		if (e.responseId != null && (typeof e.responseId != "string" || e.responseId.length) && (n.responseId = I(e.responseId)), e.fileUrls) {
			if (!B.isArray(e.fileUrls)) throw F(".FileURLsResponse.fileUrls: array expected");
			n.fileUrls = B(e.fileUrls.length);
			for (let r = 0; r < e.fileUrls.length; ++r) {
				if (!A.isObject(e.fileUrls[r])) throw F(".FileURLsResponse.fileUrls: object expected");
				n.fileUrls[r] = U.FileURLs.fromObject(e.fileUrls[r], t + 1);
			}
		}
		return e.errorMsg != null && (typeof e.errorMsg != "string" || e.errorMsg.length) && (n.errorMsg = I(e.errorMsg)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileUrls = []), t.defaults && (r.responseId = "", r.errorMsg = ""), e.responseId != null && j.hasOwnProperty.call(e, "responseId") && (r.responseId = e.responseId), e.fileUrls && e.fileUrls.length) {
			r.fileUrls = B(e.fileUrls.length);
			for (let i = 0; i < e.fileUrls.length; ++i) r.fileUrls[i] = U.FileURLs.toObject(e.fileUrls[i], t, n + 1);
		}
		return e.errorMsg != null && j.hasOwnProperty.call(e, "errorMsg") && (r.errorMsg = e.errorMsg), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FileURLsResponse";
	}, e;
})(), U.UploadedFileInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.name = "", e.prototype.size = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.fileId = "", e.prototype.fileUrls = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(18).string(e.name), e.size != null && j.hasOwnProperty.call(e, "size") && (typeof e.size == "object" ? e.size.low || e.size.high : e.size !== 0) && t.uint32(24).uint64(e.size), e.fileId != null && j.hasOwnProperty.call(e, "fileId") && e.fileId !== "" && t.uint32(34).string(e.fileId), e.fileUrls != null && j.hasOwnProperty.call(e, "fileUrls") && U.FileURLs.encode(e.fileUrls, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.UploadedFileInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 3:
					if (a !== 0) break;
					(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.size = s : delete o.size;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fileId = s : delete o.fileId;
					continue;
				case 5:
					if (a !== 2) break;
					o.fileUrls = U.FileURLs.decode(e, e.uint32(), M, r + 1, o.fileUrls);
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.UploadedFileInfo) return e;
		if (!A.isObject(e)) throw F(".UploadedFileInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.UploadedFileInfo();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.size != null && (typeof e.size == "object" ? e.size.low || e.size.high : R(e.size) !== 0) && (A.Long ? n.size = A.Long.fromValue(e.size, !0) : typeof e.size == "string" ? n.size = V(e.size, 10) : typeof e.size == "number" ? n.size = e.size : typeof e.size == "object" && (n.size = new A.LongBits(e.size.low >>> 0, e.size.high >>> 0).toNumber(!0))), e.fileId != null && (typeof e.fileId != "string" || e.fileId.length) && (n.fileId = I(e.fileId)), e.fileUrls != null) {
			if (!A.isObject(e.fileUrls)) throw F(".UploadedFileInfo.fileUrls: object expected");
			n.fileUrls = U.FileURLs.fromObject(e.fileUrls, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if (t.defaults) {
			if (r.name = "", A.Long) {
				let e = new A.Long(0, 0, !0);
				r.size = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.size = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.fileId = "", r.fileUrls = null;
		}
		return e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.size != null && j.hasOwnProperty.call(e, "size") && (r.size = H !== void 0 && t.longs === H ? typeof e.size == "number" ? H(e.size) : A.Long.fromBits(e.size.low >>> 0, e.size.high >>> 0, !0).toBigInt() : typeof e.size == "number" ? t.longs === I ? I(e.size) : e.size : t.longs === I ? A.Long.prototype.toString.call(e.size) : t.longs === R ? new A.LongBits(e.size.low >>> 0, e.size.high >>> 0).toNumber(!0) : e.size), e.fileId != null && j.hasOwnProperty.call(e, "fileId") && (r.fileId = e.fileId), e.fileUrls != null && j.hasOwnProperty.call(e, "fileUrls") && (r.fileUrls = U.FileURLs.toObject(e.fileUrls, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/UploadedFileInfo";
	}, e;
})(), U.FileUploaderState = (() => {
	let e = function(e) {
		if (this.uploadedFileInfo = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.uploadedFileInfo = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.uploadedFileInfo != null && e.uploadedFileInfo.length) for (let r = 0; r < e.uploadedFileInfo.length; ++r) U.UploadedFileInfo.encode(e.uploadedFileInfo[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FileUploaderState(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 2) break;
					o.uploadedFileInfo && o.uploadedFileInfo.length || (o.uploadedFileInfo = []), o.uploadedFileInfo.push(U.UploadedFileInfo.decode(e, e.uint32(), M, r + 1));
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FileUploaderState) return e;
		if (!A.isObject(e)) throw F(".FileUploaderState: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FileUploaderState();
		if (e.uploadedFileInfo) {
			if (!B.isArray(e.uploadedFileInfo)) throw F(".FileUploaderState.uploadedFileInfo: array expected");
			n.uploadedFileInfo = B(e.uploadedFileInfo.length);
			for (let r = 0; r < e.uploadedFileInfo.length; ++r) {
				if (!A.isObject(e.uploadedFileInfo[r])) throw F(".FileUploaderState.uploadedFileInfo: object expected");
				n.uploadedFileInfo[r] = U.UploadedFileInfo.fromObject(e.uploadedFileInfo[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.uploadedFileInfo = []), e.uploadedFileInfo && e.uploadedFileInfo.length) {
			r.uploadedFileInfo = B(e.uploadedFileInfo.length);
			for (let i = 0; i < e.uploadedFileInfo.length; ++i) r.uploadedFileInfo[i] = U.UploadedFileInfo.toObject(e.uploadedFileInfo[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FileUploaderState";
	}, e;
})(), U.ChatInputValue = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.data = null, e.prototype.fileUploaderState = null, e.prototype.audioFileInfo = null;
	let t;
	return j.defineProperty(e.prototype, "_data", {
		get: A.oneOfGetter(t = ["data"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_fileUploaderState", {
		get: A.oneOfGetter(t = ["fileUploaderState"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_audioFileInfo", {
		get: A.oneOfGetter(t = ["audioFileInfo"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && j.hasOwnProperty.call(e, "data") && t.uint32(10).string(e.data), e.fileUploaderState != null && j.hasOwnProperty.call(e, "fileUploaderState") && U.FileUploaderState.encode(e.fileUploaderState, t.uint32(18).fork(), n + 1).ldelim(), e.audioFileInfo != null && j.hasOwnProperty.call(e, "audioFileInfo") && U.UploadedFileInfo.encode(e.audioFileInfo, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ChatInputValue(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = e.stringVerify(), o._data = "data";
					continue;
				case 2:
					if (a !== 2) break;
					o.fileUploaderState = U.FileUploaderState.decode(e, e.uint32(), M, r + 1, o.fileUploaderState), o._fileUploaderState = "fileUploaderState";
					continue;
				case 3:
					if (a !== 2) break;
					o.audioFileInfo = U.UploadedFileInfo.decode(e, e.uint32(), M, r + 1, o.audioFileInfo), o._audioFileInfo = "audioFileInfo";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ChatInputValue) return e;
		if (!A.isObject(e)) throw F(".ChatInputValue: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ChatInputValue();
		if (e.data != null && (n.data = I(e.data)), e.fileUploaderState != null) {
			if (!A.isObject(e.fileUploaderState)) throw F(".ChatInputValue.fileUploaderState: object expected");
			n.fileUploaderState = U.FileUploaderState.fromObject(e.fileUploaderState, t + 1);
		}
		if (e.audioFileInfo != null) {
			if (!A.isObject(e.audioFileInfo)) throw F(".ChatInputValue.audioFileInfo: object expected");
			n.audioFileInfo = U.UploadedFileInfo.fromObject(e.audioFileInfo, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = e.data), e.fileUploaderState != null && j.hasOwnProperty.call(e, "fileUploaderState") && (r.fileUploaderState = U.FileUploaderState.toObject(e.fileUploaderState, t, n + 1)), e.audioFileInfo != null && j.hasOwnProperty.call(e, "audioFileInfo") && (r.audioFileInfo = U.UploadedFileInfo.toObject(e.audioFileInfo, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ChatInputValue";
	}, e;
})(), U.ComponentInstance = (() => {
	let e = function(e) {
		if (this.specialArgs = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.jsonArgs = "", e.prototype.specialArgs = A.emptyArray, e.prototype.componentName = "", e.prototype.url = "", e.prototype.formId = "", e.prototype.tabIndex = null;
	let t;
	return j.defineProperty(e.prototype, "_tabIndex", {
		get: A.oneOfGetter(t = ["tabIndex"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.jsonArgs != null && j.hasOwnProperty.call(e, "jsonArgs") && e.jsonArgs !== "" && t.uint32(18).string(e.jsonArgs), e.specialArgs != null && e.specialArgs.length) for (let r = 0; r < e.specialArgs.length; ++r) U.SpecialArg.encode(e.specialArgs[r], t.uint32(26).fork(), n + 1).ldelim();
		if (e.componentName != null && j.hasOwnProperty.call(e, "componentName") && e.componentName !== "" && t.uint32(34).string(e.componentName), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(42).string(e.url), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.tabIndex != null && j.hasOwnProperty.call(e, "tabIndex") && t.uint32(56).int32(e.tabIndex), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ComponentInstance(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.jsonArgs = s : delete o.jsonArgs;
					continue;
				case 3:
					if (a !== 2) break;
					o.specialArgs && o.specialArgs.length || (o.specialArgs = []), o.specialArgs.push(U.SpecialArg.decode(e, e.uint32(), M, r + 1));
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.componentName = s : delete o.componentName;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 7:
					if (a !== 0) break;
					o.tabIndex = e.int32(), o._tabIndex = "tabIndex";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ComponentInstance) return e;
		if (!A.isObject(e)) throw F(".ComponentInstance: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ComponentInstance();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.jsonArgs != null && (typeof e.jsonArgs != "string" || e.jsonArgs.length) && (n.jsonArgs = I(e.jsonArgs)), e.specialArgs) {
			if (!B.isArray(e.specialArgs)) throw F(".ComponentInstance.specialArgs: array expected");
			n.specialArgs = B(e.specialArgs.length);
			for (let r = 0; r < e.specialArgs.length; ++r) {
				if (!A.isObject(e.specialArgs[r])) throw F(".ComponentInstance.specialArgs: object expected");
				n.specialArgs[r] = U.SpecialArg.fromObject(e.specialArgs[r], t + 1);
			}
		}
		return e.componentName != null && (typeof e.componentName != "string" || e.componentName.length) && (n.componentName = I(e.componentName)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.tabIndex != null && (n.tabIndex = e.tabIndex | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.specialArgs = []), t.defaults && (r.id = "", r.jsonArgs = "", r.componentName = "", r.url = "", r.formId = ""), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.jsonArgs != null && j.hasOwnProperty.call(e, "jsonArgs") && (r.jsonArgs = e.jsonArgs), e.specialArgs && e.specialArgs.length) {
			r.specialArgs = B(e.specialArgs.length);
			for (let i = 0; i < e.specialArgs.length; ++i) r.specialArgs[i] = U.SpecialArg.toObject(e.specialArgs[i], t, n + 1);
		}
		return e.componentName != null && j.hasOwnProperty.call(e, "componentName") && (r.componentName = e.componentName), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.tabIndex != null && j.hasOwnProperty.call(e, "tabIndex") && (r.tabIndex = e.tabIndex), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ComponentInstance";
	}, e;
})(), U.SpecialArg = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.key = "", e.prototype.arrowDataframe = null, e.prototype.bytes = null;
	let t;
	return j.defineProperty(e.prototype, "value", {
		get: A.oneOfGetter(t = ["arrowDataframe", "bytes"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.key != null && j.hasOwnProperty.call(e, "key") && e.key !== "" && t.uint32(10).string(e.key), e.arrowDataframe != null && j.hasOwnProperty.call(e, "arrowDataframe") && U.ArrowDataframe.encode(e.arrowDataframe, t.uint32(18).fork(), n + 1).ldelim(), e.bytes != null && j.hasOwnProperty.call(e, "bytes") && t.uint32(26).bytes(e.bytes), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SpecialArg(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.key = s : delete o.key;
					continue;
				case 2:
					if (a !== 2) break;
					o.arrowDataframe = U.ArrowDataframe.decode(e, e.uint32(), M, r + 1, o.arrowDataframe), o.value = "arrowDataframe";
					continue;
				case 3:
					if (a !== 2) break;
					o.bytes = e.bytes(), o.value = "bytes";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SpecialArg) return e;
		if (!A.isObject(e)) throw F(".SpecialArg: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SpecialArg();
		if (e.key != null && (typeof e.key != "string" || e.key.length) && (n.key = I(e.key)), e.arrowDataframe != null) {
			if (!A.isObject(e.arrowDataframe)) throw F(".SpecialArg.arrowDataframe: object expected");
			n.arrowDataframe = U.ArrowDataframe.fromObject(e.arrowDataframe, t + 1);
		}
		return e.bytes != null && (typeof e.bytes == "string" ? A.base64.decode(e.bytes, n.bytes = A.newBuffer(A.base64.length(e.bytes)), 0) : e.bytes.length >= 0 && (n.bytes = e.bytes)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.key = ""), e.key != null && j.hasOwnProperty.call(e, "key") && (r.key = e.key), e.arrowDataframe != null && j.hasOwnProperty.call(e, "arrowDataframe") && (r.arrowDataframe = U.ArrowDataframe.toObject(e.arrowDataframe, t, n + 1), t.oneofs && (r.value = "arrowDataframe")), e.bytes != null && j.hasOwnProperty.call(e, "bytes") && (r.bytes = t.bytes === I ? A.base64.encode(e.bytes, 0, e.bytes.length) : t.bytes === B ? B.prototype.slice.call(e.bytes) : e.bytes, t.oneofs && (r.value = "bytes")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SpecialArg";
	}, e;
})(), U.ArrowDataframe = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = null, e.prototype.height = 0, e.prototype.width = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && j.hasOwnProperty.call(e, "data") && U.ArrowTable.encode(e.data, t.uint32(10).fork(), n + 1).ldelim(), e.height != null && j.hasOwnProperty.call(e, "height") && e.height !== 0 && t.uint32(16).uint32(e.height), e.width != null && j.hasOwnProperty.call(e, "width") && e.width !== 0 && t.uint32(24).uint32(e.width), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ArrowDataframe(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.data = U.ArrowTable.decode(e, e.uint32(), M, r + 1, o.data);
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.uint32()) ? o.height = s : delete o.height;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.width = s : delete o.width;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ArrowDataframe) return e;
		if (!A.isObject(e)) throw F(".ArrowDataframe: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ArrowDataframe();
		if (e.data != null) {
			if (!A.isObject(e.data)) throw F(".ArrowDataframe.data: object expected");
			n.data = U.ArrowTable.fromObject(e.data, t + 1);
		}
		return e.height != null && R(e.height) !== 0 && (n.height = e.height >>> 0), e.width != null && R(e.width) !== 0 && (n.width = e.width >>> 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.data = null, r.height = 0, r.width = 0), e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = U.ArrowTable.toObject(e.data, t, n + 1)), e.height != null && j.hasOwnProperty.call(e, "height") && (r.height = e.height), e.width != null && j.hasOwnProperty.call(e, "width") && (r.width = e.width), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ArrowDataframe";
	}, e;
})(), U.ArrowTable = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.data = A.newBuffer([]), e.prototype.index = A.newBuffer([]), e.prototype.columns = A.newBuffer([]), e.prototype.styler = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.data != null && j.hasOwnProperty.call(e, "data") && e.data.length && t.uint32(10).bytes(e.data), e.index != null && j.hasOwnProperty.call(e, "index") && e.index.length && t.uint32(18).bytes(e.index), e.columns != null && j.hasOwnProperty.call(e, "columns") && e.columns.length && t.uint32(26).bytes(e.columns), e.styler != null && j.hasOwnProperty.call(e, "styler") && U.ArrowTableStyler.encode(e.styler, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ArrowTable(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.data = s : delete o.data;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.index = s : delete o.index;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.columns = s : delete o.columns;
					continue;
				case 5:
					if (a !== 2) break;
					o.styler = U.ArrowTableStyler.decode(e, e.uint32(), M, r + 1, o.styler);
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ArrowTable) return e;
		if (!A.isObject(e)) throw F(".ArrowTable: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ArrowTable();
		if (e.data != null && e.data.length && (typeof e.data == "string" ? A.base64.decode(e.data, n.data = A.newBuffer(A.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.index != null && e.index.length && (typeof e.index == "string" ? A.base64.decode(e.index, n.index = A.newBuffer(A.base64.length(e.index)), 0) : e.index.length >= 0 && (n.index = e.index)), e.columns != null && e.columns.length && (typeof e.columns == "string" ? A.base64.decode(e.columns, n.columns = A.newBuffer(A.base64.length(e.columns)), 0) : e.columns.length >= 0 && (n.columns = e.columns)), e.styler != null) {
			if (!A.isObject(e.styler)) throw F(".ArrowTable.styler: object expected");
			n.styler = U.ArrowTableStyler.fromObject(e.styler, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (t.bytes === I ? r.data = "" : (r.data = [], t.bytes !== B && (r.data = A.newBuffer(r.data))), t.bytes === I ? r.index = "" : (r.index = [], t.bytes !== B && (r.index = A.newBuffer(r.index))), t.bytes === I ? r.columns = "" : (r.columns = [], t.bytes !== B && (r.columns = A.newBuffer(r.columns))), r.styler = null), e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = t.bytes === I ? A.base64.encode(e.data, 0, e.data.length) : t.bytes === B ? B.prototype.slice.call(e.data) : e.data), e.index != null && j.hasOwnProperty.call(e, "index") && (r.index = t.bytes === I ? A.base64.encode(e.index, 0, e.index.length) : t.bytes === B ? B.prototype.slice.call(e.index) : e.index), e.columns != null && j.hasOwnProperty.call(e, "columns") && (r.columns = t.bytes === I ? A.base64.encode(e.columns, 0, e.columns.length) : t.bytes === B ? B.prototype.slice.call(e.columns) : e.columns), e.styler != null && j.hasOwnProperty.call(e, "styler") && (r.styler = U.ArrowTableStyler.toObject(e.styler, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ArrowTable";
	}, e;
})(), U.ArrowTableStyler = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.uuid = "", e.prototype.caption = "", e.prototype.styles = "", e.prototype.displayValues = A.newBuffer([]), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.uuid != null && j.hasOwnProperty.call(e, "uuid") && e.uuid !== "" && t.uint32(10).string(e.uuid), e.caption != null && j.hasOwnProperty.call(e, "caption") && e.caption !== "" && t.uint32(18).string(e.caption), e.styles != null && j.hasOwnProperty.call(e, "styles") && e.styles !== "" && t.uint32(26).string(e.styles), e.displayValues != null && j.hasOwnProperty.call(e, "displayValues") && e.displayValues.length && t.uint32(34).bytes(e.displayValues), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ArrowTableStyler(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.uuid = s : delete o.uuid;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.caption = s : delete o.caption;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.styles = s : delete o.styles;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.bytes()).length ? o.displayValues = s : delete o.displayValues;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ArrowTableStyler) return e;
		if (!A.isObject(e)) throw F(".ArrowTableStyler: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ArrowTableStyler();
		return e.uuid != null && (typeof e.uuid != "string" || e.uuid.length) && (n.uuid = I(e.uuid)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = I(e.caption)), e.styles != null && (typeof e.styles != "string" || e.styles.length) && (n.styles = I(e.styles)), e.displayValues != null && e.displayValues.length && (typeof e.displayValues == "string" ? A.base64.decode(e.displayValues, n.displayValues = A.newBuffer(A.base64.length(e.displayValues)), 0) : e.displayValues.length >= 0 && (n.displayValues = e.displayValues)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.uuid = "", r.caption = "", r.styles = "", t.bytes === I ? r.displayValues = "" : (r.displayValues = [], t.bytes !== B && (r.displayValues = A.newBuffer(r.displayValues)))), e.uuid != null && j.hasOwnProperty.call(e, "uuid") && (r.uuid = e.uuid), e.caption != null && j.hasOwnProperty.call(e, "caption") && (r.caption = e.caption), e.styles != null && j.hasOwnProperty.call(e, "styles") && (r.styles = e.styles), e.displayValues != null && j.hasOwnProperty.call(e, "displayValues") && (r.displayValues = t.bytes === I ? A.base64.encode(e.displayValues, 0, e.displayValues.length) : t.bytes === B ? B.prototype.slice.call(e.displayValues) : e.displayValues), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ArrowTableStyler";
	}, e;
})(), U.Dataframe = (() => {
	let e = function(e) {
		if (this.columnOrder = [], this.selectionMode = [], this.buttonClickWidgets = {}, e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.arrowData = null, e.prototype.id = "", e.prototype.columns = "", e.prototype.editingMode = 0, e.prototype.disabled = !1, e.prototype.formId = "", e.prototype.columnOrder = A.emptyArray, e.prototype.selectionMode = A.emptyArray, e.prototype.rowHeight = null, e.prototype.placeholder = null, e.prototype.selectionState = null, e.prototype.selectionDefault = null, e.prototype.buttonClickWidgets = A.emptyObject, e.prototype.lazyData = null, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_rowHeight", {
		get: A.oneOfGetter(t = ["rowHeight"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_placeholder", {
		get: A.oneOfGetter(t = ["placeholder"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_selectionState", {
		get: A.oneOfGetter(t = ["selectionState"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_selectionDefault", {
		get: A.oneOfGetter(t = ["selectionDefault"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_lazyData", {
		get: A.oneOfGetter(t = ["lazyData"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && U.ArrowData.encode(e.arrowData, t.uint32(10).fork(), n + 1).ldelim(), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(18).string(e.id), e.columns != null && j.hasOwnProperty.call(e, "columns") && e.columns !== "" && t.uint32(26).string(e.columns), e.editingMode != null && j.hasOwnProperty.call(e, "editingMode") && e.editingMode !== 0 && t.uint32(32).int32(e.editingMode), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(40).bool(e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.columnOrder != null && e.columnOrder.length) for (let n = 0; n < e.columnOrder.length; ++n) t.uint32(58).string(e.columnOrder[n]);
		if (e.selectionMode != null && e.selectionMode.length && t.uint32(66).int32s(e.selectionMode), e.rowHeight != null && j.hasOwnProperty.call(e, "rowHeight") && t.uint32(72).uint32(e.rowHeight), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && t.uint32(82).string(e.placeholder), e.selectionState != null && j.hasOwnProperty.call(e, "selectionState") && t.uint32(90).string(e.selectionState), e.selectionDefault != null && j.hasOwnProperty.call(e, "selectionDefault") && t.uint32(98).string(e.selectionDefault), e.buttonClickWidgets != null && j.hasOwnProperty.call(e, "buttonClickWidgets")) for (let n = j.keys(e.buttonClickWidgets), r = 0; r < n.length; ++r) t.uint32(106).fork().uint32(10).string(n[r]).uint32(18).string(e.buttonClickWidgets[n[r]]).ldelim();
		if (e.lazyData != null && j.hasOwnProperty.call(e, "lazyData") && U.LazyDataframe.encode(e.lazyData, t.uint32(114).fork(), n + 1).ldelim(), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(122).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s, c;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Dataframe(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let l = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (l !== 2) break;
					o.arrowData = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.arrowData);
					continue;
				case 2:
					if (l !== 2) break;
					(c = e.stringVerify()).length ? o.id = c : delete o.id;
					continue;
				case 3:
					if (l !== 2) break;
					(c = e.stringVerify()).length ? o.columns = c : delete o.columns;
					continue;
				case 4:
					if (l !== 0) break;
					(c = e.int32()) ? o.editingMode = c : delete o.editingMode;
					continue;
				case 5:
					if (l !== 0) break;
					(c = e.bool()) ? o.disabled = c : delete o.disabled;
					continue;
				case 6:
					if (l !== 2) break;
					(c = e.stringVerify()).length ? o.formId = c : delete o.formId;
					continue;
				case 7:
					if (l !== 2) break;
					o.columnOrder && o.columnOrder.length || (o.columnOrder = []), o.columnOrder.push(e.stringVerify());
					continue;
				case 8:
					if (l === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []), e.int32s(o.selectionMode);
						continue;
					}
					if (l !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 9:
					if (l !== 0) break;
					o.rowHeight = e.uint32(), o._rowHeight = "rowHeight";
					continue;
				case 10:
					if (l !== 2) break;
					o.placeholder = e.stringVerify(), o._placeholder = "placeholder";
					continue;
				case 11:
					if (l !== 2) break;
					o.selectionState = e.stringVerify(), o._selectionState = "selectionState";
					continue;
				case 12:
					if (l !== 2) break;
					o.selectionDefault = e.stringVerify(), o._selectionDefault = "selectionDefault";
					continue;
				case 13: {
					if (l !== 2) break;
					o.buttonClickWidgets === A.emptyObject && (o.buttonClickWidgets = {});
					let t = e.uint32() + e.pos;
					if (t > e.len) throw P("index out of range");
					for (e.len = t, s = "", c = ""; e.pos < t;) {
						let t = e.tag();
						switch (l = t & 7, t >>>= 3) {
							case 1:
								if (l !== 2) break;
								s = e.stringVerify();
								continue;
							case 2:
								if (l !== 2) break;
								c = e.stringVerify();
								continue;
						}
						e.skipType(l, r, t);
					}
					if (e.pos !== t) throw P("index out of range");
					e.len = a, s === "__proto__" && A.makeProp(o.buttonClickWidgets, s), o.buttonClickWidgets[s] = c;
					continue;
				}
				case 14:
					if (l !== 2) break;
					o.lazyData = U.LazyDataframe.decode(e, e.uint32(), M, r + 1, o.lazyData), o._lazyData = "lazyData";
					continue;
				case 15:
					if (l !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(l, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Dataframe) return e;
		if (!A.isObject(e)) throw F(".Dataframe: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Dataframe();
		if (e.arrowData != null) {
			if (!A.isObject(e.arrowData)) throw F(".Dataframe.arrowData: object expected");
			n.arrowData = U.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.columns != null && (typeof e.columns != "string" || e.columns.length) && (n.columns = I(e.columns)), e.editingMode !== 0 && (typeof e.editingMode != "string" || U.Dataframe.EditingMode[e.editingMode] !== 0)) switch (e.editingMode) {
			case "READ_ONLY":
			case 0:
				n.editingMode = 0;
				break;
			case "FIXED":
			case 1:
				n.editingMode = 1;
				break;
			case "DYNAMIC":
			case 2:
				n.editingMode = 2;
				break;
			case "ADD_ONLY":
			case 3:
				n.editingMode = 3;
				break;
			case "DELETE_ONLY":
			case 4:
				n.editingMode = 4;
				break;
			default: typeof e.editingMode == "number" && (e.editingMode | 0) === e.editingMode && (n.editingMode = e.editingMode);
		}
		if (e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.columnOrder) {
			if (!B.isArray(e.columnOrder)) throw F(".Dataframe.columnOrder: array expected");
			n.columnOrder = B(e.columnOrder.length);
			for (let t = 0; t < e.columnOrder.length; ++t) n.columnOrder[t] = I(e.columnOrder[t]);
		}
		if (e.selectionMode) {
			if (!B.isArray(e.selectionMode)) throw F(".Dataframe.selectionMode: array expected");
			n.selectionMode = [];
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				case "SINGLE_ROW":
				case 0:
					n.selectionMode[n.selectionMode.length] = 0;
					break;
				case "MULTI_ROW":
				case 1:
					n.selectionMode[n.selectionMode.length] = 1;
					break;
				case "SINGLE_COLUMN":
				case 2:
					n.selectionMode[n.selectionMode.length] = 2;
					break;
				case "MULTI_COLUMN":
				case 3:
					n.selectionMode[n.selectionMode.length] = 3;
					break;
				case "SINGLE_CELL":
				case 4:
					n.selectionMode[n.selectionMode.length] = 4;
					break;
				case "MULTI_CELL":
				case 5:
					n.selectionMode[n.selectionMode.length] = 5;
					break;
				case "SINGLE_ROW_REQUIRED":
				case 6:
					n.selectionMode[n.selectionMode.length] = 6;
					break;
				default: typeof e.selectionMode[t] == "number" && (e.selectionMode[t] | 0) === e.selectionMode[t] && (n.selectionMode[n.selectionMode.length] = e.selectionMode[t]);
			}
		}
		if (e.rowHeight != null && (n.rowHeight = e.rowHeight >>> 0), e.placeholder != null && (n.placeholder = I(e.placeholder)), e.selectionState != null && (n.selectionState = I(e.selectionState)), e.selectionDefault != null && (n.selectionDefault = I(e.selectionDefault)), e.buttonClickWidgets) {
			if (!A.isObject(e.buttonClickWidgets)) throw F(".Dataframe.buttonClickWidgets: object expected");
			n.buttonClickWidgets = {};
			for (let t = j.keys(e.buttonClickWidgets), r = 0; r < t.length; ++r) t[r] === "__proto__" && A.makeProp(n.buttonClickWidgets, t[r]), n.buttonClickWidgets[t[r]] = I(e.buttonClickWidgets[t[r]]);
		}
		if (e.lazyData != null) {
			if (!A.isObject(e.lazyData)) throw F(".Dataframe.lazyData: object expected");
			n.lazyData = U.LazyDataframe.fromObject(e.lazyData, t + 1);
		}
		return e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.columnOrder = [], r.selectionMode = []), (t.objects || t.defaults) && (r.buttonClickWidgets = {}), t.defaults && (r.arrowData = null, r.id = "", r.columns = "", r.editingMode = t.enums === I ? "READ_ONLY" : 0, r.disabled = !1, r.formId = ""), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && (r.arrowData = U.ArrowData.toObject(e.arrowData, t, n + 1)), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.columns != null && j.hasOwnProperty.call(e, "columns") && (r.columns = e.columns), e.editingMode != null && j.hasOwnProperty.call(e, "editingMode") && (r.editingMode = t.enums === I ? U.Dataframe.EditingMode[e.editingMode] === M ? e.editingMode : U.Dataframe.EditingMode[e.editingMode] : e.editingMode), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.columnOrder && e.columnOrder.length) {
			r.columnOrder = B(e.columnOrder.length);
			for (let t = 0; t < e.columnOrder.length; ++t) r.columnOrder[t] = e.columnOrder[t];
		}
		if (e.selectionMode && e.selectionMode.length) {
			r.selectionMode = B(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === I ? U.Dataframe.SelectionMode[e.selectionMode[n]] === M ? e.selectionMode[n] : U.Dataframe.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		e.rowHeight != null && j.hasOwnProperty.call(e, "rowHeight") && (r.rowHeight = e.rowHeight), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.selectionState != null && j.hasOwnProperty.call(e, "selectionState") && (r.selectionState = e.selectionState), e.selectionDefault != null && j.hasOwnProperty.call(e, "selectionDefault") && (r.selectionDefault = e.selectionDefault);
		let i;
		if (e.buttonClickWidgets && (i = j.keys(e.buttonClickWidgets)).length) {
			r.buttonClickWidgets = {};
			for (let t = 0; t < i.length; ++t) i[t] === "__proto__" && A.makeProp(r.buttonClickWidgets, i[t]), r.buttonClickWidgets[i[t]] = e.buttonClickWidgets[i[t]];
		}
		return e.lazyData != null && j.hasOwnProperty.call(e, "lazyData") && (r.lazyData = U.LazyDataframe.toObject(e.lazyData, t, n + 1)), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Dataframe";
	}, e.EditingMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "READ_ONLY"] = 0, t[e[1] = "FIXED"] = 1, t[e[2] = "DYNAMIC"] = 2, t[e[3] = "ADD_ONLY"] = 3, t[e[4] = "DELETE_ONLY"] = 4, t;
	})(), e.SelectionMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SINGLE_ROW"] = 0, t[e[1] = "MULTI_ROW"] = 1, t[e[2] = "SINGLE_COLUMN"] = 2, t[e[3] = "MULTI_COLUMN"] = 3, t[e[4] = "SINGLE_CELL"] = 4, t[e[5] = "MULTI_CELL"] = 5, t[e[6] = "SINGLE_ROW_REQUIRED"] = 6, t;
	})(), e;
})(), U.LazyDataframe = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.sourceId = "", e.prototype.rowCount = null, e.prototype.pageSize = 0, e.prototype.accessMode = 0, e.prototype.initialChunk = null, e.prototype.sortable = !1;
	let t;
	return j.defineProperty(e.prototype, "_rowCount", {
		get: A.oneOfGetter(t = ["rowCount"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && e.sourceId !== "" && t.uint32(10).string(e.sourceId), e.rowCount != null && j.hasOwnProperty.call(e, "rowCount") && t.uint32(16).uint64(e.rowCount), e.pageSize != null && j.hasOwnProperty.call(e, "pageSize") && e.pageSize !== 0 && t.uint32(24).uint32(e.pageSize), e.accessMode != null && j.hasOwnProperty.call(e, "accessMode") && e.accessMode !== 0 && t.uint32(32).int32(e.accessMode), e.initialChunk != null && j.hasOwnProperty.call(e, "initialChunk") && U.ArrowData.encode(e.initialChunk, t.uint32(42).fork(), n + 1).ldelim(), e.sortable != null && j.hasOwnProperty.call(e, "sortable") && e.sortable !== !1 && t.uint32(48).bool(e.sortable), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.LazyDataframe(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sourceId = s : delete o.sourceId;
					continue;
				case 2:
					if (a !== 0) break;
					o.rowCount = e.uint64(), o._rowCount = "rowCount";
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.pageSize = s : delete o.pageSize;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.accessMode = s : delete o.accessMode;
					continue;
				case 5:
					if (a !== 2) break;
					o.initialChunk = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.initialChunk);
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.sortable = s : delete o.sortable;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.LazyDataframe) return e;
		if (!A.isObject(e)) throw F(".LazyDataframe: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.LazyDataframe();
		if (e.sourceId != null && (typeof e.sourceId != "string" || e.sourceId.length) && (n.sourceId = I(e.sourceId)), e.rowCount != null && (A.Long ? n.rowCount = A.Long.fromValue(e.rowCount, !0) : typeof e.rowCount == "string" ? n.rowCount = V(e.rowCount, 10) : typeof e.rowCount == "number" ? n.rowCount = e.rowCount : typeof e.rowCount == "object" && (n.rowCount = new A.LongBits(e.rowCount.low >>> 0, e.rowCount.high >>> 0).toNumber(!0))), e.pageSize != null && R(e.pageSize) !== 0 && (n.pageSize = e.pageSize >>> 0), e.accessMode !== 0 && (typeof e.accessMode != "string" || U.LazyDataframe.AccessMode[e.accessMode] !== 0)) switch (e.accessMode) {
			case "ACCESS_MODE_UNSPECIFIED":
			case 0:
				n.accessMode = 0;
				break;
			case "RANDOM_ACCESS":
			case 1:
				n.accessMode = 1;
				break;
			case "SEQUENTIAL":
			case 2:
				n.accessMode = 2;
				break;
			default: typeof e.accessMode == "number" && (e.accessMode | 0) === e.accessMode && (n.accessMode = e.accessMode);
		}
		if (e.initialChunk != null) {
			if (!A.isObject(e.initialChunk)) throw F(".LazyDataframe.initialChunk: object expected");
			n.initialChunk = U.ArrowData.fromObject(e.initialChunk, t + 1);
		}
		return e.sortable != null && e.sortable && (n.sortable = L(e.sortable)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.sourceId = "", r.pageSize = 0, r.accessMode = t.enums === I ? "ACCESS_MODE_UNSPECIFIED" : 0, r.initialChunk = null, r.sortable = !1), e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && (r.sourceId = e.sourceId), e.rowCount != null && j.hasOwnProperty.call(e, "rowCount") && (r.rowCount = H !== void 0 && t.longs === H ? typeof e.rowCount == "number" ? H(e.rowCount) : A.Long.fromBits(e.rowCount.low >>> 0, e.rowCount.high >>> 0, !0).toBigInt() : typeof e.rowCount == "number" ? t.longs === I ? I(e.rowCount) : e.rowCount : t.longs === I ? A.Long.prototype.toString.call(e.rowCount) : t.longs === R ? new A.LongBits(e.rowCount.low >>> 0, e.rowCount.high >>> 0).toNumber(!0) : e.rowCount), e.pageSize != null && j.hasOwnProperty.call(e, "pageSize") && (r.pageSize = e.pageSize), e.accessMode != null && j.hasOwnProperty.call(e, "accessMode") && (r.accessMode = t.enums === I ? U.LazyDataframe.AccessMode[e.accessMode] === M ? e.accessMode : U.LazyDataframe.AccessMode[e.accessMode] : e.accessMode), e.initialChunk != null && j.hasOwnProperty.call(e, "initialChunk") && (r.initialChunk = U.ArrowData.toObject(e.initialChunk, t, n + 1)), e.sortable != null && j.hasOwnProperty.call(e, "sortable") && (r.sortable = e.sortable), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/LazyDataframe";
	}, e.AccessMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "ACCESS_MODE_UNSPECIFIED"] = 0, t[e[1] = "RANDOM_ACCESS"] = 1, t[e[2] = "SEQUENTIAL"] = 2, t;
	})(), e;
})(), U.SortState = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.column = "", e.prototype.direction = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.column != null && j.hasOwnProperty.call(e, "column") && e.column !== "" && t.uint32(10).string(e.column), e.direction != null && j.hasOwnProperty.call(e, "direction") && e.direction !== 0 && t.uint32(16).int32(e.direction), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SortState(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.column = s : delete o.column;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.direction = s : delete o.direction;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SortState) return e;
		if (!A.isObject(e)) throw F(".SortState: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SortState();
		if (e.column != null && (typeof e.column != "string" || e.column.length) && (n.column = I(e.column)), e.direction !== 0 && (typeof e.direction != "string" || U.SortState.SortDirection[e.direction] !== 0)) switch (e.direction) {
			case "SORT_DIRECTION_UNSPECIFIED":
			case 0:
				n.direction = 0;
				break;
			case "ASCENDING":
			case 1:
				n.direction = 1;
				break;
			case "DESCENDING":
			case 2:
				n.direction = 2;
				break;
			default: typeof e.direction == "number" && (e.direction | 0) === e.direction && (n.direction = e.direction);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.column = "", r.direction = t.enums === I ? "SORT_DIRECTION_UNSPECIFIED" : 0), e.column != null && j.hasOwnProperty.call(e, "column") && (r.column = e.column), e.direction != null && j.hasOwnProperty.call(e, "direction") && (r.direction = t.enums === I ? U.SortState.SortDirection[e.direction] === M ? e.direction : U.SortState.SortDirection[e.direction] : e.direction), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SortState";
	}, e.SortDirection = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SORT_DIRECTION_UNSPECIFIED"] = 0, t[e[1] = "ASCENDING"] = 1, t[e[2] = "DESCENDING"] = 2, t;
	})(), e;
})(), U.Balloons = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.show = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.show != null && j.hasOwnProperty.call(e, "show") && e.show !== !1 && t.uint32(24).bool(e.show), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Balloons(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.show = s : delete o.show;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Balloons) return e;
		if (!A.isObject(e)) throw F(".Balloons: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Balloons();
		return e.show != null && e.show && (n.show = L(e.show)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.show = !1), e.show != null && j.hasOwnProperty.call(e, "show") && (r.show = e.show), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Balloons";
	}, e;
})(), U.MixedData = (() => {
	let e = function(e) {
		if (this.arrowBlobs = {}, e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.json = "", e.prototype.arrowBlobs = A.emptyObject, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.json != null && j.hasOwnProperty.call(e, "json") && e.json !== "" && t.uint32(10).string(e.json), e.arrowBlobs != null && j.hasOwnProperty.call(e, "arrowBlobs")) for (let r = j.keys(e.arrowBlobs), i = 0; i < r.length; ++i) t.uint32(18).fork().uint32(10).string(r[i]), U.ArrowData.encode(e.arrowBlobs[r[i]], t.uint32(18).fork(), n + 1).ldelim().ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s, c;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.MixedData(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let l = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (l !== 2) break;
					(c = e.stringVerify()).length ? o.json = c : delete o.json;
					continue;
				case 2: {
					if (l !== 2) break;
					o.arrowBlobs === A.emptyObject && (o.arrowBlobs = {});
					let t = e.uint32() + e.pos;
					if (t > e.len) throw P("index out of range");
					for (e.len = t, s = "", c = null; e.pos < t;) {
						let t = e.tag();
						switch (l = t & 7, t >>>= 3) {
							case 1:
								if (l !== 2) break;
								s = e.stringVerify();
								continue;
							case 2:
								if (l !== 2) break;
								c = U.ArrowData.decode(e, e.uint32(), M, r + 1, c);
								continue;
						}
						e.skipType(l, r, t);
					}
					if (e.pos !== t) throw P("index out of range");
					e.len = a, s === "__proto__" && A.makeProp(o.arrowBlobs, s), o.arrowBlobs[s] = c || new U.ArrowData();
					continue;
				}
			}
			e.skipType(l, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.MixedData) return e;
		if (!A.isObject(e)) throw F(".MixedData: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.MixedData();
		if (e.json != null && (typeof e.json != "string" || e.json.length) && (n.json = I(e.json)), e.arrowBlobs) {
			if (!A.isObject(e.arrowBlobs)) throw F(".MixedData.arrowBlobs: object expected");
			n.arrowBlobs = {};
			for (let r = j.keys(e.arrowBlobs), i = 0; i < r.length; ++i) {
				if (r[i] === "__proto__" && A.makeProp(n.arrowBlobs, r[i]), !A.isObject(e.arrowBlobs[r[i]])) throw F(".MixedData.arrowBlobs: object expected");
				n.arrowBlobs[r[i]] = U.ArrowData.fromObject(e.arrowBlobs[r[i]], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		(t.objects || t.defaults) && (r.arrowBlobs = {}), t.defaults && (r.json = ""), e.json != null && j.hasOwnProperty.call(e, "json") && (r.json = e.json);
		let i;
		if (e.arrowBlobs && (i = j.keys(e.arrowBlobs)).length) {
			r.arrowBlobs = {};
			for (let a = 0; a < i.length; ++a) i[a] === "__proto__" && A.makeProp(r.arrowBlobs, i[a]), r.arrowBlobs[i[a]] = U.ArrowData.toObject(e.arrowBlobs[i[a]], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/MixedData";
	}, e;
})(), U.BidiComponent = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.componentName = "", e.prototype.jsContent = null, e.prototype.jsSourcePath = null, e.prototype.formId = "", e.prototype.htmlContent = null, e.prototype.cssContent = null, e.prototype.cssSourcePath = null, e.prototype.isolateStyles = !1, e.prototype.json = null, e.prototype.arrowData = null, e.prototype.bytes = null, e.prototype.mixed = null;
	let t;
	return j.defineProperty(e.prototype, "_jsContent", {
		get: A.oneOfGetter(t = ["jsContent"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_jsSourcePath", {
		get: A.oneOfGetter(t = ["jsSourcePath"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_htmlContent", {
		get: A.oneOfGetter(t = ["htmlContent"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_cssContent", {
		get: A.oneOfGetter(t = ["cssContent"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_cssSourcePath", {
		get: A.oneOfGetter(t = ["cssSourcePath"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "data", {
		get: A.oneOfGetter(t = [
			"json",
			"arrowData",
			"bytes",
			"mixed"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.componentName != null && j.hasOwnProperty.call(e, "componentName") && e.componentName !== "" && t.uint32(18).string(e.componentName), e.jsContent != null && j.hasOwnProperty.call(e, "jsContent") && t.uint32(26).string(e.jsContent), e.jsSourcePath != null && j.hasOwnProperty.call(e, "jsSourcePath") && t.uint32(34).string(e.jsSourcePath), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.htmlContent != null && j.hasOwnProperty.call(e, "htmlContent") && t.uint32(50).string(e.htmlContent), e.cssContent != null && j.hasOwnProperty.call(e, "cssContent") && t.uint32(58).string(e.cssContent), e.cssSourcePath != null && j.hasOwnProperty.call(e, "cssSourcePath") && t.uint32(66).string(e.cssSourcePath), e.isolateStyles != null && j.hasOwnProperty.call(e, "isolateStyles") && e.isolateStyles !== !1 && t.uint32(72).bool(e.isolateStyles), e.json != null && j.hasOwnProperty.call(e, "json") && t.uint32(82).string(e.json), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && U.ArrowData.encode(e.arrowData, t.uint32(90).fork(), n + 1).ldelim(), e.bytes != null && j.hasOwnProperty.call(e, "bytes") && t.uint32(98).bytes(e.bytes), e.mixed != null && j.hasOwnProperty.call(e, "mixed") && U.MixedData.encode(e.mixed, t.uint32(106).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.BidiComponent(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.componentName = s : delete o.componentName;
					continue;
				case 3:
					if (a !== 2) break;
					o.jsContent = e.stringVerify(), o._jsContent = "jsContent";
					continue;
				case 4:
					if (a !== 2) break;
					o.jsSourcePath = e.stringVerify(), o._jsSourcePath = "jsSourcePath";
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					o.htmlContent = e.stringVerify(), o._htmlContent = "htmlContent";
					continue;
				case 7:
					if (a !== 2) break;
					o.cssContent = e.stringVerify(), o._cssContent = "cssContent";
					continue;
				case 8:
					if (a !== 2) break;
					o.cssSourcePath = e.stringVerify(), o._cssSourcePath = "cssSourcePath";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.isolateStyles = s : delete o.isolateStyles;
					continue;
				case 10:
					if (a !== 2) break;
					o.json = e.stringVerify(), o.data = "json";
					continue;
				case 11:
					if (a !== 2) break;
					o.arrowData = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.arrowData), o.data = "arrowData";
					continue;
				case 12:
					if (a !== 2) break;
					o.bytes = e.bytes(), o.data = "bytes";
					continue;
				case 13:
					if (a !== 2) break;
					o.mixed = U.MixedData.decode(e, e.uint32(), M, r + 1, o.mixed), o.data = "mixed";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.BidiComponent) return e;
		if (!A.isObject(e)) throw F(".BidiComponent: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.BidiComponent();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.componentName != null && (typeof e.componentName != "string" || e.componentName.length) && (n.componentName = I(e.componentName)), e.jsContent != null && (n.jsContent = I(e.jsContent)), e.jsSourcePath != null && (n.jsSourcePath = I(e.jsSourcePath)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.htmlContent != null && (n.htmlContent = I(e.htmlContent)), e.cssContent != null && (n.cssContent = I(e.cssContent)), e.cssSourcePath != null && (n.cssSourcePath = I(e.cssSourcePath)), e.isolateStyles != null && e.isolateStyles && (n.isolateStyles = L(e.isolateStyles)), e.json != null && (n.json = I(e.json)), e.arrowData != null) {
			if (!A.isObject(e.arrowData)) throw F(".BidiComponent.arrowData: object expected");
			n.arrowData = U.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.bytes != null && (typeof e.bytes == "string" ? A.base64.decode(e.bytes, n.bytes = A.newBuffer(A.base64.length(e.bytes)), 0) : e.bytes.length >= 0 && (n.bytes = e.bytes)), e.mixed != null) {
			if (!A.isObject(e.mixed)) throw F(".BidiComponent.mixed: object expected");
			n.mixed = U.MixedData.fromObject(e.mixed, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.componentName = "", r.formId = "", r.isolateStyles = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.componentName != null && j.hasOwnProperty.call(e, "componentName") && (r.componentName = e.componentName), e.jsContent != null && j.hasOwnProperty.call(e, "jsContent") && (r.jsContent = e.jsContent), e.jsSourcePath != null && j.hasOwnProperty.call(e, "jsSourcePath") && (r.jsSourcePath = e.jsSourcePath), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.htmlContent != null && j.hasOwnProperty.call(e, "htmlContent") && (r.htmlContent = e.htmlContent), e.cssContent != null && j.hasOwnProperty.call(e, "cssContent") && (r.cssContent = e.cssContent), e.cssSourcePath != null && j.hasOwnProperty.call(e, "cssSourcePath") && (r.cssSourcePath = e.cssSourcePath), e.isolateStyles != null && j.hasOwnProperty.call(e, "isolateStyles") && (r.isolateStyles = e.isolateStyles), e.json != null && j.hasOwnProperty.call(e, "json") && (r.json = e.json, t.oneofs && (r.data = "json")), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && (r.arrowData = U.ArrowData.toObject(e.arrowData, t, n + 1), t.oneofs && (r.data = "arrowData")), e.bytes != null && j.hasOwnProperty.call(e, "bytes") && (r.bytes = t.bytes === I ? A.base64.encode(e.bytes, 0, e.bytes.length) : t.bytes === B ? B.prototype.slice.call(e.bytes) : e.bytes, t.oneofs && (r.data = "bytes")), e.mixed != null && j.hasOwnProperty.call(e, "mixed") && (r.mixed = U.MixedData.toObject(e.mixed, t, n + 1), t.oneofs && (r.data = "mixed")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/BidiComponent";
	}, e;
})(), U.Block = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.vertical = null, e.prototype.horizontal = null, e.prototype.column = null, e.prototype.expandable = null, e.prototype.form = null, e.prototype.tabContainer = null, e.prototype.tab = null, e.prototype.chatMessage = null, e.prototype.popover = null, e.prototype.dialog = null, e.prototype.flexContainer = null, e.prototype.transparent = null, e.prototype.allowEmpty = !1, e.prototype.id = null, e.prototype.heightConfig = null, e.prototype.widthConfig = null, e.prototype.autoscroll = null;
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = [
			"vertical",
			"horizontal",
			"column",
			"expandable",
			"form",
			"tabContainer",
			"tab",
			"chatMessage",
			"popover",
			"dialog",
			"flexContainer",
			"transparent"
		]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_id", {
		get: A.oneOfGetter(t = ["id"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_heightConfig", {
		get: A.oneOfGetter(t = ["heightConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_widthConfig", {
		get: A.oneOfGetter(t = ["widthConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_autoscroll", {
		get: A.oneOfGetter(t = ["autoscroll"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.vertical != null && j.hasOwnProperty.call(e, "vertical") && U.Block.Vertical.encode(e.vertical, t.uint32(10).fork(), n + 1).ldelim(), e.horizontal != null && j.hasOwnProperty.call(e, "horizontal") && U.Block.Horizontal.encode(e.horizontal, t.uint32(18).fork(), n + 1).ldelim(), e.column != null && j.hasOwnProperty.call(e, "column") && U.Block.Column.encode(e.column, t.uint32(26).fork(), n + 1).ldelim(), e.expandable != null && j.hasOwnProperty.call(e, "expandable") && U.Block.Expandable.encode(e.expandable, t.uint32(34).fork(), n + 1).ldelim(), e.form != null && j.hasOwnProperty.call(e, "form") && U.Block.Form.encode(e.form, t.uint32(42).fork(), n + 1).ldelim(), e.tabContainer != null && j.hasOwnProperty.call(e, "tabContainer") && U.Block.TabContainer.encode(e.tabContainer, t.uint32(50).fork(), n + 1).ldelim(), e.tab != null && j.hasOwnProperty.call(e, "tab") && U.Block.Tab.encode(e.tab, t.uint32(58).fork(), n + 1).ldelim(), e.allowEmpty != null && j.hasOwnProperty.call(e, "allowEmpty") && e.allowEmpty !== !1 && t.uint32(64).bool(e.allowEmpty), e.chatMessage != null && j.hasOwnProperty.call(e, "chatMessage") && U.Block.ChatMessage.encode(e.chatMessage, t.uint32(74).fork(), n + 1).ldelim(), e.popover != null && j.hasOwnProperty.call(e, "popover") && U.Block.Popover.encode(e.popover, t.uint32(82).fork(), n + 1).ldelim(), e.dialog != null && j.hasOwnProperty.call(e, "dialog") && U.Block.Dialog.encode(e.dialog, t.uint32(90).fork(), n + 1).ldelim(), e.id != null && j.hasOwnProperty.call(e, "id") && t.uint32(98).string(e.id), e.flexContainer != null && j.hasOwnProperty.call(e, "flexContainer") && U.Block.FlexContainer.encode(e.flexContainer, t.uint32(106).fork(), n + 1).ldelim(), e.heightConfig != null && j.hasOwnProperty.call(e, "heightConfig") && U.streamlit.HeightConfig.encode(e.heightConfig, t.uint32(114).fork(), n + 1).ldelim(), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(122).fork(), n + 1).ldelim(), e.autoscroll != null && j.hasOwnProperty.call(e, "autoscroll") && t.uint32(128).bool(e.autoscroll), e.transparent != null && j.hasOwnProperty.call(e, "transparent") && U.Block.Transparent.encode(e.transparent, t.uint32(138).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Block(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.vertical = U.Block.Vertical.decode(e, e.uint32(), M, r + 1, o.vertical), o.type = "vertical";
					continue;
				case 2:
					if (a !== 2) break;
					o.horizontal = U.Block.Horizontal.decode(e, e.uint32(), M, r + 1, o.horizontal), o.type = "horizontal";
					continue;
				case 3:
					if (a !== 2) break;
					o.column = U.Block.Column.decode(e, e.uint32(), M, r + 1, o.column), o.type = "column";
					continue;
				case 4:
					if (a !== 2) break;
					o.expandable = U.Block.Expandable.decode(e, e.uint32(), M, r + 1, o.expandable), o.type = "expandable";
					continue;
				case 5:
					if (a !== 2) break;
					o.form = U.Block.Form.decode(e, e.uint32(), M, r + 1, o.form), o.type = "form";
					continue;
				case 6:
					if (a !== 2) break;
					o.tabContainer = U.Block.TabContainer.decode(e, e.uint32(), M, r + 1, o.tabContainer), o.type = "tabContainer";
					continue;
				case 7:
					if (a !== 2) break;
					o.tab = U.Block.Tab.decode(e, e.uint32(), M, r + 1, o.tab), o.type = "tab";
					continue;
				case 9:
					if (a !== 2) break;
					o.chatMessage = U.Block.ChatMessage.decode(e, e.uint32(), M, r + 1, o.chatMessage), o.type = "chatMessage";
					continue;
				case 10:
					if (a !== 2) break;
					o.popover = U.Block.Popover.decode(e, e.uint32(), M, r + 1, o.popover), o.type = "popover";
					continue;
				case 11:
					if (a !== 2) break;
					o.dialog = U.Block.Dialog.decode(e, e.uint32(), M, r + 1, o.dialog), o.type = "dialog";
					continue;
				case 13:
					if (a !== 2) break;
					o.flexContainer = U.Block.FlexContainer.decode(e, e.uint32(), M, r + 1, o.flexContainer), o.type = "flexContainer";
					continue;
				case 17:
					if (a !== 2) break;
					o.transparent = U.Block.Transparent.decode(e, e.uint32(), M, r + 1, o.transparent), o.type = "transparent";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowEmpty = s : delete o.allowEmpty;
					continue;
				case 12:
					if (a !== 2) break;
					o.id = e.stringVerify(), o._id = "id";
					continue;
				case 14:
					if (a !== 2) break;
					o.heightConfig = U.streamlit.HeightConfig.decode(e, e.uint32(), M, r + 1, o.heightConfig), o._heightConfig = "heightConfig";
					continue;
				case 15:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 16:
					if (a !== 0) break;
					o.autoscroll = e.bool(), o._autoscroll = "autoscroll";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Block) return e;
		if (!A.isObject(e)) throw F(".Block: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Block();
		if (e.vertical != null) {
			if (!A.isObject(e.vertical)) throw F(".Block.vertical: object expected");
			n.vertical = U.Block.Vertical.fromObject(e.vertical, t + 1);
		}
		if (e.horizontal != null) {
			if (!A.isObject(e.horizontal)) throw F(".Block.horizontal: object expected");
			n.horizontal = U.Block.Horizontal.fromObject(e.horizontal, t + 1);
		}
		if (e.column != null) {
			if (!A.isObject(e.column)) throw F(".Block.column: object expected");
			n.column = U.Block.Column.fromObject(e.column, t + 1);
		}
		if (e.expandable != null) {
			if (!A.isObject(e.expandable)) throw F(".Block.expandable: object expected");
			n.expandable = U.Block.Expandable.fromObject(e.expandable, t + 1);
		}
		if (e.form != null) {
			if (!A.isObject(e.form)) throw F(".Block.form: object expected");
			n.form = U.Block.Form.fromObject(e.form, t + 1);
		}
		if (e.tabContainer != null) {
			if (!A.isObject(e.tabContainer)) throw F(".Block.tabContainer: object expected");
			n.tabContainer = U.Block.TabContainer.fromObject(e.tabContainer, t + 1);
		}
		if (e.tab != null) {
			if (!A.isObject(e.tab)) throw F(".Block.tab: object expected");
			n.tab = U.Block.Tab.fromObject(e.tab, t + 1);
		}
		if (e.chatMessage != null) {
			if (!A.isObject(e.chatMessage)) throw F(".Block.chatMessage: object expected");
			n.chatMessage = U.Block.ChatMessage.fromObject(e.chatMessage, t + 1);
		}
		if (e.popover != null) {
			if (!A.isObject(e.popover)) throw F(".Block.popover: object expected");
			n.popover = U.Block.Popover.fromObject(e.popover, t + 1);
		}
		if (e.dialog != null) {
			if (!A.isObject(e.dialog)) throw F(".Block.dialog: object expected");
			n.dialog = U.Block.Dialog.fromObject(e.dialog, t + 1);
		}
		if (e.flexContainer != null) {
			if (!A.isObject(e.flexContainer)) throw F(".Block.flexContainer: object expected");
			n.flexContainer = U.Block.FlexContainer.fromObject(e.flexContainer, t + 1);
		}
		if (e.transparent != null) {
			if (!A.isObject(e.transparent)) throw F(".Block.transparent: object expected");
			n.transparent = U.Block.Transparent.fromObject(e.transparent, t + 1);
		}
		if (e.allowEmpty != null && e.allowEmpty && (n.allowEmpty = L(e.allowEmpty)), e.id != null && (n.id = I(e.id)), e.heightConfig != null) {
			if (!A.isObject(e.heightConfig)) throw F(".Block.heightConfig: object expected");
			n.heightConfig = U.streamlit.HeightConfig.fromObject(e.heightConfig, t + 1);
		}
		if (e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Block.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.autoscroll != null && (n.autoscroll = L(e.autoscroll)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.allowEmpty = !1), e.vertical != null && j.hasOwnProperty.call(e, "vertical") && (r.vertical = U.Block.Vertical.toObject(e.vertical, t, n + 1), t.oneofs && (r.type = "vertical")), e.horizontal != null && j.hasOwnProperty.call(e, "horizontal") && (r.horizontal = U.Block.Horizontal.toObject(e.horizontal, t, n + 1), t.oneofs && (r.type = "horizontal")), e.column != null && j.hasOwnProperty.call(e, "column") && (r.column = U.Block.Column.toObject(e.column, t, n + 1), t.oneofs && (r.type = "column")), e.expandable != null && j.hasOwnProperty.call(e, "expandable") && (r.expandable = U.Block.Expandable.toObject(e.expandable, t, n + 1), t.oneofs && (r.type = "expandable")), e.form != null && j.hasOwnProperty.call(e, "form") && (r.form = U.Block.Form.toObject(e.form, t, n + 1), t.oneofs && (r.type = "form")), e.tabContainer != null && j.hasOwnProperty.call(e, "tabContainer") && (r.tabContainer = U.Block.TabContainer.toObject(e.tabContainer, t, n + 1), t.oneofs && (r.type = "tabContainer")), e.tab != null && j.hasOwnProperty.call(e, "tab") && (r.tab = U.Block.Tab.toObject(e.tab, t, n + 1), t.oneofs && (r.type = "tab")), e.allowEmpty != null && j.hasOwnProperty.call(e, "allowEmpty") && (r.allowEmpty = e.allowEmpty), e.chatMessage != null && j.hasOwnProperty.call(e, "chatMessage") && (r.chatMessage = U.Block.ChatMessage.toObject(e.chatMessage, t, n + 1), t.oneofs && (r.type = "chatMessage")), e.popover != null && j.hasOwnProperty.call(e, "popover") && (r.popover = U.Block.Popover.toObject(e.popover, t, n + 1), t.oneofs && (r.type = "popover")), e.dialog != null && j.hasOwnProperty.call(e, "dialog") && (r.dialog = U.Block.Dialog.toObject(e.dialog, t, n + 1), t.oneofs && (r.type = "dialog")), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.flexContainer != null && j.hasOwnProperty.call(e, "flexContainer") && (r.flexContainer = U.Block.FlexContainer.toObject(e.flexContainer, t, n + 1), t.oneofs && (r.type = "flexContainer")), e.heightConfig != null && j.hasOwnProperty.call(e, "heightConfig") && (r.heightConfig = U.streamlit.HeightConfig.toObject(e.heightConfig, t, n + 1)), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.autoscroll != null && j.hasOwnProperty.call(e, "autoscroll") && (r.autoscroll = e.autoscroll), e.transparent != null && j.hasOwnProperty.call(e, "transparent") && (r.transparent = U.Block.Transparent.toObject(e.transparent, t, n + 1), t.oneofs && (r.type = "transparent")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Block";
	}, e.Vertical = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.border = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.border != null && j.hasOwnProperty.call(e, "border") && e.border !== !1 && t.uint32(8).bool(e.border), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Vertical(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Vertical) return e;
			if (!A.isObject(e)) throw F(".Block.Vertical: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Vertical();
			return e.border != null && e.border && (n.border = L(e.border)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.border = !1), e.border != null && j.hasOwnProperty.call(e, "border") && (r.border = e.border), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Vertical";
		}, e;
	})(), e.Horizontal = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.gap = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.gap != null && j.hasOwnProperty.call(e, "gap") && e.gap !== "" && t.uint32(10).string(e.gap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Horizontal(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.gap = s : delete o.gap;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Horizontal) return e;
			if (!A.isObject(e)) throw F(".Block.Horizontal: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Horizontal();
			return e.gap != null && (typeof e.gap != "string" || e.gap.length) && (n.gap = I(e.gap)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.gap = ""), e.gap != null && j.hasOwnProperty.call(e, "gap") && (r.gap = e.gap), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Horizontal";
		}, e;
	})(), e.FlexContainer = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.border = !1, e.prototype.gapConfig = null, e.prototype.scale = 0, e.prototype.direction = 0, e.prototype.wrap = !1, e.prototype.justify = 0, e.prototype.align = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.border != null && j.hasOwnProperty.call(e, "border") && e.border !== !1 && t.uint32(8).bool(e.border), e.gapConfig != null && j.hasOwnProperty.call(e, "gapConfig") && U.streamlit.GapConfig.encode(e.gapConfig, t.uint32(18).fork(), n + 1).ldelim(), e.scale != null && j.hasOwnProperty.call(e, "scale") && !j.is(e.scale, 0) && t.uint32(29).float(e.scale), e.direction != null && j.hasOwnProperty.call(e, "direction") && e.direction !== 0 && t.uint32(32).int32(e.direction), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && e.wrap !== !1 && t.uint32(40).bool(e.wrap), e.justify != null && j.hasOwnProperty.call(e, "justify") && e.justify !== 0 && t.uint32(56).int32(e.justify), e.align != null && j.hasOwnProperty.call(e, "align") && e.align !== 0 && t.uint32(64).int32(e.align), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.FlexContainer(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
					case 2:
						if (a !== 2) break;
						o.gapConfig = U.streamlit.GapConfig.decode(e, e.uint32(), M, r + 1, o.gapConfig);
						continue;
					case 3:
						if (a !== 5) break;
						j.is(s = e.float(), 0) ? delete o.scale : o.scale = s;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.int32()) ? o.direction = s : delete o.direction;
						continue;
					case 5:
						if (a !== 0) break;
						(s = e.bool()) ? o.wrap = s : delete o.wrap;
						continue;
					case 7:
						if (a !== 0) break;
						(s = e.int32()) ? o.justify = s : delete o.justify;
						continue;
					case 8:
						if (a !== 0) break;
						(s = e.int32()) ? o.align = s : delete o.align;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.FlexContainer) return e;
			if (!A.isObject(e)) throw F(".Block.FlexContainer: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.FlexContainer();
			if (e.border != null && e.border && (n.border = L(e.border)), e.gapConfig != null) {
				if (!A.isObject(e.gapConfig)) throw F(".Block.FlexContainer.gapConfig: object expected");
				n.gapConfig = U.streamlit.GapConfig.fromObject(e.gapConfig, t + 1);
			}
			if (e.scale != null && (j.is(R(e.scale), 0) || (n.scale = R(e.scale))), e.direction !== 0 && (typeof e.direction != "string" || U.Block.FlexContainer.Direction[e.direction] !== 0)) switch (e.direction) {
				case "DIRECTION_UNDEFINED":
				case 0:
					n.direction = 0;
					break;
				case "VERTICAL":
				case 1:
					n.direction = 1;
					break;
				case "HORIZONTAL":
				case 2:
					n.direction = 2;
					break;
				default: typeof e.direction == "number" && (e.direction | 0) === e.direction && (n.direction = e.direction);
			}
			if (e.wrap != null && e.wrap && (n.wrap = L(e.wrap)), e.justify !== 0 && (typeof e.justify != "string" || U.Block.FlexContainer.Justify[e.justify] !== 0)) switch (e.justify) {
				case "JUSTIFY_UNDEFINED":
				case 0:
					n.justify = 0;
					break;
				case "JUSTIFY_START":
				case 1:
					n.justify = 1;
					break;
				case "JUSTIFY_END":
				case 2:
					n.justify = 2;
					break;
				case "JUSTIFY_CENTER":
				case 3:
					n.justify = 3;
					break;
				case "SPACE_BETWEEN":
				case 4:
					n.justify = 4;
					break;
				default: typeof e.justify == "number" && (e.justify | 0) === e.justify && (n.justify = e.justify);
			}
			if (e.align !== 0 && (typeof e.align != "string" || U.Block.FlexContainer.Align[e.align] !== 0)) switch (e.align) {
				case "ALIGN_UNDEFINED":
				case 0:
					n.align = 0;
					break;
				case "ALIGN_START":
				case 1:
					n.align = 1;
					break;
				case "ALIGN_END":
				case 2:
					n.align = 2;
					break;
				case "ALIGN_CENTER":
				case 3:
					n.align = 3;
					break;
				case "STRETCH":
				case 4:
					n.align = 4;
					break;
				default: typeof e.align == "number" && (e.align | 0) === e.align && (n.align = e.align);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.border = !1, r.gapConfig = null, r.scale = 0, r.direction = t.enums === I ? "DIRECTION_UNDEFINED" : 0, r.wrap = !1, r.justify = t.enums === I ? "JUSTIFY_UNDEFINED" : 0, r.align = t.enums === I ? "ALIGN_UNDEFINED" : 0), e.border != null && j.hasOwnProperty.call(e, "border") && (r.border = e.border), e.gapConfig != null && j.hasOwnProperty.call(e, "gapConfig") && (r.gapConfig = U.streamlit.GapConfig.toObject(e.gapConfig, t, n + 1)), e.scale != null && j.hasOwnProperty.call(e, "scale") && (r.scale = t.json && !z(e.scale) ? I(e.scale) : e.scale), e.direction != null && j.hasOwnProperty.call(e, "direction") && (r.direction = t.enums === I ? U.Block.FlexContainer.Direction[e.direction] === M ? e.direction : U.Block.FlexContainer.Direction[e.direction] : e.direction), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), e.justify != null && j.hasOwnProperty.call(e, "justify") && (r.justify = t.enums === I ? U.Block.FlexContainer.Justify[e.justify] === M ? e.justify : U.Block.FlexContainer.Justify[e.justify] : e.justify), e.align != null && j.hasOwnProperty.call(e, "align") && (r.align = t.enums === I ? U.Block.FlexContainer.Align[e.align] === M ? e.align : U.Block.FlexContainer.Align[e.align] : e.align), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.FlexContainer";
		}, e.Direction = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "DIRECTION_UNDEFINED"] = 0, t[e[1] = "VERTICAL"] = 1, t[e[2] = "HORIZONTAL"] = 2, t;
		})(), e.Justify = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "JUSTIFY_UNDEFINED"] = 0, t[e[1] = "JUSTIFY_START"] = 1, t[e[2] = "JUSTIFY_END"] = 2, t[e[3] = "JUSTIFY_CENTER"] = 3, t[e[4] = "SPACE_BETWEEN"] = 4, t;
		})(), e.Align = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "ALIGN_UNDEFINED"] = 0, t[e[1] = "ALIGN_START"] = 1, t[e[2] = "ALIGN_END"] = 2, t[e[3] = "ALIGN_CENTER"] = 3, t[e[4] = "STRETCH"] = 4, t;
		})(), e;
	})(), e.Column = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.weight = 0, e.prototype.verticalAlignment = 0, e.prototype.showBorder = !1, e.prototype.gapConfig = null;
		let t;
		return j.defineProperty(e.prototype, "_gapConfig", {
			get: A.oneOfGetter(t = ["gapConfig"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.weight != null && j.hasOwnProperty.call(e, "weight") && !j.is(e.weight, 0) && t.uint32(9).double(e.weight), e.verticalAlignment != null && j.hasOwnProperty.call(e, "verticalAlignment") && e.verticalAlignment !== 0 && t.uint32(24).int32(e.verticalAlignment), e.showBorder != null && j.hasOwnProperty.call(e, "showBorder") && e.showBorder !== !1 && t.uint32(32).bool(e.showBorder), e.gapConfig != null && j.hasOwnProperty.call(e, "gapConfig") && U.streamlit.GapConfig.encode(e.gapConfig, t.uint32(42).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Column(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						j.is(s = e.double(), 0) ? delete o.weight : o.weight = s;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.verticalAlignment = s : delete o.verticalAlignment;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.showBorder = s : delete o.showBorder;
						continue;
					case 5:
						if (a !== 2) break;
						o.gapConfig = U.streamlit.GapConfig.decode(e, e.uint32(), M, r + 1, o.gapConfig), o._gapConfig = "gapConfig";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Column) return e;
			if (!A.isObject(e)) throw F(".Block.Column: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Column();
			if (e.weight != null && (j.is(R(e.weight), 0) || (n.weight = R(e.weight))), e.verticalAlignment !== 0 && (typeof e.verticalAlignment != "string" || U.Block.Column.VerticalAlignment[e.verticalAlignment] !== 0)) switch (e.verticalAlignment) {
				case "TOP":
				case 0:
					n.verticalAlignment = 0;
					break;
				case "CENTER":
				case 1:
					n.verticalAlignment = 1;
					break;
				case "BOTTOM":
				case 2:
					n.verticalAlignment = 2;
					break;
				default: typeof e.verticalAlignment == "number" && (e.verticalAlignment | 0) === e.verticalAlignment && (n.verticalAlignment = e.verticalAlignment);
			}
			if (e.showBorder != null && e.showBorder && (n.showBorder = L(e.showBorder)), e.gapConfig != null) {
				if (!A.isObject(e.gapConfig)) throw F(".Block.Column.gapConfig: object expected");
				n.gapConfig = U.streamlit.GapConfig.fromObject(e.gapConfig, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.weight = 0, r.verticalAlignment = t.enums === I ? "TOP" : 0, r.showBorder = !1), e.weight != null && j.hasOwnProperty.call(e, "weight") && (r.weight = t.json && !z(e.weight) ? I(e.weight) : e.weight), e.verticalAlignment != null && j.hasOwnProperty.call(e, "verticalAlignment") && (r.verticalAlignment = t.enums === I ? U.Block.Column.VerticalAlignment[e.verticalAlignment] === M ? e.verticalAlignment : U.Block.Column.VerticalAlignment[e.verticalAlignment] : e.verticalAlignment), e.showBorder != null && j.hasOwnProperty.call(e, "showBorder") && (r.showBorder = e.showBorder), e.gapConfig != null && j.hasOwnProperty.call(e, "gapConfig") && (r.gapConfig = U.streamlit.GapConfig.toObject(e.gapConfig, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Column";
		}, e.VerticalAlignment = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "TOP"] = 0, t[e[1] = "CENTER"] = 1, t[e[2] = "BOTTOM"] = 2, t;
		})(), e;
	})(), e.Expandable = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.label = "", e.prototype.expanded = null, e.prototype.icon = "", e.prototype.id = null, e.prototype.type = 0, e.prototype.state = 0, e.prototype.queryParamKey = null, e.prototype.defaultExpanded = null;
		let t;
		return j.defineProperty(e.prototype, "_expanded", {
			get: A.oneOfGetter(t = ["expanded"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_id", {
			get: A.oneOfGetter(t = ["id"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_queryParamKey", {
			get: A.oneOfGetter(t = ["queryParamKey"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_defaultExpanded", {
			get: A.oneOfGetter(t = ["defaultExpanded"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(10).string(e.label), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && t.uint32(16).bool(e.expanded), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(26).string(e.icon), e.id != null && j.hasOwnProperty.call(e, "id") && t.uint32(34).string(e.id), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(40).int32(e.type), e.state != null && j.hasOwnProperty.call(e, "state") && e.state !== 0 && t.uint32(48).int32(e.state), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(58).string(e.queryParamKey), e.defaultExpanded != null && j.hasOwnProperty.call(e, "defaultExpanded") && t.uint32(64).bool(e.defaultExpanded), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Expandable(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.label = s : delete o.label;
						continue;
					case 2:
						if (a !== 0) break;
						o.expanded = e.bool(), o._expanded = "expanded";
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
						continue;
					case 4:
						if (a !== 2) break;
						o.id = e.stringVerify(), o._id = "id";
						continue;
					case 5:
						if (a !== 0) break;
						(s = e.int32()) ? o.type = s : delete o.type;
						continue;
					case 6:
						if (a !== 0) break;
						(s = e.int32()) ? o.state = s : delete o.state;
						continue;
					case 7:
						if (a !== 2) break;
						o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
						continue;
					case 8:
						if (a !== 0) break;
						o.defaultExpanded = e.bool(), o._defaultExpanded = "defaultExpanded";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Expandable) return e;
			if (!A.isObject(e)) throw F(".Block.Expandable: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Expandable();
			if (e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.expanded != null && (n.expanded = L(e.expanded)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.id != null && (n.id = I(e.id)), e.type !== 0 && (typeof e.type != "string" || U.Block.Expandable.Type[e.type] !== 0)) switch (e.type) {
				case "DEFAULT":
				case 0:
					n.type = 0;
					break;
				case "COMPACT":
				case 1:
					n.type = 1;
					break;
				case "STEP":
				case 2:
					n.type = 2;
					break;
				default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
			}
			if (e.state !== 0 && (typeof e.state != "string" || U.Block.Expandable.State[e.state] !== 0)) switch (e.state) {
				case "STATE_UNDEFINED":
				case 0:
					n.state = 0;
					break;
				case "RUNNING":
				case 1:
					n.state = 1;
					break;
				case "COMPLETE":
				case 2:
					n.state = 2;
					break;
				case "ERROR":
				case 3:
					n.state = 3;
					break;
				default: typeof e.state == "number" && (e.state | 0) === e.state && (n.state = e.state);
			}
			return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.defaultExpanded != null && (n.defaultExpanded = L(e.defaultExpanded)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = "", r.icon = "", r.type = t.enums === I ? "DEFAULT" : 0, r.state = t.enums === I ? "STATE_UNDEFINED" : 0), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && (r.expanded = e.expanded), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.Block.Expandable.Type[e.type] === M ? e.type : U.Block.Expandable.Type[e.type] : e.type), e.state != null && j.hasOwnProperty.call(e, "state") && (r.state = t.enums === I ? U.Block.Expandable.State[e.state] === M ? e.state : U.Block.Expandable.State[e.state] : e.state), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.defaultExpanded != null && j.hasOwnProperty.call(e, "defaultExpanded") && (r.defaultExpanded = e.defaultExpanded), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Expandable";
		}, e.Type = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "DEFAULT"] = 0, t[e[1] = "COMPACT"] = 1, t[e[2] = "STEP"] = 2, t;
		})(), e.State = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "STATE_UNDEFINED"] = 0, t[e[1] = "RUNNING"] = 1, t[e[2] = "COMPLETE"] = 2, t[e[3] = "ERROR"] = 3, t;
		})(), e;
	})(), e.Dialog = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.title = "", e.prototype.dismissible = !1, e.prototype.width = 0, e.prototype.isOpen = null, e.prototype.id = "", e.prototype.icon = "", e.prototype.position = 0;
		let t;
		return j.defineProperty(e.prototype, "_isOpen", {
			get: A.oneOfGetter(t = ["isOpen"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.title != null && j.hasOwnProperty.call(e, "title") && e.title !== "" && t.uint32(10).string(e.title), e.dismissible != null && j.hasOwnProperty.call(e, "dismissible") && e.dismissible !== !1 && t.uint32(16).bool(e.dismissible), e.width != null && j.hasOwnProperty.call(e, "width") && e.width !== 0 && t.uint32(24).int32(e.width), e.isOpen != null && j.hasOwnProperty.call(e, "isOpen") && t.uint32(32).bool(e.isOpen), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(42).string(e.id), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(50).string(e.icon), e.position != null && j.hasOwnProperty.call(e, "position") && e.position !== 0 && t.uint32(56).int32(e.position), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Dialog(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.title = s : delete o.title;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.dismissible = s : delete o.dismissible;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.width = s : delete o.width;
						continue;
					case 4:
						if (a !== 0) break;
						o.isOpen = e.bool(), o._isOpen = "isOpen";
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.id = s : delete o.id;
						continue;
					case 6:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
						continue;
					case 7:
						if (a !== 0) break;
						(s = e.int32()) ? o.position = s : delete o.position;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Dialog) return e;
			if (!A.isObject(e)) throw F(".Block.Dialog: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Dialog();
			if (e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = I(e.title)), e.dismissible != null && e.dismissible && (n.dismissible = L(e.dismissible)), e.width !== 0 && (typeof e.width != "string" || U.Block.Dialog.DialogWidth[e.width] !== 0)) switch (e.width) {
				case "SMALL":
				case 0:
					n.width = 0;
					break;
				case "LARGE":
				case 1:
					n.width = 1;
					break;
				case "MEDIUM":
				case 2:
					n.width = 2;
					break;
				default: typeof e.width == "number" && (e.width | 0) === e.width && (n.width = e.width);
			}
			if (e.isOpen != null && (n.isOpen = L(e.isOpen)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.position !== 0 && (typeof e.position != "string" || U.Block.Dialog.DialogPosition[e.position] !== 0)) switch (e.position) {
				case "CENTER":
				case 0:
					n.position = 0;
					break;
				case "LEFT":
				case 1:
					n.position = 1;
					break;
				case "RIGHT":
				case 2:
					n.position = 2;
					break;
				default: typeof e.position == "number" && (e.position | 0) === e.position && (n.position = e.position);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.title = "", r.dismissible = !1, r.width = t.enums === I ? "SMALL" : 0, r.id = "", r.icon = "", r.position = t.enums === I ? "CENTER" : 0), e.title != null && j.hasOwnProperty.call(e, "title") && (r.title = e.title), e.dismissible != null && j.hasOwnProperty.call(e, "dismissible") && (r.dismissible = e.dismissible), e.width != null && j.hasOwnProperty.call(e, "width") && (r.width = t.enums === I ? U.Block.Dialog.DialogWidth[e.width] === M ? e.width : U.Block.Dialog.DialogWidth[e.width] : e.width), e.isOpen != null && j.hasOwnProperty.call(e, "isOpen") && (r.isOpen = e.isOpen), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.position != null && j.hasOwnProperty.call(e, "position") && (r.position = t.enums === I ? U.Block.Dialog.DialogPosition[e.position] === M ? e.position : U.Block.Dialog.DialogPosition[e.position] : e.position), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Dialog";
		}, e.DialogWidth = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "SMALL"] = 0, t[e[1] = "LARGE"] = 1, t[e[2] = "MEDIUM"] = 2, t;
		})(), e.DialogPosition = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "CENTER"] = 0, t[e[1] = "LEFT"] = 1, t[e[2] = "RIGHT"] = 2, t;
		})(), e;
	})(), e.Form = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.formId = "", e.prototype.clearOnSubmit = !1, e.prototype.border = !1, e.prototype.enterToSubmit = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(10).string(e.formId), e.clearOnSubmit != null && j.hasOwnProperty.call(e, "clearOnSubmit") && e.clearOnSubmit !== !1 && t.uint32(16).bool(e.clearOnSubmit), e.border != null && j.hasOwnProperty.call(e, "border") && e.border !== !1 && t.uint32(24).bool(e.border), e.enterToSubmit != null && j.hasOwnProperty.call(e, "enterToSubmit") && e.enterToSubmit !== !1 && t.uint32(32).bool(e.enterToSubmit), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Form(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.clearOnSubmit = s : delete o.clearOnSubmit;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.bool()) ? o.border = s : delete o.border;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.enterToSubmit = s : delete o.enterToSubmit;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Form) return e;
			if (!A.isObject(e)) throw F(".Block.Form: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Form();
			return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.clearOnSubmit != null && e.clearOnSubmit && (n.clearOnSubmit = L(e.clearOnSubmit)), e.border != null && e.border && (n.border = L(e.border)), e.enterToSubmit != null && e.enterToSubmit && (n.enterToSubmit = L(e.enterToSubmit)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.formId = "", r.clearOnSubmit = !1, r.border = !1, r.enterToSubmit = !1), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.clearOnSubmit != null && j.hasOwnProperty.call(e, "clearOnSubmit") && (r.clearOnSubmit = e.clearOnSubmit), e.border != null && j.hasOwnProperty.call(e, "border") && (r.border = e.border), e.enterToSubmit != null && j.hasOwnProperty.call(e, "enterToSubmit") && (r.enterToSubmit = e.enterToSubmit), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Form";
		}, e;
	})(), e.TabContainer = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.defaultTabIndex = 0, e.prototype.id = null, e.prototype.queryParamKey = null, e.prototype.defaultTabLabel = null;
		let t;
		return j.defineProperty(e.prototype, "_id", {
			get: A.oneOfGetter(t = ["id"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_queryParamKey", {
			get: A.oneOfGetter(t = ["queryParamKey"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_defaultTabLabel", {
			get: A.oneOfGetter(t = ["defaultTabLabel"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.defaultTabIndex != null && j.hasOwnProperty.call(e, "defaultTabIndex") && e.defaultTabIndex !== 0 && t.uint32(8).int32(e.defaultTabIndex), e.id != null && j.hasOwnProperty.call(e, "id") && t.uint32(18).string(e.id), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(26).string(e.queryParamKey), e.defaultTabLabel != null && j.hasOwnProperty.call(e, "defaultTabLabel") && t.uint32(34).string(e.defaultTabLabel), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.TabContainer(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						(s = e.int32()) ? o.defaultTabIndex = s : delete o.defaultTabIndex;
						continue;
					case 2:
						if (a !== 2) break;
						o.id = e.stringVerify(), o._id = "id";
						continue;
					case 3:
						if (a !== 2) break;
						o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
						continue;
					case 4:
						if (a !== 2) break;
						o.defaultTabLabel = e.stringVerify(), o._defaultTabLabel = "defaultTabLabel";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.TabContainer) return e;
			if (!A.isObject(e)) throw F(".Block.TabContainer: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.TabContainer();
			return e.defaultTabIndex != null && R(e.defaultTabIndex) !== 0 && (n.defaultTabIndex = e.defaultTabIndex | 0), e.id != null && (n.id = I(e.id)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.defaultTabLabel != null && (n.defaultTabLabel = I(e.defaultTabLabel)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.defaultTabIndex = 0), e.defaultTabIndex != null && j.hasOwnProperty.call(e, "defaultTabIndex") && (r.defaultTabIndex = e.defaultTabIndex), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.defaultTabLabel != null && j.hasOwnProperty.call(e, "defaultTabLabel") && (r.defaultTabLabel = e.defaultTabLabel), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.TabContainer";
		}, e;
	})(), e.Tab = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.label = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(10).string(e.label), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Tab(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.label = s : delete o.label;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Tab) return e;
			if (!A.isObject(e)) throw F(".Block.Tab: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Tab();
			return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = ""), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Tab";
		}, e;
	})(), e.Popover = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.label = "", e.prototype.help = "", e.prototype.disabled = !1, e.prototype.icon = "", e.prototype.type = "", e.prototype.open = null, e.prototype.id = null, e.prototype.wrap = null;
		let t;
		return j.defineProperty(e.prototype, "_open", {
			get: A.oneOfGetter(t = ["open"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_id", {
			get: A.oneOfGetter(t = ["id"]),
			set: A.oneOfSetter(t)
		}), j.defineProperty(e.prototype, "_wrap", {
			get: A.oneOfGetter(t = ["wrap"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(10).string(e.label), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(26).string(e.help), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(32).bool(e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(42).string(e.icon), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(50).string(e.type), e.open != null && j.hasOwnProperty.call(e, "open") && t.uint32(56).bool(e.open), e.id != null && j.hasOwnProperty.call(e, "id") && t.uint32(66).string(e.id), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(72).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Popover(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.label = s : delete o.label;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.help = s : delete o.help;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.disabled = s : delete o.disabled;
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
						continue;
					case 6:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.type = s : delete o.type;
						continue;
					case 7:
						if (a !== 0) break;
						o.open = e.bool(), o._open = "open";
						continue;
					case 8:
						if (a !== 2) break;
						o.id = e.stringVerify(), o._id = "id";
						continue;
					case 9:
						if (a !== 0) break;
						o.wrap = e.bool(), o._wrap = "wrap";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Popover) return e;
			if (!A.isObject(e)) throw F(".Block.Popover: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.Popover();
			return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.open != null && (n.open = L(e.open)), e.id != null && (n.id = I(e.id)), e.wrap != null && (n.wrap = L(e.wrap)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.label = "", r.help = "", r.disabled = !1, r.icon = "", r.type = ""), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.open != null && j.hasOwnProperty.call(e, "open") && (r.open = e.open), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Popover";
		}, e;
	})(), e.ChatMessage = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.name = "", e.prototype.avatar = "", e.prototype.avatarType = 0, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.avatar != null && j.hasOwnProperty.call(e, "avatar") && e.avatar !== "" && t.uint32(18).string(e.avatar), e.avatarType != null && j.hasOwnProperty.call(e, "avatarType") && e.avatarType !== 0 && t.uint32(24).int32(e.avatarType), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.ChatMessage(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.avatar = s : delete o.avatar;
						continue;
					case 3:
						if (a !== 0) break;
						(s = e.int32()) ? o.avatarType = s : delete o.avatarType;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.ChatMessage) return e;
			if (!A.isObject(e)) throw F(".Block.ChatMessage: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.Block.ChatMessage();
			if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.avatar != null && (typeof e.avatar != "string" || e.avatar.length) && (n.avatar = I(e.avatar)), e.avatarType !== 0 && (typeof e.avatarType != "string" || U.Block.ChatMessage.AvatarType[e.avatarType] !== 0)) switch (e.avatarType) {
				case "IMAGE":
				case 0:
					n.avatarType = 0;
					break;
				case "EMOJI":
				case 1:
					n.avatarType = 1;
					break;
				case "ICON":
				case 2:
					n.avatarType = 2;
					break;
				default: typeof e.avatarType == "number" && (e.avatarType | 0) === e.avatarType && (n.avatarType = e.avatarType);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.name = "", r.avatar = "", r.avatarType = t.enums === I ? "IMAGE" : 0), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.avatar != null && j.hasOwnProperty.call(e, "avatar") && (r.avatar = e.avatar), e.avatarType != null && j.hasOwnProperty.call(e, "avatarType") && (r.avatarType = t.enums === I ? U.Block.ChatMessage.AvatarType[e.avatarType] === M ? e.avatarType : U.Block.ChatMessage.AvatarType[e.avatarType] : e.avatarType), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.ChatMessage";
		}, e.AvatarType = (function() {
			let e = j.create(null), t = j.create(e);
			return t[e[0] = "IMAGE"] = 0, t[e[1] = "EMOJI"] = 1, t[e[2] = "ICON"] = 2, t;
		})(), e;
	})(), e.Transparent = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.Block.Transparent(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.Block.Transparent) return e;
			if (!A.isObject(e)) throw F(".Block.Transparent: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			return new U.Block.Transparent();
		}, e.toObject = function() {
			return {};
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/Block.Transparent";
		}, e;
	})(), e;
})(), U.Button = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.isFormSubmitter = !1, e.prototype.type = "", e.prototype.disabled = !1, e.prototype.icon = "", e.prototype.shortcut = "", e.prototype.iconPosition = 0, e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== !1 && t.uint32(24).bool(e.default), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.isFormSubmitter != null && j.hasOwnProperty.call(e, "isFormSubmitter") && e.isFormSubmitter !== !1 && t.uint32(48).bool(e.isFormSubmitter), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(58).string(e.type), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(64).bool(e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(82).string(e.icon), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && e.shortcut !== "" && t.uint32(90).string(e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && e.iconPosition !== 0 && t.uint32(96).int32(e.iconPosition), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(104).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Button(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFormSubmitter = s : delete o.isFormSubmitter;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
				case 13:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Button) return e;
		if (!A.isObject(e)) throw F(".Button: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Button();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && e.default && (n.default = L(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.isFormSubmitter != null && e.isFormSubmitter && (n.isFormSubmitter = L(e.isFormSubmitter)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = I(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || U.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
			default: typeof e.iconPosition == "number" && (e.iconPosition | 0) === e.iconPosition && (n.iconPosition = e.iconPosition);
		}
		return e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.isFormSubmitter = !1, r.type = "", r.disabled = !1, r.icon = "", r.shortcut = "", r.iconPosition = t.enums === I ? "LEFT" : 0), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.isFormSubmitter != null && j.hasOwnProperty.call(e, "isFormSubmitter") && (r.isFormSubmitter = e.isFormSubmitter), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && (r.iconPosition = t.enums === I ? U.streamlit.ButtonLikeIconPosition[e.iconPosition] === M ? e.iconPosition : U.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Button";
	}, e;
})(), U.ButtonGroup = (() => {
	let e = function(e) {
		if (this.options = [], this.default = [], this.rawValues = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.options = A.emptyArray, e.prototype.default = A.emptyArray, e.prototype.disabled = !1, e.prototype.clickMode = 0, e.prototype.formId = "", e.prototype.setValue = !1, e.prototype.style = 0, e.prototype.label = "", e.prototype.labelVisibility = null, e.prototype.help = null, e.prototype.rawValues = A.emptyArray, e.prototype.queryParamKey = null, e.prototype.required = !1, e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_help", {
		get: A.oneOfGetter(t = ["help"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.options != null && e.options.length) for (let r = 0; r < e.options.length; ++r) U.ButtonGroup.Option.encode(e.options[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.default != null && e.default.length && t.uint32(26).uint32s(e.default), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(32).bool(e.disabled), e.clickMode != null && j.hasOwnProperty.call(e, "clickMode") && e.clickMode !== 0 && t.uint32(40).int32(e.clickMode), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(64).bool(e.setValue), e.style != null && j.hasOwnProperty.call(e, "style") && e.style !== 0 && t.uint32(80).int32(e.style), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(90).string(e.label), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.help != null && j.hasOwnProperty.call(e, "help") && t.uint32(106).string(e.help), e.rawValues != null && e.rawValues.length) for (let n = 0; n < e.rawValues.length; ++n) t.uint32(114).string(e.rawValues[n]);
		if (e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.required != null && j.hasOwnProperty.call(e, "required") && e.required !== !1 && t.uint32(128).bool(e.required), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(136).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ButtonGroup(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(U.ButtonGroup.Option.decode(e, e.uint32(), M, r + 1));
					continue;
				case 3:
					if (a === 2) {
						o.default && o.default.length || (o.default = []), e.uint32s(o.default);
						continue;
					}
					if (a !== 0) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.uint32());
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.clickMode = s : delete o.clickMode;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.style = s : delete o.style;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					o.help = e.stringVerify(), o._help = "help";
					continue;
				case 14:
					if (a !== 2) break;
					o.rawValues && o.rawValues.length || (o.rawValues = []), o.rawValues.push(e.stringVerify());
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 16:
					if (a !== 0) break;
					(s = e.bool()) ? o.required = s : delete o.required;
					continue;
				case 17:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ButtonGroup) return e;
		if (!A.isObject(e)) throw F(".ButtonGroup: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ButtonGroup();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.options) {
			if (!B.isArray(e.options)) throw F(".ButtonGroup.options: array expected");
			n.options = B(e.options.length);
			for (let r = 0; r < e.options.length; ++r) {
				if (!A.isObject(e.options[r])) throw F(".ButtonGroup.options: object expected");
				n.options[r] = U.ButtonGroup.Option.fromObject(e.options[r], t + 1);
			}
		}
		if (e.default) {
			if (!B.isArray(e.default)) throw F(".ButtonGroup.default: array expected");
			n.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = e.default[t] >>> 0;
		}
		if (e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.clickMode !== 0 && (typeof e.clickMode != "string" || U.ButtonGroup.ClickMode[e.clickMode] !== 0)) switch (e.clickMode) {
			case "SINGLE_SELECT":
			case 0:
				n.clickMode = 0;
				break;
			case "MULTI_SELECT":
			case 1:
				n.clickMode = 1;
				break;
			default: typeof e.clickMode == "number" && (e.clickMode | 0) === e.clickMode && (n.clickMode = e.clickMode);
		}
		if (e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.style !== 0 && (typeof e.style != "string" || U.ButtonGroup.Style[e.style] !== 0)) switch (e.style) {
			case "SEGMENTED_CONTROL":
			case 0:
				n.style = 0;
				break;
			case "PILLS":
			case 1:
				n.style = 1;
				break;
			default: typeof e.style == "number" && (e.style | 0) === e.style && (n.style = e.style);
		}
		if (e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".ButtonGroup.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.help != null && (n.help = I(e.help)), e.rawValues) {
			if (!B.isArray(e.rawValues)) throw F(".ButtonGroup.rawValues: array expected");
			n.rawValues = B(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) n.rawValues[t] = I(e.rawValues[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.required != null && e.required && (n.required = L(e.required)), e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = [], r.default = [], r.rawValues = []), t.defaults && (r.id = "", r.disabled = !1, r.clickMode = t.enums === I ? "SINGLE_SELECT" : 0, r.formId = "", r.setValue = !1, r.style = t.enums === I ? "SEGMENTED_CONTROL" : 0, r.label = "", r.labelVisibility = null, r.required = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let i = 0; i < e.options.length; ++i) r.options[i] = U.ButtonGroup.Option.toObject(e.options[i], t, n + 1);
		}
		if (e.default && e.default.length) {
			r.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.clickMode != null && j.hasOwnProperty.call(e, "clickMode") && (r.clickMode = t.enums === I ? U.ButtonGroup.ClickMode[e.clickMode] === M ? e.clickMode : U.ButtonGroup.ClickMode[e.clickMode] : e.clickMode), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.style != null && j.hasOwnProperty.call(e, "style") && (r.style = t.enums === I ? U.ButtonGroup.Style[e.style] === M ? e.style : U.ButtonGroup.Style[e.style] : e.style), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.rawValues && e.rawValues.length) {
			r.rawValues = B(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) r.rawValues[t] = e.rawValues[t];
		}
		return e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.required != null && j.hasOwnProperty.call(e, "required") && (r.required = e.required), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ButtonGroup";
	}, e.ClickMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SINGLE_SELECT"] = 0, t[e[1] = "MULTI_SELECT"] = 1, t;
	})(), e.Option = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.content = "", e.prototype.contentIcon = null;
		let t;
		return j.defineProperty(e.prototype, "_contentIcon", {
			get: A.oneOfGetter(t = ["contentIcon"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.content != null && j.hasOwnProperty.call(e, "content") && e.content !== "" && t.uint32(10).string(e.content), e.contentIcon != null && j.hasOwnProperty.call(e, "contentIcon") && t.uint32(26).string(e.contentIcon), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.ButtonGroup.Option(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.content = s : delete o.content;
						continue;
					case 3:
						if (a !== 2) break;
						o.contentIcon = e.stringVerify(), o._contentIcon = "contentIcon";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.ButtonGroup.Option) return e;
			if (!A.isObject(e)) throw F(".ButtonGroup.Option: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.ButtonGroup.Option();
			return e.content != null && (typeof e.content != "string" || e.content.length) && (n.content = I(e.content)), e.contentIcon != null && (n.contentIcon = I(e.contentIcon)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.content = ""), e.content != null && j.hasOwnProperty.call(e, "content") && (r.content = e.content), e.contentIcon != null && j.hasOwnProperty.call(e, "contentIcon") && (r.contentIcon = e.contentIcon), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/ButtonGroup.Option";
		}, e;
	})(), e.Style = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SEGMENTED_CONTROL"] = 0, t[e[1] = "PILLS"] = 1, t;
	})(), e;
})(), U.CameraInput = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.resolutionHeight = null;
	let t;
	return j.defineProperty(e.prototype, "_resolutionHeight", {
		get: A.oneOfGetter(t = ["resolutionHeight"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(26).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(34).string(e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(40).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(50).fork(), n + 1).ldelim(), e.resolutionHeight != null && j.hasOwnProperty.call(e, "resolutionHeight") && t.uint32(56).int32(e.resolutionHeight), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.CameraInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 7:
					if (a !== 0) break;
					o.resolutionHeight = e.int32(), o._resolutionHeight = "resolutionHeight";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.CameraInput) return e;
		if (!A.isObject(e)) throw F(".CameraInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.CameraInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".CameraInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.resolutionHeight != null && (n.resolutionHeight = e.resolutionHeight | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.resolutionHeight != null && j.hasOwnProperty.call(e, "resolutionHeight") && (r.resolutionHeight = e.resolutionHeight), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/CameraInput";
	}, e;
})(), U.ChatInput = (() => {
	let e = function(e) {
		if (this.fileType = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.placeholder = "", e.prototype.maxChars = 0, e.prototype.disabled = !1, e.prototype.value = "", e.prototype.setValue = !1, e.prototype.default = "", e.prototype.acceptFile = 0, e.prototype.fileType = A.emptyArray, e.prototype.maxUploadSizeMb = 0, e.prototype.acceptAudio = !1, e.prototype.audioSampleRate = null, e.prototype.submitMode = 0, e.prototype.isAutoPositionedAtBottom = !1;
	let t;
	return j.defineProperty(e.prototype, "_audioSampleRate", {
		get: A.oneOfGetter(t = ["audioSampleRate"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(18).string(e.placeholder), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && e.maxChars !== 0 && t.uint32(24).uint32(e.maxChars), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(32).bool(e.disabled), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== "" && t.uint32(42).string(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(48).bool(e.setValue), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== "" && t.uint32(58).string(e.default), e.acceptFile != null && j.hasOwnProperty.call(e, "acceptFile") && e.acceptFile !== 0 && t.uint32(72).int32(e.acceptFile), e.fileType != null && e.fileType.length) for (let n = 0; n < e.fileType.length; ++n) t.uint32(82).string(e.fileType[n]);
		if (e.maxUploadSizeMb != null && j.hasOwnProperty.call(e, "maxUploadSizeMb") && e.maxUploadSizeMb !== 0 && t.uint32(88).int32(e.maxUploadSizeMb), e.acceptAudio != null && j.hasOwnProperty.call(e, "acceptAudio") && e.acceptAudio !== !1 && t.uint32(96).bool(e.acceptAudio), e.audioSampleRate != null && j.hasOwnProperty.call(e, "audioSampleRate") && t.uint32(104).int32(e.audioSampleRate), e.submitMode != null && j.hasOwnProperty.call(e, "submitMode") && e.submitMode !== 0 && t.uint32(112).int32(e.submitMode), e.isAutoPositionedAtBottom != null && j.hasOwnProperty.call(e, "isAutoPositionedAtBottom") && e.isAutoPositionedAtBottom !== !1 && t.uint32(120).bool(e.isAutoPositionedAtBottom), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ChatInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.value = s : delete o.value;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.default = s : delete o.default;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.int32()) ? o.acceptFile = s : delete o.acceptFile;
					continue;
				case 10:
					if (a !== 2) break;
					o.fileType && o.fileType.length || (o.fileType = []), o.fileType.push(e.stringVerify());
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxUploadSizeMb = s : delete o.maxUploadSizeMb;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.acceptAudio = s : delete o.acceptAudio;
					continue;
				case 13:
					if (a !== 0) break;
					o.audioSampleRate = e.int32(), o._audioSampleRate = "audioSampleRate";
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.int32()) ? o.submitMode = s : delete o.submitMode;
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.bool()) ? o.isAutoPositionedAtBottom = s : delete o.isAutoPositionedAtBottom;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ChatInput) return e;
		if (!A.isObject(e)) throw F(".ChatInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ChatInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.maxChars != null && R(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = I(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.default != null && (typeof e.default != "string" || e.default.length) && (n.default = I(e.default)), e.acceptFile !== 0 && (typeof e.acceptFile != "string" || U.ChatInput.AcceptFile[e.acceptFile] !== 0)) switch (e.acceptFile) {
			case "NONE":
			case 0:
				n.acceptFile = 0;
				break;
			case "SINGLE":
			case 1:
				n.acceptFile = 1;
				break;
			case "MULTIPLE":
			case 2:
				n.acceptFile = 2;
				break;
			case "DIRECTORY":
			case 3:
				n.acceptFile = 3;
				break;
			default: typeof e.acceptFile == "number" && (e.acceptFile | 0) === e.acceptFile && (n.acceptFile = e.acceptFile);
		}
		if (e.fileType) {
			if (!B.isArray(e.fileType)) throw F(".ChatInput.fileType: array expected");
			n.fileType = B(e.fileType.length);
			for (let t = 0; t < e.fileType.length; ++t) n.fileType[t] = I(e.fileType[t]);
		}
		if (e.maxUploadSizeMb != null && R(e.maxUploadSizeMb) !== 0 && (n.maxUploadSizeMb = e.maxUploadSizeMb | 0), e.acceptAudio != null && e.acceptAudio && (n.acceptAudio = L(e.acceptAudio)), e.audioSampleRate != null && (n.audioSampleRate = e.audioSampleRate | 0), e.submitMode !== 0 && (typeof e.submitMode != "string" || U.ChatInput.SubmitMode[e.submitMode] !== 0)) switch (e.submitMode) {
			case "SUBMIT_MODE_SUBMIT":
			case 0:
				n.submitMode = 0;
				break;
			case "SUBMIT_MODE_DISABLE":
			case 1:
				n.submitMode = 1;
				break;
			case "SUBMIT_MODE_STOP":
			case 2:
				n.submitMode = 2;
				break;
			default: typeof e.submitMode == "number" && (e.submitMode | 0) === e.submitMode && (n.submitMode = e.submitMode);
		}
		return e.isAutoPositionedAtBottom != null && e.isAutoPositionedAtBottom && (n.isAutoPositionedAtBottom = L(e.isAutoPositionedAtBottom)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fileType = []), t.defaults && (r.id = "", r.placeholder = "", r.maxChars = 0, r.disabled = !1, r.value = "", r.setValue = !1, r.default = "", r.acceptFile = t.enums === I ? "NONE" : 0, r.maxUploadSizeMb = 0, r.acceptAudio = !1, r.submitMode = t.enums === I ? "SUBMIT_MODE_SUBMIT" : 0, r.isAutoPositionedAtBottom = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && (r.maxChars = e.maxChars), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.acceptFile != null && j.hasOwnProperty.call(e, "acceptFile") && (r.acceptFile = t.enums === I ? U.ChatInput.AcceptFile[e.acceptFile] === M ? e.acceptFile : U.ChatInput.AcceptFile[e.acceptFile] : e.acceptFile), e.fileType && e.fileType.length) {
			r.fileType = B(e.fileType.length);
			for (let t = 0; t < e.fileType.length; ++t) r.fileType[t] = e.fileType[t];
		}
		return e.maxUploadSizeMb != null && j.hasOwnProperty.call(e, "maxUploadSizeMb") && (r.maxUploadSizeMb = e.maxUploadSizeMb), e.acceptAudio != null && j.hasOwnProperty.call(e, "acceptAudio") && (r.acceptAudio = e.acceptAudio), e.audioSampleRate != null && j.hasOwnProperty.call(e, "audioSampleRate") && (r.audioSampleRate = e.audioSampleRate), e.submitMode != null && j.hasOwnProperty.call(e, "submitMode") && (r.submitMode = t.enums === I ? U.ChatInput.SubmitMode[e.submitMode] === M ? e.submitMode : U.ChatInput.SubmitMode[e.submitMode] : e.submitMode), e.isAutoPositionedAtBottom != null && j.hasOwnProperty.call(e, "isAutoPositionedAtBottom") && (r.isAutoPositionedAtBottom = e.isAutoPositionedAtBottom), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ChatInput";
	}, e.AcceptFile = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "NONE"] = 0, t[e[1] = "SINGLE"] = 1, t[e[2] = "MULTIPLE"] = 2, t[e[3] = "DIRECTORY"] = 3, t;
	})(), e.SubmitMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SUBMIT_MODE_SUBMIT"] = 0, t[e[1] = "SUBMIT_MODE_DISABLE"] = 1, t[e[2] = "SUBMIT_MODE_STOP"] = 2, t;
	})(), e;
})(), U.Checkbox = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = !1, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.type = 0, e.prototype.queryParamKey = null, e.prototype.wrap = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== !1 && t.uint32(24).bool(e.default), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== !1 && t.uint32(48).bool(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(56).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(64).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(80).int32(e.type), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(90).string(e.queryParamKey), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(96).bool(e.wrap), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(104).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Checkbox(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.value = s : delete o.value;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 11:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 12:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Checkbox) return e;
		if (!A.isObject(e)) throw F(".Checkbox: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Checkbox();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && e.default && (n.default = L(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && e.value && (n.value = L(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".Checkbox.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.type !== 0 && (typeof e.type != "string" || U.Checkbox.StyleType[e.type] !== 0)) switch (e.type) {
			case "DEFAULT":
			case 0:
				n.type = 0;
				break;
			case "TOGGLE":
			case 1:
				n.type = 1;
				break;
			default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.wrap != null && (n.wrap = L(e.wrap)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.value = !1, r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.type = t.enums === I ? "DEFAULT" : 0, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.Checkbox.StyleType[e.type] === M ? e.type : U.Checkbox.StyleType[e.type] : e.type), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Checkbox";
	}, e.StyleType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "TOGGLE"] = 1, t;
	})(), e;
})(), U.Code = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.codeText = "", e.prototype.language = "", e.prototype.showLineNumbers = !1, e.prototype.wrapLines = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.codeText != null && j.hasOwnProperty.call(e, "codeText") && e.codeText !== "" && t.uint32(10).string(e.codeText), e.language != null && j.hasOwnProperty.call(e, "language") && e.language !== "" && t.uint32(18).string(e.language), e.showLineNumbers != null && j.hasOwnProperty.call(e, "showLineNumbers") && e.showLineNumbers !== !1 && t.uint32(24).bool(e.showLineNumbers), e.wrapLines != null && j.hasOwnProperty.call(e, "wrapLines") && e.wrapLines !== !1 && t.uint32(32).bool(e.wrapLines), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Code(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.codeText = s : delete o.codeText;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.language = s : delete o.language;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.showLineNumbers = s : delete o.showLineNumbers;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.wrapLines = s : delete o.wrapLines;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Code) return e;
		if (!A.isObject(e)) throw F(".Code: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Code();
		return e.codeText != null && (typeof e.codeText != "string" || e.codeText.length) && (n.codeText = I(e.codeText)), e.language != null && (typeof e.language != "string" || e.language.length) && (n.language = I(e.language)), e.showLineNumbers != null && e.showLineNumbers && (n.showLineNumbers = L(e.showLineNumbers)), e.wrapLines != null && e.wrapLines && (n.wrapLines = L(e.wrapLines)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.codeText = "", r.language = "", r.showLineNumbers = !1, r.wrapLines = !1), e.codeText != null && j.hasOwnProperty.call(e, "codeText") && (r.codeText = e.codeText), e.language != null && j.hasOwnProperty.call(e, "language") && (r.language = e.language), e.showLineNumbers != null && j.hasOwnProperty.call(e, "showLineNumbers") && (r.showLineNumbers = e.showLineNumbers), e.wrapLines != null && j.hasOwnProperty.call(e, "wrapLines") && (r.wrapLines = e.wrapLines), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Code";
	}, e;
})(), U.ColorPicker = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.value = "", e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.queryParamKey = null;
	let t;
	return j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== "" && t.uint32(26).string(e.default), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== "" && t.uint32(50).string(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(56).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(64).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(82).string(e.queryParamKey), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ColorPicker(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.value = s : delete o.value;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ColorPicker) return e;
		if (!A.isObject(e)) throw F(".ColorPicker: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ColorPicker();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (typeof e.default != "string" || e.default.length) && (n.default = I(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = I(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".ColorPicker.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = "", r.help = "", r.formId = "", r.value = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ColorPicker";
	}, e;
})(), U.DateInput = (() => {
	let e = function(e) {
		if (this.default = [], this.value = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = A.emptyArray, e.prototype.min = "", e.prototype.max = "", e.prototype.isRange = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = A.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.format = "", e.prototype.queryParamKey = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && e.default.length) for (let n = 0; n < e.default.length; ++n) t.uint32(26).string(e.default[n]);
		if (e.min != null && j.hasOwnProperty.call(e, "min") && e.min !== "" && t.uint32(34).string(e.min), e.max != null && j.hasOwnProperty.call(e, "max") && e.max !== "" && t.uint32(42).string(e.max), e.isRange != null && j.hasOwnProperty.call(e, "isRange") && e.isRange !== !1 && t.uint32(48).bool(e.isRange), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(58).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(66).string(e.formId), e.value != null && e.value.length) for (let n = 0; n < e.value.length; ++n) t.uint32(74).string(e.value[n]);
		if (e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(80).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(88).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== "" && t.uint32(106).string(e.format), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(120).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DateInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.stringVerify());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.min = s : delete o.min;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.max = s : delete o.max;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.isRange = s : delete o.isRange;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 9:
					if (a !== 2) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.stringVerify());
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.format = s : delete o.format;
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DateInput) return e;
		if (!A.isObject(e)) throw F(".DateInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DateInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default) {
			if (!B.isArray(e.default)) throw F(".DateInput.default: array expected");
			n.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = I(e.default[t]);
		}
		if (e.min != null && (typeof e.min != "string" || e.min.length) && (n.min = I(e.min)), e.max != null && (typeof e.max != "string" || e.max.length) && (n.max = I(e.max)), e.isRange != null && e.isRange && (n.isRange = L(e.isRange)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value) {
			if (!B.isArray(e.value)) throw F(".DateInput.value: array expected");
			n.value = B(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = I(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".DateInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = I(e.format)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = []), t.defaults && (r.id = "", r.label = "", r.min = "", r.max = "", r.isRange = !1, r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.format = "", r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default && e.default.length) {
			r.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.min != null && j.hasOwnProperty.call(e, "min") && (r.min = e.min), e.max != null && j.hasOwnProperty.call(e, "max") && (r.max = e.max), e.isRange != null && j.hasOwnProperty.call(e, "isRange") && (r.isRange = e.isRange), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value && e.value.length) {
			r.value = B(e.value.length);
			for (let t = 0; t < e.value.length; ++t) r.value[t] = e.value[t];
		}
		return e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DateInput";
	}, e;
})(), U.DateTimeInput = (() => {
	let e = function(e) {
		if (this.default = [], this.value = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = A.emptyArray, e.prototype.min = "", e.prototype.max = "", e.prototype.help = "", e.prototype.formId = "", e.prototype.value = A.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.format = "", e.prototype.step = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.isRange = !1, e.prototype.queryParamKey = null;
	let t;
	return j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && e.default.length) for (let n = 0; n < e.default.length; ++n) t.uint32(26).string(e.default[n]);
		if (e.min != null && j.hasOwnProperty.call(e, "min") && e.min !== "" && t.uint32(34).string(e.min), e.max != null && j.hasOwnProperty.call(e, "max") && e.max !== "" && t.uint32(42).string(e.max), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(50).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(58).string(e.formId), e.value != null && e.value.length) for (let n = 0; n < e.value.length; ++n) t.uint32(66).string(e.value[n]);
		if (e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(72).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(80).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(90).fork(), n + 1).ldelim(), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== "" && t.uint32(98).string(e.format), e.step != null && j.hasOwnProperty.call(e, "step") && (typeof e.step == "object" ? e.step.low || e.step.high : e.step !== 0) && t.uint32(104).int64(e.step), e.isRange != null && j.hasOwnProperty.call(e, "isRange") && e.isRange !== !1 && t.uint32(112).bool(e.isRange), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DateTimeInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.stringVerify());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.min = s : delete o.min;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.max = s : delete o.max;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.stringVerify());
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 11:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.format = s : delete o.format;
					continue;
				case 13:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.step = s : delete o.step;
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.bool()) ? o.isRange = s : delete o.isRange;
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DateTimeInput) return e;
		if (!A.isObject(e)) throw F(".DateTimeInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DateTimeInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default) {
			if (!B.isArray(e.default)) throw F(".DateTimeInput.default: array expected");
			n.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = I(e.default[t]);
		}
		if (e.min != null && (typeof e.min != "string" || e.min.length) && (n.min = I(e.min)), e.max != null && (typeof e.max != "string" || e.max.length) && (n.max = I(e.max)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value) {
			if (!B.isArray(e.value)) throw F(".DateTimeInput.value: array expected");
			n.value = B(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = I(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".DateTimeInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = I(e.format)), e.step != null && (typeof e.step == "object" ? e.step.low || e.step.high : R(e.step) !== 0) && (A.Long ? n.step = A.Long.fromValue(e.step, !1) : typeof e.step == "string" ? n.step = V(e.step, 10) : typeof e.step == "number" ? n.step = e.step : typeof e.step == "object" && (n.step = new A.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber())), e.isRange != null && e.isRange && (n.isRange = L(e.isRange)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = []), t.defaults) {
			if (r.id = "", r.label = "", r.min = "", r.max = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.format = "", A.Long) {
				let e = new A.Long(0, 0, !1);
				r.step = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.step = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.isRange = !1;
		}
		if (e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default && e.default.length) {
			r.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.min != null && j.hasOwnProperty.call(e, "min") && (r.min = e.min), e.max != null && j.hasOwnProperty.call(e, "max") && (r.max = e.max), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value && e.value.length) {
			r.value = B(e.value.length);
			for (let t = 0; t < e.value.length; ++t) r.value[t] = e.value[t];
		}
		return e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.step != null && j.hasOwnProperty.call(e, "step") && (r.step = H !== void 0 && t.longs === H ? typeof e.step == "number" ? H(e.step) : A.Long.fromBits(e.step.low >>> 0, e.step.high >>> 0, !1).toBigInt() : typeof e.step == "number" ? t.longs === I ? I(e.step) : e.step : t.longs === I ? A.Long.prototype.toString.call(e.step) : t.longs === R ? new A.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber() : e.step), e.isRange != null && j.hasOwnProperty.call(e, "isRange") && (r.isRange = e.isRange), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DateTimeInput";
	}, e;
})(), U.DeckGlJsonChart = (() => {
	let e = function(e) {
		if (this.selectionMode = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.json = "", e.prototype.tooltip = "", e.prototype.id = "", e.prototype.mapboxToken = "", e.prototype.selectionMode = A.emptyArray, e.prototype.formId = "", e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.json != null && j.hasOwnProperty.call(e, "json") && e.json !== "" && t.uint32(10).string(e.json), e.tooltip != null && j.hasOwnProperty.call(e, "tooltip") && e.tooltip !== "" && t.uint32(18).string(e.tooltip), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(42).string(e.id), e.mapboxToken != null && j.hasOwnProperty.call(e, "mapboxToken") && e.mapboxToken !== "" && t.uint32(50).string(e.mapboxToken), e.selectionMode != null && e.selectionMode.length && t.uint32(74).int32s(e.selectionMode), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(82).string(e.formId), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(90).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DeckGlJsonChart(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.json = s : delete o.json;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.tooltip = s : delete o.tooltip;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.mapboxToken = s : delete o.mapboxToken;
					continue;
				case 9:
					if (a === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []), e.int32s(o.selectionMode);
						continue;
					}
					if (a !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 11:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DeckGlJsonChart) return e;
		if (!A.isObject(e)) throw F(".DeckGlJsonChart: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DeckGlJsonChart();
		if (e.json != null && (typeof e.json != "string" || e.json.length) && (n.json = I(e.json)), e.tooltip != null && (typeof e.tooltip != "string" || e.tooltip.length) && (n.tooltip = I(e.tooltip)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.mapboxToken != null && (typeof e.mapboxToken != "string" || e.mapboxToken.length) && (n.mapboxToken = I(e.mapboxToken)), e.selectionMode) {
			if (!B.isArray(e.selectionMode)) throw F(".DeckGlJsonChart.selectionMode: array expected");
			n.selectionMode = [];
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				case "SINGLE_OBJECT":
				case 0:
					n.selectionMode[n.selectionMode.length] = 0;
					break;
				case "MULTI_OBJECT":
				case 1:
					n.selectionMode[n.selectionMode.length] = 1;
					break;
				default: typeof e.selectionMode[t] == "number" && (e.selectionMode[t] | 0) === e.selectionMode[t] && (n.selectionMode[n.selectionMode.length] = e.selectionMode[t]);
			}
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.selectionMode = []), t.defaults && (r.json = "", r.tooltip = "", r.id = "", r.mapboxToken = "", r.formId = ""), e.json != null && j.hasOwnProperty.call(e, "json") && (r.json = e.json), e.tooltip != null && j.hasOwnProperty.call(e, "tooltip") && (r.tooltip = e.tooltip), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.mapboxToken != null && j.hasOwnProperty.call(e, "mapboxToken") && (r.mapboxToken = e.mapboxToken), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = B(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === I ? U.DeckGlJsonChart.SelectionMode[e.selectionMode[n]] === M ? e.selectionMode[n] : U.DeckGlJsonChart.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		return e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DeckGlJsonChart";
	}, e.SelectionMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SINGLE_OBJECT"] = 0, t[e[1] = "MULTI_OBJECT"] = 1, t;
	})(), e;
})(), U.Delta = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.newElement = null, e.prototype.addBlock = null, e.prototype.newTransient = null, e.prototype.fragmentId = "";
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = [
			"newElement",
			"addBlock",
			"newTransient"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.newElement != null && j.hasOwnProperty.call(e, "newElement") && U.Element.encode(e.newElement, t.uint32(26).fork(), n + 1).ldelim(), e.addBlock != null && j.hasOwnProperty.call(e, "addBlock") && U.Block.encode(e.addBlock, t.uint32(50).fork(), n + 1).ldelim(), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && e.fragmentId !== "" && t.uint32(66).string(e.fragmentId), e.newTransient != null && j.hasOwnProperty.call(e, "newTransient") && U.Transient.encode(e.newTransient, t.uint32(74).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Delta(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					o.newElement = U.Element.decode(e, e.uint32(), M, r + 1, o.newElement), o.type = "newElement";
					continue;
				case 6:
					if (a !== 2) break;
					o.addBlock = U.Block.decode(e, e.uint32(), M, r + 1, o.addBlock), o.type = "addBlock";
					continue;
				case 9:
					if (a !== 2) break;
					o.newTransient = U.Transient.decode(e, e.uint32(), M, r + 1, o.newTransient), o.type = "newTransient";
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fragmentId = s : delete o.fragmentId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Delta) return e;
		if (!A.isObject(e)) throw F(".Delta: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Delta();
		if (e.newElement != null) {
			if (!A.isObject(e.newElement)) throw F(".Delta.newElement: object expected");
			n.newElement = U.Element.fromObject(e.newElement, t + 1);
		}
		if (e.addBlock != null) {
			if (!A.isObject(e.addBlock)) throw F(".Delta.addBlock: object expected");
			n.addBlock = U.Block.fromObject(e.addBlock, t + 1);
		}
		if (e.newTransient != null) {
			if (!A.isObject(e.newTransient)) throw F(".Delta.newTransient: object expected");
			n.newTransient = U.Transient.fromObject(e.newTransient, t + 1);
		}
		return e.fragmentId != null && (typeof e.fragmentId != "string" || e.fragmentId.length) && (n.fragmentId = I(e.fragmentId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.fragmentId = ""), e.newElement != null && j.hasOwnProperty.call(e, "newElement") && (r.newElement = U.Element.toObject(e.newElement, t, n + 1), t.oneofs && (r.type = "newElement")), e.addBlock != null && j.hasOwnProperty.call(e, "addBlock") && (r.addBlock = U.Block.toObject(e.addBlock, t, n + 1), t.oneofs && (r.type = "addBlock")), e.fragmentId != null && j.hasOwnProperty.call(e, "fragmentId") && (r.fragmentId = e.fragmentId), e.newTransient != null && j.hasOwnProperty.call(e, "newTransient") && (r.newTransient = U.Transient.toObject(e.newTransient, t, n + 1), t.oneofs && (r.type = "newTransient")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Delta";
	}, e;
})(), U.Element = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.heightConfig = null, e.prototype.widthConfig = null, e.prototype.textAlignmentConfig = null, e.prototype.hasOneShotEffect = null, e.prototype.alert = null, e.prototype.dataframe = null, e.prototype.table = null, e.prototype.vegaLiteChart = null, e.prototype.audio = null, e.prototype.audioInput = null, e.prototype.balloons = null, e.prototype.bidiComponent = null, e.prototype.button = null, e.prototype.buttonGroup = null, e.prototype.downloadButton = null, e.prototype.cameraInput = null, e.prototype.chatInput = null, e.prototype.checkbox = null, e.prototype.colorPicker = null, e.prototype.componentInstance = null, e.prototype.dateInput = null, e.prototype.deckGlJsonChart = null, e.prototype.helpInfo = null, e.prototype.empty = null, e.prototype.exception = null, e.prototype.favicon = null, e.prototype.feedback = null, e.prototype.fileUploader = null, e.prototype.graphvizChart = null, e.prototype.html = null, e.prototype.iframe = null, e.prototype.imgs = null, e.prototype.json = null, e.prototype.linkButton = null, e.prototype.markdown = null, e.prototype.metric = null, e.prototype.multiselect = null, e.prototype.numberInput = null, e.prototype.pageLink = null, e.prototype.plotlyChart = null, e.prototype.progress = null, e.prototype.radio = null, e.prototype.selectbox = null, e.prototype.skeleton = null, e.prototype.slider = null, e.prototype.snow = null, e.prototype.space = null, e.prototype.spinner = null, e.prototype.text = null, e.prototype.textArea = null, e.prototype.textInput = null, e.prototype.timeInput = null, e.prototype.dateTimeInput = null, e.prototype.toast = null, e.prototype.video = null, e.prototype.heading = null, e.prototype.code = null, e.prototype.menuButton = null, e.prototype.pagination = null, e.prototype.echartsChart = null;
	let t;
	return j.defineProperty(e.prototype, "_heightConfig", {
		get: A.oneOfGetter(t = ["heightConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_widthConfig", {
		get: A.oneOfGetter(t = ["widthConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_textAlignmentConfig", {
		get: A.oneOfGetter(t = ["textAlignmentConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_hasOneShotEffect", {
		get: A.oneOfGetter(t = ["hasOneShotEffect"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = /* @__PURE__ */ "alert.dataframe.table.vegaLiteChart.audio.audioInput.balloons.bidiComponent.button.buttonGroup.downloadButton.cameraInput.chatInput.checkbox.colorPicker.componentInstance.dateInput.deckGlJsonChart.helpInfo.empty.exception.favicon.feedback.fileUploader.graphvizChart.html.iframe.imgs.json.linkButton.markdown.metric.multiselect.numberInput.pageLink.plotlyChart.progress.radio.selectbox.skeleton.slider.snow.space.spinner.text.textArea.textInput.timeInput.dateTimeInput.toast.video.heading.code.menuButton.pagination.echartsChart".split(".")),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.text != null && j.hasOwnProperty.call(e, "text") && U.Text.encode(e.text, t.uint32(10).fork(), n + 1).ldelim(), e.empty != null && j.hasOwnProperty.call(e, "empty") && U.Empty.encode(e.empty, t.uint32(18).fork(), n + 1).ldelim(), e.progress != null && j.hasOwnProperty.call(e, "progress") && U.Progress.encode(e.progress, t.uint32(42).fork(), n + 1).ldelim(), e.imgs != null && j.hasOwnProperty.call(e, "imgs") && U.ImageList.encode(e.imgs, t.uint32(50).fork(), n + 1).ldelim(), e.helpInfo != null && j.hasOwnProperty.call(e, "helpInfo") && U.Help.encode(e.helpInfo, t.uint32(58).fork(), n + 1).ldelim(), e.exception != null && j.hasOwnProperty.call(e, "exception") && U.Exception.encode(e.exception, t.uint32(66).fork(), n + 1).ldelim(), e.balloons != null && j.hasOwnProperty.call(e, "balloons") && U.Balloons.encode(e.balloons, t.uint32(98).fork(), n + 1).ldelim(), e.audio != null && j.hasOwnProperty.call(e, "audio") && U.Audio.encode(e.audio, t.uint32(106).fork(), n + 1).ldelim(), e.video != null && j.hasOwnProperty.call(e, "video") && U.Video.encode(e.video, t.uint32(114).fork(), n + 1).ldelim(), e.plotlyChart != null && j.hasOwnProperty.call(e, "plotlyChart") && U.PlotlyChart.encode(e.plotlyChart, t.uint32(130).fork(), n + 1).ldelim(), e.graphvizChart != null && j.hasOwnProperty.call(e, "graphvizChart") && U.GraphVizChart.encode(e.graphvizChart, t.uint32(146).fork(), n + 1).ldelim(), e.button != null && j.hasOwnProperty.call(e, "button") && U.Button.encode(e.button, t.uint32(154).fork(), n + 1).ldelim(), e.checkbox != null && j.hasOwnProperty.call(e, "checkbox") && U.Checkbox.encode(e.checkbox, t.uint32(162).fork(), n + 1).ldelim(), e.slider != null && j.hasOwnProperty.call(e, "slider") && U.Slider.encode(e.slider, t.uint32(170).fork(), n + 1).ldelim(), e.textArea != null && j.hasOwnProperty.call(e, "textArea") && U.TextArea.encode(e.textArea, t.uint32(178).fork(), n + 1).ldelim(), e.radio != null && j.hasOwnProperty.call(e, "radio") && U.Radio.encode(e.radio, t.uint32(186).fork(), n + 1).ldelim(), e.textInput != null && j.hasOwnProperty.call(e, "textInput") && U.TextInput.encode(e.textInput, t.uint32(194).fork(), n + 1).ldelim(), e.selectbox != null && j.hasOwnProperty.call(e, "selectbox") && U.Selectbox.encode(e.selectbox, t.uint32(202).fork(), n + 1).ldelim(), e.timeInput != null && j.hasOwnProperty.call(e, "timeInput") && U.TimeInput.encode(e.timeInput, t.uint32(210).fork(), n + 1).ldelim(), e.dateInput != null && j.hasOwnProperty.call(e, "dateInput") && U.DateInput.encode(e.dateInput, t.uint32(218).fork(), n + 1).ldelim(), e.multiselect != null && j.hasOwnProperty.call(e, "multiselect") && U.MultiSelect.encode(e.multiselect, t.uint32(226).fork(), n + 1).ldelim(), e.markdown != null && j.hasOwnProperty.call(e, "markdown") && U.Markdown.encode(e.markdown, t.uint32(234).fork(), n + 1).ldelim(), e.alert != null && j.hasOwnProperty.call(e, "alert") && U.Alert.encode(e.alert, t.uint32(242).fork(), n + 1).ldelim(), e.json != null && j.hasOwnProperty.call(e, "json") && U.Json.encode(e.json, t.uint32(250).fork(), n + 1).ldelim(), e.numberInput != null && j.hasOwnProperty.call(e, "numberInput") && U.NumberInput.encode(e.numberInput, t.uint32(258).fork(), n + 1).ldelim(), e.fileUploader != null && j.hasOwnProperty.call(e, "fileUploader") && U.FileUploader.encode(e.fileUploader, t.uint32(266).fork(), n + 1).ldelim(), e.deckGlJsonChart != null && j.hasOwnProperty.call(e, "deckGlJsonChart") && U.DeckGlJsonChart.encode(e.deckGlJsonChart, t.uint32(274).fork(), n + 1).ldelim(), e.colorPicker != null && j.hasOwnProperty.call(e, "colorPicker") && U.ColorPicker.encode(e.colorPicker, t.uint32(282).fork(), n + 1).ldelim(), e.favicon != null && j.hasOwnProperty.call(e, "favicon") && U.Favicon.encode(e.favicon, t.uint32(290).fork(), n + 1).ldelim(), e.componentInstance != null && j.hasOwnProperty.call(e, "componentInstance") && U.ComponentInstance.encode(e.componentInstance, t.uint32(298).fork(), n + 1).ldelim(), e.iframe != null && j.hasOwnProperty.call(e, "iframe") && U.IFrame.encode(e.iframe, t.uint32(306).fork(), n + 1).ldelim(), e.table != null && j.hasOwnProperty.call(e, "table") && U.Table.encode(e.table, t.uint32(314).fork(), n + 1).ldelim(), e.dataframe != null && j.hasOwnProperty.call(e, "dataframe") && U.Dataframe.encode(e.dataframe, t.uint32(322).fork(), n + 1).ldelim(), e.vegaLiteChart != null && j.hasOwnProperty.call(e, "vegaLiteChart") && U.VegaLiteChart.encode(e.vegaLiteChart, t.uint32(330).fork(), n + 1).ldelim(), e.metric != null && j.hasOwnProperty.call(e, "metric") && U.Metric.encode(e.metric, t.uint32(338).fork(), n + 1).ldelim(), e.downloadButton != null && j.hasOwnProperty.call(e, "downloadButton") && U.DownloadButton.encode(e.downloadButton, t.uint32(346).fork(), n + 1).ldelim(), e.spinner != null && j.hasOwnProperty.call(e, "spinner") && U.Spinner.encode(e.spinner, t.uint32(354).fork(), n + 1).ldelim(), e.cameraInput != null && j.hasOwnProperty.call(e, "cameraInput") && U.CameraInput.encode(e.cameraInput, t.uint32(362).fork(), n + 1).ldelim(), e.snow != null && j.hasOwnProperty.call(e, "snow") && U.Snow.encode(e.snow, t.uint32(370).fork(), n + 1).ldelim(), e.heading != null && j.hasOwnProperty.call(e, "heading") && U.Heading.encode(e.heading, t.uint32(378).fork(), n + 1).ldelim(), e.code != null && j.hasOwnProperty.call(e, "code") && U.Code.encode(e.code, t.uint32(386).fork(), n + 1).ldelim(), e.chatInput != null && j.hasOwnProperty.call(e, "chatInput") && U.ChatInput.encode(e.chatInput, t.uint32(394).fork(), n + 1).ldelim(), e.toast != null && j.hasOwnProperty.call(e, "toast") && U.Toast.encode(e.toast, t.uint32(402).fork(), n + 1).ldelim(), e.linkButton != null && j.hasOwnProperty.call(e, "linkButton") && U.LinkButton.encode(e.linkButton, t.uint32(410).fork(), n + 1).ldelim(), e.skeleton != null && j.hasOwnProperty.call(e, "skeleton") && U.Skeleton.encode(e.skeleton, t.uint32(418).fork(), n + 1).ldelim(), e.pageLink != null && j.hasOwnProperty.call(e, "pageLink") && U.PageLink.encode(e.pageLink, t.uint32(426).fork(), n + 1).ldelim(), e.html != null && j.hasOwnProperty.call(e, "html") && U.Html.encode(e.html, t.uint32(434).fork(), n + 1).ldelim(), e.buttonGroup != null && j.hasOwnProperty.call(e, "buttonGroup") && U.ButtonGroup.encode(e.buttonGroup, t.uint32(442).fork(), n + 1).ldelim(), e.audioInput != null && j.hasOwnProperty.call(e, "audioInput") && U.AudioInput.encode(e.audioInput, t.uint32(450).fork(), n + 1).ldelim(), e.heightConfig != null && j.hasOwnProperty.call(e, "heightConfig") && U.streamlit.HeightConfig.encode(e.heightConfig, t.uint32(458).fork(), n + 1).ldelim(), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(466).fork(), n + 1).ldelim(), e.bidiComponent != null && j.hasOwnProperty.call(e, "bidiComponent") && U.BidiComponent.encode(e.bidiComponent, t.uint32(474).fork(), n + 1).ldelim(), e.space != null && j.hasOwnProperty.call(e, "space") && U.Space.encode(e.space, t.uint32(482).fork(), n + 1).ldelim(), e.textAlignmentConfig != null && j.hasOwnProperty.call(e, "textAlignmentConfig") && U.streamlit.TextAlignmentConfig.encode(e.textAlignmentConfig, t.uint32(490).fork(), n + 1).ldelim(), e.dateTimeInput != null && j.hasOwnProperty.call(e, "dateTimeInput") && U.DateTimeInput.encode(e.dateTimeInput, t.uint32(498).fork(), n + 1).ldelim(), e.feedback != null && j.hasOwnProperty.call(e, "feedback") && U.Feedback.encode(e.feedback, t.uint32(506).fork(), n + 1).ldelim(), e.menuButton != null && j.hasOwnProperty.call(e, "menuButton") && U.MenuButton.encode(e.menuButton, t.uint32(514).fork(), n + 1).ldelim(), e.hasOneShotEffect != null && j.hasOwnProperty.call(e, "hasOneShotEffect") && t.uint32(520).bool(e.hasOneShotEffect), e.pagination != null && j.hasOwnProperty.call(e, "pagination") && U.Pagination.encode(e.pagination, t.uint32(530).fork(), n + 1).ldelim(), e.echartsChart != null && j.hasOwnProperty.call(e, "echartsChart") && U.EChartsChart.encode(e.echartsChart, t.uint32(538).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Element(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 57:
					if (a !== 2) break;
					o.heightConfig = U.streamlit.HeightConfig.decode(e, e.uint32(), M, r + 1, o.heightConfig), o._heightConfig = "heightConfig";
					continue;
				case 58:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 61:
					if (a !== 2) break;
					o.textAlignmentConfig = U.streamlit.TextAlignmentConfig.decode(e, e.uint32(), M, r + 1, o.textAlignmentConfig), o._textAlignmentConfig = "textAlignmentConfig";
					continue;
				case 65:
					if (a !== 0) break;
					o.hasOneShotEffect = e.bool(), o._hasOneShotEffect = "hasOneShotEffect";
					continue;
				case 30:
					if (a !== 2) break;
					o.alert = U.Alert.decode(e, e.uint32(), M, r + 1, o.alert), o.type = "alert";
					continue;
				case 40:
					if (a !== 2) break;
					o.dataframe = U.Dataframe.decode(e, e.uint32(), M, r + 1, o.dataframe), o.type = "dataframe";
					continue;
				case 39:
					if (a !== 2) break;
					o.table = U.Table.decode(e, e.uint32(), M, r + 1, o.table), o.type = "table";
					continue;
				case 41:
					if (a !== 2) break;
					o.vegaLiteChart = U.VegaLiteChart.decode(e, e.uint32(), M, r + 1, o.vegaLiteChart), o.type = "vegaLiteChart";
					continue;
				case 13:
					if (a !== 2) break;
					o.audio = U.Audio.decode(e, e.uint32(), M, r + 1, o.audio), o.type = "audio";
					continue;
				case 56:
					if (a !== 2) break;
					o.audioInput = U.AudioInput.decode(e, e.uint32(), M, r + 1, o.audioInput), o.type = "audioInput";
					continue;
				case 12:
					if (a !== 2) break;
					o.balloons = U.Balloons.decode(e, e.uint32(), M, r + 1, o.balloons), o.type = "balloons";
					continue;
				case 59:
					if (a !== 2) break;
					o.bidiComponent = U.BidiComponent.decode(e, e.uint32(), M, r + 1, o.bidiComponent), o.type = "bidiComponent";
					continue;
				case 19:
					if (a !== 2) break;
					o.button = U.Button.decode(e, e.uint32(), M, r + 1, o.button), o.type = "button";
					continue;
				case 55:
					if (a !== 2) break;
					o.buttonGroup = U.ButtonGroup.decode(e, e.uint32(), M, r + 1, o.buttonGroup), o.type = "buttonGroup";
					continue;
				case 43:
					if (a !== 2) break;
					o.downloadButton = U.DownloadButton.decode(e, e.uint32(), M, r + 1, o.downloadButton), o.type = "downloadButton";
					continue;
				case 45:
					if (a !== 2) break;
					o.cameraInput = U.CameraInput.decode(e, e.uint32(), M, r + 1, o.cameraInput), o.type = "cameraInput";
					continue;
				case 49:
					if (a !== 2) break;
					o.chatInput = U.ChatInput.decode(e, e.uint32(), M, r + 1, o.chatInput), o.type = "chatInput";
					continue;
				case 20:
					if (a !== 2) break;
					o.checkbox = U.Checkbox.decode(e, e.uint32(), M, r + 1, o.checkbox), o.type = "checkbox";
					continue;
				case 35:
					if (a !== 2) break;
					o.colorPicker = U.ColorPicker.decode(e, e.uint32(), M, r + 1, o.colorPicker), o.type = "colorPicker";
					continue;
				case 37:
					if (a !== 2) break;
					o.componentInstance = U.ComponentInstance.decode(e, e.uint32(), M, r + 1, o.componentInstance), o.type = "componentInstance";
					continue;
				case 27:
					if (a !== 2) break;
					o.dateInput = U.DateInput.decode(e, e.uint32(), M, r + 1, o.dateInput), o.type = "dateInput";
					continue;
				case 34:
					if (a !== 2) break;
					o.deckGlJsonChart = U.DeckGlJsonChart.decode(e, e.uint32(), M, r + 1, o.deckGlJsonChart), o.type = "deckGlJsonChart";
					continue;
				case 7:
					if (a !== 2) break;
					o.helpInfo = U.Help.decode(e, e.uint32(), M, r + 1, o.helpInfo), o.type = "helpInfo";
					continue;
				case 2:
					if (a !== 2) break;
					o.empty = U.Empty.decode(e, e.uint32(), M, r + 1, o.empty), o.type = "empty";
					continue;
				case 8:
					if (a !== 2) break;
					o.exception = U.Exception.decode(e, e.uint32(), M, r + 1, o.exception), o.type = "exception";
					continue;
				case 36:
					if (a !== 2) break;
					o.favicon = U.Favicon.decode(e, e.uint32(), M, r + 1, o.favicon), o.type = "favicon";
					continue;
				case 63:
					if (a !== 2) break;
					o.feedback = U.Feedback.decode(e, e.uint32(), M, r + 1, o.feedback), o.type = "feedback";
					continue;
				case 33:
					if (a !== 2) break;
					o.fileUploader = U.FileUploader.decode(e, e.uint32(), M, r + 1, o.fileUploader), o.type = "fileUploader";
					continue;
				case 18:
					if (a !== 2) break;
					o.graphvizChart = U.GraphVizChart.decode(e, e.uint32(), M, r + 1, o.graphvizChart), o.type = "graphvizChart";
					continue;
				case 54:
					if (a !== 2) break;
					o.html = U.Html.decode(e, e.uint32(), M, r + 1, o.html), o.type = "html";
					continue;
				case 38:
					if (a !== 2) break;
					o.iframe = U.IFrame.decode(e, e.uint32(), M, r + 1, o.iframe), o.type = "iframe";
					continue;
				case 6:
					if (a !== 2) break;
					o.imgs = U.ImageList.decode(e, e.uint32(), M, r + 1, o.imgs), o.type = "imgs";
					continue;
				case 31:
					if (a !== 2) break;
					o.json = U.Json.decode(e, e.uint32(), M, r + 1, o.json), o.type = "json";
					continue;
				case 51:
					if (a !== 2) break;
					o.linkButton = U.LinkButton.decode(e, e.uint32(), M, r + 1, o.linkButton), o.type = "linkButton";
					continue;
				case 29:
					if (a !== 2) break;
					o.markdown = U.Markdown.decode(e, e.uint32(), M, r + 1, o.markdown), o.type = "markdown";
					continue;
				case 42:
					if (a !== 2) break;
					o.metric = U.Metric.decode(e, e.uint32(), M, r + 1, o.metric), o.type = "metric";
					continue;
				case 28:
					if (a !== 2) break;
					o.multiselect = U.MultiSelect.decode(e, e.uint32(), M, r + 1, o.multiselect), o.type = "multiselect";
					continue;
				case 32:
					if (a !== 2) break;
					o.numberInput = U.NumberInput.decode(e, e.uint32(), M, r + 1, o.numberInput), o.type = "numberInput";
					continue;
				case 53:
					if (a !== 2) break;
					o.pageLink = U.PageLink.decode(e, e.uint32(), M, r + 1, o.pageLink), o.type = "pageLink";
					continue;
				case 16:
					if (a !== 2) break;
					o.plotlyChart = U.PlotlyChart.decode(e, e.uint32(), M, r + 1, o.plotlyChart), o.type = "plotlyChart";
					continue;
				case 5:
					if (a !== 2) break;
					o.progress = U.Progress.decode(e, e.uint32(), M, r + 1, o.progress), o.type = "progress";
					continue;
				case 23:
					if (a !== 2) break;
					o.radio = U.Radio.decode(e, e.uint32(), M, r + 1, o.radio), o.type = "radio";
					continue;
				case 25:
					if (a !== 2) break;
					o.selectbox = U.Selectbox.decode(e, e.uint32(), M, r + 1, o.selectbox), o.type = "selectbox";
					continue;
				case 52:
					if (a !== 2) break;
					o.skeleton = U.Skeleton.decode(e, e.uint32(), M, r + 1, o.skeleton), o.type = "skeleton";
					continue;
				case 21:
					if (a !== 2) break;
					o.slider = U.Slider.decode(e, e.uint32(), M, r + 1, o.slider), o.type = "slider";
					continue;
				case 46:
					if (a !== 2) break;
					o.snow = U.Snow.decode(e, e.uint32(), M, r + 1, o.snow), o.type = "snow";
					continue;
				case 60:
					if (a !== 2) break;
					o.space = U.Space.decode(e, e.uint32(), M, r + 1, o.space), o.type = "space";
					continue;
				case 44:
					if (a !== 2) break;
					o.spinner = U.Spinner.decode(e, e.uint32(), M, r + 1, o.spinner), o.type = "spinner";
					continue;
				case 1:
					if (a !== 2) break;
					o.text = U.Text.decode(e, e.uint32(), M, r + 1, o.text), o.type = "text";
					continue;
				case 22:
					if (a !== 2) break;
					o.textArea = U.TextArea.decode(e, e.uint32(), M, r + 1, o.textArea), o.type = "textArea";
					continue;
				case 24:
					if (a !== 2) break;
					o.textInput = U.TextInput.decode(e, e.uint32(), M, r + 1, o.textInput), o.type = "textInput";
					continue;
				case 26:
					if (a !== 2) break;
					o.timeInput = U.TimeInput.decode(e, e.uint32(), M, r + 1, o.timeInput), o.type = "timeInput";
					continue;
				case 62:
					if (a !== 2) break;
					o.dateTimeInput = U.DateTimeInput.decode(e, e.uint32(), M, r + 1, o.dateTimeInput), o.type = "dateTimeInput";
					continue;
				case 50:
					if (a !== 2) break;
					o.toast = U.Toast.decode(e, e.uint32(), M, r + 1, o.toast), o.type = "toast";
					continue;
				case 14:
					if (a !== 2) break;
					o.video = U.Video.decode(e, e.uint32(), M, r + 1, o.video), o.type = "video";
					continue;
				case 47:
					if (a !== 2) break;
					o.heading = U.Heading.decode(e, e.uint32(), M, r + 1, o.heading), o.type = "heading";
					continue;
				case 48:
					if (a !== 2) break;
					o.code = U.Code.decode(e, e.uint32(), M, r + 1, o.code), o.type = "code";
					continue;
				case 64:
					if (a !== 2) break;
					o.menuButton = U.MenuButton.decode(e, e.uint32(), M, r + 1, o.menuButton), o.type = "menuButton";
					continue;
				case 66:
					if (a !== 2) break;
					o.pagination = U.Pagination.decode(e, e.uint32(), M, r + 1, o.pagination), o.type = "pagination";
					continue;
				case 67:
					if (a !== 2) break;
					o.echartsChart = U.EChartsChart.decode(e, e.uint32(), M, r + 1, o.echartsChart), o.type = "echartsChart";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Element) return e;
		if (!A.isObject(e)) throw F(".Element: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Element();
		if (e.heightConfig != null) {
			if (!A.isObject(e.heightConfig)) throw F(".Element.heightConfig: object expected");
			n.heightConfig = U.streamlit.HeightConfig.fromObject(e.heightConfig, t + 1);
		}
		if (e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Element.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		if (e.textAlignmentConfig != null) {
			if (!A.isObject(e.textAlignmentConfig)) throw F(".Element.textAlignmentConfig: object expected");
			n.textAlignmentConfig = U.streamlit.TextAlignmentConfig.fromObject(e.textAlignmentConfig, t + 1);
		}
		if (e.hasOneShotEffect != null && (n.hasOneShotEffect = L(e.hasOneShotEffect)), e.alert != null) {
			if (!A.isObject(e.alert)) throw F(".Element.alert: object expected");
			n.alert = U.Alert.fromObject(e.alert, t + 1);
		}
		if (e.dataframe != null) {
			if (!A.isObject(e.dataframe)) throw F(".Element.dataframe: object expected");
			n.dataframe = U.Dataframe.fromObject(e.dataframe, t + 1);
		}
		if (e.table != null) {
			if (!A.isObject(e.table)) throw F(".Element.table: object expected");
			n.table = U.Table.fromObject(e.table, t + 1);
		}
		if (e.vegaLiteChart != null) {
			if (!A.isObject(e.vegaLiteChart)) throw F(".Element.vegaLiteChart: object expected");
			n.vegaLiteChart = U.VegaLiteChart.fromObject(e.vegaLiteChart, t + 1);
		}
		if (e.audio != null) {
			if (!A.isObject(e.audio)) throw F(".Element.audio: object expected");
			n.audio = U.Audio.fromObject(e.audio, t + 1);
		}
		if (e.audioInput != null) {
			if (!A.isObject(e.audioInput)) throw F(".Element.audioInput: object expected");
			n.audioInput = U.AudioInput.fromObject(e.audioInput, t + 1);
		}
		if (e.balloons != null) {
			if (!A.isObject(e.balloons)) throw F(".Element.balloons: object expected");
			n.balloons = U.Balloons.fromObject(e.balloons, t + 1);
		}
		if (e.bidiComponent != null) {
			if (!A.isObject(e.bidiComponent)) throw F(".Element.bidiComponent: object expected");
			n.bidiComponent = U.BidiComponent.fromObject(e.bidiComponent, t + 1);
		}
		if (e.button != null) {
			if (!A.isObject(e.button)) throw F(".Element.button: object expected");
			n.button = U.Button.fromObject(e.button, t + 1);
		}
		if (e.buttonGroup != null) {
			if (!A.isObject(e.buttonGroup)) throw F(".Element.buttonGroup: object expected");
			n.buttonGroup = U.ButtonGroup.fromObject(e.buttonGroup, t + 1);
		}
		if (e.downloadButton != null) {
			if (!A.isObject(e.downloadButton)) throw F(".Element.downloadButton: object expected");
			n.downloadButton = U.DownloadButton.fromObject(e.downloadButton, t + 1);
		}
		if (e.cameraInput != null) {
			if (!A.isObject(e.cameraInput)) throw F(".Element.cameraInput: object expected");
			n.cameraInput = U.CameraInput.fromObject(e.cameraInput, t + 1);
		}
		if (e.chatInput != null) {
			if (!A.isObject(e.chatInput)) throw F(".Element.chatInput: object expected");
			n.chatInput = U.ChatInput.fromObject(e.chatInput, t + 1);
		}
		if (e.checkbox != null) {
			if (!A.isObject(e.checkbox)) throw F(".Element.checkbox: object expected");
			n.checkbox = U.Checkbox.fromObject(e.checkbox, t + 1);
		}
		if (e.colorPicker != null) {
			if (!A.isObject(e.colorPicker)) throw F(".Element.colorPicker: object expected");
			n.colorPicker = U.ColorPicker.fromObject(e.colorPicker, t + 1);
		}
		if (e.componentInstance != null) {
			if (!A.isObject(e.componentInstance)) throw F(".Element.componentInstance: object expected");
			n.componentInstance = U.ComponentInstance.fromObject(e.componentInstance, t + 1);
		}
		if (e.dateInput != null) {
			if (!A.isObject(e.dateInput)) throw F(".Element.dateInput: object expected");
			n.dateInput = U.DateInput.fromObject(e.dateInput, t + 1);
		}
		if (e.deckGlJsonChart != null) {
			if (!A.isObject(e.deckGlJsonChart)) throw F(".Element.deckGlJsonChart: object expected");
			n.deckGlJsonChart = U.DeckGlJsonChart.fromObject(e.deckGlJsonChart, t + 1);
		}
		if (e.helpInfo != null) {
			if (!A.isObject(e.helpInfo)) throw F(".Element.helpInfo: object expected");
			n.helpInfo = U.Help.fromObject(e.helpInfo, t + 1);
		}
		if (e.empty != null) {
			if (!A.isObject(e.empty)) throw F(".Element.empty: object expected");
			n.empty = U.Empty.fromObject(e.empty, t + 1);
		}
		if (e.exception != null) {
			if (!A.isObject(e.exception)) throw F(".Element.exception: object expected");
			n.exception = U.Exception.fromObject(e.exception, t + 1);
		}
		if (e.favicon != null) {
			if (!A.isObject(e.favicon)) throw F(".Element.favicon: object expected");
			n.favicon = U.Favicon.fromObject(e.favicon, t + 1);
		}
		if (e.feedback != null) {
			if (!A.isObject(e.feedback)) throw F(".Element.feedback: object expected");
			n.feedback = U.Feedback.fromObject(e.feedback, t + 1);
		}
		if (e.fileUploader != null) {
			if (!A.isObject(e.fileUploader)) throw F(".Element.fileUploader: object expected");
			n.fileUploader = U.FileUploader.fromObject(e.fileUploader, t + 1);
		}
		if (e.graphvizChart != null) {
			if (!A.isObject(e.graphvizChart)) throw F(".Element.graphvizChart: object expected");
			n.graphvizChart = U.GraphVizChart.fromObject(e.graphvizChart, t + 1);
		}
		if (e.html != null) {
			if (!A.isObject(e.html)) throw F(".Element.html: object expected");
			n.html = U.Html.fromObject(e.html, t + 1);
		}
		if (e.iframe != null) {
			if (!A.isObject(e.iframe)) throw F(".Element.iframe: object expected");
			n.iframe = U.IFrame.fromObject(e.iframe, t + 1);
		}
		if (e.imgs != null) {
			if (!A.isObject(e.imgs)) throw F(".Element.imgs: object expected");
			n.imgs = U.ImageList.fromObject(e.imgs, t + 1);
		}
		if (e.json != null) {
			if (!A.isObject(e.json)) throw F(".Element.json: object expected");
			n.json = U.Json.fromObject(e.json, t + 1);
		}
		if (e.linkButton != null) {
			if (!A.isObject(e.linkButton)) throw F(".Element.linkButton: object expected");
			n.linkButton = U.LinkButton.fromObject(e.linkButton, t + 1);
		}
		if (e.markdown != null) {
			if (!A.isObject(e.markdown)) throw F(".Element.markdown: object expected");
			n.markdown = U.Markdown.fromObject(e.markdown, t + 1);
		}
		if (e.metric != null) {
			if (!A.isObject(e.metric)) throw F(".Element.metric: object expected");
			n.metric = U.Metric.fromObject(e.metric, t + 1);
		}
		if (e.multiselect != null) {
			if (!A.isObject(e.multiselect)) throw F(".Element.multiselect: object expected");
			n.multiselect = U.MultiSelect.fromObject(e.multiselect, t + 1);
		}
		if (e.numberInput != null) {
			if (!A.isObject(e.numberInput)) throw F(".Element.numberInput: object expected");
			n.numberInput = U.NumberInput.fromObject(e.numberInput, t + 1);
		}
		if (e.pageLink != null) {
			if (!A.isObject(e.pageLink)) throw F(".Element.pageLink: object expected");
			n.pageLink = U.PageLink.fromObject(e.pageLink, t + 1);
		}
		if (e.plotlyChart != null) {
			if (!A.isObject(e.plotlyChart)) throw F(".Element.plotlyChart: object expected");
			n.plotlyChart = U.PlotlyChart.fromObject(e.plotlyChart, t + 1);
		}
		if (e.progress != null) {
			if (!A.isObject(e.progress)) throw F(".Element.progress: object expected");
			n.progress = U.Progress.fromObject(e.progress, t + 1);
		}
		if (e.radio != null) {
			if (!A.isObject(e.radio)) throw F(".Element.radio: object expected");
			n.radio = U.Radio.fromObject(e.radio, t + 1);
		}
		if (e.selectbox != null) {
			if (!A.isObject(e.selectbox)) throw F(".Element.selectbox: object expected");
			n.selectbox = U.Selectbox.fromObject(e.selectbox, t + 1);
		}
		if (e.skeleton != null) {
			if (!A.isObject(e.skeleton)) throw F(".Element.skeleton: object expected");
			n.skeleton = U.Skeleton.fromObject(e.skeleton, t + 1);
		}
		if (e.slider != null) {
			if (!A.isObject(e.slider)) throw F(".Element.slider: object expected");
			n.slider = U.Slider.fromObject(e.slider, t + 1);
		}
		if (e.snow != null) {
			if (!A.isObject(e.snow)) throw F(".Element.snow: object expected");
			n.snow = U.Snow.fromObject(e.snow, t + 1);
		}
		if (e.space != null) {
			if (!A.isObject(e.space)) throw F(".Element.space: object expected");
			n.space = U.Space.fromObject(e.space, t + 1);
		}
		if (e.spinner != null) {
			if (!A.isObject(e.spinner)) throw F(".Element.spinner: object expected");
			n.spinner = U.Spinner.fromObject(e.spinner, t + 1);
		}
		if (e.text != null) {
			if (!A.isObject(e.text)) throw F(".Element.text: object expected");
			n.text = U.Text.fromObject(e.text, t + 1);
		}
		if (e.textArea != null) {
			if (!A.isObject(e.textArea)) throw F(".Element.textArea: object expected");
			n.textArea = U.TextArea.fromObject(e.textArea, t + 1);
		}
		if (e.textInput != null) {
			if (!A.isObject(e.textInput)) throw F(".Element.textInput: object expected");
			n.textInput = U.TextInput.fromObject(e.textInput, t + 1);
		}
		if (e.timeInput != null) {
			if (!A.isObject(e.timeInput)) throw F(".Element.timeInput: object expected");
			n.timeInput = U.TimeInput.fromObject(e.timeInput, t + 1);
		}
		if (e.dateTimeInput != null) {
			if (!A.isObject(e.dateTimeInput)) throw F(".Element.dateTimeInput: object expected");
			n.dateTimeInput = U.DateTimeInput.fromObject(e.dateTimeInput, t + 1);
		}
		if (e.toast != null) {
			if (!A.isObject(e.toast)) throw F(".Element.toast: object expected");
			n.toast = U.Toast.fromObject(e.toast, t + 1);
		}
		if (e.video != null) {
			if (!A.isObject(e.video)) throw F(".Element.video: object expected");
			n.video = U.Video.fromObject(e.video, t + 1);
		}
		if (e.heading != null) {
			if (!A.isObject(e.heading)) throw F(".Element.heading: object expected");
			n.heading = U.Heading.fromObject(e.heading, t + 1);
		}
		if (e.code != null) {
			if (!A.isObject(e.code)) throw F(".Element.code: object expected");
			n.code = U.Code.fromObject(e.code, t + 1);
		}
		if (e.menuButton != null) {
			if (!A.isObject(e.menuButton)) throw F(".Element.menuButton: object expected");
			n.menuButton = U.MenuButton.fromObject(e.menuButton, t + 1);
		}
		if (e.pagination != null) {
			if (!A.isObject(e.pagination)) throw F(".Element.pagination: object expected");
			n.pagination = U.Pagination.fromObject(e.pagination, t + 1);
		}
		if (e.echartsChart != null) {
			if (!A.isObject(e.echartsChart)) throw F(".Element.echartsChart: object expected");
			n.echartsChart = U.EChartsChart.fromObject(e.echartsChart, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return e.text != null && j.hasOwnProperty.call(e, "text") && (r.text = U.Text.toObject(e.text, t, n + 1), t.oneofs && (r.type = "text")), e.empty != null && j.hasOwnProperty.call(e, "empty") && (r.empty = U.Empty.toObject(e.empty, t, n + 1), t.oneofs && (r.type = "empty")), e.progress != null && j.hasOwnProperty.call(e, "progress") && (r.progress = U.Progress.toObject(e.progress, t, n + 1), t.oneofs && (r.type = "progress")), e.imgs != null && j.hasOwnProperty.call(e, "imgs") && (r.imgs = U.ImageList.toObject(e.imgs, t, n + 1), t.oneofs && (r.type = "imgs")), e.helpInfo != null && j.hasOwnProperty.call(e, "helpInfo") && (r.helpInfo = U.Help.toObject(e.helpInfo, t, n + 1), t.oneofs && (r.type = "helpInfo")), e.exception != null && j.hasOwnProperty.call(e, "exception") && (r.exception = U.Exception.toObject(e.exception, t, n + 1), t.oneofs && (r.type = "exception")), e.balloons != null && j.hasOwnProperty.call(e, "balloons") && (r.balloons = U.Balloons.toObject(e.balloons, t, n + 1), t.oneofs && (r.type = "balloons")), e.audio != null && j.hasOwnProperty.call(e, "audio") && (r.audio = U.Audio.toObject(e.audio, t, n + 1), t.oneofs && (r.type = "audio")), e.video != null && j.hasOwnProperty.call(e, "video") && (r.video = U.Video.toObject(e.video, t, n + 1), t.oneofs && (r.type = "video")), e.plotlyChart != null && j.hasOwnProperty.call(e, "plotlyChart") && (r.plotlyChart = U.PlotlyChart.toObject(e.plotlyChart, t, n + 1), t.oneofs && (r.type = "plotlyChart")), e.graphvizChart != null && j.hasOwnProperty.call(e, "graphvizChart") && (r.graphvizChart = U.GraphVizChart.toObject(e.graphvizChart, t, n + 1), t.oneofs && (r.type = "graphvizChart")), e.button != null && j.hasOwnProperty.call(e, "button") && (r.button = U.Button.toObject(e.button, t, n + 1), t.oneofs && (r.type = "button")), e.checkbox != null && j.hasOwnProperty.call(e, "checkbox") && (r.checkbox = U.Checkbox.toObject(e.checkbox, t, n + 1), t.oneofs && (r.type = "checkbox")), e.slider != null && j.hasOwnProperty.call(e, "slider") && (r.slider = U.Slider.toObject(e.slider, t, n + 1), t.oneofs && (r.type = "slider")), e.textArea != null && j.hasOwnProperty.call(e, "textArea") && (r.textArea = U.TextArea.toObject(e.textArea, t, n + 1), t.oneofs && (r.type = "textArea")), e.radio != null && j.hasOwnProperty.call(e, "radio") && (r.radio = U.Radio.toObject(e.radio, t, n + 1), t.oneofs && (r.type = "radio")), e.textInput != null && j.hasOwnProperty.call(e, "textInput") && (r.textInput = U.TextInput.toObject(e.textInput, t, n + 1), t.oneofs && (r.type = "textInput")), e.selectbox != null && j.hasOwnProperty.call(e, "selectbox") && (r.selectbox = U.Selectbox.toObject(e.selectbox, t, n + 1), t.oneofs && (r.type = "selectbox")), e.timeInput != null && j.hasOwnProperty.call(e, "timeInput") && (r.timeInput = U.TimeInput.toObject(e.timeInput, t, n + 1), t.oneofs && (r.type = "timeInput")), e.dateInput != null && j.hasOwnProperty.call(e, "dateInput") && (r.dateInput = U.DateInput.toObject(e.dateInput, t, n + 1), t.oneofs && (r.type = "dateInput")), e.multiselect != null && j.hasOwnProperty.call(e, "multiselect") && (r.multiselect = U.MultiSelect.toObject(e.multiselect, t, n + 1), t.oneofs && (r.type = "multiselect")), e.markdown != null && j.hasOwnProperty.call(e, "markdown") && (r.markdown = U.Markdown.toObject(e.markdown, t, n + 1), t.oneofs && (r.type = "markdown")), e.alert != null && j.hasOwnProperty.call(e, "alert") && (r.alert = U.Alert.toObject(e.alert, t, n + 1), t.oneofs && (r.type = "alert")), e.json != null && j.hasOwnProperty.call(e, "json") && (r.json = U.Json.toObject(e.json, t, n + 1), t.oneofs && (r.type = "json")), e.numberInput != null && j.hasOwnProperty.call(e, "numberInput") && (r.numberInput = U.NumberInput.toObject(e.numberInput, t, n + 1), t.oneofs && (r.type = "numberInput")), e.fileUploader != null && j.hasOwnProperty.call(e, "fileUploader") && (r.fileUploader = U.FileUploader.toObject(e.fileUploader, t, n + 1), t.oneofs && (r.type = "fileUploader")), e.deckGlJsonChart != null && j.hasOwnProperty.call(e, "deckGlJsonChart") && (r.deckGlJsonChart = U.DeckGlJsonChart.toObject(e.deckGlJsonChart, t, n + 1), t.oneofs && (r.type = "deckGlJsonChart")), e.colorPicker != null && j.hasOwnProperty.call(e, "colorPicker") && (r.colorPicker = U.ColorPicker.toObject(e.colorPicker, t, n + 1), t.oneofs && (r.type = "colorPicker")), e.favicon != null && j.hasOwnProperty.call(e, "favicon") && (r.favicon = U.Favicon.toObject(e.favicon, t, n + 1), t.oneofs && (r.type = "favicon")), e.componentInstance != null && j.hasOwnProperty.call(e, "componentInstance") && (r.componentInstance = U.ComponentInstance.toObject(e.componentInstance, t, n + 1), t.oneofs && (r.type = "componentInstance")), e.iframe != null && j.hasOwnProperty.call(e, "iframe") && (r.iframe = U.IFrame.toObject(e.iframe, t, n + 1), t.oneofs && (r.type = "iframe")), e.table != null && j.hasOwnProperty.call(e, "table") && (r.table = U.Table.toObject(e.table, t, n + 1), t.oneofs && (r.type = "table")), e.dataframe != null && j.hasOwnProperty.call(e, "dataframe") && (r.dataframe = U.Dataframe.toObject(e.dataframe, t, n + 1), t.oneofs && (r.type = "dataframe")), e.vegaLiteChart != null && j.hasOwnProperty.call(e, "vegaLiteChart") && (r.vegaLiteChart = U.VegaLiteChart.toObject(e.vegaLiteChart, t, n + 1), t.oneofs && (r.type = "vegaLiteChart")), e.metric != null && j.hasOwnProperty.call(e, "metric") && (r.metric = U.Metric.toObject(e.metric, t, n + 1), t.oneofs && (r.type = "metric")), e.downloadButton != null && j.hasOwnProperty.call(e, "downloadButton") && (r.downloadButton = U.DownloadButton.toObject(e.downloadButton, t, n + 1), t.oneofs && (r.type = "downloadButton")), e.spinner != null && j.hasOwnProperty.call(e, "spinner") && (r.spinner = U.Spinner.toObject(e.spinner, t, n + 1), t.oneofs && (r.type = "spinner")), e.cameraInput != null && j.hasOwnProperty.call(e, "cameraInput") && (r.cameraInput = U.CameraInput.toObject(e.cameraInput, t, n + 1), t.oneofs && (r.type = "cameraInput")), e.snow != null && j.hasOwnProperty.call(e, "snow") && (r.snow = U.Snow.toObject(e.snow, t, n + 1), t.oneofs && (r.type = "snow")), e.heading != null && j.hasOwnProperty.call(e, "heading") && (r.heading = U.Heading.toObject(e.heading, t, n + 1), t.oneofs && (r.type = "heading")), e.code != null && j.hasOwnProperty.call(e, "code") && (r.code = U.Code.toObject(e.code, t, n + 1), t.oneofs && (r.type = "code")), e.chatInput != null && j.hasOwnProperty.call(e, "chatInput") && (r.chatInput = U.ChatInput.toObject(e.chatInput, t, n + 1), t.oneofs && (r.type = "chatInput")), e.toast != null && j.hasOwnProperty.call(e, "toast") && (r.toast = U.Toast.toObject(e.toast, t, n + 1), t.oneofs && (r.type = "toast")), e.linkButton != null && j.hasOwnProperty.call(e, "linkButton") && (r.linkButton = U.LinkButton.toObject(e.linkButton, t, n + 1), t.oneofs && (r.type = "linkButton")), e.skeleton != null && j.hasOwnProperty.call(e, "skeleton") && (r.skeleton = U.Skeleton.toObject(e.skeleton, t, n + 1), t.oneofs && (r.type = "skeleton")), e.pageLink != null && j.hasOwnProperty.call(e, "pageLink") && (r.pageLink = U.PageLink.toObject(e.pageLink, t, n + 1), t.oneofs && (r.type = "pageLink")), e.html != null && j.hasOwnProperty.call(e, "html") && (r.html = U.Html.toObject(e.html, t, n + 1), t.oneofs && (r.type = "html")), e.buttonGroup != null && j.hasOwnProperty.call(e, "buttonGroup") && (r.buttonGroup = U.ButtonGroup.toObject(e.buttonGroup, t, n + 1), t.oneofs && (r.type = "buttonGroup")), e.audioInput != null && j.hasOwnProperty.call(e, "audioInput") && (r.audioInput = U.AudioInput.toObject(e.audioInput, t, n + 1), t.oneofs && (r.type = "audioInput")), e.heightConfig != null && j.hasOwnProperty.call(e, "heightConfig") && (r.heightConfig = U.streamlit.HeightConfig.toObject(e.heightConfig, t, n + 1)), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.bidiComponent != null && j.hasOwnProperty.call(e, "bidiComponent") && (r.bidiComponent = U.BidiComponent.toObject(e.bidiComponent, t, n + 1), t.oneofs && (r.type = "bidiComponent")), e.space != null && j.hasOwnProperty.call(e, "space") && (r.space = U.Space.toObject(e.space, t, n + 1), t.oneofs && (r.type = "space")), e.textAlignmentConfig != null && j.hasOwnProperty.call(e, "textAlignmentConfig") && (r.textAlignmentConfig = U.streamlit.TextAlignmentConfig.toObject(e.textAlignmentConfig, t, n + 1)), e.dateTimeInput != null && j.hasOwnProperty.call(e, "dateTimeInput") && (r.dateTimeInput = U.DateTimeInput.toObject(e.dateTimeInput, t, n + 1), t.oneofs && (r.type = "dateTimeInput")), e.feedback != null && j.hasOwnProperty.call(e, "feedback") && (r.feedback = U.Feedback.toObject(e.feedback, t, n + 1), t.oneofs && (r.type = "feedback")), e.menuButton != null && j.hasOwnProperty.call(e, "menuButton") && (r.menuButton = U.MenuButton.toObject(e.menuButton, t, n + 1), t.oneofs && (r.type = "menuButton")), e.hasOneShotEffect != null && j.hasOwnProperty.call(e, "hasOneShotEffect") && (r.hasOneShotEffect = e.hasOneShotEffect), e.pagination != null && j.hasOwnProperty.call(e, "pagination") && (r.pagination = U.Pagination.toObject(e.pagination, t, n + 1), t.oneofs && (r.type = "pagination")), e.echartsChart != null && j.hasOwnProperty.call(e, "echartsChart") && (r.echartsChart = U.EChartsChart.toObject(e.echartsChart, t, n + 1), t.oneofs && (r.type = "echartsChart")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Element";
	}, e;
})(), U.DownloadButton = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.url = "", e.prototype.disabled = !1, e.prototype.useContainerWidth = !1, e.prototype.type = "", e.prototype.icon = "", e.prototype.ignoreRerun = !1, e.prototype.deferredFileId = null, e.prototype.shortcut = "", e.prototype.iconPosition = 0, e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_deferredFileId", {
		get: A.oneOfGetter(t = ["deferredFileId"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== !1 && t.uint32(24).bool(e.default), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(50).string(e.url), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(56).bool(e.disabled), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && e.useContainerWidth !== !1 && t.uint32(64).bool(e.useContainerWidth), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(74).string(e.type), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(82).string(e.icon), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(88).bool(e.ignoreRerun), e.deferredFileId != null && j.hasOwnProperty.call(e, "deferredFileId") && t.uint32(98).string(e.deferredFileId), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && e.shortcut !== "" && t.uint32(106).string(e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && e.iconPosition !== 0 && t.uint32(112).int32(e.iconPosition), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(120).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DownloadButton(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
				case 12:
					if (a !== 2) break;
					o.deferredFileId = e.stringVerify(), o._deferredFileId = "deferredFileId";
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
				case 15:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DownloadButton) return e;
		if (!A.isObject(e)) throw F(".DownloadButton: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DownloadButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && e.default && (n.default = L(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = L(e.useContainerWidth)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), e.deferredFileId != null && (n.deferredFileId = I(e.deferredFileId)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = I(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || U.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
			default: typeof e.iconPosition == "number" && (e.iconPosition | 0) === e.iconPosition && (n.iconPosition = e.iconPosition);
		}
		return e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.default = !1, r.help = "", r.formId = "", r.url = "", r.disabled = !1, r.useContainerWidth = !1, r.type = "", r.icon = "", r.ignoreRerun = !1, r.shortcut = "", r.iconPosition = t.enums === I ? "LEFT" : 0), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), e.deferredFileId != null && j.hasOwnProperty.call(e, "deferredFileId") && (r.deferredFileId = e.deferredFileId), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && (r.iconPosition = t.enums === I ? U.streamlit.ButtonLikeIconPosition[e.iconPosition] === M ? e.iconPosition : U.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DownloadButton";
	}, e;
})(), U.EChartsChart = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.spec = "", e.prototype.theme = "", e.prototype.id = "", e.prototype.renderer = 0, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.spec != null && j.hasOwnProperty.call(e, "spec") && e.spec !== "" && t.uint32(10).string(e.spec), e.theme != null && j.hasOwnProperty.call(e, "theme") && e.theme !== "" && t.uint32(18).string(e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(26).string(e.id), e.renderer != null && j.hasOwnProperty.call(e, "renderer") && e.renderer !== 0 && t.uint32(48).int32(e.renderer), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(58).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.EChartsChart(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.spec = s : delete o.spec;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.theme = s : delete o.theme;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.renderer = s : delete o.renderer;
					continue;
				case 7:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.EChartsChart) return e;
		if (!A.isObject(e)) throw F(".EChartsChart: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.EChartsChart();
		if (e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = I(e.spec)), e.theme != null && (typeof e.theme != "string" || e.theme.length) && (n.theme = I(e.theme)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.renderer !== 0 && (typeof e.renderer != "string" || U.EChartsChart.Renderer[e.renderer] !== 0)) switch (e.renderer) {
			case "CANVAS":
			case 0:
				n.renderer = 0;
				break;
			case "SVG":
			case 1:
				n.renderer = 1;
				break;
			default: typeof e.renderer == "number" && (e.renderer | 0) === e.renderer && (n.renderer = e.renderer);
		}
		return e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.spec = "", r.theme = "", r.id = "", r.renderer = t.enums === I ? "CANVAS" : 0), e.spec != null && j.hasOwnProperty.call(e, "spec") && (r.spec = e.spec), e.theme != null && j.hasOwnProperty.call(e, "theme") && (r.theme = e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.renderer != null && j.hasOwnProperty.call(e, "renderer") && (r.renderer = t.enums === I ? U.EChartsChart.Renderer[e.renderer] === M ? e.renderer : U.EChartsChart.Renderer[e.renderer] : e.renderer), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/EChartsChart";
	}, e.Renderer = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "CANVAS"] = 0, t[e[1] = "SVG"] = 1, t;
	})(), e;
})(), U.Empty = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Empty(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Empty) return e;
		if (!A.isObject(e)) throw F(".Empty: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		return new U.Empty();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Empty";
	}, e;
})(), U.Exception = (() => {
	let e = function(e) {
		if (this.stackTrace = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.type = "", e.prototype.message = "", e.prototype.messageIsMarkdown = !1, e.prototype.stackTrace = A.emptyArray, e.prototype.isWarning = !1, e.prototype.widthConfig = null, e.prototype.isStreamlitException = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(10).string(e.type), e.message != null && j.hasOwnProperty.call(e, "message") && e.message !== "" && t.uint32(18).string(e.message), e.stackTrace != null && e.stackTrace.length) for (let n = 0; n < e.stackTrace.length; ++n) t.uint32(26).string(e.stackTrace[n]);
		if (e.messageIsMarkdown != null && j.hasOwnProperty.call(e, "messageIsMarkdown") && e.messageIsMarkdown !== !1 && t.uint32(32).bool(e.messageIsMarkdown), e.isWarning != null && j.hasOwnProperty.call(e, "isWarning") && e.isWarning !== !1 && t.uint32(40).bool(e.isWarning), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(50).fork(), n + 1).ldelim(), e.isStreamlitException != null && j.hasOwnProperty.call(e, "isStreamlitException") && e.isStreamlitException !== !1 && t.uint32(56).bool(e.isStreamlitException), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Exception(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.message = s : delete o.message;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.messageIsMarkdown = s : delete o.messageIsMarkdown;
					continue;
				case 3:
					if (a !== 2) break;
					o.stackTrace && o.stackTrace.length || (o.stackTrace = []), o.stackTrace.push(e.stringVerify());
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.isWarning = s : delete o.isWarning;
					continue;
				case 6:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig);
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.isStreamlitException = s : delete o.isStreamlitException;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Exception) return e;
		if (!A.isObject(e)) throw F(".Exception: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Exception();
		if (e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.message != null && (typeof e.message != "string" || e.message.length) && (n.message = I(e.message)), e.messageIsMarkdown != null && e.messageIsMarkdown && (n.messageIsMarkdown = L(e.messageIsMarkdown)), e.stackTrace) {
			if (!B.isArray(e.stackTrace)) throw F(".Exception.stackTrace: array expected");
			n.stackTrace = B(e.stackTrace.length);
			for (let t = 0; t < e.stackTrace.length; ++t) n.stackTrace[t] = I(e.stackTrace[t]);
		}
		if (e.isWarning != null && e.isWarning && (n.isWarning = L(e.isWarning)), e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Exception.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.isStreamlitException != null && e.isStreamlitException && (n.isStreamlitException = L(e.isStreamlitException)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.stackTrace = []), t.defaults && (r.type = "", r.message = "", r.messageIsMarkdown = !1, r.isWarning = !1, r.widthConfig = null, r.isStreamlitException = !1), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.message != null && j.hasOwnProperty.call(e, "message") && (r.message = e.message), e.stackTrace && e.stackTrace.length) {
			r.stackTrace = B(e.stackTrace.length);
			for (let t = 0; t < e.stackTrace.length; ++t) r.stackTrace[t] = e.stackTrace[t];
		}
		return e.messageIsMarkdown != null && j.hasOwnProperty.call(e, "messageIsMarkdown") && (r.messageIsMarkdown = e.messageIsMarkdown), e.isWarning != null && j.hasOwnProperty.call(e, "isWarning") && (r.isWarning = e.isWarning), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.isStreamlitException != null && j.hasOwnProperty.call(e, "isStreamlitException") && (r.isStreamlitException = e.isStreamlitException), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Exception";
	}, e;
})(), U.Favicon = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(10).string(e.url), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Favicon(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Favicon) return e;
		if (!A.isObject(e)) throw F(".Favicon: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Favicon();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = ""), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Favicon";
	}, e;
})(), U.Feedback = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.type = 0, e.prototype.default = null, e.prototype.disabled = !1, e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_value", {
		get: A.oneOfGetter(t = ["value"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(16).int32(e.type), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(24).uint32(e.default), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(32).bool(e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(48).uint32(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(56).bool(e.setValue), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Feedback(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.uint32(), o._default = "default";
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 0) break;
					o.value = e.uint32(), o._value = "value";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Feedback) return e;
		if (!A.isObject(e)) throw F(".Feedback: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Feedback();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.type !== 0 && (typeof e.type != "string" || U.Feedback.FeedbackType[e.type] !== 0)) switch (e.type) {
			case "THUMBS":
			case 0:
				n.type = 0;
				break;
			case "FACES":
			case 1:
				n.type = 1;
				break;
			case "STARS":
			case 2:
				n.type = 2;
				break;
			default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
		}
		return e.default != null && (n.default = e.default >>> 0), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && (n.value = e.value >>> 0), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.type = t.enums === I ? "THUMBS" : 0, r.disabled = !1, r.formId = "", r.setValue = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.Feedback.FeedbackType[e.type] === M ? e.type : U.Feedback.FeedbackType[e.type] : e.type), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Feedback";
	}, e.FeedbackType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "THUMBS"] = 0, t[e[1] = "FACES"] = 1, t[e[2] = "STARS"] = 2, t;
	})(), e;
})(), U.FileUploader = (() => {
	let e = function(e) {
		if (this.type = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.id = "", e.prototype.label = "", e.prototype.type = A.emptyArray, e.prototype.maxUploadSizeMb = 0, e.prototype.multipleFiles = !1, e.prototype.help = "", e.prototype.formId = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.acceptDirectory = !1, e.prototype.ignoreRerun = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.type != null && e.type.length) for (let n = 0; n < e.type.length; ++n) t.uint32(26).string(e.type[n]);
		if (e.maxUploadSizeMb != null && j.hasOwnProperty.call(e, "maxUploadSizeMb") && e.maxUploadSizeMb !== 0 && t.uint32(32).int32(e.maxUploadSizeMb), e.multipleFiles != null && j.hasOwnProperty.call(e, "multipleFiles") && e.multipleFiles !== !1 && t.uint32(48).bool(e.multipleFiles), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(58).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(66).string(e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(72).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.acceptDirectory != null && j.hasOwnProperty.call(e, "acceptDirectory") && e.acceptDirectory !== !1 && t.uint32(88).bool(e.acceptDirectory), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(96).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FileUploader(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.type && o.type.length || (o.type = []), o.type.push(e.stringVerify());
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxUploadSizeMb = s : delete o.maxUploadSizeMb;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.multipleFiles = s : delete o.multipleFiles;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.acceptDirectory = s : delete o.acceptDirectory;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FileUploader) return e;
		if (!A.isObject(e)) throw F(".FileUploader: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FileUploader();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.type) {
			if (!B.isArray(e.type)) throw F(".FileUploader.type: array expected");
			n.type = B(e.type.length);
			for (let t = 0; t < e.type.length; ++t) n.type[t] = I(e.type[t]);
		}
		if (e.maxUploadSizeMb != null && R(e.maxUploadSizeMb) !== 0 && (n.maxUploadSizeMb = e.maxUploadSizeMb | 0), e.multipleFiles != null && e.multipleFiles && (n.multipleFiles = L(e.multipleFiles)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".FileUploader.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.acceptDirectory != null && e.acceptDirectory && (n.acceptDirectory = L(e.acceptDirectory)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.type = []), t.defaults && (r.id = "", r.label = "", r.maxUploadSizeMb = 0, r.multipleFiles = !1, r.help = "", r.formId = "", r.disabled = !1, r.labelVisibility = null, r.acceptDirectory = !1, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.type && e.type.length) {
			r.type = B(e.type.length);
			for (let t = 0; t < e.type.length; ++t) r.type[t] = e.type[t];
		}
		return e.maxUploadSizeMb != null && j.hasOwnProperty.call(e, "maxUploadSizeMb") && (r.maxUploadSizeMb = e.maxUploadSizeMb), e.multipleFiles != null && j.hasOwnProperty.call(e, "multipleFiles") && (r.multipleFiles = e.multipleFiles), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.acceptDirectory != null && j.hasOwnProperty.call(e, "acceptDirectory") && (r.acceptDirectory = e.acceptDirectory), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FileUploader";
	}, e;
})(), U.GraphVizChart = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.spec = "", e.prototype.elementId = "", e.prototype.engine = "", e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.spec != null && j.hasOwnProperty.call(e, "spec") && e.spec !== "" && t.uint32(10).string(e.spec), e.elementId != null && j.hasOwnProperty.call(e, "elementId") && e.elementId !== "" && t.uint32(42).string(e.elementId), e.engine != null && j.hasOwnProperty.call(e, "engine") && e.engine !== "" && t.uint32(50).string(e.engine), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(58).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.GraphVizChart(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.spec = s : delete o.spec;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.elementId = s : delete o.elementId;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.engine = s : delete o.engine;
					continue;
				case 7:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.GraphVizChart) return e;
		if (!A.isObject(e)) throw F(".GraphVizChart: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.GraphVizChart();
		return e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = I(e.spec)), e.elementId != null && (typeof e.elementId != "string" || e.elementId.length) && (n.elementId = I(e.elementId)), e.engine != null && (typeof e.engine != "string" || e.engine.length) && (n.engine = I(e.engine)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.spec = "", r.elementId = "", r.engine = ""), e.spec != null && j.hasOwnProperty.call(e, "spec") && (r.spec = e.spec), e.elementId != null && j.hasOwnProperty.call(e, "elementId") && (r.elementId = e.elementId), e.engine != null && j.hasOwnProperty.call(e, "engine") && (r.engine = e.engine), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/GraphVizChart";
	}, e;
})(), U.Heading = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.tag = "", e.prototype.anchor = "", e.prototype.body = "", e.prototype.help = "", e.prototype.hideAnchor = !1, e.prototype.divider = "", e.prototype.wrap = null, e.prototype.icon = "";
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.tag != null && j.hasOwnProperty.call(e, "tag") && e.tag !== "" && t.uint32(10).string(e.tag), e.anchor != null && j.hasOwnProperty.call(e, "anchor") && e.anchor !== "" && t.uint32(18).string(e.anchor), e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(26).string(e.body), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.hideAnchor != null && j.hasOwnProperty.call(e, "hideAnchor") && e.hideAnchor !== !1 && t.uint32(40).bool(e.hideAnchor), e.divider != null && j.hasOwnProperty.call(e, "divider") && e.divider !== "" && t.uint32(50).string(e.divider), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(56).bool(e.wrap), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(66).string(e.icon), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Heading(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.tag = s : delete o.tag;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.anchor = s : delete o.anchor;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideAnchor = s : delete o.hideAnchor;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.divider = s : delete o.divider;
					continue;
				case 7:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Heading) return e;
		if (!A.isObject(e)) throw F(".Heading: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Heading();
		return e.tag != null && (typeof e.tag != "string" || e.tag.length) && (n.tag = I(e.tag)), e.anchor != null && (typeof e.anchor != "string" || e.anchor.length) && (n.anchor = I(e.anchor)), e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.hideAnchor != null && e.hideAnchor && (n.hideAnchor = L(e.hideAnchor)), e.divider != null && (typeof e.divider != "string" || e.divider.length) && (n.divider = I(e.divider)), e.wrap != null && (n.wrap = L(e.wrap)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.tag = "", r.anchor = "", r.body = "", r.help = "", r.hideAnchor = !1, r.divider = "", r.icon = ""), e.tag != null && j.hasOwnProperty.call(e, "tag") && (r.tag = e.tag), e.anchor != null && j.hasOwnProperty.call(e, "anchor") && (r.anchor = e.anchor), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.hideAnchor != null && j.hasOwnProperty.call(e, "hideAnchor") && (r.hideAnchor = e.hideAnchor), e.divider != null && j.hasOwnProperty.call(e, "divider") && (r.divider = e.divider), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Heading";
	}, e;
})(), U.Help = (() => {
	let e = function(e) {
		if (this.members = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.docString = "", e.prototype.type = "", e.prototype.name = "", e.prototype.value = "", e.prototype.members = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.docString != null && j.hasOwnProperty.call(e, "docString") && e.docString !== "" && t.uint32(26).string(e.docString), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(34).string(e.type), e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(50).string(e.name), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== "" && t.uint32(58).string(e.value), e.members != null && e.members.length) for (let r = 0; r < e.members.length; ++r) U.Member.encode(e.members[r], t.uint32(66).fork(), n + 1).ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Help(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.docString = s : delete o.docString;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.value = s : delete o.value;
					continue;
				case 8:
					if (a !== 2) break;
					o.members && o.members.length || (o.members = []), o.members.push(U.Member.decode(e, e.uint32(), M, r + 1));
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Help) return e;
		if (!A.isObject(e)) throw F(".Help: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Help();
		if (e.docString != null && (typeof e.docString != "string" || e.docString.length) && (n.docString = I(e.docString)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = I(e.value)), e.members) {
			if (!B.isArray(e.members)) throw F(".Help.members: array expected");
			n.members = B(e.members.length);
			for (let r = 0; r < e.members.length; ++r) {
				if (!A.isObject(e.members[r])) throw F(".Help.members: object expected");
				n.members[r] = U.Member.fromObject(e.members[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.members = []), t.defaults && (r.docString = "", r.type = "", r.name = "", r.value = ""), e.docString != null && j.hasOwnProperty.call(e, "docString") && (r.docString = e.docString), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.members && e.members.length) {
			r.members = B(e.members.length);
			for (let i = 0; i < e.members.length; ++i) r.members[i] = U.Member.toObject(e.members[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Help";
	}, e;
})(), U.Member = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.name = "", e.prototype.type = "", e.prototype.value = null, e.prototype.docString = null;
	let t;
	return j.defineProperty(e.prototype, "contents", {
		get: A.oneOfGetter(t = ["value", "docString"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(18).string(e.type), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(26).string(e.value), e.docString != null && j.hasOwnProperty.call(e, "docString") && t.uint32(34).string(e.docString), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Member(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 3:
					if (a !== 2) break;
					o.value = e.stringVerify(), o.contents = "value";
					continue;
				case 4:
					if (a !== 2) break;
					o.docString = e.stringVerify(), o.contents = "docString";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Member) return e;
		if (!A.isObject(e)) throw F(".Member: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Member();
		return e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.value != null && (n.value = I(e.value)), e.docString != null && (n.docString = I(e.docString)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.name = "", r.type = ""), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value, t.oneofs && (r.contents = "value")), e.docString != null && j.hasOwnProperty.call(e, "docString") && (r.docString = e.docString, t.oneofs && (r.contents = "docString")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Member";
	}, e;
})(), U.Html = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.body = "", e.prototype.unsafeAllowJavascript = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.unsafeAllowJavascript != null && j.hasOwnProperty.call(e, "unsafeAllowJavascript") && e.unsafeAllowJavascript !== !1 && t.uint32(16).bool(e.unsafeAllowJavascript), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Html(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.unsafeAllowJavascript = s : delete o.unsafeAllowJavascript;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Html) return e;
		if (!A.isObject(e)) throw F(".Html: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Html();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.unsafeAllowJavascript != null && e.unsafeAllowJavascript && (n.unsafeAllowJavascript = L(e.unsafeAllowJavascript)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.unsafeAllowJavascript = !1), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.unsafeAllowJavascript != null && j.hasOwnProperty.call(e, "unsafeAllowJavascript") && (r.unsafeAllowJavascript = e.unsafeAllowJavascript), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Html";
	}, e;
})(), U.IFrame = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.src = null, e.prototype.srcdoc = null, e.prototype.scrolling = !1, e.prototype.tabIndex = null, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = ["src", "srcdoc"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_tabIndex", {
		get: A.oneOfGetter(t = ["tabIndex"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.src != null && j.hasOwnProperty.call(e, "src") && t.uint32(10).string(e.src), e.srcdoc != null && j.hasOwnProperty.call(e, "srcdoc") && t.uint32(18).string(e.srcdoc), e.scrolling != null && j.hasOwnProperty.call(e, "scrolling") && e.scrolling !== !1 && t.uint32(56).bool(e.scrolling), e.tabIndex != null && j.hasOwnProperty.call(e, "tabIndex") && t.uint32(64).int32(e.tabIndex), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(74).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.IFrame(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.src = e.stringVerify(), o.type = "src";
					continue;
				case 2:
					if (a !== 2) break;
					o.srcdoc = e.stringVerify(), o.type = "srcdoc";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.scrolling = s : delete o.scrolling;
					continue;
				case 8:
					if (a !== 0) break;
					o.tabIndex = e.int32(), o._tabIndex = "tabIndex";
					continue;
				case 9:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.IFrame) return e;
		if (!A.isObject(e)) throw F(".IFrame: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.IFrame();
		return e.src != null && (n.src = I(e.src)), e.srcdoc != null && (n.srcdoc = I(e.srcdoc)), e.scrolling != null && e.scrolling && (n.scrolling = L(e.scrolling)), e.tabIndex != null && (n.tabIndex = e.tabIndex | 0), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.scrolling = !1), e.src != null && j.hasOwnProperty.call(e, "src") && (r.src = e.src, t.oneofs && (r.type = "src")), e.srcdoc != null && j.hasOwnProperty.call(e, "srcdoc") && (r.srcdoc = e.srcdoc, t.oneofs && (r.type = "srcdoc")), e.scrolling != null && j.hasOwnProperty.call(e, "scrolling") && (r.scrolling = e.scrolling), e.tabIndex != null && j.hasOwnProperty.call(e, "tabIndex") && (r.tabIndex = e.tabIndex), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/IFrame";
	}, e;
})(), U.Image = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.url = "", e.prototype.caption = "", e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.caption != null && j.hasOwnProperty.call(e, "caption") && e.caption !== "" && t.uint32(18).string(e.caption), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(26).string(e.url), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(42).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Image(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.caption = s : delete o.caption;
					continue;
				case 5:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Image) return e;
		if (!A.isObject(e)) throw F(".Image: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Image();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.caption != null && (typeof e.caption != "string" || e.caption.length) && (n.caption = I(e.caption)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.caption = "", r.url = ""), e.caption != null && j.hasOwnProperty.call(e, "caption") && (r.caption = e.caption), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Image";
	}, e;
})(), U.ImageList = (() => {
	let e = function(e) {
		if (this.imgs = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.imgs = A.emptyArray, e.prototype.link = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.imgs != null && e.imgs.length) for (let r = 0; r < e.imgs.length; ++r) U.Image.encode(e.imgs[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.link != null && j.hasOwnProperty.call(e, "link") && e.link !== "" && t.uint32(26).string(e.link), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ImageList(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.imgs && o.imgs.length || (o.imgs = []), o.imgs.push(U.Image.decode(e, e.uint32(), M, r + 1));
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.link = s : delete o.link;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ImageList) return e;
		if (!A.isObject(e)) throw F(".ImageList: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ImageList();
		if (e.imgs) {
			if (!B.isArray(e.imgs)) throw F(".ImageList.imgs: array expected");
			n.imgs = B(e.imgs.length);
			for (let r = 0; r < e.imgs.length; ++r) {
				if (!A.isObject(e.imgs[r])) throw F(".ImageList.imgs: object expected");
				n.imgs[r] = U.Image.fromObject(e.imgs[r], t + 1);
			}
		}
		return e.link != null && (typeof e.link != "string" || e.link.length) && (n.link = I(e.link)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.imgs = []), t.defaults && (r.link = ""), e.imgs && e.imgs.length) {
			r.imgs = B(e.imgs.length);
			for (let i = 0; i < e.imgs.length; ++i) r.imgs[i] = U.Image.toObject(e.imgs[i], t, n + 1);
		}
		return e.link != null && j.hasOwnProperty.call(e, "link") && (r.link = e.link), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ImageList";
	}, e;
})(), U.Json = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.body = "", e.prototype.expanded = !1, e.prototype.maxExpandDepth = null;
	let t;
	return j.defineProperty(e.prototype, "_maxExpandDepth", {
		get: A.oneOfGetter(t = ["maxExpandDepth"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && e.expanded !== !1 && t.uint32(16).bool(e.expanded), e.maxExpandDepth != null && j.hasOwnProperty.call(e, "maxExpandDepth") && t.uint32(24).int32(e.maxExpandDepth), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Json(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.expanded = s : delete o.expanded;
					continue;
				case 3:
					if (a !== 0) break;
					o.maxExpandDepth = e.int32(), o._maxExpandDepth = "maxExpandDepth";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Json) return e;
		if (!A.isObject(e)) throw F(".Json: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Json();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.expanded != null && e.expanded && (n.expanded = L(e.expanded)), e.maxExpandDepth != null && (n.maxExpandDepth = e.maxExpandDepth | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.expanded = !1), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && (r.expanded = e.expanded), e.maxExpandDepth != null && j.hasOwnProperty.call(e, "maxExpandDepth") && (r.maxExpandDepth = e.maxExpandDepth), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Json";
	}, e;
})(), U.LinkButton = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.help = "", e.prototype.url = "", e.prototype.disabled = !1, e.prototype.useContainerWidth = !1, e.prototype.type = "", e.prototype.icon = "", e.prototype.shortcut = "", e.prototype.iconPosition = 0, e.prototype.ignoreRerun = !1, e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(50).string(e.url), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(56).bool(e.disabled), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && e.useContainerWidth !== !1 && t.uint32(64).bool(e.useContainerWidth), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(74).string(e.type), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(82).string(e.icon), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && e.shortcut !== "" && t.uint32(90).string(e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && e.iconPosition !== 0 && t.uint32(96).int32(e.iconPosition), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(104).bool(e.ignoreRerun), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(112).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.LinkButton(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.shortcut = s : delete o.shortcut;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
				case 14:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.LinkButton) return e;
		if (!A.isObject(e)) throw F(".LinkButton: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.LinkButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = L(e.useContainerWidth)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.shortcut != null && (typeof e.shortcut != "string" || e.shortcut.length) && (n.shortcut = I(e.shortcut)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || U.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
			default: typeof e.iconPosition == "number" && (e.iconPosition | 0) === e.iconPosition && (n.iconPosition = e.iconPosition);
		}
		return e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.help = "", r.url = "", r.disabled = !1, r.useContainerWidth = !1, r.type = "", r.icon = "", r.shortcut = "", r.iconPosition = t.enums === I ? "LEFT" : 0, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.shortcut != null && j.hasOwnProperty.call(e, "shortcut") && (r.shortcut = e.shortcut), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && (r.iconPosition = t.enums === I ? U.streamlit.ButtonLikeIconPosition[e.iconPosition] === M ? e.iconPosition : U.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/LinkButton";
	}, e;
})(), U.Markdown = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.body = "", e.prototype.allowHtml = !1, e.prototype.elementType = 0, e.prototype.help = "", e.prototype.unterminatedParsing = !1, e.prototype.hideAnchors = !1, e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.allowHtml != null && j.hasOwnProperty.call(e, "allowHtml") && e.allowHtml !== !1 && t.uint32(16).bool(e.allowHtml), e.elementType != null && j.hasOwnProperty.call(e, "elementType") && e.elementType !== 0 && t.uint32(32).int32(e.elementType), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(42).string(e.help), e.unterminatedParsing != null && j.hasOwnProperty.call(e, "unterminatedParsing") && e.unterminatedParsing !== !1 && t.uint32(48).bool(e.unterminatedParsing), e.hideAnchors != null && j.hasOwnProperty.call(e, "hideAnchors") && e.hideAnchors !== !1 && t.uint32(56).bool(e.hideAnchors), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(64).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Markdown(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowHtml = s : delete o.allowHtml;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.elementType = s : delete o.elementType;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.unterminatedParsing = s : delete o.unterminatedParsing;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideAnchors = s : delete o.hideAnchors;
					continue;
				case 8:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Markdown) return e;
		if (!A.isObject(e)) throw F(".Markdown: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Markdown();
		if (e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.allowHtml != null && e.allowHtml && (n.allowHtml = L(e.allowHtml)), e.elementType !== 0 && (typeof e.elementType != "string" || U.Markdown.Type[e.elementType] !== 0)) switch (e.elementType) {
			case "UNSPECIFIED":
			case 0:
				n.elementType = 0;
				break;
			case "NATIVE":
			case 1:
				n.elementType = 1;
				break;
			case "CAPTION":
			case 2:
				n.elementType = 2;
				break;
			case "CODE":
			case 3:
				n.elementType = 3;
				break;
			case "LATEX":
			case 4:
				n.elementType = 4;
				break;
			case "DIVIDER":
			case 5:
				n.elementType = 5;
				break;
			default: typeof e.elementType == "number" && (e.elementType | 0) === e.elementType && (n.elementType = e.elementType);
		}
		return e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.unterminatedParsing != null && e.unterminatedParsing && (n.unterminatedParsing = L(e.unterminatedParsing)), e.hideAnchors != null && e.hideAnchors && (n.hideAnchors = L(e.hideAnchors)), e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.allowHtml = !1, r.elementType = t.enums === I ? "UNSPECIFIED" : 0, r.help = "", r.unterminatedParsing = !1, r.hideAnchors = !1), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.allowHtml != null && j.hasOwnProperty.call(e, "allowHtml") && (r.allowHtml = e.allowHtml), e.elementType != null && j.hasOwnProperty.call(e, "elementType") && (r.elementType = t.enums === I ? U.Markdown.Type[e.elementType] === M ? e.elementType : U.Markdown.Type[e.elementType] : e.elementType), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.unterminatedParsing != null && j.hasOwnProperty.call(e, "unterminatedParsing") && (r.unterminatedParsing = e.unterminatedParsing), e.hideAnchors != null && j.hasOwnProperty.call(e, "hideAnchors") && (r.hideAnchors = e.hideAnchors), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Markdown";
	}, e.Type = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "NATIVE"] = 1, t[e[2] = "CAPTION"] = 2, t[e[3] = "CODE"] = 3, t[e[4] = "LATEX"] = 4, t[e[5] = "DIVIDER"] = 5, t;
	})(), e;
})(), U.MenuButton = (() => {
	let e = function(e) {
		if (this.options = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.options = A.emptyArray, e.prototype.help = "", e.prototype.type = "", e.prototype.disabled = !1, e.prototype.icon = "", e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(26).string(e.options[n]);
		if (e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== "" && t.uint32(42).string(e.type), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(48).bool(e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(58).string(e.icon), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(64).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.MenuButton(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.stringVerify());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.type = s : delete o.type;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 8:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.MenuButton) return e;
		if (!A.isObject(e)) throw F(".MenuButton: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.MenuButton();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.options) {
			if (!B.isArray(e.options)) throw F(".MenuButton.options: array expected");
			n.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = I(e.options[t]);
		}
		return e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.type != null && (typeof e.type != "string" || e.type.length) && (n.type = I(e.type)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.type = "", r.disabled = !1, r.icon = ""), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		return e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = e.type), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/MenuButton";
	}, e;
})(), U.Metric = (() => {
	let e = function(e) {
		if (this.chartData = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.label = "", e.prototype.body = "", e.prototype.delta = "", e.prototype.direction = 0, e.prototype.color = 0, e.prototype.help = "", e.prototype.labelVisibility = null, e.prototype.showBorder = !1, e.prototype.chartData = A.emptyArray, e.prototype.chartType = 0, e.prototype.format = "", e.prototype.deltaDescription = "", e.prototype.icon = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(10).string(e.label), e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(18).string(e.body), e.delta != null && j.hasOwnProperty.call(e, "delta") && e.delta !== "" && t.uint32(26).string(e.delta), e.direction != null && j.hasOwnProperty.call(e, "direction") && e.direction !== 0 && t.uint32(32).int32(e.direction), e.color != null && j.hasOwnProperty.call(e, "color") && e.color !== 0 && t.uint32(40).int32(e.color), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(50).string(e.help), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(58).fork(), n + 1).ldelim(), e.showBorder != null && j.hasOwnProperty.call(e, "showBorder") && e.showBorder !== !1 && t.uint32(64).bool(e.showBorder), e.chartData != null && e.chartData.length && t.uint32(74).doubles(e.chartData), e.chartType != null && j.hasOwnProperty.call(e, "chartType") && e.chartType !== 0 && t.uint32(80).int32(e.chartType), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== "" && t.uint32(90).string(e.format), e.deltaDescription != null && j.hasOwnProperty.call(e, "deltaDescription") && e.deltaDescription !== "" && t.uint32(98).string(e.deltaDescription), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(106).string(e.icon), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Metric(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.delta = s : delete o.delta;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.direction = s : delete o.direction;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.color = s : delete o.color;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.showBorder = s : delete o.showBorder;
					continue;
				case 9:
					if (a === 2) {
						o.chartData && o.chartData.length || (o.chartData = []), e.doubles(o.chartData);
						continue;
					}
					if (a !== 1) break;
					o.chartData && o.chartData.length || (o.chartData = []), o.chartData.push(e.double());
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.chartType = s : delete o.chartType;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.format = s : delete o.format;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.deltaDescription = s : delete o.deltaDescription;
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Metric) return e;
		if (!A.isObject(e)) throw F(".Metric: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Metric();
		if (e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.delta != null && (typeof e.delta != "string" || e.delta.length) && (n.delta = I(e.delta)), e.direction !== 0 && (typeof e.direction != "string" || U.Metric.MetricDirection[e.direction] !== 0)) switch (e.direction) {
			case "DOWN":
			case 0:
				n.direction = 0;
				break;
			case "UP":
			case 1:
				n.direction = 1;
				break;
			case "NONE":
			case 2:
				n.direction = 2;
				break;
			default: typeof e.direction == "number" && (e.direction | 0) === e.direction && (n.direction = e.direction);
		}
		if (e.color !== 0 && (typeof e.color != "string" || U.Metric.MetricColor[e.color] !== 0)) switch (e.color) {
			case "RED":
			case 0:
				n.color = 0;
				break;
			case "GREEN":
			case 1:
				n.color = 1;
				break;
			case "GRAY":
			case 2:
				n.color = 2;
				break;
			case "ORANGE":
			case 3:
				n.color = 3;
				break;
			case "YELLOW":
			case 4:
				n.color = 4;
				break;
			case "BLUE":
			case 5:
				n.color = 5;
				break;
			case "VIOLET":
			case 6:
				n.color = 6;
				break;
			case "PRIMARY":
			case 7:
				n.color = 7;
				break;
			default: typeof e.color == "number" && (e.color | 0) === e.color && (n.color = e.color);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".Metric.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.showBorder != null && e.showBorder && (n.showBorder = L(e.showBorder)), e.chartData) {
			if (!B.isArray(e.chartData)) throw F(".Metric.chartData: array expected");
			n.chartData = B(e.chartData.length);
			for (let t = 0; t < e.chartData.length; ++t) n.chartData[t] = R(e.chartData[t]);
		}
		if (e.chartType !== 0 && (typeof e.chartType != "string" || U.Metric.ChartType[e.chartType] !== 0)) switch (e.chartType) {
			case "LINE":
			case 0:
				n.chartType = 0;
				break;
			case "BAR":
			case 1:
				n.chartType = 1;
				break;
			case "AREA":
			case 2:
				n.chartType = 2;
				break;
			default: typeof e.chartType == "number" && (e.chartType | 0) === e.chartType && (n.chartType = e.chartType);
		}
		return e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = I(e.format)), e.deltaDescription != null && (typeof e.deltaDescription != "string" || e.deltaDescription.length) && (n.deltaDescription = I(e.deltaDescription)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.chartData = []), t.defaults && (r.label = "", r.body = "", r.delta = "", r.direction = t.enums === I ? "DOWN" : 0, r.color = t.enums === I ? "RED" : 0, r.help = "", r.labelVisibility = null, r.showBorder = !1, r.chartType = t.enums === I ? "LINE" : 0, r.format = "", r.deltaDescription = "", r.icon = ""), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.delta != null && j.hasOwnProperty.call(e, "delta") && (r.delta = e.delta), e.direction != null && j.hasOwnProperty.call(e, "direction") && (r.direction = t.enums === I ? U.Metric.MetricDirection[e.direction] === M ? e.direction : U.Metric.MetricDirection[e.direction] : e.direction), e.color != null && j.hasOwnProperty.call(e, "color") && (r.color = t.enums === I ? U.Metric.MetricColor[e.color] === M ? e.color : U.Metric.MetricColor[e.color] : e.color), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.showBorder != null && j.hasOwnProperty.call(e, "showBorder") && (r.showBorder = e.showBorder), e.chartData && e.chartData.length) {
			r.chartData = B(e.chartData.length);
			for (let n = 0; n < e.chartData.length; ++n) r.chartData[n] = t.json && !z(e.chartData[n]) ? I(e.chartData[n]) : e.chartData[n];
		}
		return e.chartType != null && j.hasOwnProperty.call(e, "chartType") && (r.chartType = t.enums === I ? U.Metric.ChartType[e.chartType] === M ? e.chartType : U.Metric.ChartType[e.chartType] : e.chartType), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.deltaDescription != null && j.hasOwnProperty.call(e, "deltaDescription") && (r.deltaDescription = e.deltaDescription), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Metric";
	}, e.MetricDirection = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "DOWN"] = 0, t[e[1] = "UP"] = 1, t[e[2] = "NONE"] = 2, t;
	})(), e.MetricColor = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "RED"] = 0, t[e[1] = "GREEN"] = 1, t[e[2] = "GRAY"] = 2, t[e[3] = "ORANGE"] = 3, t[e[4] = "YELLOW"] = 4, t[e[5] = "BLUE"] = 5, t[e[6] = "VIOLET"] = 6, t[e[7] = "PRIMARY"] = 7, t;
	})(), e.ChartType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "LINE"] = 0, t[e[1] = "BAR"] = 1, t[e[2] = "AREA"] = 2, t;
	})(), e;
})(), U.MultiSelect = (() => {
	let e = function(e) {
		if (this.default = [], this.options = [], this.rawValues = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = A.emptyArray, e.prototype.options = A.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValues = A.emptyArray, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.maxSelections = 0, e.prototype.placeholder = "", e.prototype.acceptNewOptions = null, e.prototype.queryParamKey = null, e.prototype.filterMode = 0, e.prototype.wrap = null, e.prototype.selectAll = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_acceptNewOptions", {
		get: A.oneOfGetter(t = ["acceptNewOptions"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_selectAll", {
		get: A.oneOfGetter(t = ["selectAll"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && e.default.length && t.uint32(26).int32s(e.default), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(42).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(64).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(72).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.maxSelections != null && j.hasOwnProperty.call(e, "maxSelections") && e.maxSelections !== 0 && t.uint32(88).int32(e.maxSelections), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(98).string(e.placeholder), e.acceptNewOptions != null && j.hasOwnProperty.call(e, "acceptNewOptions") && t.uint32(104).bool(e.acceptNewOptions), e.rawValues != null && e.rawValues.length) for (let n = 0; n < e.rawValues.length; ++n) t.uint32(114).string(e.rawValues[n]);
		if (e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.filterMode != null && j.hasOwnProperty.call(e, "filterMode") && e.filterMode !== 0 && t.uint32(128).int32(e.filterMode), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(136).bool(e.wrap), e.selectAll != null && j.hasOwnProperty.call(e, "selectAll") && t.uint32(144).int32(e.selectAll), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(152).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.MultiSelect(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a === 2) {
						o.default && o.default.length || (o.default = []), e.int32s(o.default);
						continue;
					}
					if (a !== 0) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.int32());
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.stringVerify());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 14:
					if (a !== 2) break;
					o.rawValues && o.rawValues.length || (o.rawValues = []), o.rawValues.push(e.stringVerify());
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxSelections = s : delete o.maxSelections;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 13:
					if (a !== 0) break;
					o.acceptNewOptions = e.bool(), o._acceptNewOptions = "acceptNewOptions";
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 16:
					if (a !== 0) break;
					(s = e.int32()) ? o.filterMode = s : delete o.filterMode;
					continue;
				case 17:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
				case 18:
					if (a !== 0) break;
					o.selectAll = e.int32(), o._selectAll = "selectAll";
					continue;
				case 19:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.MultiSelect) return e;
		if (!A.isObject(e)) throw F(".MultiSelect: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.MultiSelect();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default) {
			if (!B.isArray(e.default)) throw F(".MultiSelect.default: array expected");
			n.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = e.default[t] | 0;
		}
		if (e.options) {
			if (!B.isArray(e.options)) throw F(".MultiSelect.options: array expected");
			n.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = I(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.rawValues) {
			if (!B.isArray(e.rawValues)) throw F(".MultiSelect.rawValues: array expected");
			n.rawValues = B(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) n.rawValues[t] = I(e.rawValues[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".MultiSelect.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.maxSelections != null && R(e.maxSelections) !== 0 && (n.maxSelections = e.maxSelections | 0), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.acceptNewOptions != null && (n.acceptNewOptions = L(e.acceptNewOptions)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.filterMode !== 0 && (typeof e.filterMode != "string" || U.streamlit.SelectWidgetFilterMode[e.filterMode] !== 0)) switch (e.filterMode) {
			case "FILTER_MODE_FUZZY":
			case 0:
				n.filterMode = 0;
				break;
			case "FILTER_MODE_CONTAINS":
			case 1:
				n.filterMode = 1;
				break;
			case "FILTER_MODE_PREFIX":
			case 2:
				n.filterMode = 2;
				break;
			case "FILTER_MODE_NONE":
			case 3:
				n.filterMode = 3;
				break;
			default: typeof e.filterMode == "number" && (e.filterMode | 0) === e.filterMode && (n.filterMode = e.filterMode);
		}
		return e.wrap != null && (n.wrap = L(e.wrap)), e.selectAll != null && (n.selectAll = e.selectAll | 0), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.options = [], r.rawValues = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.maxSelections = 0, r.placeholder = "", r.filterMode = t.enums === I ? "FILTER_MODE_FUZZY" : 0, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default && e.default.length) {
			r.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) r.default[t] = e.default[t];
		}
		if (e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.maxSelections != null && j.hasOwnProperty.call(e, "maxSelections") && (r.maxSelections = e.maxSelections), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.acceptNewOptions != null && j.hasOwnProperty.call(e, "acceptNewOptions") && (r.acceptNewOptions = e.acceptNewOptions), e.rawValues && e.rawValues.length) {
			r.rawValues = B(e.rawValues.length);
			for (let t = 0; t < e.rawValues.length; ++t) r.rawValues[t] = e.rawValues[t];
		}
		return e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.filterMode != null && j.hasOwnProperty.call(e, "filterMode") && (r.filterMode = t.enums === I ? U.streamlit.SelectWidgetFilterMode[e.filterMode] === M ? e.filterMode : U.streamlit.SelectWidgetFilterMode[e.filterMode] : e.filterMode), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), e.selectAll != null && j.hasOwnProperty.call(e, "selectAll") && (r.selectAll = e.selectAll), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/MultiSelect";
	}, e;
})(), U.NumberInput = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.formId = "", e.prototype.format = "", e.prototype.hasMin = !1, e.prototype.hasMax = !1, e.prototype.dataType = 0, e.prototype.default = null, e.prototype.step = 0, e.prototype.min = 0, e.prototype.max = 0, e.prototype.help = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.placeholder = "", e.prototype.icon = "", e.prototype.queryParamKey = null, e.prototype.ignoreRerun = !1, e.prototype.required = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_value", {
		get: A.oneOfGetter(t = ["value"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(26).string(e.formId), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== "" && t.uint32(66).string(e.format), e.hasMin != null && j.hasOwnProperty.call(e, "hasMin") && e.hasMin !== !1 && t.uint32(88).bool(e.hasMin), e.hasMax != null && j.hasOwnProperty.call(e, "hasMax") && e.hasMax !== !1 && t.uint32(96).bool(e.hasMax), e.dataType != null && j.hasOwnProperty.call(e, "dataType") && e.dataType !== 0 && t.uint32(104).int32(e.dataType), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(113).double(e.default), e.step != null && j.hasOwnProperty.call(e, "step") && !j.is(e.step, 0) && t.uint32(121).double(e.step), e.min != null && j.hasOwnProperty.call(e, "min") && !j.is(e.min, 0) && t.uint32(129).double(e.min), e.max != null && j.hasOwnProperty.call(e, "max") && !j.is(e.max, 0) && t.uint32(137).double(e.max), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(146).string(e.help), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(153).double(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(160).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(168).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(178).fork(), n + 1).ldelim(), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(186).string(e.placeholder), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(194).string(e.icon), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(202).string(e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(208).bool(e.ignoreRerun), e.required != null && j.hasOwnProperty.call(e, "required") && e.required !== !1 && t.uint32(216).bool(e.required), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.NumberInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.format = s : delete o.format;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasMin = s : delete o.hasMin;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasMax = s : delete o.hasMax;
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.int32()) ? o.dataType = s : delete o.dataType;
					continue;
				case 14:
					if (a !== 1) break;
					o.default = e.double(), o._default = "default";
					continue;
				case 15:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.step : o.step = s;
					continue;
				case 16:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.min : o.min = s;
					continue;
				case 17:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.max : o.max = s;
					continue;
				case 18:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 19:
					if (a !== 1) break;
					o.value = e.double(), o._value = "value";
					continue;
				case 20:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 21:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 22:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 23:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 24:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 25:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 26:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
				case 27:
					if (a !== 0) break;
					(s = e.bool()) ? o.required = s : delete o.required;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.NumberInput) return e;
		if (!A.isObject(e)) throw F(".NumberInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.NumberInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = I(e.format)), e.hasMin != null && e.hasMin && (n.hasMin = L(e.hasMin)), e.hasMax != null && e.hasMax && (n.hasMax = L(e.hasMax)), e.dataType !== 0 && (typeof e.dataType != "string" || U.NumberInput.DataType[e.dataType] !== 0)) switch (e.dataType) {
			case "INT":
			case 0:
				n.dataType = 0;
				break;
			case "FLOAT":
			case 1:
				n.dataType = 1;
				break;
			default: typeof e.dataType == "number" && (e.dataType | 0) === e.dataType && (n.dataType = e.dataType);
		}
		if (e.default != null && (n.default = R(e.default)), e.step != null && (j.is(R(e.step), 0) || (n.step = R(e.step))), e.min != null && (j.is(R(e.min), 0) || (n.min = R(e.min))), e.max != null && (j.is(R(e.max), 0) || (n.max = R(e.max))), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.value != null && (n.value = R(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".NumberInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), e.required != null && e.required && (n.required = L(e.required)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.formId = "", r.format = "", r.hasMin = !1, r.hasMax = !1, r.dataType = t.enums === I ? "INT" : 0, r.step = 0, r.min = 0, r.max = 0, r.help = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.placeholder = "", r.icon = "", r.ignoreRerun = !1, r.required = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.hasMin != null && j.hasOwnProperty.call(e, "hasMin") && (r.hasMin = e.hasMin), e.hasMax != null && j.hasOwnProperty.call(e, "hasMax") && (r.hasMax = e.hasMax), e.dataType != null && j.hasOwnProperty.call(e, "dataType") && (r.dataType = t.enums === I ? U.NumberInput.DataType[e.dataType] === M ? e.dataType : U.NumberInput.DataType[e.dataType] : e.dataType), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = t.json && !z(e.default) ? I(e.default) : e.default), e.step != null && j.hasOwnProperty.call(e, "step") && (r.step = t.json && !z(e.step) ? I(e.step) : e.step), e.min != null && j.hasOwnProperty.call(e, "min") && (r.min = t.json && !z(e.min) ? I(e.min) : e.min), e.max != null && j.hasOwnProperty.call(e, "max") && (r.max = t.json && !z(e.max) ? I(e.max) : e.max), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = t.json && !z(e.value) ? I(e.value) : e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), e.required != null && j.hasOwnProperty.call(e, "required") && (r.required = e.required), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/NumberInput";
	}, e.DataType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "INT"] = 0, t[e[1] = "FLOAT"] = 1, t;
	})(), e;
})(), U.PageLink = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.page = "", e.prototype.label = "", e.prototype.icon = "", e.prototype.pageScriptHash = "", e.prototype.help = "", e.prototype.useContainerWidth = null, e.prototype.disabled = !1, e.prototype.external = !1, e.prototype.queryString = "", e.prototype.iconPosition = 0;
	let t;
	return j.defineProperty(e.prototype, "_useContainerWidth", {
		get: A.oneOfGetter(t = ["useContainerWidth"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.page != null && j.hasOwnProperty.call(e, "page") && e.page !== "" && t.uint32(10).string(e.page), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(26).string(e.icon), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(34).string(e.pageScriptHash), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(42).string(e.help), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && t.uint32(48).bool(e.useContainerWidth), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(56).bool(e.disabled), e.external != null && j.hasOwnProperty.call(e, "external") && e.external !== !1 && t.uint32(64).bool(e.external), e.queryString != null && j.hasOwnProperty.call(e, "queryString") && e.queryString !== "" && t.uint32(74).string(e.queryString), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && e.iconPosition !== 0 && t.uint32(80).int32(e.iconPosition), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PageLink(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.page = s : delete o.page;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 0) break;
					o.useContainerWidth = e.bool(), o._useContainerWidth = "useContainerWidth";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.external = s : delete o.external;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.queryString = s : delete o.queryString;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconPosition = s : delete o.iconPosition;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PageLink) return e;
		if (!A.isObject(e)) throw F(".PageLink: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PageLink();
		if (e.page != null && (typeof e.page != "string" || e.page.length) && (n.page = I(e.page)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.useContainerWidth != null && (n.useContainerWidth = L(e.useContainerWidth)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.external != null && e.external && (n.external = L(e.external)), e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = I(e.queryString)), e.iconPosition !== 0 && (typeof e.iconPosition != "string" || U.streamlit.ButtonLikeIconPosition[e.iconPosition] !== 0)) switch (e.iconPosition) {
			case "LEFT":
			case 0:
				n.iconPosition = 0;
				break;
			case "RIGHT":
			case 1:
				n.iconPosition = 1;
				break;
			default: typeof e.iconPosition == "number" && (e.iconPosition | 0) === e.iconPosition && (n.iconPosition = e.iconPosition);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.page = "", r.label = "", r.icon = "", r.pageScriptHash = "", r.help = "", r.disabled = !1, r.external = !1, r.queryString = "", r.iconPosition = t.enums === I ? "LEFT" : 0), e.page != null && j.hasOwnProperty.call(e, "page") && (r.page = e.page), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.external != null && j.hasOwnProperty.call(e, "external") && (r.external = e.external), e.queryString != null && j.hasOwnProperty.call(e, "queryString") && (r.queryString = e.queryString), e.iconPosition != null && j.hasOwnProperty.call(e, "iconPosition") && (r.iconPosition = t.enums === I ? U.streamlit.ButtonLikeIconPosition[e.iconPosition] === M ? e.iconPosition : U.streamlit.ButtonLikeIconPosition[e.iconPosition] : e.iconPosition), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PageLink";
	}, e;
})(), U.Pagination = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.numPages = 0, e.prototype.default = 0, e.prototype.maxVisiblePages = null, e.prototype.disabled = !1, e.prototype.formId = "", e.prototype.value = 0, e.prototype.setValue = !1, e.prototype.queryParamKey = null;
	let t;
	return j.defineProperty(e.prototype, "_maxVisiblePages", {
		get: A.oneOfGetter(t = ["maxVisiblePages"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.numPages != null && j.hasOwnProperty.call(e, "numPages") && e.numPages !== 0 && t.uint32(16).uint32(e.numPages), e.default != null && j.hasOwnProperty.call(e, "default") && e.default !== 0 && t.uint32(24).uint32(e.default), e.maxVisiblePages != null && j.hasOwnProperty.call(e, "maxVisiblePages") && t.uint32(32).uint32(e.maxVisiblePages), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(40).bool(e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== 0 && t.uint32(56).uint32(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(64).bool(e.setValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(74).string(e.queryParamKey), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Pagination(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.uint32()) ? o.numPages = s : delete o.numPages;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.uint32()) ? o.default = s : delete o.default;
					continue;
				case 4:
					if (a !== 0) break;
					o.maxVisiblePages = e.uint32(), o._maxVisiblePages = "maxVisiblePages";
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.uint32()) ? o.value = s : delete o.value;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Pagination) return e;
		if (!A.isObject(e)) throw F(".Pagination: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Pagination();
		return e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.numPages != null && R(e.numPages) !== 0 && (n.numPages = e.numPages >>> 0), e.default != null && R(e.default) !== 0 && (n.default = e.default >>> 0), e.maxVisiblePages != null && (n.maxVisiblePages = e.maxVisiblePages >>> 0), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && R(e.value) !== 0 && (n.value = e.value >>> 0), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.numPages = 0, r.default = 0, r.disabled = !1, r.formId = "", r.value = 0, r.setValue = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.numPages != null && j.hasOwnProperty.call(e, "numPages") && (r.numPages = e.numPages), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.maxVisiblePages != null && j.hasOwnProperty.call(e, "maxVisiblePages") && (r.maxVisiblePages = e.maxVisiblePages), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Pagination";
	}, e;
})(), U.PlotlyChart = (() => {
	let e = function(e) {
		if (this.selectionMode = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.theme = "", e.prototype.id = "", e.prototype.selectionMode = A.emptyArray, e.prototype.formId = "", e.prototype.spec = "", e.prototype.config = "", e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.theme != null && j.hasOwnProperty.call(e, "theme") && e.theme !== "" && t.uint32(50).string(e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(58).string(e.id), e.selectionMode != null && e.selectionMode.length && t.uint32(66).int32s(e.selectionMode), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(74).string(e.formId), e.spec != null && j.hasOwnProperty.call(e, "spec") && e.spec !== "" && t.uint32(82).string(e.spec), e.config != null && j.hasOwnProperty.call(e, "config") && e.config !== "" && t.uint32(90).string(e.config), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(98).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PlotlyChart(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.theme = s : delete o.theme;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 8:
					if (a === 2) {
						o.selectionMode && o.selectionMode.length || (o.selectionMode = []), e.int32s(o.selectionMode);
						continue;
					}
					if (a !== 0) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.int32());
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.spec = s : delete o.spec;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.config = s : delete o.config;
					continue;
				case 12:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PlotlyChart) return e;
		if (!A.isObject(e)) throw F(".PlotlyChart: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PlotlyChart();
		if (e.theme != null && (typeof e.theme != "string" || e.theme.length) && (n.theme = I(e.theme)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.selectionMode) {
			if (!B.isArray(e.selectionMode)) throw F(".PlotlyChart.selectionMode: array expected");
			n.selectionMode = [];
			for (let t = 0; t < e.selectionMode.length; ++t) switch (e.selectionMode[t]) {
				case "POINTS":
				case 0:
					n.selectionMode[n.selectionMode.length] = 0;
					break;
				case "BOX":
				case 1:
					n.selectionMode[n.selectionMode.length] = 1;
					break;
				case "LASSO":
				case 2:
					n.selectionMode[n.selectionMode.length] = 2;
					break;
				default: typeof e.selectionMode[t] == "number" && (e.selectionMode[t] | 0) === e.selectionMode[t] && (n.selectionMode[n.selectionMode.length] = e.selectionMode[t]);
			}
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = I(e.spec)), e.config != null && (typeof e.config != "string" || e.config.length) && (n.config = I(e.config)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.selectionMode = []), t.defaults && (r.theme = "", r.id = "", r.formId = "", r.spec = "", r.config = ""), e.theme != null && j.hasOwnProperty.call(e, "theme") && (r.theme = e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = B(e.selectionMode.length);
			for (let n = 0; n < e.selectionMode.length; ++n) r.selectionMode[n] = t.enums === I ? U.PlotlyChart.SelectionMode[e.selectionMode[n]] === M ? e.selectionMode[n] : U.PlotlyChart.SelectionMode[e.selectionMode[n]] : e.selectionMode[n];
		}
		return e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.spec != null && j.hasOwnProperty.call(e, "spec") && (r.spec = e.spec), e.config != null && j.hasOwnProperty.call(e, "config") && (r.config = e.config), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PlotlyChart";
	}, e.SelectionMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "POINTS"] = 0, t[e[1] = "BOX"] = 1, t[e[2] = "LASSO"] = 2, t;
	})(), e;
})(), U.Progress = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.value = 0, e.prototype.text = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== 0 && t.uint32(8).uint32(e.value), e.text != null && j.hasOwnProperty.call(e, "text") && e.text !== "" && t.uint32(18).string(e.text), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Progress(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.uint32()) ? o.value = s : delete o.value;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.text = s : delete o.text;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Progress) return e;
		if (!A.isObject(e)) throw F(".Progress: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Progress();
		return e.value != null && R(e.value) !== 0 && (n.value = e.value >>> 0), e.text != null && (typeof e.text != "string" || e.text.length) && (n.text = I(e.text)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.value = 0, r.text = ""), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.text != null && j.hasOwnProperty.call(e, "text") && (r.text = e.text), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Progress";
	}, e;
})(), U.Radio = (() => {
	let e = function(e) {
		if (this.options = [], this.captions = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.options = A.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValue = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.horizontal = !1, e.prototype.labelVisibility = null, e.prototype.captions = A.emptyArray, e.prototype.queryParamKey = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_rawValue", {
		get: A.oneOfGetter(t = ["rawValue"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(24).int32(e.default), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(42).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(64).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(72).bool(e.disabled), e.horizontal != null && j.hasOwnProperty.call(e, "horizontal") && e.horizontal !== !1 && t.uint32(80).bool(e.horizontal), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(90).fork(), n + 1).ldelim(), e.captions != null && e.captions.length) for (let n = 0; n < e.captions.length; ++n) t.uint32(98).string(e.captions[n]);
		if (e.rawValue != null && j.hasOwnProperty.call(e, "rawValue") && t.uint32(106).string(e.rawValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(120).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Radio(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.int32(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.stringVerify());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 13:
					if (a !== 2) break;
					o.rawValue = e.stringVerify(), o._rawValue = "rawValue";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.horizontal = s : delete o.horizontal;
					continue;
				case 11:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 12:
					if (a !== 2) break;
					o.captions && o.captions.length || (o.captions = []), o.captions.push(e.stringVerify());
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Radio) return e;
		if (!A.isObject(e)) throw F(".Radio: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Radio();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (n.default = e.default | 0), e.options) {
			if (!B.isArray(e.options)) throw F(".Radio.options: array expected");
			n.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = I(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.rawValue != null && (n.rawValue = I(e.rawValue)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.horizontal != null && e.horizontal && (n.horizontal = L(e.horizontal)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".Radio.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.captions) {
			if (!B.isArray(e.captions)) throw F(".Radio.captions: array expected");
			n.captions = B(e.captions.length);
			for (let t = 0; t < e.captions.length; ++t) n.captions[t] = I(e.captions[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = [], r.captions = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.horizontal = !1, r.labelVisibility = null, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.horizontal != null && j.hasOwnProperty.call(e, "horizontal") && (r.horizontal = e.horizontal), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.captions && e.captions.length) {
			r.captions = B(e.captions.length);
			for (let t = 0; t < e.captions.length; ++t) r.captions[t] = e.captions[t];
		}
		return e.rawValue != null && j.hasOwnProperty.call(e, "rawValue") && (r.rawValue = e.rawValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Radio";
	}, e;
})(), U.Selectbox = (() => {
	let e = function(e) {
		if (this.options = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.options = A.emptyArray, e.prototype.help = "", e.prototype.formId = "", e.prototype.rawValue = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.placeholder = "", e.prototype.acceptNewOptions = null, e.prototype.queryParamKey = null, e.prototype.filterMode = 0, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_rawValue", {
		get: A.oneOfGetter(t = ["rawValue"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_acceptNewOptions", {
		get: A.oneOfGetter(t = ["acceptNewOptions"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(24).int32(e.default), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(34).string(e.options[n]);
		if (e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(42).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(50).string(e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(64).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(72).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(82).fork(), n + 1).ldelim(), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(90).string(e.placeholder), e.acceptNewOptions != null && j.hasOwnProperty.call(e, "acceptNewOptions") && t.uint32(96).bool(e.acceptNewOptions), e.rawValue != null && j.hasOwnProperty.call(e, "rawValue") && t.uint32(106).string(e.rawValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(114).string(e.queryParamKey), e.filterMode != null && j.hasOwnProperty.call(e, "filterMode") && e.filterMode !== 0 && t.uint32(120).int32(e.filterMode), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(128).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Selectbox(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 0) break;
					o.default = e.int32(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.stringVerify());
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 13:
					if (a !== 2) break;
					o.rawValue = e.stringVerify(), o._rawValue = "rawValue";
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 10:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 12:
					if (a !== 0) break;
					o.acceptNewOptions = e.bool(), o._acceptNewOptions = "acceptNewOptions";
					continue;
				case 14:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.int32()) ? o.filterMode = s : delete o.filterMode;
					continue;
				case 16:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Selectbox) return e;
		if (!A.isObject(e)) throw F(".Selectbox: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Selectbox();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (n.default = e.default | 0), e.options) {
			if (!B.isArray(e.options)) throw F(".Selectbox.options: array expected");
			n.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = I(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.rawValue != null && (n.rawValue = I(e.rawValue)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".Selectbox.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.acceptNewOptions != null && (n.acceptNewOptions = L(e.acceptNewOptions)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.filterMode !== 0 && (typeof e.filterMode != "string" || U.streamlit.SelectWidgetFilterMode[e.filterMode] !== 0)) switch (e.filterMode) {
			case "FILTER_MODE_FUZZY":
			case 0:
				n.filterMode = 0;
				break;
			case "FILTER_MODE_CONTAINS":
			case 1:
				n.filterMode = 1;
				break;
			case "FILTER_MODE_PREFIX":
			case 2:
				n.filterMode = 2;
				break;
			case "FILTER_MODE_NONE":
			case 3:
				n.filterMode = 3;
				break;
			default: typeof e.filterMode == "number" && (e.filterMode | 0) === e.filterMode && (n.filterMode = e.filterMode);
		}
		return e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.options = []), t.defaults && (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, r.placeholder = "", r.filterMode = t.enums === I ? "FILTER_MODE_FUZZY" : 0, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		return e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.acceptNewOptions != null && j.hasOwnProperty.call(e, "acceptNewOptions") && (r.acceptNewOptions = e.acceptNewOptions), e.rawValue != null && j.hasOwnProperty.call(e, "rawValue") && (r.rawValue = e.rawValue), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.filterMode != null && j.hasOwnProperty.call(e, "filterMode") && (r.filterMode = t.enums === I ? U.streamlit.SelectWidgetFilterMode[e.filterMode] === M ? e.filterMode : U.streamlit.SelectWidgetFilterMode[e.filterMode] : e.filterMode), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Selectbox";
	}, e;
})(), U.Skeleton = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.style = 0, e.prototype.height = null;
	let t;
	return j.defineProperty(e.prototype, "_height", {
		get: A.oneOfGetter(t = ["height"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.style != null && j.hasOwnProperty.call(e, "style") && e.style !== 0 && t.uint32(8).int32(e.style), e.height != null && j.hasOwnProperty.call(e, "height") && t.uint32(16).int32(e.height), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Skeleton(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.int32()) ? o.style = s : delete o.style;
					continue;
				case 2:
					if (a !== 0) break;
					o.height = e.int32(), o._height = "height";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Skeleton) return e;
		if (!A.isObject(e)) throw F(".Skeleton: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Skeleton();
		if (e.style !== 0 && (typeof e.style != "string" || U.Skeleton.SkeletonStyle[e.style] !== 0)) switch (e.style) {
			case "ELEMENT":
			case 0:
				n.style = 0;
				break;
			case "APP":
			case 1:
				n.style = 1;
				break;
			default: typeof e.style == "number" && (e.style | 0) === e.style && (n.style = e.style);
		}
		return e.height != null && (n.height = e.height | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.style = t.enums === I ? "ELEMENT" : 0), e.style != null && j.hasOwnProperty.call(e, "style") && (r.style = t.enums === I ? U.Skeleton.SkeletonStyle[e.style] === M ? e.style : U.Skeleton.SkeletonStyle[e.style] : e.style), e.height != null && j.hasOwnProperty.call(e, "height") && (r.height = e.height), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Skeleton";
	}, e.SkeletonStyle = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "ELEMENT"] = 0, t[e[1] = "APP"] = 1, t;
	})(), e;
})(), U.Slider = (() => {
	let e = function(e) {
		if (this.default = [], this.value = [], this.options = [], this.rawValue = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.formId = "", e.prototype.label = "", e.prototype.format = "", e.prototype.dataType = 0, e.prototype.default = A.emptyArray, e.prototype.min = 0, e.prototype.max = 0, e.prototype.step = 0, e.prototype.value = A.emptyArray, e.prototype.setValue = !1, e.prototype.options = A.emptyArray, e.prototype.help = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.type = 0, e.prototype.rawValue = A.emptyArray, e.prototype.queryParamKey = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(18).string(e.formId), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(26).string(e.label), e.format != null && j.hasOwnProperty.call(e, "format") && e.format !== "" && t.uint32(34).string(e.format), e.dataType != null && j.hasOwnProperty.call(e, "dataType") && e.dataType !== 0 && t.uint32(40).int32(e.dataType), e.default != null && e.default.length && t.uint32(50).doubles(e.default), e.min != null && j.hasOwnProperty.call(e, "min") && !j.is(e.min, 0) && t.uint32(57).double(e.min), e.max != null && j.hasOwnProperty.call(e, "max") && !j.is(e.max, 0) && t.uint32(65).double(e.max), e.step != null && j.hasOwnProperty.call(e, "step") && !j.is(e.step, 0) && t.uint32(73).double(e.step), e.value != null && e.value.length && t.uint32(82).doubles(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(88).bool(e.setValue), e.options != null && e.options.length) for (let n = 0; n < e.options.length; ++n) t.uint32(106).string(e.options[n]);
		if (e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(114).string(e.help), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(120).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(130).fork(), n + 1).ldelim(), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(136).int32(e.type), e.rawValue != null && e.rawValue.length) for (let n = 0; n < e.rawValue.length; ++n) t.uint32(146).string(e.rawValue[n]);
		if (e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(154).string(e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(160).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Slider(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.format = s : delete o.format;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.dataType = s : delete o.dataType;
					continue;
				case 6:
					if (a === 2) {
						o.default && o.default.length || (o.default = []), e.doubles(o.default);
						continue;
					}
					if (a !== 1) break;
					o.default && o.default.length || (o.default = []), o.default.push(e.double());
					continue;
				case 7:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.min : o.min = s;
					continue;
				case 8:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.max : o.max = s;
					continue;
				case 9:
					if (a !== 1) break;
					j.is(s = e.double(), 0) ? delete o.step : o.step = s;
					continue;
				case 10:
					if (a === 2) {
						o.value && o.value.length || (o.value = []), e.doubles(o.value);
						continue;
					}
					if (a !== 1) break;
					o.value && o.value.length || (o.value = []), o.value.push(e.double());
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 13:
					if (a !== 2) break;
					o.options && o.options.length || (o.options = []), o.options.push(e.stringVerify());
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 15:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 16:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 17:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 18:
					if (a !== 2) break;
					o.rawValue && o.rawValue.length || (o.rawValue = []), o.rawValue.push(e.stringVerify());
					continue;
				case 19:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 20:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Slider) return e;
		if (!A.isObject(e)) throw F(".Slider: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Slider();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.format != null && (typeof e.format != "string" || e.format.length) && (n.format = I(e.format)), e.dataType !== 0 && (typeof e.dataType != "string" || U.Slider.DataType[e.dataType] !== 0)) switch (e.dataType) {
			case "INT":
			case 0:
				n.dataType = 0;
				break;
			case "FLOAT":
			case 1:
				n.dataType = 1;
				break;
			case "DATETIME":
			case 2:
				n.dataType = 2;
				break;
			case "DATE":
			case 3:
				n.dataType = 3;
				break;
			case "TIME":
			case 4:
				n.dataType = 4;
				break;
			default: typeof e.dataType == "number" && (e.dataType | 0) === e.dataType && (n.dataType = e.dataType);
		}
		if (e.default) {
			if (!B.isArray(e.default)) throw F(".Slider.default: array expected");
			n.default = B(e.default.length);
			for (let t = 0; t < e.default.length; ++t) n.default[t] = R(e.default[t]);
		}
		if (e.min != null && (j.is(R(e.min), 0) || (n.min = R(e.min))), e.max != null && (j.is(R(e.max), 0) || (n.max = R(e.max))), e.step != null && (j.is(R(e.step), 0) || (n.step = R(e.step))), e.value) {
			if (!B.isArray(e.value)) throw F(".Slider.value: array expected");
			n.value = B(e.value.length);
			for (let t = 0; t < e.value.length; ++t) n.value[t] = R(e.value[t]);
		}
		if (e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.options) {
			if (!B.isArray(e.options)) throw F(".Slider.options: array expected");
			n.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) n.options[t] = I(e.options[t]);
		}
		if (e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".Slider.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		if (e.type !== 0 && (typeof e.type != "string" || U.Slider.Type[e.type] !== 0)) switch (e.type) {
			case "UNSPECIFIED":
			case 0:
				n.type = 0;
				break;
			case "SLIDER":
			case 1:
				n.type = 1;
				break;
			case "SELECT_SLIDER":
			case 2:
				n.type = 2;
				break;
			default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
		}
		if (e.rawValue) {
			if (!B.isArray(e.rawValue)) throw F(".Slider.rawValue: array expected");
			n.rawValue = B(e.rawValue.length);
			for (let t = 0; t < e.rawValue.length; ++t) n.rawValue[t] = I(e.rawValue[t]);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.default = [], r.value = [], r.options = [], r.rawValue = []), t.defaults && (r.id = "", r.formId = "", r.label = "", r.format = "", r.dataType = t.enums === I ? "INT" : 0, r.min = 0, r.max = 0, r.step = 0, r.setValue = !1, r.help = "", r.disabled = !1, r.labelVisibility = null, r.type = t.enums === I ? "UNSPECIFIED" : 0, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.dataType != null && j.hasOwnProperty.call(e, "dataType") && (r.dataType = t.enums === I ? U.Slider.DataType[e.dataType] === M ? e.dataType : U.Slider.DataType[e.dataType] : e.dataType), e.default && e.default.length) {
			r.default = B(e.default.length);
			for (let n = 0; n < e.default.length; ++n) r.default[n] = t.json && !z(e.default[n]) ? I(e.default[n]) : e.default[n];
		}
		if (e.min != null && j.hasOwnProperty.call(e, "min") && (r.min = t.json && !z(e.min) ? I(e.min) : e.min), e.max != null && j.hasOwnProperty.call(e, "max") && (r.max = t.json && !z(e.max) ? I(e.max) : e.max), e.step != null && j.hasOwnProperty.call(e, "step") && (r.step = t.json && !z(e.step) ? I(e.step) : e.step), e.value && e.value.length) {
			r.value = B(e.value.length);
			for (let n = 0; n < e.value.length; ++n) r.value[n] = t.json && !z(e.value[n]) ? I(e.value[n]) : e.value[n];
		}
		if (e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.options && e.options.length) {
			r.options = B(e.options.length);
			for (let t = 0; t < e.options.length; ++t) r.options[t] = e.options[t];
		}
		if (e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.Slider.Type[e.type] === M ? e.type : U.Slider.Type[e.type] : e.type), e.rawValue && e.rawValue.length) {
			r.rawValue = B(e.rawValue.length);
			for (let t = 0; t < e.rawValue.length; ++t) r.rawValue[t] = e.rawValue[t];
		}
		return e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Slider";
	}, e.DataType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "INT"] = 0, t[e[1] = "FLOAT"] = 1, t[e[2] = "DATETIME"] = 2, t[e[3] = "DATE"] = 3, t[e[4] = "TIME"] = 4, t;
	})(), e.Type = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "UNSPECIFIED"] = 0, t[e[1] = "SLIDER"] = 1, t[e[2] = "SELECT_SLIDER"] = 2, t;
	})(), e;
})(), U.Snow = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.show = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.show != null && j.hasOwnProperty.call(e, "show") && e.show !== !1 && t.uint32(8).bool(e.show), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Snow(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.show = s : delete o.show;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Snow) return e;
		if (!A.isObject(e)) throw F(".Snow: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Snow();
		return e.show != null && e.show && (n.show = L(e.show)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.show = !1), e.show != null && j.hasOwnProperty.call(e, "show") && (r.show = e.show), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Snow";
	}, e;
})(), U.Space = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Space(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Space) return e;
		if (!A.isObject(e)) throw F(".Space: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		return new U.Space();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Space";
	}, e;
})(), U.Spinner = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.text = "", e.prototype.cache = !1, e.prototype.showTime = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.text != null && j.hasOwnProperty.call(e, "text") && e.text !== "" && t.uint32(10).string(e.text), e.cache != null && j.hasOwnProperty.call(e, "cache") && e.cache !== !1 && t.uint32(16).bool(e.cache), e.showTime != null && j.hasOwnProperty.call(e, "showTime") && e.showTime !== !1 && t.uint32(24).bool(e.showTime), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Spinner(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.text = s : delete o.text;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.cache = s : delete o.cache;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.showTime = s : delete o.showTime;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Spinner) return e;
		if (!A.isObject(e)) throw F(".Spinner: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Spinner();
		return e.text != null && (typeof e.text != "string" || e.text.length) && (n.text = I(e.text)), e.cache != null && e.cache && (n.cache = L(e.cache)), e.showTime != null && e.showTime && (n.showTime = L(e.showTime)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.text = "", r.cache = !1, r.showTime = !1), e.text != null && j.hasOwnProperty.call(e, "text") && (r.text = e.text), e.cache != null && j.hasOwnProperty.call(e, "cache") && (r.cache = e.cache), e.showTime != null && j.hasOwnProperty.call(e, "showTime") && (r.showTime = e.showTime), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Spinner";
	}, e;
})(), U.Table = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.arrowData = null, e.prototype.borderMode = 0, e.prototype.hideIndex = !1, e.prototype.hideHeader = !1, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && U.ArrowData.encode(e.arrowData, t.uint32(10).fork(), n + 1).ldelim(), e.borderMode != null && j.hasOwnProperty.call(e, "borderMode") && e.borderMode !== 0 && t.uint32(16).int32(e.borderMode), e.hideIndex != null && j.hasOwnProperty.call(e, "hideIndex") && e.hideIndex !== !1 && t.uint32(24).bool(e.hideIndex), e.hideHeader != null && j.hasOwnProperty.call(e, "hideHeader") && e.hideHeader !== !1 && t.uint32(32).bool(e.hideHeader), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(42).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Table(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.arrowData = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.arrowData);
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.int32()) ? o.borderMode = s : delete o.borderMode;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideIndex = s : delete o.hideIndex;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideHeader = s : delete o.hideHeader;
					continue;
				case 5:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Table) return e;
		if (!A.isObject(e)) throw F(".Table: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Table();
		if (e.arrowData != null) {
			if (!A.isObject(e.arrowData)) throw F(".Table.arrowData: object expected");
			n.arrowData = U.ArrowData.fromObject(e.arrowData, t + 1);
		}
		if (e.borderMode !== 0 && (typeof e.borderMode != "string" || U.Table.BorderMode[e.borderMode] !== 0)) switch (e.borderMode) {
			case "ALL":
			case 0:
				n.borderMode = 0;
				break;
			case "NONE":
			case 1:
				n.borderMode = 1;
				break;
			case "HORIZONTAL":
			case 2:
				n.borderMode = 2;
				break;
			default: typeof e.borderMode == "number" && (e.borderMode | 0) === e.borderMode && (n.borderMode = e.borderMode);
		}
		return e.hideIndex != null && e.hideIndex && (n.hideIndex = L(e.hideIndex)), e.hideHeader != null && e.hideHeader && (n.hideHeader = L(e.hideHeader)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.arrowData = null, r.borderMode = t.enums === I ? "ALL" : 0, r.hideIndex = !1, r.hideHeader = !1), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && (r.arrowData = U.ArrowData.toObject(e.arrowData, t, n + 1)), e.borderMode != null && j.hasOwnProperty.call(e, "borderMode") && (r.borderMode = t.enums === I ? U.Table.BorderMode[e.borderMode] === M ? e.borderMode : U.Table.BorderMode[e.borderMode] : e.borderMode), e.hideIndex != null && j.hasOwnProperty.call(e, "hideIndex") && (r.hideIndex = e.hideIndex), e.hideHeader != null && j.hasOwnProperty.call(e, "hideHeader") && (r.hideHeader = e.hideHeader), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Table";
	}, e.BorderMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "ALL"] = 0, t[e[1] = "NONE"] = 1, t[e[2] = "HORIZONTAL"] = 2, t;
	})(), e;
})(), U.Text = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.body = "", e.prototype.help = "", e.prototype.wrap = null;
	let t;
	return j.defineProperty(e.prototype, "_wrap", {
		get: A.oneOfGetter(t = ["wrap"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(18).string(e.help), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && t.uint32(24).bool(e.wrap), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Text(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 3:
					if (a !== 0) break;
					o.wrap = e.bool(), o._wrap = "wrap";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Text) return e;
		if (!A.isObject(e)) throw F(".Text: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Text();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.wrap != null && (n.wrap = L(e.wrap)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.help = ""), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.wrap != null && j.hasOwnProperty.call(e, "wrap") && (r.wrap = e.wrap), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Text";
	}, e;
})(), U.TextArea = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.maxChars = 0, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.placeholder = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.queryParamKey = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_value", {
		get: A.oneOfGetter(t = ["value"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && e.maxChars !== 0 && t.uint32(40).uint32(e.maxChars), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(50).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(58).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(66).string(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(72).bool(e.setValue), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(82).string(e.placeholder), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(88).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(98).fork(), n + 1).ldelim(), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(106).string(e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(112).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.TextArea(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.stringVerify(), o._default = "default";
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value = e.stringVerify(), o._value = "value";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 12:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 13:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 14:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.TextArea) return e;
		if (!A.isObject(e)) throw F(".TextArea: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.TextArea();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (n.default = I(e.default)), e.maxChars != null && R(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && (n.value = I(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".TextArea.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.maxChars = 0, r.help = "", r.formId = "", r.setValue = !1, r.placeholder = "", r.disabled = !1, r.labelVisibility = null, r.ignoreRerun = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && (r.maxChars = e.maxChars), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/TextArea";
	}, e;
})(), U.TextInput = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.type = 0, e.prototype.maxChars = 0, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.autocomplete = "", e.prototype.placeholder = "", e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.icon = "", e.prototype.queryParamKey = null, e.prototype.validateRegex = null, e.prototype.validateMessage = null, e.prototype.ignoreRerun = !1, e.prototype.liveDebounceMs = null, e.prototype.required = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_value", {
		get: A.oneOfGetter(t = ["value"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_validateRegex", {
		get: A.oneOfGetter(t = ["validateRegex"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_validateMessage", {
		get: A.oneOfGetter(t = ["validateMessage"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_liveDebounceMs", {
		get: A.oneOfGetter(t = ["liveDebounceMs"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(32).int32(e.type), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && e.maxChars !== 0 && t.uint32(40).uint32(e.maxChars), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(50).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(58).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(66).string(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(72).bool(e.setValue), e.autocomplete != null && j.hasOwnProperty.call(e, "autocomplete") && e.autocomplete !== "" && t.uint32(82).string(e.autocomplete), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && e.placeholder !== "" && t.uint32(90).string(e.placeholder), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(96).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(106).fork(), n + 1).ldelim(), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(114).string(e.icon), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(122).string(e.queryParamKey), e.validateRegex != null && j.hasOwnProperty.call(e, "validateRegex") && t.uint32(130).string(e.validateRegex), e.validateMessage != null && j.hasOwnProperty.call(e, "validateMessage") && t.uint32(138).string(e.validateMessage), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(144).bool(e.ignoreRerun), e.liveDebounceMs != null && j.hasOwnProperty.call(e, "liveDebounceMs") && t.uint32(152).uint32(e.liveDebounceMs), e.required != null && j.hasOwnProperty.call(e, "required") && e.required !== !1 && t.uint32(160).bool(e.required), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.TextInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.stringVerify(), o._default = "default";
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.uint32()) ? o.maxChars = s : delete o.maxChars;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 8:
					if (a !== 2) break;
					o.value = e.stringVerify(), o._value = "value";
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.autocomplete = s : delete o.autocomplete;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.placeholder = s : delete o.placeholder;
					continue;
				case 12:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 13:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 15:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 16:
					if (a !== 2) break;
					o.validateRegex = e.stringVerify(), o._validateRegex = "validateRegex";
					continue;
				case 17:
					if (a !== 2) break;
					o.validateMessage = e.stringVerify(), o._validateMessage = "validateMessage";
					continue;
				case 18:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
				case 19:
					if (a !== 0) break;
					o.liveDebounceMs = e.uint32(), o._liveDebounceMs = "liveDebounceMs";
					continue;
				case 20:
					if (a !== 0) break;
					(s = e.bool()) ? o.required = s : delete o.required;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.TextInput) return e;
		if (!A.isObject(e)) throw F(".TextInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.TextInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (n.default = I(e.default)), e.type !== 0 && (typeof e.type != "string" || U.TextInput.Type[e.type] !== 0)) switch (e.type) {
			case "DEFAULT":
			case 0:
				n.type = 0;
				break;
			case "PASSWORD":
			case 1:
				n.type = 1;
				break;
			case "EMAIL":
			case 2:
				n.type = 2;
				break;
			case "URL":
			case 3:
				n.type = 3;
				break;
			case "PHONE":
			case 4:
				n.type = 4;
				break;
			case "SEARCH":
			case 5:
				n.type = 5;
				break;
			default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
		}
		if (e.maxChars != null && R(e.maxChars) !== 0 && (n.maxChars = e.maxChars >>> 0), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && (n.value = I(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.autocomplete != null && (typeof e.autocomplete != "string" || e.autocomplete.length) && (n.autocomplete = I(e.autocomplete)), e.placeholder != null && (typeof e.placeholder != "string" || e.placeholder.length) && (n.placeholder = I(e.placeholder)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".TextInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.validateRegex != null && (n.validateRegex = I(e.validateRegex)), e.validateMessage != null && (n.validateMessage = I(e.validateMessage)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), e.liveDebounceMs != null && (n.liveDebounceMs = e.liveDebounceMs >>> 0), e.required != null && e.required && (n.required = L(e.required)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.id = "", r.label = "", r.type = t.enums === I ? "DEFAULT" : 0, r.maxChars = 0, r.help = "", r.formId = "", r.setValue = !1, r.autocomplete = "", r.placeholder = "", r.disabled = !1, r.labelVisibility = null, r.icon = "", r.ignoreRerun = !1, r.required = !1), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.TextInput.Type[e.type] === M ? e.type : U.TextInput.Type[e.type] : e.type), e.maxChars != null && j.hasOwnProperty.call(e, "maxChars") && (r.maxChars = e.maxChars), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.autocomplete != null && j.hasOwnProperty.call(e, "autocomplete") && (r.autocomplete = e.autocomplete), e.placeholder != null && j.hasOwnProperty.call(e, "placeholder") && (r.placeholder = e.placeholder), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.validateRegex != null && j.hasOwnProperty.call(e, "validateRegex") && (r.validateRegex = e.validateRegex), e.validateMessage != null && j.hasOwnProperty.call(e, "validateMessage") && (r.validateMessage = e.validateMessage), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), e.liveDebounceMs != null && j.hasOwnProperty.call(e, "liveDebounceMs") && (r.liveDebounceMs = e.liveDebounceMs), e.required != null && j.hasOwnProperty.call(e, "required") && (r.required = e.required), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/TextInput";
	}, e.Type = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "PASSWORD"] = 1, t[e[2] = "EMAIL"] = 2, t[e[3] = "URL"] = 3, t[e[4] = "PHONE"] = 4, t[e[5] = "SEARCH"] = 5, t;
	})(), e;
})(), U.TimeInput = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.id = "", e.prototype.label = "", e.prototype.default = null, e.prototype.help = "", e.prototype.formId = "", e.prototype.value = null, e.prototype.setValue = !1, e.prototype.disabled = !1, e.prototype.labelVisibility = null, e.prototype.step = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.queryParamKey = null, e.prototype.format = null, e.prototype.ignoreRerun = !1;
	let t;
	return j.defineProperty(e.prototype, "_default", {
		get: A.oneOfGetter(t = ["default"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_value", {
		get: A.oneOfGetter(t = ["value"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_queryParamKey", {
		get: A.oneOfGetter(t = ["queryParamKey"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_format", {
		get: A.oneOfGetter(t = ["format"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(10).string(e.id), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(18).string(e.label), e.default != null && j.hasOwnProperty.call(e, "default") && t.uint32(26).string(e.default), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(42).string(e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && t.uint32(50).string(e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && e.setValue !== !1 && t.uint32(56).bool(e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && e.disabled !== !1 && t.uint32(64).bool(e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && U.LabelVisibility.encode(e.labelVisibility, t.uint32(74).fork(), n + 1).ldelim(), e.step != null && j.hasOwnProperty.call(e, "step") && (typeof e.step == "object" ? e.step.low || e.step.high : e.step !== 0) && t.uint32(80).int64(e.step), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && t.uint32(90).string(e.queryParamKey), e.format != null && j.hasOwnProperty.call(e, "format") && t.uint32(98).string(e.format), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && e.ignoreRerun !== !1 && t.uint32(104).bool(e.ignoreRerun), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.TimeInput(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 3:
					if (a !== 2) break;
					o.default = e.stringVerify(), o._default = "default";
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.help = s : delete o.help;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 6:
					if (a !== 2) break;
					o.value = e.stringVerify(), o._value = "value";
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.setValue = s : delete o.setValue;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.disabled = s : delete o.disabled;
					continue;
				case 9:
					if (a !== 2) break;
					o.labelVisibility = U.LabelVisibility.decode(e, e.uint32(), M, r + 1, o.labelVisibility);
					continue;
				case 10:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.step = s : delete o.step;
					continue;
				case 11:
					if (a !== 2) break;
					o.queryParamKey = e.stringVerify(), o._queryParamKey = "queryParamKey";
					continue;
				case 12:
					if (a !== 2) break;
					o.format = e.stringVerify(), o._format = "format";
					continue;
				case 13:
					if (a !== 0) break;
					(s = e.bool()) ? o.ignoreRerun = s : delete o.ignoreRerun;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.TimeInput) return e;
		if (!A.isObject(e)) throw F(".TimeInput: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.TimeInput();
		if (e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.default != null && (n.default = I(e.default)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.value != null && (n.value = I(e.value)), e.setValue != null && e.setValue && (n.setValue = L(e.setValue)), e.disabled != null && e.disabled && (n.disabled = L(e.disabled)), e.labelVisibility != null) {
			if (!A.isObject(e.labelVisibility)) throw F(".TimeInput.labelVisibility: object expected");
			n.labelVisibility = U.LabelVisibility.fromObject(e.labelVisibility, t + 1);
		}
		return e.step != null && (typeof e.step == "object" ? e.step.low || e.step.high : R(e.step) !== 0) && (A.Long ? n.step = A.Long.fromValue(e.step, !1) : typeof e.step == "string" ? n.step = V(e.step, 10) : typeof e.step == "number" ? n.step = e.step : typeof e.step == "object" && (n.step = new A.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber())), e.queryParamKey != null && (n.queryParamKey = I(e.queryParamKey)), e.format != null && (n.format = I(e.format)), e.ignoreRerun != null && e.ignoreRerun && (n.ignoreRerun = L(e.ignoreRerun)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if (t.defaults) {
			if (r.id = "", r.label = "", r.help = "", r.formId = "", r.setValue = !1, r.disabled = !1, r.labelVisibility = null, A.Long) {
				let e = new A.Long(0, 0, !1);
				r.step = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.step = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.ignoreRerun = !1;
		}
		return e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.default != null && j.hasOwnProperty.call(e, "default") && (r.default = e.default), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), e.setValue != null && j.hasOwnProperty.call(e, "setValue") && (r.setValue = e.setValue), e.disabled != null && j.hasOwnProperty.call(e, "disabled") && (r.disabled = e.disabled), e.labelVisibility != null && j.hasOwnProperty.call(e, "labelVisibility") && (r.labelVisibility = U.LabelVisibility.toObject(e.labelVisibility, t, n + 1)), e.step != null && j.hasOwnProperty.call(e, "step") && (r.step = H !== void 0 && t.longs === H ? typeof e.step == "number" ? H(e.step) : A.Long.fromBits(e.step.low >>> 0, e.step.high >>> 0, !1).toBigInt() : typeof e.step == "number" ? t.longs === I ? I(e.step) : e.step : t.longs === I ? A.Long.prototype.toString.call(e.step) : t.longs === R ? new A.LongBits(e.step.low >>> 0, e.step.high >>> 0).toNumber() : e.step), e.queryParamKey != null && j.hasOwnProperty.call(e, "queryParamKey") && (r.queryParamKey = e.queryParamKey), e.format != null && j.hasOwnProperty.call(e, "format") && (r.format = e.format), e.ignoreRerun != null && j.hasOwnProperty.call(e, "ignoreRerun") && (r.ignoreRerun = e.ignoreRerun), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/TimeInput";
	}, e;
})(), U.Toast = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.body = "", e.prototype.icon = "", e.prototype.duration = null;
	let t;
	return j.defineProperty(e.prototype, "_duration", {
		get: A.oneOfGetter(t = ["duration"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.body != null && j.hasOwnProperty.call(e, "body") && e.body !== "" && t.uint32(10).string(e.body), e.icon != null && j.hasOwnProperty.call(e, "icon") && e.icon !== "" && t.uint32(18).string(e.icon), e.duration != null && j.hasOwnProperty.call(e, "duration") && t.uint32(24).int32(e.duration), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Toast(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.body = s : delete o.body;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.icon = s : delete o.icon;
					continue;
				case 3:
					if (a !== 0) break;
					o.duration = e.int32(), o._duration = "duration";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Toast) return e;
		if (!A.isObject(e)) throw F(".Toast: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Toast();
		return e.body != null && (typeof e.body != "string" || e.body.length) && (n.body = I(e.body)), e.icon != null && (typeof e.icon != "string" || e.icon.length) && (n.icon = I(e.icon)), e.duration != null && (n.duration = e.duration | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.body = "", r.icon = ""), e.body != null && j.hasOwnProperty.call(e, "body") && (r.body = e.body), e.icon != null && j.hasOwnProperty.call(e, "icon") && (r.icon = e.icon), e.duration != null && j.hasOwnProperty.call(e, "duration") && (r.duration = e.duration), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Toast";
	}, e;
})(), U.VegaLiteChart = (() => {
	let e = function(e) {
		if (this.datasets = [], this.selectionMode = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.spec = "", e.prototype.data = null, e.prototype.datasets = A.emptyArray, e.prototype.useContainerWidth = !1, e.prototype.theme = "", e.prototype.id = "", e.prototype.selectionMode = A.emptyArray, e.prototype.formId = "", e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.spec != null && j.hasOwnProperty.call(e, "spec") && e.spec !== "" && t.uint32(10).string(e.spec), e.data != null && j.hasOwnProperty.call(e, "data") && U.ArrowData.encode(e.data, t.uint32(18).fork(), n + 1).ldelim(), e.datasets != null && e.datasets.length) for (let r = 0; r < e.datasets.length; ++r) U.ArrowNamedDataSet.encode(e.datasets[r], t.uint32(34).fork(), n + 1).ldelim();
		if (e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && e.useContainerWidth !== !1 && t.uint32(40).bool(e.useContainerWidth), e.theme != null && j.hasOwnProperty.call(e, "theme") && e.theme !== "" && t.uint32(50).string(e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(58).string(e.id), e.selectionMode != null && e.selectionMode.length) for (let n = 0; n < e.selectionMode.length; ++n) t.uint32(66).string(e.selectionMode[n]);
		if (e.formId != null && j.hasOwnProperty.call(e, "formId") && e.formId !== "" && t.uint32(74).string(e.formId), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(82).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.VegaLiteChart(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.spec = s : delete o.spec;
					continue;
				case 2:
					if (a !== 2) break;
					o.data = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.data);
					continue;
				case 4:
					if (a !== 2) break;
					o.datasets && o.datasets.length || (o.datasets = []), o.datasets.push(U.ArrowNamedDataSet.decode(e, e.uint32(), M, r + 1));
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.useContainerWidth = s : delete o.useContainerWidth;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.theme = s : delete o.theme;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 8:
					if (a !== 2) break;
					o.selectionMode && o.selectionMode.length || (o.selectionMode = []), o.selectionMode.push(e.stringVerify());
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.formId = s : delete o.formId;
					continue;
				case 10:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.VegaLiteChart) return e;
		if (!A.isObject(e)) throw F(".VegaLiteChart: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.VegaLiteChart();
		if (e.spec != null && (typeof e.spec != "string" || e.spec.length) && (n.spec = I(e.spec)), e.data != null) {
			if (!A.isObject(e.data)) throw F(".VegaLiteChart.data: object expected");
			n.data = U.ArrowData.fromObject(e.data, t + 1);
		}
		if (e.datasets) {
			if (!B.isArray(e.datasets)) throw F(".VegaLiteChart.datasets: array expected");
			n.datasets = B(e.datasets.length);
			for (let r = 0; r < e.datasets.length; ++r) {
				if (!A.isObject(e.datasets[r])) throw F(".VegaLiteChart.datasets: object expected");
				n.datasets[r] = U.ArrowNamedDataSet.fromObject(e.datasets[r], t + 1);
			}
		}
		if (e.useContainerWidth != null && e.useContainerWidth && (n.useContainerWidth = L(e.useContainerWidth)), e.theme != null && (typeof e.theme != "string" || e.theme.length) && (n.theme = I(e.theme)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.selectionMode) {
			if (!B.isArray(e.selectionMode)) throw F(".VegaLiteChart.selectionMode: array expected");
			n.selectionMode = B(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) n.selectionMode[t] = I(e.selectionMode[t]);
		}
		return e.formId != null && (typeof e.formId != "string" || e.formId.length) && (n.formId = I(e.formId)), e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.datasets = [], r.selectionMode = []), t.defaults && (r.spec = "", r.data = null, r.useContainerWidth = !1, r.theme = "", r.id = "", r.formId = ""), e.spec != null && j.hasOwnProperty.call(e, "spec") && (r.spec = e.spec), e.data != null && j.hasOwnProperty.call(e, "data") && (r.data = U.ArrowData.toObject(e.data, t, n + 1)), e.datasets && e.datasets.length) {
			r.datasets = B(e.datasets.length);
			for (let i = 0; i < e.datasets.length; ++i) r.datasets[i] = U.ArrowNamedDataSet.toObject(e.datasets[i], t, n + 1);
		}
		if (e.useContainerWidth != null && j.hasOwnProperty.call(e, "useContainerWidth") && (r.useContainerWidth = e.useContainerWidth), e.theme != null && j.hasOwnProperty.call(e, "theme") && (r.theme = e.theme), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.selectionMode && e.selectionMode.length) {
			r.selectionMode = B(e.selectionMode.length);
			for (let t = 0; t < e.selectionMode.length; ++t) r.selectionMode[t] = e.selectionMode[t];
		}
		return e.formId != null && j.hasOwnProperty.call(e, "formId") && (r.formId = e.formId), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/VegaLiteChart";
	}, e;
})(), U.SubtitleTrack = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.label = "", e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(10).string(e.label), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(18).string(e.url), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SubtitleTrack(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SubtitleTrack) return e;
		if (!A.isObject(e)) throw F(".SubtitleTrack: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SubtitleTrack();
		return e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.label = "", r.url = ""), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SubtitleTrack";
	}, e;
})(), U.Video = (() => {
	let e = function(e) {
		if (this.subtitles = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.url = "", e.prototype.startTime = 0, e.prototype.type = 0, e.prototype.subtitles = A.emptyArray, e.prototype.endTime = 0, e.prototype.loop = !1, e.prototype.autoplay = !1, e.prototype.muted = !1, e.prototype.id = "", e.prototype.widthConfig = null, e.prototype.alt = null;
	let t;
	return j.defineProperty(e.prototype, "_widthConfig", {
		get: A.oneOfGetter(t = ["widthConfig"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_alt", {
		get: A.oneOfGetter(t = ["alt"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.startTime != null && j.hasOwnProperty.call(e, "startTime") && e.startTime !== 0 && t.uint32(24).int32(e.startTime), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(40).int32(e.type), e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(50).string(e.url), e.subtitles != null && e.subtitles.length) for (let r = 0; r < e.subtitles.length; ++r) U.SubtitleTrack.encode(e.subtitles[r], t.uint32(58).fork(), n + 1).ldelim();
		if (e.endTime != null && j.hasOwnProperty.call(e, "endTime") && e.endTime !== 0 && t.uint32(64).int32(e.endTime), e.loop != null && j.hasOwnProperty.call(e, "loop") && e.loop !== !1 && t.uint32(72).bool(e.loop), e.autoplay != null && j.hasOwnProperty.call(e, "autoplay") && e.autoplay !== !1 && t.uint32(80).bool(e.autoplay), e.muted != null && j.hasOwnProperty.call(e, "muted") && e.muted !== !1 && t.uint32(88).bool(e.muted), e.id != null && j.hasOwnProperty.call(e, "id") && e.id !== "" && t.uint32(98).string(e.id), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && U.streamlit.WidthConfig.encode(e.widthConfig, t.uint32(106).fork(), n + 1).ldelim(), e.alt != null && j.hasOwnProperty.call(e, "alt") && t.uint32(114).string(e.alt), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Video(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.startTime = s : delete o.startTime;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.type = s : delete o.type;
					continue;
				case 7:
					if (a !== 2) break;
					o.subtitles && o.subtitles.length || (o.subtitles = []), o.subtitles.push(U.SubtitleTrack.decode(e, e.uint32(), M, r + 1));
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.int32()) ? o.endTime = s : delete o.endTime;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.bool()) ? o.loop = s : delete o.loop;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.autoplay = s : delete o.autoplay;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.muted = s : delete o.muted;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.id = s : delete o.id;
					continue;
				case 13:
					if (a !== 2) break;
					o.widthConfig = U.streamlit.WidthConfig.decode(e, e.uint32(), M, r + 1, o.widthConfig), o._widthConfig = "widthConfig";
					continue;
				case 14:
					if (a !== 2) break;
					o.alt = e.stringVerify(), o._alt = "alt";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Video) return e;
		if (!A.isObject(e)) throw F(".Video: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Video();
		if (e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.startTime != null && R(e.startTime) !== 0 && (n.startTime = e.startTime | 0), e.type !== 0 && (typeof e.type != "string" || U.Video.Type[e.type] !== 0)) switch (e.type) {
			case "UNUSED":
			case 0:
				n.type = 0;
				break;
			case "NATIVE":
			case 1:
				n.type = 1;
				break;
			case "YOUTUBE_IFRAME":
			case 2:
				n.type = 2;
				break;
			default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
		}
		if (e.subtitles) {
			if (!B.isArray(e.subtitles)) throw F(".Video.subtitles: array expected");
			n.subtitles = B(e.subtitles.length);
			for (let r = 0; r < e.subtitles.length; ++r) {
				if (!A.isObject(e.subtitles[r])) throw F(".Video.subtitles: object expected");
				n.subtitles[r] = U.SubtitleTrack.fromObject(e.subtitles[r], t + 1);
			}
		}
		if (e.endTime != null && R(e.endTime) !== 0 && (n.endTime = e.endTime | 0), e.loop != null && e.loop && (n.loop = L(e.loop)), e.autoplay != null && e.autoplay && (n.autoplay = L(e.autoplay)), e.muted != null && e.muted && (n.muted = L(e.muted)), e.id != null && (typeof e.id != "string" || e.id.length) && (n.id = I(e.id)), e.widthConfig != null) {
			if (!A.isObject(e.widthConfig)) throw F(".Video.widthConfig: object expected");
			n.widthConfig = U.streamlit.WidthConfig.fromObject(e.widthConfig, t + 1);
		}
		return e.alt != null && (n.alt = I(e.alt)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.subtitles = []), t.defaults && (r.startTime = 0, r.type = t.enums === I ? "UNUSED" : 0, r.url = "", r.endTime = 0, r.loop = !1, r.autoplay = !1, r.muted = !1, r.id = ""), e.startTime != null && j.hasOwnProperty.call(e, "startTime") && (r.startTime = e.startTime), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.Video.Type[e.type] === M ? e.type : U.Video.Type[e.type] : e.type), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.subtitles && e.subtitles.length) {
			r.subtitles = B(e.subtitles.length);
			for (let i = 0; i < e.subtitles.length; ++i) r.subtitles[i] = U.SubtitleTrack.toObject(e.subtitles[i], t, n + 1);
		}
		return e.endTime != null && j.hasOwnProperty.call(e, "endTime") && (r.endTime = e.endTime), e.loop != null && j.hasOwnProperty.call(e, "loop") && (r.loop = e.loop), e.autoplay != null && j.hasOwnProperty.call(e, "autoplay") && (r.autoplay = e.autoplay), e.muted != null && j.hasOwnProperty.call(e, "muted") && (r.muted = e.muted), e.id != null && j.hasOwnProperty.call(e, "id") && (r.id = e.id), e.widthConfig != null && j.hasOwnProperty.call(e, "widthConfig") && (r.widthConfig = U.streamlit.WidthConfig.toObject(e.widthConfig, t, n + 1)), e.alt != null && j.hasOwnProperty.call(e, "alt") && (r.alt = e.alt), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Video";
	}, e.Type = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "UNUSED"] = 0, t[e[1] = "NATIVE"] = 1, t[e[2] = "YOUTUBE_IFRAME"] = 2, t;
	})(), e;
})(), U.Transient = (() => {
	let e = function(e) {
		if (this.elements = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.elements = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.elements != null && e.elements.length) for (let r = 0; r < e.elements.length; ++r) U.Element.encode(e.elements[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Transient(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.elements && o.elements.length || (o.elements = []), o.elements.push(U.Element.decode(e, e.uint32(), M, r + 1));
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Transient) return e;
		if (!A.isObject(e)) throw F(".Transient: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Transient();
		if (e.elements) {
			if (!B.isArray(e.elements)) throw F(".Transient.elements: array expected");
			n.elements = B(e.elements.length);
			for (let r = 0; r < e.elements.length; ++r) {
				if (!A.isObject(e.elements[r])) throw F(".Transient.elements: object expected");
				n.elements[r] = U.Element.fromObject(e.elements[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.elements = []), e.elements && e.elements.length) {
			r.elements = B(e.elements.length);
			for (let i = 0; i < e.elements.length; ++i) r.elements[i] = U.Element.toObject(e.elements[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Transient";
	}, e;
})();
var ie = U.ForwardMsg = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.hash = "", e.prototype.metadata = null, e.prototype.newSession = null, e.prototype.delta = null, e.prototype.pageInfoChanged = null, e.prototype.pageConfigChanged = null, e.prototype.scriptFinished = null, e.prototype.gitInfoChanged = null, e.prototype.pageProfile = null, e.prototype.sessionStatusChanged = null, e.prototype.sessionEvent = null, e.prototype.navigation = null, e.prototype.pageNotFound = null, e.prototype.fileUrlsResponse = null, e.prototype.autoRerun = null, e.prototype.stopAutoRerun = null, e.prototype.logo = null, e.prototype.authRedirect = null, e.prototype.parentMessage = null, e.prototype.refHash = null, e.prototype.heartbeatAck = null, e.prototype.backendOperationResponse = null, e.prototype.debugLastBackmsgId = "";
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = [
			"newSession",
			"delta",
			"pageInfoChanged",
			"pageConfigChanged",
			"scriptFinished",
			"gitInfoChanged",
			"pageProfile",
			"sessionStatusChanged",
			"sessionEvent",
			"navigation",
			"pageNotFound",
			"fileUrlsResponse",
			"autoRerun",
			"stopAutoRerun",
			"logo",
			"authRedirect",
			"parentMessage",
			"refHash",
			"heartbeatAck",
			"backendOperationResponse"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.hash != null && j.hasOwnProperty.call(e, "hash") && e.hash !== "" && t.uint32(10).string(e.hash), e.metadata != null && j.hasOwnProperty.call(e, "metadata") && U.ForwardMsgMetadata.encode(e.metadata, t.uint32(18).fork(), n + 1).ldelim(), e.newSession != null && j.hasOwnProperty.call(e, "newSession") && U.NewSession.encode(e.newSession, t.uint32(34).fork(), n + 1).ldelim(), e.delta != null && j.hasOwnProperty.call(e, "delta") && U.Delta.encode(e.delta, t.uint32(42).fork(), n + 1).ldelim(), e.scriptFinished != null && j.hasOwnProperty.call(e, "scriptFinished") && t.uint32(48).int32(e.scriptFinished), e.sessionStatusChanged != null && j.hasOwnProperty.call(e, "sessionStatusChanged") && U.SessionStatus.encode(e.sessionStatusChanged, t.uint32(74).fork(), n + 1).ldelim(), e.sessionEvent != null && j.hasOwnProperty.call(e, "sessionEvent") && U.SessionEvent.encode(e.sessionEvent, t.uint32(82).fork(), n + 1).ldelim(), e.refHash != null && j.hasOwnProperty.call(e, "refHash") && t.uint32(90).string(e.refHash), e.pageInfoChanged != null && j.hasOwnProperty.call(e, "pageInfoChanged") && U.PageInfo.encode(e.pageInfoChanged, t.uint32(98).fork(), n + 1).ldelim(), e.pageConfigChanged != null && j.hasOwnProperty.call(e, "pageConfigChanged") && U.PageConfig.encode(e.pageConfigChanged, t.uint32(106).fork(), n + 1).ldelim(), e.gitInfoChanged != null && j.hasOwnProperty.call(e, "gitInfoChanged") && U.GitInfo.encode(e.gitInfoChanged, t.uint32(114).fork(), n + 1).ldelim(), e.pageNotFound != null && j.hasOwnProperty.call(e, "pageNotFound") && U.PageNotFound.encode(e.pageNotFound, t.uint32(122).fork(), n + 1).ldelim(), e.debugLastBackmsgId != null && j.hasOwnProperty.call(e, "debugLastBackmsgId") && e.debugLastBackmsgId !== "" && t.uint32(138).string(e.debugLastBackmsgId), e.pageProfile != null && j.hasOwnProperty.call(e, "pageProfile") && U.PageProfile.encode(e.pageProfile, t.uint32(146).fork(), n + 1).ldelim(), e.fileUrlsResponse != null && j.hasOwnProperty.call(e, "fileUrlsResponse") && U.FileURLsResponse.encode(e.fileUrlsResponse, t.uint32(154).fork(), n + 1).ldelim(), e.parentMessage != null && j.hasOwnProperty.call(e, "parentMessage") && U.ParentMessage.encode(e.parentMessage, t.uint32(162).fork(), n + 1).ldelim(), e.autoRerun != null && j.hasOwnProperty.call(e, "autoRerun") && U.AutoRerun.encode(e.autoRerun, t.uint32(170).fork(), n + 1).ldelim(), e.logo != null && j.hasOwnProperty.call(e, "logo") && U.Logo.encode(e.logo, t.uint32(178).fork(), n + 1).ldelim(), e.navigation != null && j.hasOwnProperty.call(e, "navigation") && U.Navigation.encode(e.navigation, t.uint32(186).fork(), n + 1).ldelim(), e.authRedirect != null && j.hasOwnProperty.call(e, "authRedirect") && U.AuthRedirect.encode(e.authRedirect, t.uint32(194).fork(), n + 1).ldelim(), e.heartbeatAck != null && j.hasOwnProperty.call(e, "heartbeatAck") && t.uint32(208).bool(e.heartbeatAck), e.backendOperationResponse != null && j.hasOwnProperty.call(e, "backendOperationResponse") && U.BackendOperationResponse.encode(e.backendOperationResponse, t.uint32(218).fork(), n + 1).ldelim(), e.stopAutoRerun != null && j.hasOwnProperty.call(e, "stopAutoRerun") && U.StopAutoRerun.encode(e.stopAutoRerun, t.uint32(226).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ForwardMsg(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.hash = s : delete o.hash;
					continue;
				case 2:
					if (a !== 2) break;
					o.metadata = U.ForwardMsgMetadata.decode(e, e.uint32(), M, r + 1, o.metadata);
					continue;
				case 4:
					if (a !== 2) break;
					o.newSession = U.NewSession.decode(e, e.uint32(), M, r + 1, o.newSession), o.type = "newSession";
					continue;
				case 5:
					if (a !== 2) break;
					o.delta = U.Delta.decode(e, e.uint32(), M, r + 1, o.delta), o.type = "delta";
					continue;
				case 12:
					if (a !== 2) break;
					o.pageInfoChanged = U.PageInfo.decode(e, e.uint32(), M, r + 1, o.pageInfoChanged), o.type = "pageInfoChanged";
					continue;
				case 13:
					if (a !== 2) break;
					o.pageConfigChanged = U.PageConfig.decode(e, e.uint32(), M, r + 1, o.pageConfigChanged), o.type = "pageConfigChanged";
					continue;
				case 6:
					if (a !== 0) break;
					o.scriptFinished = e.int32(), o.type = "scriptFinished";
					continue;
				case 14:
					if (a !== 2) break;
					o.gitInfoChanged = U.GitInfo.decode(e, e.uint32(), M, r + 1, o.gitInfoChanged), o.type = "gitInfoChanged";
					continue;
				case 18:
					if (a !== 2) break;
					o.pageProfile = U.PageProfile.decode(e, e.uint32(), M, r + 1, o.pageProfile), o.type = "pageProfile";
					continue;
				case 9:
					if (a !== 2) break;
					o.sessionStatusChanged = U.SessionStatus.decode(e, e.uint32(), M, r + 1, o.sessionStatusChanged), o.type = "sessionStatusChanged";
					continue;
				case 10:
					if (a !== 2) break;
					o.sessionEvent = U.SessionEvent.decode(e, e.uint32(), M, r + 1, o.sessionEvent), o.type = "sessionEvent";
					continue;
				case 23:
					if (a !== 2) break;
					o.navigation = U.Navigation.decode(e, e.uint32(), M, r + 1, o.navigation), o.type = "navigation";
					continue;
				case 15:
					if (a !== 2) break;
					o.pageNotFound = U.PageNotFound.decode(e, e.uint32(), M, r + 1, o.pageNotFound), o.type = "pageNotFound";
					continue;
				case 19:
					if (a !== 2) break;
					o.fileUrlsResponse = U.FileURLsResponse.decode(e, e.uint32(), M, r + 1, o.fileUrlsResponse), o.type = "fileUrlsResponse";
					continue;
				case 21:
					if (a !== 2) break;
					o.autoRerun = U.AutoRerun.decode(e, e.uint32(), M, r + 1, o.autoRerun), o.type = "autoRerun";
					continue;
				case 28:
					if (a !== 2) break;
					o.stopAutoRerun = U.StopAutoRerun.decode(e, e.uint32(), M, r + 1, o.stopAutoRerun), o.type = "stopAutoRerun";
					continue;
				case 22:
					if (a !== 2) break;
					o.logo = U.Logo.decode(e, e.uint32(), M, r + 1, o.logo), o.type = "logo";
					continue;
				case 24:
					if (a !== 2) break;
					o.authRedirect = U.AuthRedirect.decode(e, e.uint32(), M, r + 1, o.authRedirect), o.type = "authRedirect";
					continue;
				case 20:
					if (a !== 2) break;
					o.parentMessage = U.ParentMessage.decode(e, e.uint32(), M, r + 1, o.parentMessage), o.type = "parentMessage";
					continue;
				case 11:
					if (a !== 2) break;
					o.refHash = e.stringVerify(), o.type = "refHash";
					continue;
				case 26:
					if (a !== 0) break;
					o.heartbeatAck = e.bool(), o.type = "heartbeatAck";
					continue;
				case 27:
					if (a !== 2) break;
					o.backendOperationResponse = U.BackendOperationResponse.decode(e, e.uint32(), M, r + 1, o.backendOperationResponse), o.type = "backendOperationResponse";
					continue;
				case 17:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.debugLastBackmsgId = s : delete o.debugLastBackmsgId;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ForwardMsg) return e;
		if (!A.isObject(e)) throw F(".ForwardMsg: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ForwardMsg();
		if (e.hash != null && (typeof e.hash != "string" || e.hash.length) && (n.hash = I(e.hash)), e.metadata != null) {
			if (!A.isObject(e.metadata)) throw F(".ForwardMsg.metadata: object expected");
			n.metadata = U.ForwardMsgMetadata.fromObject(e.metadata, t + 1);
		}
		if (e.newSession != null) {
			if (!A.isObject(e.newSession)) throw F(".ForwardMsg.newSession: object expected");
			n.newSession = U.NewSession.fromObject(e.newSession, t + 1);
		}
		if (e.delta != null) {
			if (!A.isObject(e.delta)) throw F(".ForwardMsg.delta: object expected");
			n.delta = U.Delta.fromObject(e.delta, t + 1);
		}
		if (e.pageInfoChanged != null) {
			if (!A.isObject(e.pageInfoChanged)) throw F(".ForwardMsg.pageInfoChanged: object expected");
			n.pageInfoChanged = U.PageInfo.fromObject(e.pageInfoChanged, t + 1);
		}
		if (e.pageConfigChanged != null) {
			if (!A.isObject(e.pageConfigChanged)) throw F(".ForwardMsg.pageConfigChanged: object expected");
			n.pageConfigChanged = U.PageConfig.fromObject(e.pageConfigChanged, t + 1);
		}
		switch (e.scriptFinished) {
			case "FINISHED_SUCCESSFULLY":
			case 0:
				n.scriptFinished = 0;
				break;
			case "FINISHED_WITH_COMPILE_ERROR":
			case 1:
				n.scriptFinished = 1;
				break;
			case "FINISHED_EARLY_FOR_RERUN":
			case 2:
				n.scriptFinished = 2;
				break;
			case "FINISHED_FRAGMENT_RUN_SUCCESSFULLY":
			case 3:
				n.scriptFinished = 3;
				break;
			default: typeof e.scriptFinished == "number" && (e.scriptFinished | 0) === e.scriptFinished && (n.scriptFinished = e.scriptFinished);
		}
		if (e.gitInfoChanged != null) {
			if (!A.isObject(e.gitInfoChanged)) throw F(".ForwardMsg.gitInfoChanged: object expected");
			n.gitInfoChanged = U.GitInfo.fromObject(e.gitInfoChanged, t + 1);
		}
		if (e.pageProfile != null) {
			if (!A.isObject(e.pageProfile)) throw F(".ForwardMsg.pageProfile: object expected");
			n.pageProfile = U.PageProfile.fromObject(e.pageProfile, t + 1);
		}
		if (e.sessionStatusChanged != null) {
			if (!A.isObject(e.sessionStatusChanged)) throw F(".ForwardMsg.sessionStatusChanged: object expected");
			n.sessionStatusChanged = U.SessionStatus.fromObject(e.sessionStatusChanged, t + 1);
		}
		if (e.sessionEvent != null) {
			if (!A.isObject(e.sessionEvent)) throw F(".ForwardMsg.sessionEvent: object expected");
			n.sessionEvent = U.SessionEvent.fromObject(e.sessionEvent, t + 1);
		}
		if (e.navigation != null) {
			if (!A.isObject(e.navigation)) throw F(".ForwardMsg.navigation: object expected");
			n.navigation = U.Navigation.fromObject(e.navigation, t + 1);
		}
		if (e.pageNotFound != null) {
			if (!A.isObject(e.pageNotFound)) throw F(".ForwardMsg.pageNotFound: object expected");
			n.pageNotFound = U.PageNotFound.fromObject(e.pageNotFound, t + 1);
		}
		if (e.fileUrlsResponse != null) {
			if (!A.isObject(e.fileUrlsResponse)) throw F(".ForwardMsg.fileUrlsResponse: object expected");
			n.fileUrlsResponse = U.FileURLsResponse.fromObject(e.fileUrlsResponse, t + 1);
		}
		if (e.autoRerun != null) {
			if (!A.isObject(e.autoRerun)) throw F(".ForwardMsg.autoRerun: object expected");
			n.autoRerun = U.AutoRerun.fromObject(e.autoRerun, t + 1);
		}
		if (e.stopAutoRerun != null) {
			if (!A.isObject(e.stopAutoRerun)) throw F(".ForwardMsg.stopAutoRerun: object expected");
			n.stopAutoRerun = U.StopAutoRerun.fromObject(e.stopAutoRerun, t + 1);
		}
		if (e.logo != null) {
			if (!A.isObject(e.logo)) throw F(".ForwardMsg.logo: object expected");
			n.logo = U.Logo.fromObject(e.logo, t + 1);
		}
		if (e.authRedirect != null) {
			if (!A.isObject(e.authRedirect)) throw F(".ForwardMsg.authRedirect: object expected");
			n.authRedirect = U.AuthRedirect.fromObject(e.authRedirect, t + 1);
		}
		if (e.parentMessage != null) {
			if (!A.isObject(e.parentMessage)) throw F(".ForwardMsg.parentMessage: object expected");
			n.parentMessage = U.ParentMessage.fromObject(e.parentMessage, t + 1);
		}
		if (e.refHash != null && (n.refHash = I(e.refHash)), e.heartbeatAck != null && (n.heartbeatAck = L(e.heartbeatAck)), e.backendOperationResponse != null) {
			if (!A.isObject(e.backendOperationResponse)) throw F(".ForwardMsg.backendOperationResponse: object expected");
			n.backendOperationResponse = U.BackendOperationResponse.fromObject(e.backendOperationResponse, t + 1);
		}
		return e.debugLastBackmsgId != null && (typeof e.debugLastBackmsgId != "string" || e.debugLastBackmsgId.length) && (n.debugLastBackmsgId = I(e.debugLastBackmsgId)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.hash = "", r.metadata = null, r.debugLastBackmsgId = ""), e.hash != null && j.hasOwnProperty.call(e, "hash") && (r.hash = e.hash), e.metadata != null && j.hasOwnProperty.call(e, "metadata") && (r.metadata = U.ForwardMsgMetadata.toObject(e.metadata, t, n + 1)), e.newSession != null && j.hasOwnProperty.call(e, "newSession") && (r.newSession = U.NewSession.toObject(e.newSession, t, n + 1), t.oneofs && (r.type = "newSession")), e.delta != null && j.hasOwnProperty.call(e, "delta") && (r.delta = U.Delta.toObject(e.delta, t, n + 1), t.oneofs && (r.type = "delta")), e.scriptFinished != null && j.hasOwnProperty.call(e, "scriptFinished") && (r.scriptFinished = t.enums === I ? U.ForwardMsg.ScriptFinishedStatus[e.scriptFinished] === M ? e.scriptFinished : U.ForwardMsg.ScriptFinishedStatus[e.scriptFinished] : e.scriptFinished, t.oneofs && (r.type = "scriptFinished")), e.sessionStatusChanged != null && j.hasOwnProperty.call(e, "sessionStatusChanged") && (r.sessionStatusChanged = U.SessionStatus.toObject(e.sessionStatusChanged, t, n + 1), t.oneofs && (r.type = "sessionStatusChanged")), e.sessionEvent != null && j.hasOwnProperty.call(e, "sessionEvent") && (r.sessionEvent = U.SessionEvent.toObject(e.sessionEvent, t, n + 1), t.oneofs && (r.type = "sessionEvent")), e.refHash != null && j.hasOwnProperty.call(e, "refHash") && (r.refHash = e.refHash, t.oneofs && (r.type = "refHash")), e.pageInfoChanged != null && j.hasOwnProperty.call(e, "pageInfoChanged") && (r.pageInfoChanged = U.PageInfo.toObject(e.pageInfoChanged, t, n + 1), t.oneofs && (r.type = "pageInfoChanged")), e.pageConfigChanged != null && j.hasOwnProperty.call(e, "pageConfigChanged") && (r.pageConfigChanged = U.PageConfig.toObject(e.pageConfigChanged, t, n + 1), t.oneofs && (r.type = "pageConfigChanged")), e.gitInfoChanged != null && j.hasOwnProperty.call(e, "gitInfoChanged") && (r.gitInfoChanged = U.GitInfo.toObject(e.gitInfoChanged, t, n + 1), t.oneofs && (r.type = "gitInfoChanged")), e.pageNotFound != null && j.hasOwnProperty.call(e, "pageNotFound") && (r.pageNotFound = U.PageNotFound.toObject(e.pageNotFound, t, n + 1), t.oneofs && (r.type = "pageNotFound")), e.debugLastBackmsgId != null && j.hasOwnProperty.call(e, "debugLastBackmsgId") && (r.debugLastBackmsgId = e.debugLastBackmsgId), e.pageProfile != null && j.hasOwnProperty.call(e, "pageProfile") && (r.pageProfile = U.PageProfile.toObject(e.pageProfile, t, n + 1), t.oneofs && (r.type = "pageProfile")), e.fileUrlsResponse != null && j.hasOwnProperty.call(e, "fileUrlsResponse") && (r.fileUrlsResponse = U.FileURLsResponse.toObject(e.fileUrlsResponse, t, n + 1), t.oneofs && (r.type = "fileUrlsResponse")), e.parentMessage != null && j.hasOwnProperty.call(e, "parentMessage") && (r.parentMessage = U.ParentMessage.toObject(e.parentMessage, t, n + 1), t.oneofs && (r.type = "parentMessage")), e.autoRerun != null && j.hasOwnProperty.call(e, "autoRerun") && (r.autoRerun = U.AutoRerun.toObject(e.autoRerun, t, n + 1), t.oneofs && (r.type = "autoRerun")), e.logo != null && j.hasOwnProperty.call(e, "logo") && (r.logo = U.Logo.toObject(e.logo, t, n + 1), t.oneofs && (r.type = "logo")), e.navigation != null && j.hasOwnProperty.call(e, "navigation") && (r.navigation = U.Navigation.toObject(e.navigation, t, n + 1), t.oneofs && (r.type = "navigation")), e.authRedirect != null && j.hasOwnProperty.call(e, "authRedirect") && (r.authRedirect = U.AuthRedirect.toObject(e.authRedirect, t, n + 1), t.oneofs && (r.type = "authRedirect")), e.heartbeatAck != null && j.hasOwnProperty.call(e, "heartbeatAck") && (r.heartbeatAck = e.heartbeatAck, t.oneofs && (r.type = "heartbeatAck")), e.backendOperationResponse != null && j.hasOwnProperty.call(e, "backendOperationResponse") && (r.backendOperationResponse = U.BackendOperationResponse.toObject(e.backendOperationResponse, t, n + 1), t.oneofs && (r.type = "backendOperationResponse")), e.stopAutoRerun != null && j.hasOwnProperty.call(e, "stopAutoRerun") && (r.stopAutoRerun = U.StopAutoRerun.toObject(e.stopAutoRerun, t, n + 1), t.oneofs && (r.type = "stopAutoRerun")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ForwardMsg";
	}, e.ScriptFinishedStatus = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "FINISHED_SUCCESSFULLY"] = 0, t[e[1] = "FINISHED_WITH_COMPILE_ERROR"] = 1, t[e[2] = "FINISHED_EARLY_FOR_RERUN"] = 2, t[e[3] = "FINISHED_FRAGMENT_RUN_SUCCESSFULLY"] = 3, t;
	})(), e;
})();
U.BackendOperationResponse = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.requestId = "", e.prototype.errorMsg = "", e.prototype.errorReason = "", e.prototype.deferredFile = null, e.prototype.installSkills = null, e.prototype.dismissSkillsNudge = null, e.prototype.dataframeChunk = null;
	let t;
	return j.defineProperty(e.prototype, "payload", {
		get: A.oneOfGetter(t = [
			"deferredFile",
			"installSkills",
			"dismissSkillsNudge",
			"dataframeChunk"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.requestId != null && j.hasOwnProperty.call(e, "requestId") && e.requestId !== "" && t.uint32(10).string(e.requestId), e.errorMsg != null && j.hasOwnProperty.call(e, "errorMsg") && e.errorMsg !== "" && t.uint32(18).string(e.errorMsg), e.deferredFile != null && j.hasOwnProperty.call(e, "deferredFile") && U.DeferredFileResponsePayload.encode(e.deferredFile, t.uint32(26).fork(), n + 1).ldelim(), e.installSkills != null && j.hasOwnProperty.call(e, "installSkills") && U.InstallSkillsResponsePayload.encode(e.installSkills, t.uint32(34).fork(), n + 1).ldelim(), e.dismissSkillsNudge != null && j.hasOwnProperty.call(e, "dismissSkillsNudge") && U.DismissSkillsNudgeResponsePayload.encode(e.dismissSkillsNudge, t.uint32(42).fork(), n + 1).ldelim(), e.dataframeChunk != null && j.hasOwnProperty.call(e, "dataframeChunk") && U.DataframeChunkResponsePayload.encode(e.dataframeChunk, t.uint32(50).fork(), n + 1).ldelim(), e.errorReason != null && j.hasOwnProperty.call(e, "errorReason") && e.errorReason !== "" && t.uint32(58).string(e.errorReason), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.BackendOperationResponse(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.requestId = s : delete o.requestId;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.errorMsg = s : delete o.errorMsg;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.errorReason = s : delete o.errorReason;
					continue;
				case 3:
					if (a !== 2) break;
					o.deferredFile = U.DeferredFileResponsePayload.decode(e, e.uint32(), M, r + 1, o.deferredFile), o.payload = "deferredFile";
					continue;
				case 4:
					if (a !== 2) break;
					o.installSkills = U.InstallSkillsResponsePayload.decode(e, e.uint32(), M, r + 1, o.installSkills), o.payload = "installSkills";
					continue;
				case 5:
					if (a !== 2) break;
					o.dismissSkillsNudge = U.DismissSkillsNudgeResponsePayload.decode(e, e.uint32(), M, r + 1, o.dismissSkillsNudge), o.payload = "dismissSkillsNudge";
					continue;
				case 6:
					if (a !== 2) break;
					o.dataframeChunk = U.DataframeChunkResponsePayload.decode(e, e.uint32(), M, r + 1, o.dataframeChunk), o.payload = "dataframeChunk";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.BackendOperationResponse) return e;
		if (!A.isObject(e)) throw F(".BackendOperationResponse: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.BackendOperationResponse();
		if (e.requestId != null && (typeof e.requestId != "string" || e.requestId.length) && (n.requestId = I(e.requestId)), e.errorMsg != null && (typeof e.errorMsg != "string" || e.errorMsg.length) && (n.errorMsg = I(e.errorMsg)), e.errorReason != null && (typeof e.errorReason != "string" || e.errorReason.length) && (n.errorReason = I(e.errorReason)), e.deferredFile != null) {
			if (!A.isObject(e.deferredFile)) throw F(".BackendOperationResponse.deferredFile: object expected");
			n.deferredFile = U.DeferredFileResponsePayload.fromObject(e.deferredFile, t + 1);
		}
		if (e.installSkills != null) {
			if (!A.isObject(e.installSkills)) throw F(".BackendOperationResponse.installSkills: object expected");
			n.installSkills = U.InstallSkillsResponsePayload.fromObject(e.installSkills, t + 1);
		}
		if (e.dismissSkillsNudge != null) {
			if (!A.isObject(e.dismissSkillsNudge)) throw F(".BackendOperationResponse.dismissSkillsNudge: object expected");
			n.dismissSkillsNudge = U.DismissSkillsNudgeResponsePayload.fromObject(e.dismissSkillsNudge, t + 1);
		}
		if (e.dataframeChunk != null) {
			if (!A.isObject(e.dataframeChunk)) throw F(".BackendOperationResponse.dataframeChunk: object expected");
			n.dataframeChunk = U.DataframeChunkResponsePayload.fromObject(e.dataframeChunk, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.requestId = "", r.errorMsg = "", r.errorReason = ""), e.requestId != null && j.hasOwnProperty.call(e, "requestId") && (r.requestId = e.requestId), e.errorMsg != null && j.hasOwnProperty.call(e, "errorMsg") && (r.errorMsg = e.errorMsg), e.deferredFile != null && j.hasOwnProperty.call(e, "deferredFile") && (r.deferredFile = U.DeferredFileResponsePayload.toObject(e.deferredFile, t, n + 1), t.oneofs && (r.payload = "deferredFile")), e.installSkills != null && j.hasOwnProperty.call(e, "installSkills") && (r.installSkills = U.InstallSkillsResponsePayload.toObject(e.installSkills, t, n + 1), t.oneofs && (r.payload = "installSkills")), e.dismissSkillsNudge != null && j.hasOwnProperty.call(e, "dismissSkillsNudge") && (r.dismissSkillsNudge = U.DismissSkillsNudgeResponsePayload.toObject(e.dismissSkillsNudge, t, n + 1), t.oneofs && (r.payload = "dismissSkillsNudge")), e.dataframeChunk != null && j.hasOwnProperty.call(e, "dataframeChunk") && (r.dataframeChunk = U.DataframeChunkResponsePayload.toObject(e.dataframeChunk, t, n + 1), t.oneofs && (r.payload = "dataframeChunk")), e.errorReason != null && j.hasOwnProperty.call(e, "errorReason") && (r.errorReason = e.errorReason), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/BackendOperationResponse";
	}, e;
})(), U.DeferredFileResponsePayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.url = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(10).string(e.url), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DeferredFileResponsePayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DeferredFileResponsePayload) return e;
		if (!A.isObject(e)) throw F(".DeferredFileResponsePayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DeferredFileResponsePayload();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = ""), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DeferredFileResponsePayload";
	}, e;
})(), U.InstallSkillsResponsePayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.detail = "", e.prototype.fallbackReason = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.detail != null && j.hasOwnProperty.call(e, "detail") && e.detail !== "" && t.uint32(10).string(e.detail), e.fallbackReason != null && j.hasOwnProperty.call(e, "fallbackReason") && e.fallbackReason !== "" && t.uint32(18).string(e.fallbackReason), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.InstallSkillsResponsePayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.detail = s : delete o.detail;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.fallbackReason = s : delete o.fallbackReason;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.InstallSkillsResponsePayload) return e;
		if (!A.isObject(e)) throw F(".InstallSkillsResponsePayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.InstallSkillsResponsePayload();
		return e.detail != null && (typeof e.detail != "string" || e.detail.length) && (n.detail = I(e.detail)), e.fallbackReason != null && (typeof e.fallbackReason != "string" || e.fallbackReason.length) && (n.fallbackReason = I(e.fallbackReason)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.detail = "", r.fallbackReason = ""), e.detail != null && j.hasOwnProperty.call(e, "detail") && (r.detail = e.detail), e.fallbackReason != null && j.hasOwnProperty.call(e, "fallbackReason") && (r.fallbackReason = e.fallbackReason), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/InstallSkillsResponsePayload";
	}, e;
})(), U.DismissSkillsNudgeResponsePayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DismissSkillsNudgeResponsePayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			e.skipType(i & 7, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DismissSkillsNudgeResponsePayload) return e;
		if (!A.isObject(e)) throw F(".DismissSkillsNudgeResponsePayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		return new U.DismissSkillsNudgeResponsePayload();
	}, e.toObject = function() {
		return {};
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DismissSkillsNudgeResponsePayload";
	}, e;
})(), U.DataframeChunkResponsePayload = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.sourceId = "", e.prototype.offset = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.endOfStream = !1, e.prototype.arrowData = null, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && e.sourceId !== "" && t.uint32(10).string(e.sourceId), e.offset != null && j.hasOwnProperty.call(e, "offset") && (typeof e.offset == "object" ? e.offset.low || e.offset.high : e.offset !== 0) && t.uint32(16).uint64(e.offset), e.endOfStream != null && j.hasOwnProperty.call(e, "endOfStream") && e.endOfStream !== !1 && t.uint32(24).bool(e.endOfStream), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && U.ArrowData.encode(e.arrowData, t.uint32(34).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.DataframeChunkResponsePayload(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sourceId = s : delete o.sourceId;
					continue;
				case 2:
					if (a !== 0) break;
					(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.offset = s : delete o.offset;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.bool()) ? o.endOfStream = s : delete o.endOfStream;
					continue;
				case 4:
					if (a !== 2) break;
					o.arrowData = U.ArrowData.decode(e, e.uint32(), M, r + 1, o.arrowData);
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.DataframeChunkResponsePayload) return e;
		if (!A.isObject(e)) throw F(".DataframeChunkResponsePayload: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.DataframeChunkResponsePayload();
		if (e.sourceId != null && (typeof e.sourceId != "string" || e.sourceId.length) && (n.sourceId = I(e.sourceId)), e.offset != null && (typeof e.offset == "object" ? e.offset.low || e.offset.high : R(e.offset) !== 0) && (A.Long ? n.offset = A.Long.fromValue(e.offset, !0) : typeof e.offset == "string" ? n.offset = V(e.offset, 10) : typeof e.offset == "number" ? n.offset = e.offset : typeof e.offset == "object" && (n.offset = new A.LongBits(e.offset.low >>> 0, e.offset.high >>> 0).toNumber(!0))), e.endOfStream != null && e.endOfStream && (n.endOfStream = L(e.endOfStream)), e.arrowData != null) {
			if (!A.isObject(e.arrowData)) throw F(".DataframeChunkResponsePayload.arrowData: object expected");
			n.arrowData = U.ArrowData.fromObject(e.arrowData, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if (t.defaults) {
			if (r.sourceId = "", A.Long) {
				let e = new A.Long(0, 0, !0);
				r.offset = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.offset = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.endOfStream = !1, r.arrowData = null;
		}
		return e.sourceId != null && j.hasOwnProperty.call(e, "sourceId") && (r.sourceId = e.sourceId), e.offset != null && j.hasOwnProperty.call(e, "offset") && (r.offset = H !== void 0 && t.longs === H ? typeof e.offset == "number" ? H(e.offset) : A.Long.fromBits(e.offset.low >>> 0, e.offset.high >>> 0, !0).toBigInt() : typeof e.offset == "number" ? t.longs === I ? I(e.offset) : e.offset : t.longs === I ? A.Long.prototype.toString.call(e.offset) : t.longs === R ? new A.LongBits(e.offset.low >>> 0, e.offset.high >>> 0).toNumber(!0) : e.offset), e.endOfStream != null && j.hasOwnProperty.call(e, "endOfStream") && (r.endOfStream = e.endOfStream), e.arrowData != null && j.hasOwnProperty.call(e, "arrowData") && (r.arrowData = U.ArrowData.toObject(e.arrowData, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/DataframeChunkResponsePayload";
	}, e;
})(), U.ForwardMsgMetadata = (() => {
	let e = function(e) {
		if (this.deltaPath = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.cacheable = !1, e.prototype.deltaPath = A.emptyArray, e.prototype.activeScriptHash = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.cacheable != null && j.hasOwnProperty.call(e, "cacheable") && e.cacheable !== !1 && t.uint32(8).bool(e.cacheable), e.deltaPath != null && e.deltaPath.length && t.uint32(18).uint32s(e.deltaPath), e.activeScriptHash != null && j.hasOwnProperty.call(e, "activeScriptHash") && e.activeScriptHash !== "" && t.uint32(34).string(e.activeScriptHash), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ForwardMsgMetadata(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.cacheable = s : delete o.cacheable;
					continue;
				case 2:
					if (a === 2) {
						o.deltaPath && o.deltaPath.length || (o.deltaPath = []), e.uint32s(o.deltaPath);
						continue;
					}
					if (a !== 0) break;
					o.deltaPath && o.deltaPath.length || (o.deltaPath = []), o.deltaPath.push(e.uint32());
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.activeScriptHash = s : delete o.activeScriptHash;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ForwardMsgMetadata) return e;
		if (!A.isObject(e)) throw F(".ForwardMsgMetadata: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ForwardMsgMetadata();
		if (e.cacheable != null && e.cacheable && (n.cacheable = L(e.cacheable)), e.deltaPath) {
			if (!B.isArray(e.deltaPath)) throw F(".ForwardMsgMetadata.deltaPath: array expected");
			n.deltaPath = B(e.deltaPath.length);
			for (let t = 0; t < e.deltaPath.length; ++t) n.deltaPath[t] = e.deltaPath[t] >>> 0;
		}
		return e.activeScriptHash != null && (typeof e.activeScriptHash != "string" || e.activeScriptHash.length) && (n.activeScriptHash = I(e.activeScriptHash)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.deltaPath = []), t.defaults && (r.cacheable = !1, r.activeScriptHash = ""), e.cacheable != null && j.hasOwnProperty.call(e, "cacheable") && (r.cacheable = e.cacheable), e.deltaPath && e.deltaPath.length) {
			r.deltaPath = B(e.deltaPath.length);
			for (let t = 0; t < e.deltaPath.length; ++t) r.deltaPath[t] = e.deltaPath[t];
		}
		return e.activeScriptHash != null && j.hasOwnProperty.call(e, "activeScriptHash") && (r.activeScriptHash = e.activeScriptHash), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ForwardMsgMetadata";
	}, e;
})();
var ae = U.ForwardMsgList = (() => {
	let e = function(e) {
		if (this.messages = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.messages = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.messages != null && e.messages.length) for (let r = 0; r < e.messages.length; ++r) U.ForwardMsg.encode(e.messages[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ForwardMsgList(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.messages && o.messages.length || (o.messages = []), o.messages.push(U.ForwardMsg.decode(e, e.uint32(), M, r + 1));
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ForwardMsgList) return e;
		if (!A.isObject(e)) throw F(".ForwardMsgList: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ForwardMsgList();
		if (e.messages) {
			if (!B.isArray(e.messages)) throw F(".ForwardMsgList.messages: array expected");
			n.messages = B(e.messages.length);
			for (let r = 0; r < e.messages.length; ++r) {
				if (!A.isObject(e.messages[r])) throw F(".ForwardMsgList.messages: object expected");
				n.messages[r] = U.ForwardMsg.fromObject(e.messages[r], t + 1);
			}
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.messages = []), e.messages && e.messages.length) {
			r.messages = B(e.messages.length);
			for (let i = 0; i < e.messages.length; ++i) r.messages[i] = U.ForwardMsg.toObject(e.messages[i], t, n + 1);
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ForwardMsgList";
	}, e;
})();
//#endregion
//#region ../utils/dist/streamlit-utils.es.js
U.GitInfo = (() => {
	let e = function(e) {
		if (this.untrackedFiles = [], this.uncommittedFiles = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.repository = "", e.prototype.branch = "", e.prototype.module = "", e.prototype.untrackedFiles = A.emptyArray, e.prototype.uncommittedFiles = A.emptyArray, e.prototype.state = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.repository != null && j.hasOwnProperty.call(e, "repository") && e.repository !== "" && t.uint32(10).string(e.repository), e.branch != null && j.hasOwnProperty.call(e, "branch") && e.branch !== "" && t.uint32(18).string(e.branch), e.module != null && j.hasOwnProperty.call(e, "module") && e.module !== "" && t.uint32(26).string(e.module), e.untrackedFiles != null && e.untrackedFiles.length) for (let n = 0; n < e.untrackedFiles.length; ++n) t.uint32(34).string(e.untrackedFiles[n]);
		if (e.uncommittedFiles != null && e.uncommittedFiles.length) for (let n = 0; n < e.uncommittedFiles.length; ++n) t.uint32(42).string(e.uncommittedFiles[n]);
		if (e.state != null && j.hasOwnProperty.call(e, "state") && e.state !== 0 && t.uint32(48).int32(e.state), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.GitInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.repository = s : delete o.repository;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.branch = s : delete o.branch;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.module = s : delete o.module;
					continue;
				case 4:
					if (a !== 2) break;
					o.untrackedFiles && o.untrackedFiles.length || (o.untrackedFiles = []), o.untrackedFiles.push(e.stringVerify());
					continue;
				case 5:
					if (a !== 2) break;
					o.uncommittedFiles && o.uncommittedFiles.length || (o.uncommittedFiles = []), o.uncommittedFiles.push(e.stringVerify());
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.state = s : delete o.state;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.GitInfo) return e;
		if (!A.isObject(e)) throw F(".GitInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.GitInfo();
		if (e.repository != null && (typeof e.repository != "string" || e.repository.length) && (n.repository = I(e.repository)), e.branch != null && (typeof e.branch != "string" || e.branch.length) && (n.branch = I(e.branch)), e.module != null && (typeof e.module != "string" || e.module.length) && (n.module = I(e.module)), e.untrackedFiles) {
			if (!B.isArray(e.untrackedFiles)) throw F(".GitInfo.untrackedFiles: array expected");
			n.untrackedFiles = B(e.untrackedFiles.length);
			for (let t = 0; t < e.untrackedFiles.length; ++t) n.untrackedFiles[t] = I(e.untrackedFiles[t]);
		}
		if (e.uncommittedFiles) {
			if (!B.isArray(e.uncommittedFiles)) throw F(".GitInfo.uncommittedFiles: array expected");
			n.uncommittedFiles = B(e.uncommittedFiles.length);
			for (let t = 0; t < e.uncommittedFiles.length; ++t) n.uncommittedFiles[t] = I(e.uncommittedFiles[t]);
		}
		if (e.state !== 0 && (typeof e.state != "string" || U.GitInfo.GitStates[e.state] !== 0)) switch (e.state) {
			case "DEFAULT":
			case 0:
				n.state = 0;
				break;
			case "HEAD_DETACHED":
			case 1:
				n.state = 1;
				break;
			case "AHEAD_OF_REMOTE":
			case 2:
				n.state = 2;
				break;
			default: typeof e.state == "number" && (e.state | 0) === e.state && (n.state = e.state);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.untrackedFiles = [], r.uncommittedFiles = []), t.defaults && (r.repository = "", r.branch = "", r.module = "", r.state = t.enums === I ? "DEFAULT" : 0), e.repository != null && j.hasOwnProperty.call(e, "repository") && (r.repository = e.repository), e.branch != null && j.hasOwnProperty.call(e, "branch") && (r.branch = e.branch), e.module != null && j.hasOwnProperty.call(e, "module") && (r.module = e.module), e.untrackedFiles && e.untrackedFiles.length) {
			r.untrackedFiles = B(e.untrackedFiles.length);
			for (let t = 0; t < e.untrackedFiles.length; ++t) r.untrackedFiles[t] = e.untrackedFiles[t];
		}
		if (e.uncommittedFiles && e.uncommittedFiles.length) {
			r.uncommittedFiles = B(e.uncommittedFiles.length);
			for (let t = 0; t < e.uncommittedFiles.length; ++t) r.uncommittedFiles[t] = e.uncommittedFiles[t];
		}
		return e.state != null && j.hasOwnProperty.call(e, "state") && (r.state = t.enums === I ? U.GitInfo.GitStates[e.state] === M ? e.state : U.GitInfo.GitStates[e.state] : e.state), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/GitInfo";
	}, e.GitStates = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "DEFAULT"] = 0, t[e[1] = "HEAD_DETACHED"] = 1, t[e[2] = "AHEAD_OF_REMOTE"] = 2, t;
	})(), e;
})(), U.Logo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.image = "", e.prototype.link = "", e.prototype.iconImage = "", e.prototype.size = "", e.prototype.imageType = 0, e.prototype.iconImageType = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.image != null && j.hasOwnProperty.call(e, "image") && e.image !== "" && t.uint32(10).string(e.image), e.link != null && j.hasOwnProperty.call(e, "link") && e.link !== "" && t.uint32(18).string(e.link), e.iconImage != null && j.hasOwnProperty.call(e, "iconImage") && e.iconImage !== "" && t.uint32(26).string(e.iconImage), e.size != null && j.hasOwnProperty.call(e, "size") && e.size !== "" && t.uint32(34).string(e.size), e.imageType != null && j.hasOwnProperty.call(e, "imageType") && e.imageType !== 0 && t.uint32(40).int32(e.imageType), e.iconImageType != null && j.hasOwnProperty.call(e, "iconImageType") && e.iconImageType !== 0 && t.uint32(48).int32(e.iconImageType), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Logo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.image = s : delete o.image;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.link = s : delete o.link;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.iconImage = s : delete o.iconImage;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.size = s : delete o.size;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.imageType = s : delete o.imageType;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.iconImageType = s : delete o.iconImageType;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Logo) return e;
		if (!A.isObject(e)) throw F(".Logo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Logo();
		if (e.image != null && (typeof e.image != "string" || e.image.length) && (n.image = I(e.image)), e.link != null && (typeof e.link != "string" || e.link.length) && (n.link = I(e.link)), e.iconImage != null && (typeof e.iconImage != "string" || e.iconImage.length) && (n.iconImage = I(e.iconImage)), e.size != null && (typeof e.size != "string" || e.size.length) && (n.size = I(e.size)), e.imageType !== 0 && (typeof e.imageType != "string" || U.Logo.ImageType[e.imageType] !== 0)) switch (e.imageType) {
			case "IMAGE":
			case 0:
				n.imageType = 0;
				break;
			case "EMOJI":
			case 1:
				n.imageType = 1;
				break;
			case "ICON":
			case 2:
				n.imageType = 2;
				break;
			default: typeof e.imageType == "number" && (e.imageType | 0) === e.imageType && (n.imageType = e.imageType);
		}
		if (e.iconImageType !== 0 && (typeof e.iconImageType != "string" || U.Logo.ImageType[e.iconImageType] !== 0)) switch (e.iconImageType) {
			case "IMAGE":
			case 0:
				n.iconImageType = 0;
				break;
			case "EMOJI":
			case 1:
				n.iconImageType = 1;
				break;
			case "ICON":
			case 2:
				n.iconImageType = 2;
				break;
			default: typeof e.iconImageType == "number" && (e.iconImageType | 0) === e.iconImageType && (n.iconImageType = e.iconImageType);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.image = "", r.link = "", r.iconImage = "", r.size = "", r.imageType = t.enums === I ? "IMAGE" : 0, r.iconImageType = t.enums === I ? "IMAGE" : 0), e.image != null && j.hasOwnProperty.call(e, "image") && (r.image = e.image), e.link != null && j.hasOwnProperty.call(e, "link") && (r.link = e.link), e.iconImage != null && j.hasOwnProperty.call(e, "iconImage") && (r.iconImage = e.iconImage), e.size != null && j.hasOwnProperty.call(e, "size") && (r.size = e.size), e.imageType != null && j.hasOwnProperty.call(e, "imageType") && (r.imageType = t.enums === I ? U.Logo.ImageType[e.imageType] === M ? e.imageType : U.Logo.ImageType[e.imageType] : e.imageType), e.iconImageType != null && j.hasOwnProperty.call(e, "iconImageType") && (r.iconImageType = t.enums === I ? U.Logo.ImageType[e.iconImageType] === M ? e.iconImageType : U.Logo.ImageType[e.iconImageType] : e.iconImageType), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Logo";
	}, e.ImageType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "IMAGE"] = 0, t[e[1] = "EMOJI"] = 1, t[e[2] = "ICON"] = 2, t;
	})(), e;
})(), U.Navigation = (() => {
	let e = function(e) {
		if (this.sections = [], this.appPages = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.sections = A.emptyArray, e.prototype.appPages = A.emptyArray, e.prototype.position = 0, e.prototype.pageScriptHash = "", e.prototype.expanded = !1, e.prototype.visibleItems = null;
	let t;
	return j.defineProperty(e.prototype, "_visibleItems", {
		get: A.oneOfGetter(t = ["visibleItems"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.sections != null && e.sections.length) for (let n = 0; n < e.sections.length; ++n) t.uint32(10).string(e.sections[n]);
		if (e.appPages != null && e.appPages.length) for (let r = 0; r < e.appPages.length; ++r) U.AppPage.encode(e.appPages[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.position != null && j.hasOwnProperty.call(e, "position") && e.position !== 0 && t.uint32(24).int32(e.position), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(34).string(e.pageScriptHash), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && e.expanded !== !1 && t.uint32(40).bool(e.expanded), e.visibleItems != null && j.hasOwnProperty.call(e, "visibleItems") && t.uint32(48).uint32(e.visibleItems), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Navigation(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.sections && o.sections.length || (o.sections = []), o.sections.push(e.stringVerify());
					continue;
				case 2:
					if (a !== 2) break;
					o.appPages && o.appPages.length || (o.appPages = []), o.appPages.push(U.AppPage.decode(e, e.uint32(), M, r + 1));
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.position = s : delete o.position;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.expanded = s : delete o.expanded;
					continue;
				case 6:
					if (a !== 0) break;
					o.visibleItems = e.uint32(), o._visibleItems = "visibleItems";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Navigation) return e;
		if (!A.isObject(e)) throw F(".Navigation: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Navigation();
		if (e.sections) {
			if (!B.isArray(e.sections)) throw F(".Navigation.sections: array expected");
			n.sections = B(e.sections.length);
			for (let t = 0; t < e.sections.length; ++t) n.sections[t] = I(e.sections[t]);
		}
		if (e.appPages) {
			if (!B.isArray(e.appPages)) throw F(".Navigation.appPages: array expected");
			n.appPages = B(e.appPages.length);
			for (let r = 0; r < e.appPages.length; ++r) {
				if (!A.isObject(e.appPages[r])) throw F(".Navigation.appPages: object expected");
				n.appPages[r] = U.AppPage.fromObject(e.appPages[r], t + 1);
			}
		}
		if (e.position !== 0 && (typeof e.position != "string" || U.Navigation.Position[e.position] !== 0)) switch (e.position) {
			case "HIDDEN":
			case 0:
				n.position = 0;
				break;
			case "SIDEBAR":
			case 1:
				n.position = 1;
				break;
			case "TOP":
			case 2:
				n.position = 2;
				break;
			default: typeof e.position == "number" && (e.position | 0) === e.position && (n.position = e.position);
		}
		return e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.expanded != null && e.expanded && (n.expanded = L(e.expanded)), e.visibleItems != null && (n.visibleItems = e.visibleItems >>> 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.sections = [], r.appPages = []), t.defaults && (r.position = t.enums === I ? "HIDDEN" : 0, r.pageScriptHash = "", r.expanded = !1), e.sections && e.sections.length) {
			r.sections = B(e.sections.length);
			for (let t = 0; t < e.sections.length; ++t) r.sections[t] = e.sections[t];
		}
		if (e.appPages && e.appPages.length) {
			r.appPages = B(e.appPages.length);
			for (let i = 0; i < e.appPages.length; ++i) r.appPages[i] = U.AppPage.toObject(e.appPages[i], t, n + 1);
		}
		return e.position != null && j.hasOwnProperty.call(e, "position") && (r.position = t.enums === I ? U.Navigation.Position[e.position] === M ? e.position : U.Navigation.Position[e.position] : e.position), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.expanded != null && j.hasOwnProperty.call(e, "expanded") && (r.expanded = e.expanded), e.visibleItems != null && j.hasOwnProperty.call(e, "visibleItems") && (r.visibleItems = e.visibleItems), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Navigation";
	}, e.Position = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "HIDDEN"] = 0, t[e[1] = "SIDEBAR"] = 1, t[e[2] = "TOP"] = 2, t;
	})(), e;
})(), U.NewSession = (() => {
	let e = function(e) {
		if (this.appPages = [], this.fragmentIdsThisRun = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.initialize = null, e.prototype.scriptRunId = "", e.prototype.name = "", e.prototype.mainScriptPath = "", e.prototype.config = null, e.prototype.customTheme = null, e.prototype.appPages = A.emptyArray, e.prototype.pageScriptHash = "", e.prototype.fragmentIdsThisRun = A.emptyArray, e.prototype.mainScriptHash = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.initialize != null && j.hasOwnProperty.call(e, "initialize") && U.Initialize.encode(e.initialize, t.uint32(10).fork(), n + 1).ldelim(), e.scriptRunId != null && j.hasOwnProperty.call(e, "scriptRunId") && e.scriptRunId !== "" && t.uint32(18).string(e.scriptRunId), e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(26).string(e.name), e.mainScriptPath != null && j.hasOwnProperty.call(e, "mainScriptPath") && e.mainScriptPath !== "" && t.uint32(34).string(e.mainScriptPath), e.config != null && j.hasOwnProperty.call(e, "config") && U.Config.encode(e.config, t.uint32(50).fork(), n + 1).ldelim(), e.customTheme != null && j.hasOwnProperty.call(e, "customTheme") && U.CustomThemeConfig.encode(e.customTheme, t.uint32(58).fork(), n + 1).ldelim(), e.appPages != null && e.appPages.length) for (let r = 0; r < e.appPages.length; ++r) U.AppPage.encode(e.appPages[r], t.uint32(66).fork(), n + 1).ldelim();
		if (e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(74).string(e.pageScriptHash), e.fragmentIdsThisRun != null && e.fragmentIdsThisRun.length) for (let n = 0; n < e.fragmentIdsThisRun.length; ++n) t.uint32(82).string(e.fragmentIdsThisRun[n]);
		if (e.mainScriptHash != null && j.hasOwnProperty.call(e, "mainScriptHash") && e.mainScriptHash !== "" && t.uint32(90).string(e.mainScriptHash), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.NewSession(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.initialize = U.Initialize.decode(e, e.uint32(), M, r + 1, o.initialize);
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.scriptRunId = s : delete o.scriptRunId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.mainScriptPath = s : delete o.mainScriptPath;
					continue;
				case 6:
					if (a !== 2) break;
					o.config = U.Config.decode(e, e.uint32(), M, r + 1, o.config);
					continue;
				case 7:
					if (a !== 2) break;
					o.customTheme = U.CustomThemeConfig.decode(e, e.uint32(), M, r + 1, o.customTheme);
					continue;
				case 8:
					if (a !== 2) break;
					o.appPages && o.appPages.length || (o.appPages = []), o.appPages.push(U.AppPage.decode(e, e.uint32(), M, r + 1));
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 10:
					if (a !== 2) break;
					o.fragmentIdsThisRun && o.fragmentIdsThisRun.length || (o.fragmentIdsThisRun = []), o.fragmentIdsThisRun.push(e.stringVerify());
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.mainScriptHash = s : delete o.mainScriptHash;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.NewSession) return e;
		if (!A.isObject(e)) throw F(".NewSession: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.NewSession();
		if (e.initialize != null) {
			if (!A.isObject(e.initialize)) throw F(".NewSession.initialize: object expected");
			n.initialize = U.Initialize.fromObject(e.initialize, t + 1);
		}
		if (e.scriptRunId != null && (typeof e.scriptRunId != "string" || e.scriptRunId.length) && (n.scriptRunId = I(e.scriptRunId)), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.mainScriptPath != null && (typeof e.mainScriptPath != "string" || e.mainScriptPath.length) && (n.mainScriptPath = I(e.mainScriptPath)), e.config != null) {
			if (!A.isObject(e.config)) throw F(".NewSession.config: object expected");
			n.config = U.Config.fromObject(e.config, t + 1);
		}
		if (e.customTheme != null) {
			if (!A.isObject(e.customTheme)) throw F(".NewSession.customTheme: object expected");
			n.customTheme = U.CustomThemeConfig.fromObject(e.customTheme, t + 1);
		}
		if (e.appPages) {
			if (!B.isArray(e.appPages)) throw F(".NewSession.appPages: array expected");
			n.appPages = B(e.appPages.length);
			for (let r = 0; r < e.appPages.length; ++r) {
				if (!A.isObject(e.appPages[r])) throw F(".NewSession.appPages: object expected");
				n.appPages[r] = U.AppPage.fromObject(e.appPages[r], t + 1);
			}
		}
		if (e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.fragmentIdsThisRun) {
			if (!B.isArray(e.fragmentIdsThisRun)) throw F(".NewSession.fragmentIdsThisRun: array expected");
			n.fragmentIdsThisRun = B(e.fragmentIdsThisRun.length);
			for (let t = 0; t < e.fragmentIdsThisRun.length; ++t) n.fragmentIdsThisRun[t] = I(e.fragmentIdsThisRun[t]);
		}
		return e.mainScriptHash != null && (typeof e.mainScriptHash != "string" || e.mainScriptHash.length) && (n.mainScriptHash = I(e.mainScriptHash)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.appPages = [], r.fragmentIdsThisRun = []), t.defaults && (r.initialize = null, r.scriptRunId = "", r.name = "", r.mainScriptPath = "", r.config = null, r.customTheme = null, r.pageScriptHash = "", r.mainScriptHash = ""), e.initialize != null && j.hasOwnProperty.call(e, "initialize") && (r.initialize = U.Initialize.toObject(e.initialize, t, n + 1)), e.scriptRunId != null && j.hasOwnProperty.call(e, "scriptRunId") && (r.scriptRunId = e.scriptRunId), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.mainScriptPath != null && j.hasOwnProperty.call(e, "mainScriptPath") && (r.mainScriptPath = e.mainScriptPath), e.config != null && j.hasOwnProperty.call(e, "config") && (r.config = U.Config.toObject(e.config, t, n + 1)), e.customTheme != null && j.hasOwnProperty.call(e, "customTheme") && (r.customTheme = U.CustomThemeConfig.toObject(e.customTheme, t, n + 1)), e.appPages && e.appPages.length) {
			r.appPages = B(e.appPages.length);
			for (let i = 0; i < e.appPages.length; ++i) r.appPages[i] = U.AppPage.toObject(e.appPages[i], t, n + 1);
		}
		if (e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.fragmentIdsThisRun && e.fragmentIdsThisRun.length) {
			r.fragmentIdsThisRun = B(e.fragmentIdsThisRun.length);
			for (let t = 0; t < e.fragmentIdsThisRun.length; ++t) r.fragmentIdsThisRun[t] = e.fragmentIdsThisRun[t];
		}
		return e.mainScriptHash != null && j.hasOwnProperty.call(e, "mainScriptHash") && (r.mainScriptHash = e.mainScriptHash), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/NewSession";
	}, e;
})(), U.Initialize = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.userInfo = null, e.prototype.environmentInfo = null, e.prototype.sessionStatus = null, e.prototype.sessionId = "", e.prototype.isHello = !1, e.prototype.recommendSkillsInstall = !1, e.prototype.skillsNudgeSuppressedReason = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.userInfo != null && j.hasOwnProperty.call(e, "userInfo") && U.UserInfo.encode(e.userInfo, t.uint32(10).fork(), n + 1).ldelim(), e.environmentInfo != null && j.hasOwnProperty.call(e, "environmentInfo") && U.EnvironmentInfo.encode(e.environmentInfo, t.uint32(26).fork(), n + 1).ldelim(), e.sessionStatus != null && j.hasOwnProperty.call(e, "sessionStatus") && U.SessionStatus.encode(e.sessionStatus, t.uint32(34).fork(), n + 1).ldelim(), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && e.sessionId !== "" && t.uint32(50).string(e.sessionId), e.isHello != null && j.hasOwnProperty.call(e, "isHello") && e.isHello !== !1 && t.uint32(56).bool(e.isHello), e.recommendSkillsInstall != null && j.hasOwnProperty.call(e, "recommendSkillsInstall") && e.recommendSkillsInstall !== !1 && t.uint32(64).bool(e.recommendSkillsInstall), e.skillsNudgeSuppressedReason != null && j.hasOwnProperty.call(e, "skillsNudgeSuppressedReason") && e.skillsNudgeSuppressedReason !== "" && t.uint32(82).string(e.skillsNudgeSuppressedReason), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Initialize(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.userInfo = U.UserInfo.decode(e, e.uint32(), M, r + 1, o.userInfo);
					continue;
				case 3:
					if (a !== 2) break;
					o.environmentInfo = U.EnvironmentInfo.decode(e, e.uint32(), M, r + 1, o.environmentInfo);
					continue;
				case 4:
					if (a !== 2) break;
					o.sessionStatus = U.SessionStatus.decode(e, e.uint32(), M, r + 1, o.sessionStatus);
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sessionId = s : delete o.sessionId;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHello = s : delete o.isHello;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.recommendSkillsInstall = s : delete o.recommendSkillsInstall;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.skillsNudgeSuppressedReason = s : delete o.skillsNudgeSuppressedReason;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Initialize) return e;
		if (!A.isObject(e)) throw F(".Initialize: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Initialize();
		if (e.userInfo != null) {
			if (!A.isObject(e.userInfo)) throw F(".Initialize.userInfo: object expected");
			n.userInfo = U.UserInfo.fromObject(e.userInfo, t + 1);
		}
		if (e.environmentInfo != null) {
			if (!A.isObject(e.environmentInfo)) throw F(".Initialize.environmentInfo: object expected");
			n.environmentInfo = U.EnvironmentInfo.fromObject(e.environmentInfo, t + 1);
		}
		if (e.sessionStatus != null) {
			if (!A.isObject(e.sessionStatus)) throw F(".Initialize.sessionStatus: object expected");
			n.sessionStatus = U.SessionStatus.fromObject(e.sessionStatus, t + 1);
		}
		return e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = I(e.sessionId)), e.isHello != null && e.isHello && (n.isHello = L(e.isHello)), e.recommendSkillsInstall != null && e.recommendSkillsInstall && (n.recommendSkillsInstall = L(e.recommendSkillsInstall)), e.skillsNudgeSuppressedReason != null && (typeof e.skillsNudgeSuppressedReason != "string" || e.skillsNudgeSuppressedReason.length) && (n.skillsNudgeSuppressedReason = I(e.skillsNudgeSuppressedReason)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.userInfo = null, r.environmentInfo = null, r.sessionStatus = null, r.sessionId = "", r.isHello = !1, r.recommendSkillsInstall = !1, r.skillsNudgeSuppressedReason = ""), e.userInfo != null && j.hasOwnProperty.call(e, "userInfo") && (r.userInfo = U.UserInfo.toObject(e.userInfo, t, n + 1)), e.environmentInfo != null && j.hasOwnProperty.call(e, "environmentInfo") && (r.environmentInfo = U.EnvironmentInfo.toObject(e.environmentInfo, t, n + 1)), e.sessionStatus != null && j.hasOwnProperty.call(e, "sessionStatus") && (r.sessionStatus = U.SessionStatus.toObject(e.sessionStatus, t, n + 1)), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && (r.sessionId = e.sessionId), e.isHello != null && j.hasOwnProperty.call(e, "isHello") && (r.isHello = e.isHello), e.recommendSkillsInstall != null && j.hasOwnProperty.call(e, "recommendSkillsInstall") && (r.recommendSkillsInstall = e.recommendSkillsInstall), e.skillsNudgeSuppressedReason != null && j.hasOwnProperty.call(e, "skillsNudgeSuppressedReason") && (r.skillsNudgeSuppressedReason = e.skillsNudgeSuppressedReason), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Initialize";
	}, e;
})(), U.Config = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.gatherUsageStats = !1, e.prototype.maxCachedMessageAge = 0, e.prototype.allowRunOnSave = !1, e.prototype.hideTopBar = !1, e.prototype.hideSidebarNav = !1, e.prototype.toolbarMode = 0, e.prototype.showErrorLinks = 0, e.prototype.disableDataExport = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.gatherUsageStats != null && j.hasOwnProperty.call(e, "gatherUsageStats") && e.gatherUsageStats !== !1 && t.uint32(16).bool(e.gatherUsageStats), e.maxCachedMessageAge != null && j.hasOwnProperty.call(e, "maxCachedMessageAge") && e.maxCachedMessageAge !== 0 && t.uint32(24).int32(e.maxCachedMessageAge), e.allowRunOnSave != null && j.hasOwnProperty.call(e, "allowRunOnSave") && e.allowRunOnSave !== !1 && t.uint32(40).bool(e.allowRunOnSave), e.hideTopBar != null && j.hasOwnProperty.call(e, "hideTopBar") && e.hideTopBar !== !1 && t.uint32(48).bool(e.hideTopBar), e.hideSidebarNav != null && j.hasOwnProperty.call(e, "hideSidebarNav") && e.hideSidebarNav !== !1 && t.uint32(56).bool(e.hideSidebarNav), e.toolbarMode != null && j.hasOwnProperty.call(e, "toolbarMode") && e.toolbarMode !== 0 && t.uint32(64).int32(e.toolbarMode), e.showErrorLinks != null && j.hasOwnProperty.call(e, "showErrorLinks") && e.showErrorLinks !== 0 && t.uint32(72).int32(e.showErrorLinks), e.disableDataExport != null && j.hasOwnProperty.call(e, "disableDataExport") && e.disableDataExport !== !1 && t.uint32(80).bool(e.disableDataExport), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Config(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.gatherUsageStats = s : delete o.gatherUsageStats;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.maxCachedMessageAge = s : delete o.maxCachedMessageAge;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.allowRunOnSave = s : delete o.allowRunOnSave;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideTopBar = s : delete o.hideTopBar;
					continue;
				case 7:
					if (a !== 0) break;
					(s = e.bool()) ? o.hideSidebarNav = s : delete o.hideSidebarNav;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.int32()) ? o.toolbarMode = s : delete o.toolbarMode;
					continue;
				case 9:
					if (a !== 0) break;
					(s = e.int32()) ? o.showErrorLinks = s : delete o.showErrorLinks;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.disableDataExport = s : delete o.disableDataExport;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Config) return e;
		if (!A.isObject(e)) throw F(".Config: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Config();
		if (e.gatherUsageStats != null && e.gatherUsageStats && (n.gatherUsageStats = L(e.gatherUsageStats)), e.maxCachedMessageAge != null && R(e.maxCachedMessageAge) !== 0 && (n.maxCachedMessageAge = e.maxCachedMessageAge | 0), e.allowRunOnSave != null && e.allowRunOnSave && (n.allowRunOnSave = L(e.allowRunOnSave)), e.hideTopBar != null && e.hideTopBar && (n.hideTopBar = L(e.hideTopBar)), e.hideSidebarNav != null && e.hideSidebarNav && (n.hideSidebarNav = L(e.hideSidebarNav)), e.toolbarMode !== 0 && (typeof e.toolbarMode != "string" || U.Config.ToolbarMode[e.toolbarMode] !== 0)) switch (e.toolbarMode) {
			case "AUTO":
			case 0:
				n.toolbarMode = 0;
				break;
			case "DEVELOPER":
			case 1:
				n.toolbarMode = 1;
				break;
			case "VIEWER":
			case 2:
				n.toolbarMode = 2;
				break;
			case "MINIMAL":
			case 3:
				n.toolbarMode = 3;
				break;
			default: typeof e.toolbarMode == "number" && (e.toolbarMode | 0) === e.toolbarMode && (n.toolbarMode = e.toolbarMode);
		}
		if (e.showErrorLinks !== 0 && (typeof e.showErrorLinks != "string" || U.Config.ShowErrorLinks[e.showErrorLinks] !== 0)) switch (e.showErrorLinks) {
			case "SHOW_ERROR_LINKS_UNSPECIFIED":
			case 0:
				n.showErrorLinks = 0;
				break;
			case "SHOW_ERROR_LINKS_AUTO":
			case 1:
				n.showErrorLinks = 1;
				break;
			case "SHOW_ERROR_LINKS_TRUE":
			case 2:
				n.showErrorLinks = 2;
				break;
			case "SHOW_ERROR_LINKS_FALSE":
			case 3:
				n.showErrorLinks = 3;
				break;
			default: typeof e.showErrorLinks == "number" && (e.showErrorLinks | 0) === e.showErrorLinks && (n.showErrorLinks = e.showErrorLinks);
		}
		return e.disableDataExport != null && e.disableDataExport && (n.disableDataExport = L(e.disableDataExport)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.gatherUsageStats = !1, r.maxCachedMessageAge = 0, r.allowRunOnSave = !1, r.hideTopBar = !1, r.hideSidebarNav = !1, r.toolbarMode = t.enums === I ? "AUTO" : 0, r.showErrorLinks = t.enums === I ? "SHOW_ERROR_LINKS_UNSPECIFIED" : 0, r.disableDataExport = !1), e.gatherUsageStats != null && j.hasOwnProperty.call(e, "gatherUsageStats") && (r.gatherUsageStats = e.gatherUsageStats), e.maxCachedMessageAge != null && j.hasOwnProperty.call(e, "maxCachedMessageAge") && (r.maxCachedMessageAge = e.maxCachedMessageAge), e.allowRunOnSave != null && j.hasOwnProperty.call(e, "allowRunOnSave") && (r.allowRunOnSave = e.allowRunOnSave), e.hideTopBar != null && j.hasOwnProperty.call(e, "hideTopBar") && (r.hideTopBar = e.hideTopBar), e.hideSidebarNav != null && j.hasOwnProperty.call(e, "hideSidebarNav") && (r.hideSidebarNav = e.hideSidebarNav), e.toolbarMode != null && j.hasOwnProperty.call(e, "toolbarMode") && (r.toolbarMode = t.enums === I ? U.Config.ToolbarMode[e.toolbarMode] === M ? e.toolbarMode : U.Config.ToolbarMode[e.toolbarMode] : e.toolbarMode), e.showErrorLinks != null && j.hasOwnProperty.call(e, "showErrorLinks") && (r.showErrorLinks = t.enums === I ? U.Config.ShowErrorLinks[e.showErrorLinks] === M ? e.showErrorLinks : U.Config.ShowErrorLinks[e.showErrorLinks] : e.showErrorLinks), e.disableDataExport != null && j.hasOwnProperty.call(e, "disableDataExport") && (r.disableDataExport = e.disableDataExport), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Config";
	}, e.ToolbarMode = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "AUTO"] = 0, t[e[1] = "DEVELOPER"] = 1, t[e[2] = "VIEWER"] = 2, t[e[3] = "MINIMAL"] = 3, t;
	})(), e.ShowErrorLinks = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "SHOW_ERROR_LINKS_UNSPECIFIED"] = 0, t[e[1] = "SHOW_ERROR_LINKS_AUTO"] = 1, t[e[2] = "SHOW_ERROR_LINKS_TRUE"] = 2, t[e[3] = "SHOW_ERROR_LINKS_FALSE"] = 3, t;
	})(), e;
})(), U.CustomThemeConfig = (() => {
	let e = function(e) {
		if (this.fontFaces = [], this.fontSources = [], this.headingFontSizes = [], this.headingFontWeights = [], this.chartCategoricalColors = [], this.chartSequentialColors = [], this.chartDivergingColors = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.primaryColor = "", e.prototype.secondaryBackgroundColor = "", e.prototype.backgroundColor = "", e.prototype.textColor = "", e.prototype.base = 0, e.prototype.headingFont = "", e.prototype.bodyFont = "", e.prototype.codeFont = "", e.prototype.fontFaces = A.emptyArray, e.prototype.fontSources = A.emptyArray, e.prototype.baseRadius = null, e.prototype.buttonRadius = null, e.prototype.borderColor = null, e.prototype.dataframeBorderColor = null, e.prototype.showWidgetBorder = null, e.prototype.linkColor = null, e.prototype.linkUnderline = null, e.prototype.baseFontSize = null, e.prototype.baseFontWeight = null, e.prototype.codeFontWeight = null, e.prototype.codeFontSize = null, e.prototype.headingFontSizes = A.emptyArray, e.prototype.headingFontWeights = A.emptyArray, e.prototype.showSidebarBorder = null, e.prototype.codeTextColor = null, e.prototype.codeBackgroundColor = null, e.prototype.dataframeHeaderBackgroundColor = null, e.prototype.dataframeHeaderTextColor = null, e.prototype.chartCategoricalColors = A.emptyArray, e.prototype.chartSequentialColors = A.emptyArray, e.prototype.chartDivergingColors = A.emptyArray, e.prototype.redColor = null, e.prototype.orangeColor = null, e.prototype.yellowColor = null, e.prototype.blueColor = null, e.prototype.greenColor = null, e.prototype.violetColor = null, e.prototype.grayColor = null, e.prototype.redBackgroundColor = null, e.prototype.orangeBackgroundColor = null, e.prototype.yellowBackgroundColor = null, e.prototype.blueBackgroundColor = null, e.prototype.greenBackgroundColor = null, e.prototype.violetBackgroundColor = null, e.prototype.grayBackgroundColor = null, e.prototype.redTextColor = null, e.prototype.orangeTextColor = null, e.prototype.yellowTextColor = null, e.prototype.blueTextColor = null, e.prototype.greenTextColor = null, e.prototype.violetTextColor = null, e.prototype.grayTextColor = null, e.prototype.metricValueFontSize = null, e.prototype.metricValueFontWeight = null, e.prototype.sidebar = null, e.prototype.light = null, e.prototype.dark = null;
	let t;
	return j.defineProperty(e.prototype, "_baseRadius", {
		get: A.oneOfGetter(t = ["baseRadius"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_buttonRadius", {
		get: A.oneOfGetter(t = ["buttonRadius"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_borderColor", {
		get: A.oneOfGetter(t = ["borderColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_dataframeBorderColor", {
		get: A.oneOfGetter(t = ["dataframeBorderColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_showWidgetBorder", {
		get: A.oneOfGetter(t = ["showWidgetBorder"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_linkColor", {
		get: A.oneOfGetter(t = ["linkColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_linkUnderline", {
		get: A.oneOfGetter(t = ["linkUnderline"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_baseFontSize", {
		get: A.oneOfGetter(t = ["baseFontSize"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_baseFontWeight", {
		get: A.oneOfGetter(t = ["baseFontWeight"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_codeFontWeight", {
		get: A.oneOfGetter(t = ["codeFontWeight"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_codeFontSize", {
		get: A.oneOfGetter(t = ["codeFontSize"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_showSidebarBorder", {
		get: A.oneOfGetter(t = ["showSidebarBorder"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_codeTextColor", {
		get: A.oneOfGetter(t = ["codeTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_codeBackgroundColor", {
		get: A.oneOfGetter(t = ["codeBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_dataframeHeaderBackgroundColor", {
		get: A.oneOfGetter(t = ["dataframeHeaderBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_dataframeHeaderTextColor", {
		get: A.oneOfGetter(t = ["dataframeHeaderTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_redColor", {
		get: A.oneOfGetter(t = ["redColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_orangeColor", {
		get: A.oneOfGetter(t = ["orangeColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_yellowColor", {
		get: A.oneOfGetter(t = ["yellowColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_blueColor", {
		get: A.oneOfGetter(t = ["blueColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_greenColor", {
		get: A.oneOfGetter(t = ["greenColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_violetColor", {
		get: A.oneOfGetter(t = ["violetColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_grayColor", {
		get: A.oneOfGetter(t = ["grayColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_redBackgroundColor", {
		get: A.oneOfGetter(t = ["redBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_orangeBackgroundColor", {
		get: A.oneOfGetter(t = ["orangeBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_yellowBackgroundColor", {
		get: A.oneOfGetter(t = ["yellowBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_blueBackgroundColor", {
		get: A.oneOfGetter(t = ["blueBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_greenBackgroundColor", {
		get: A.oneOfGetter(t = ["greenBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_violetBackgroundColor", {
		get: A.oneOfGetter(t = ["violetBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_grayBackgroundColor", {
		get: A.oneOfGetter(t = ["grayBackgroundColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_redTextColor", {
		get: A.oneOfGetter(t = ["redTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_orangeTextColor", {
		get: A.oneOfGetter(t = ["orangeTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_yellowTextColor", {
		get: A.oneOfGetter(t = ["yellowTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_blueTextColor", {
		get: A.oneOfGetter(t = ["blueTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_greenTextColor", {
		get: A.oneOfGetter(t = ["greenTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_violetTextColor", {
		get: A.oneOfGetter(t = ["violetTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_grayTextColor", {
		get: A.oneOfGetter(t = ["grayTextColor"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_metricValueFontSize", {
		get: A.oneOfGetter(t = ["metricValueFontSize"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_metricValueFontWeight", {
		get: A.oneOfGetter(t = ["metricValueFontWeight"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_sidebar", {
		get: A.oneOfGetter(t = ["sidebar"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_light", {
		get: A.oneOfGetter(t = ["light"]),
		set: A.oneOfSetter(t)
	}), j.defineProperty(e.prototype, "_dark", {
		get: A.oneOfGetter(t = ["dark"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.primaryColor != null && j.hasOwnProperty.call(e, "primaryColor") && e.primaryColor !== "" && t.uint32(10).string(e.primaryColor), e.secondaryBackgroundColor != null && j.hasOwnProperty.call(e, "secondaryBackgroundColor") && e.secondaryBackgroundColor !== "" && t.uint32(18).string(e.secondaryBackgroundColor), e.backgroundColor != null && j.hasOwnProperty.call(e, "backgroundColor") && e.backgroundColor !== "" && t.uint32(26).string(e.backgroundColor), e.textColor != null && j.hasOwnProperty.call(e, "textColor") && e.textColor !== "" && t.uint32(34).string(e.textColor), e.base != null && j.hasOwnProperty.call(e, "base") && e.base !== 0 && t.uint32(48).int32(e.base), e.headingFont != null && j.hasOwnProperty.call(e, "headingFont") && e.headingFont !== "" && t.uint32(98).string(e.headingFont), e.bodyFont != null && j.hasOwnProperty.call(e, "bodyFont") && e.bodyFont !== "" && t.uint32(106).string(e.bodyFont), e.codeFont != null && j.hasOwnProperty.call(e, "codeFont") && e.codeFont !== "" && t.uint32(114).string(e.codeFont), e.fontFaces != null && e.fontFaces.length) for (let r = 0; r < e.fontFaces.length; ++r) U.FontFace.encode(e.fontFaces[r], t.uint32(122).fork(), n + 1).ldelim();
		if (e.baseRadius != null && j.hasOwnProperty.call(e, "baseRadius") && t.uint32(146).string(e.baseRadius), e.borderColor != null && j.hasOwnProperty.call(e, "borderColor") && t.uint32(154).string(e.borderColor), e.showWidgetBorder != null && j.hasOwnProperty.call(e, "showWidgetBorder") && t.uint32(160).bool(e.showWidgetBorder), e.linkColor != null && j.hasOwnProperty.call(e, "linkColor") && t.uint32(170).string(e.linkColor), e.baseFontSize != null && j.hasOwnProperty.call(e, "baseFontSize") && t.uint32(176).int32(e.baseFontSize), e.showSidebarBorder != null && j.hasOwnProperty.call(e, "showSidebarBorder") && t.uint32(184).bool(e.showSidebarBorder), e.sidebar != null && j.hasOwnProperty.call(e, "sidebar") && U.CustomThemeConfig.encode(e.sidebar, t.uint32(194).fork(), n + 1).ldelim(), e.codeBackgroundColor != null && j.hasOwnProperty.call(e, "codeBackgroundColor") && t.uint32(202).string(e.codeBackgroundColor), e.buttonRadius != null && j.hasOwnProperty.call(e, "buttonRadius") && t.uint32(210).string(e.buttonRadius), e.dataframeBorderColor != null && j.hasOwnProperty.call(e, "dataframeBorderColor") && t.uint32(218).string(e.dataframeBorderColor), e.codeFontSize != null && j.hasOwnProperty.call(e, "codeFontSize") && t.uint32(226).string(e.codeFontSize), e.linkUnderline != null && j.hasOwnProperty.call(e, "linkUnderline") && t.uint32(232).bool(e.linkUnderline), e.baseFontWeight != null && j.hasOwnProperty.call(e, "baseFontWeight") && t.uint32(240).int32(e.baseFontWeight), e.dataframeHeaderBackgroundColor != null && j.hasOwnProperty.call(e, "dataframeHeaderBackgroundColor") && t.uint32(250).string(e.dataframeHeaderBackgroundColor), e.codeFontWeight != null && j.hasOwnProperty.call(e, "codeFontWeight") && t.uint32(256).int32(e.codeFontWeight), e.chartCategoricalColors != null && e.chartCategoricalColors.length) for (let n = 0; n < e.chartCategoricalColors.length; ++n) t.uint32(266).string(e.chartCategoricalColors[n]);
		if (e.headingFontWeights != null && e.headingFontWeights.length && t.uint32(274).int32s(e.headingFontWeights), e.headingFontSizes != null && e.headingFontSizes.length) for (let n = 0; n < e.headingFontSizes.length; ++n) t.uint32(282).string(e.headingFontSizes[n]);
		if (e.chartSequentialColors != null && e.chartSequentialColors.length) for (let n = 0; n < e.chartSequentialColors.length; ++n) t.uint32(290).string(e.chartSequentialColors[n]);
		if (e.fontSources != null && e.fontSources.length) for (let r = 0; r < e.fontSources.length; ++r) U.FontSource.encode(e.fontSources[r], t.uint32(298).fork(), n + 1).ldelim();
		if (e.redColor != null && j.hasOwnProperty.call(e, "redColor") && t.uint32(306).string(e.redColor), e.orangeColor != null && j.hasOwnProperty.call(e, "orangeColor") && t.uint32(314).string(e.orangeColor), e.yellowColor != null && j.hasOwnProperty.call(e, "yellowColor") && t.uint32(322).string(e.yellowColor), e.blueColor != null && j.hasOwnProperty.call(e, "blueColor") && t.uint32(330).string(e.blueColor), e.greenColor != null && j.hasOwnProperty.call(e, "greenColor") && t.uint32(338).string(e.greenColor), e.violetColor != null && j.hasOwnProperty.call(e, "violetColor") && t.uint32(346).string(e.violetColor), e.grayColor != null && j.hasOwnProperty.call(e, "grayColor") && t.uint32(354).string(e.grayColor), e.redBackgroundColor != null && j.hasOwnProperty.call(e, "redBackgroundColor") && t.uint32(362).string(e.redBackgroundColor), e.orangeBackgroundColor != null && j.hasOwnProperty.call(e, "orangeBackgroundColor") && t.uint32(370).string(e.orangeBackgroundColor), e.yellowBackgroundColor != null && j.hasOwnProperty.call(e, "yellowBackgroundColor") && t.uint32(378).string(e.yellowBackgroundColor), e.blueBackgroundColor != null && j.hasOwnProperty.call(e, "blueBackgroundColor") && t.uint32(386).string(e.blueBackgroundColor), e.greenBackgroundColor != null && j.hasOwnProperty.call(e, "greenBackgroundColor") && t.uint32(394).string(e.greenBackgroundColor), e.violetBackgroundColor != null && j.hasOwnProperty.call(e, "violetBackgroundColor") && t.uint32(402).string(e.violetBackgroundColor), e.grayBackgroundColor != null && j.hasOwnProperty.call(e, "grayBackgroundColor") && t.uint32(410).string(e.grayBackgroundColor), e.redTextColor != null && j.hasOwnProperty.call(e, "redTextColor") && t.uint32(418).string(e.redTextColor), e.orangeTextColor != null && j.hasOwnProperty.call(e, "orangeTextColor") && t.uint32(426).string(e.orangeTextColor), e.yellowTextColor != null && j.hasOwnProperty.call(e, "yellowTextColor") && t.uint32(434).string(e.yellowTextColor), e.blueTextColor != null && j.hasOwnProperty.call(e, "blueTextColor") && t.uint32(442).string(e.blueTextColor), e.greenTextColor != null && j.hasOwnProperty.call(e, "greenTextColor") && t.uint32(450).string(e.greenTextColor), e.violetTextColor != null && j.hasOwnProperty.call(e, "violetTextColor") && t.uint32(458).string(e.violetTextColor), e.grayTextColor != null && j.hasOwnProperty.call(e, "grayTextColor") && t.uint32(466).string(e.grayTextColor), e.codeTextColor != null && j.hasOwnProperty.call(e, "codeTextColor") && t.uint32(474).string(e.codeTextColor), e.light != null && j.hasOwnProperty.call(e, "light") && U.CustomThemeConfig.encode(e.light, t.uint32(482).fork(), n + 1).ldelim(), e.dark != null && j.hasOwnProperty.call(e, "dark") && U.CustomThemeConfig.encode(e.dark, t.uint32(490).fork(), n + 1).ldelim(), e.chartDivergingColors != null && e.chartDivergingColors.length) for (let n = 0; n < e.chartDivergingColors.length; ++n) t.uint32(498).string(e.chartDivergingColors[n]);
		if (e.metricValueFontSize != null && j.hasOwnProperty.call(e, "metricValueFontSize") && t.uint32(514).string(e.metricValueFontSize), e.metricValueFontWeight != null && j.hasOwnProperty.call(e, "metricValueFontWeight") && t.uint32(520).int32(e.metricValueFontWeight), e.dataframeHeaderTextColor != null && j.hasOwnProperty.call(e, "dataframeHeaderTextColor") && t.uint32(530).string(e.dataframeHeaderTextColor), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.CustomThemeConfig(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.primaryColor = s : delete o.primaryColor;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.secondaryBackgroundColor = s : delete o.secondaryBackgroundColor;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.backgroundColor = s : delete o.backgroundColor;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.textColor = s : delete o.textColor;
					continue;
				case 6:
					if (a !== 0) break;
					(s = e.int32()) ? o.base = s : delete o.base;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.headingFont = s : delete o.headingFont;
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.bodyFont = s : delete o.bodyFont;
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.codeFont = s : delete o.codeFont;
					continue;
				case 15:
					if (a !== 2) break;
					o.fontFaces && o.fontFaces.length || (o.fontFaces = []), o.fontFaces.push(U.FontFace.decode(e, e.uint32(), M, r + 1));
					continue;
				case 37:
					if (a !== 2) break;
					o.fontSources && o.fontSources.length || (o.fontSources = []), o.fontSources.push(U.FontSource.decode(e, e.uint32(), M, r + 1));
					continue;
				case 18:
					if (a !== 2) break;
					o.baseRadius = e.stringVerify(), o._baseRadius = "baseRadius";
					continue;
				case 26:
					if (a !== 2) break;
					o.buttonRadius = e.stringVerify(), o._buttonRadius = "buttonRadius";
					continue;
				case 19:
					if (a !== 2) break;
					o.borderColor = e.stringVerify(), o._borderColor = "borderColor";
					continue;
				case 27:
					if (a !== 2) break;
					o.dataframeBorderColor = e.stringVerify(), o._dataframeBorderColor = "dataframeBorderColor";
					continue;
				case 20:
					if (a !== 0) break;
					o.showWidgetBorder = e.bool(), o._showWidgetBorder = "showWidgetBorder";
					continue;
				case 21:
					if (a !== 2) break;
					o.linkColor = e.stringVerify(), o._linkColor = "linkColor";
					continue;
				case 29:
					if (a !== 0) break;
					o.linkUnderline = e.bool(), o._linkUnderline = "linkUnderline";
					continue;
				case 22:
					if (a !== 0) break;
					o.baseFontSize = e.int32(), o._baseFontSize = "baseFontSize";
					continue;
				case 30:
					if (a !== 0) break;
					o.baseFontWeight = e.int32(), o._baseFontWeight = "baseFontWeight";
					continue;
				case 32:
					if (a !== 0) break;
					o.codeFontWeight = e.int32(), o._codeFontWeight = "codeFontWeight";
					continue;
				case 28:
					if (a !== 2) break;
					o.codeFontSize = e.stringVerify(), o._codeFontSize = "codeFontSize";
					continue;
				case 35:
					if (a !== 2) break;
					o.headingFontSizes && o.headingFontSizes.length || (o.headingFontSizes = []), o.headingFontSizes.push(e.stringVerify());
					continue;
				case 34:
					if (a === 2) {
						o.headingFontWeights && o.headingFontWeights.length || (o.headingFontWeights = []), e.int32s(o.headingFontWeights);
						continue;
					}
					if (a !== 0) break;
					o.headingFontWeights && o.headingFontWeights.length || (o.headingFontWeights = []), o.headingFontWeights.push(e.int32());
					continue;
				case 23:
					if (a !== 0) break;
					o.showSidebarBorder = e.bool(), o._showSidebarBorder = "showSidebarBorder";
					continue;
				case 59:
					if (a !== 2) break;
					o.codeTextColor = e.stringVerify(), o._codeTextColor = "codeTextColor";
					continue;
				case 25:
					if (a !== 2) break;
					o.codeBackgroundColor = e.stringVerify(), o._codeBackgroundColor = "codeBackgroundColor";
					continue;
				case 31:
					if (a !== 2) break;
					o.dataframeHeaderBackgroundColor = e.stringVerify(), o._dataframeHeaderBackgroundColor = "dataframeHeaderBackgroundColor";
					continue;
				case 66:
					if (a !== 2) break;
					o.dataframeHeaderTextColor = e.stringVerify(), o._dataframeHeaderTextColor = "dataframeHeaderTextColor";
					continue;
				case 33:
					if (a !== 2) break;
					o.chartCategoricalColors && o.chartCategoricalColors.length || (o.chartCategoricalColors = []), o.chartCategoricalColors.push(e.stringVerify());
					continue;
				case 36:
					if (a !== 2) break;
					o.chartSequentialColors && o.chartSequentialColors.length || (o.chartSequentialColors = []), o.chartSequentialColors.push(e.stringVerify());
					continue;
				case 62:
					if (a !== 2) break;
					o.chartDivergingColors && o.chartDivergingColors.length || (o.chartDivergingColors = []), o.chartDivergingColors.push(e.stringVerify());
					continue;
				case 38:
					if (a !== 2) break;
					o.redColor = e.stringVerify(), o._redColor = "redColor";
					continue;
				case 39:
					if (a !== 2) break;
					o.orangeColor = e.stringVerify(), o._orangeColor = "orangeColor";
					continue;
				case 40:
					if (a !== 2) break;
					o.yellowColor = e.stringVerify(), o._yellowColor = "yellowColor";
					continue;
				case 41:
					if (a !== 2) break;
					o.blueColor = e.stringVerify(), o._blueColor = "blueColor";
					continue;
				case 42:
					if (a !== 2) break;
					o.greenColor = e.stringVerify(), o._greenColor = "greenColor";
					continue;
				case 43:
					if (a !== 2) break;
					o.violetColor = e.stringVerify(), o._violetColor = "violetColor";
					continue;
				case 44:
					if (a !== 2) break;
					o.grayColor = e.stringVerify(), o._grayColor = "grayColor";
					continue;
				case 45:
					if (a !== 2) break;
					o.redBackgroundColor = e.stringVerify(), o._redBackgroundColor = "redBackgroundColor";
					continue;
				case 46:
					if (a !== 2) break;
					o.orangeBackgroundColor = e.stringVerify(), o._orangeBackgroundColor = "orangeBackgroundColor";
					continue;
				case 47:
					if (a !== 2) break;
					o.yellowBackgroundColor = e.stringVerify(), o._yellowBackgroundColor = "yellowBackgroundColor";
					continue;
				case 48:
					if (a !== 2) break;
					o.blueBackgroundColor = e.stringVerify(), o._blueBackgroundColor = "blueBackgroundColor";
					continue;
				case 49:
					if (a !== 2) break;
					o.greenBackgroundColor = e.stringVerify(), o._greenBackgroundColor = "greenBackgroundColor";
					continue;
				case 50:
					if (a !== 2) break;
					o.violetBackgroundColor = e.stringVerify(), o._violetBackgroundColor = "violetBackgroundColor";
					continue;
				case 51:
					if (a !== 2) break;
					o.grayBackgroundColor = e.stringVerify(), o._grayBackgroundColor = "grayBackgroundColor";
					continue;
				case 52:
					if (a !== 2) break;
					o.redTextColor = e.stringVerify(), o._redTextColor = "redTextColor";
					continue;
				case 53:
					if (a !== 2) break;
					o.orangeTextColor = e.stringVerify(), o._orangeTextColor = "orangeTextColor";
					continue;
				case 54:
					if (a !== 2) break;
					o.yellowTextColor = e.stringVerify(), o._yellowTextColor = "yellowTextColor";
					continue;
				case 55:
					if (a !== 2) break;
					o.blueTextColor = e.stringVerify(), o._blueTextColor = "blueTextColor";
					continue;
				case 56:
					if (a !== 2) break;
					o.greenTextColor = e.stringVerify(), o._greenTextColor = "greenTextColor";
					continue;
				case 57:
					if (a !== 2) break;
					o.violetTextColor = e.stringVerify(), o._violetTextColor = "violetTextColor";
					continue;
				case 58:
					if (a !== 2) break;
					o.grayTextColor = e.stringVerify(), o._grayTextColor = "grayTextColor";
					continue;
				case 64:
					if (a !== 2) break;
					o.metricValueFontSize = e.stringVerify(), o._metricValueFontSize = "metricValueFontSize";
					continue;
				case 65:
					if (a !== 0) break;
					o.metricValueFontWeight = e.int32(), o._metricValueFontWeight = "metricValueFontWeight";
					continue;
				case 24:
					if (a !== 2) break;
					o.sidebar = U.CustomThemeConfig.decode(e, e.uint32(), M, r + 1, o.sidebar), o._sidebar = "sidebar";
					continue;
				case 60:
					if (a !== 2) break;
					o.light = U.CustomThemeConfig.decode(e, e.uint32(), M, r + 1, o.light), o._light = "light";
					continue;
				case 61:
					if (a !== 2) break;
					o.dark = U.CustomThemeConfig.decode(e, e.uint32(), M, r + 1, o.dark), o._dark = "dark";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.CustomThemeConfig) return e;
		if (!A.isObject(e)) throw F(".CustomThemeConfig: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.CustomThemeConfig();
		if (e.primaryColor != null && (typeof e.primaryColor != "string" || e.primaryColor.length) && (n.primaryColor = I(e.primaryColor)), e.secondaryBackgroundColor != null && (typeof e.secondaryBackgroundColor != "string" || e.secondaryBackgroundColor.length) && (n.secondaryBackgroundColor = I(e.secondaryBackgroundColor)), e.backgroundColor != null && (typeof e.backgroundColor != "string" || e.backgroundColor.length) && (n.backgroundColor = I(e.backgroundColor)), e.textColor != null && (typeof e.textColor != "string" || e.textColor.length) && (n.textColor = I(e.textColor)), e.base !== 0 && (typeof e.base != "string" || U.CustomThemeConfig.BaseTheme[e.base] !== 0)) switch (e.base) {
			case "LIGHT":
			case 0:
				n.base = 0;
				break;
			case "DARK":
			case 1:
				n.base = 1;
				break;
			default: typeof e.base == "number" && (e.base | 0) === e.base && (n.base = e.base);
		}
		if (e.headingFont != null && (typeof e.headingFont != "string" || e.headingFont.length) && (n.headingFont = I(e.headingFont)), e.bodyFont != null && (typeof e.bodyFont != "string" || e.bodyFont.length) && (n.bodyFont = I(e.bodyFont)), e.codeFont != null && (typeof e.codeFont != "string" || e.codeFont.length) && (n.codeFont = I(e.codeFont)), e.fontFaces) {
			if (!B.isArray(e.fontFaces)) throw F(".CustomThemeConfig.fontFaces: array expected");
			n.fontFaces = B(e.fontFaces.length);
			for (let r = 0; r < e.fontFaces.length; ++r) {
				if (!A.isObject(e.fontFaces[r])) throw F(".CustomThemeConfig.fontFaces: object expected");
				n.fontFaces[r] = U.FontFace.fromObject(e.fontFaces[r], t + 1);
			}
		}
		if (e.fontSources) {
			if (!B.isArray(e.fontSources)) throw F(".CustomThemeConfig.fontSources: array expected");
			n.fontSources = B(e.fontSources.length);
			for (let r = 0; r < e.fontSources.length; ++r) {
				if (!A.isObject(e.fontSources[r])) throw F(".CustomThemeConfig.fontSources: object expected");
				n.fontSources[r] = U.FontSource.fromObject(e.fontSources[r], t + 1);
			}
		}
		if (e.baseRadius != null && (n.baseRadius = I(e.baseRadius)), e.buttonRadius != null && (n.buttonRadius = I(e.buttonRadius)), e.borderColor != null && (n.borderColor = I(e.borderColor)), e.dataframeBorderColor != null && (n.dataframeBorderColor = I(e.dataframeBorderColor)), e.showWidgetBorder != null && (n.showWidgetBorder = L(e.showWidgetBorder)), e.linkColor != null && (n.linkColor = I(e.linkColor)), e.linkUnderline != null && (n.linkUnderline = L(e.linkUnderline)), e.baseFontSize != null && (n.baseFontSize = e.baseFontSize | 0), e.baseFontWeight != null && (n.baseFontWeight = e.baseFontWeight | 0), e.codeFontWeight != null && (n.codeFontWeight = e.codeFontWeight | 0), e.codeFontSize != null && (n.codeFontSize = I(e.codeFontSize)), e.headingFontSizes) {
			if (!B.isArray(e.headingFontSizes)) throw F(".CustomThemeConfig.headingFontSizes: array expected");
			n.headingFontSizes = B(e.headingFontSizes.length);
			for (let t = 0; t < e.headingFontSizes.length; ++t) n.headingFontSizes[t] = I(e.headingFontSizes[t]);
		}
		if (e.headingFontWeights) {
			if (!B.isArray(e.headingFontWeights)) throw F(".CustomThemeConfig.headingFontWeights: array expected");
			n.headingFontWeights = B(e.headingFontWeights.length);
			for (let t = 0; t < e.headingFontWeights.length; ++t) n.headingFontWeights[t] = e.headingFontWeights[t] | 0;
		}
		if (e.showSidebarBorder != null && (n.showSidebarBorder = L(e.showSidebarBorder)), e.codeTextColor != null && (n.codeTextColor = I(e.codeTextColor)), e.codeBackgroundColor != null && (n.codeBackgroundColor = I(e.codeBackgroundColor)), e.dataframeHeaderBackgroundColor != null && (n.dataframeHeaderBackgroundColor = I(e.dataframeHeaderBackgroundColor)), e.dataframeHeaderTextColor != null && (n.dataframeHeaderTextColor = I(e.dataframeHeaderTextColor)), e.chartCategoricalColors) {
			if (!B.isArray(e.chartCategoricalColors)) throw F(".CustomThemeConfig.chartCategoricalColors: array expected");
			n.chartCategoricalColors = B(e.chartCategoricalColors.length);
			for (let t = 0; t < e.chartCategoricalColors.length; ++t) n.chartCategoricalColors[t] = I(e.chartCategoricalColors[t]);
		}
		if (e.chartSequentialColors) {
			if (!B.isArray(e.chartSequentialColors)) throw F(".CustomThemeConfig.chartSequentialColors: array expected");
			n.chartSequentialColors = B(e.chartSequentialColors.length);
			for (let t = 0; t < e.chartSequentialColors.length; ++t) n.chartSequentialColors[t] = I(e.chartSequentialColors[t]);
		}
		if (e.chartDivergingColors) {
			if (!B.isArray(e.chartDivergingColors)) throw F(".CustomThemeConfig.chartDivergingColors: array expected");
			n.chartDivergingColors = B(e.chartDivergingColors.length);
			for (let t = 0; t < e.chartDivergingColors.length; ++t) n.chartDivergingColors[t] = I(e.chartDivergingColors[t]);
		}
		if (e.redColor != null && (n.redColor = I(e.redColor)), e.orangeColor != null && (n.orangeColor = I(e.orangeColor)), e.yellowColor != null && (n.yellowColor = I(e.yellowColor)), e.blueColor != null && (n.blueColor = I(e.blueColor)), e.greenColor != null && (n.greenColor = I(e.greenColor)), e.violetColor != null && (n.violetColor = I(e.violetColor)), e.grayColor != null && (n.grayColor = I(e.grayColor)), e.redBackgroundColor != null && (n.redBackgroundColor = I(e.redBackgroundColor)), e.orangeBackgroundColor != null && (n.orangeBackgroundColor = I(e.orangeBackgroundColor)), e.yellowBackgroundColor != null && (n.yellowBackgroundColor = I(e.yellowBackgroundColor)), e.blueBackgroundColor != null && (n.blueBackgroundColor = I(e.blueBackgroundColor)), e.greenBackgroundColor != null && (n.greenBackgroundColor = I(e.greenBackgroundColor)), e.violetBackgroundColor != null && (n.violetBackgroundColor = I(e.violetBackgroundColor)), e.grayBackgroundColor != null && (n.grayBackgroundColor = I(e.grayBackgroundColor)), e.redTextColor != null && (n.redTextColor = I(e.redTextColor)), e.orangeTextColor != null && (n.orangeTextColor = I(e.orangeTextColor)), e.yellowTextColor != null && (n.yellowTextColor = I(e.yellowTextColor)), e.blueTextColor != null && (n.blueTextColor = I(e.blueTextColor)), e.greenTextColor != null && (n.greenTextColor = I(e.greenTextColor)), e.violetTextColor != null && (n.violetTextColor = I(e.violetTextColor)), e.grayTextColor != null && (n.grayTextColor = I(e.grayTextColor)), e.metricValueFontSize != null && (n.metricValueFontSize = I(e.metricValueFontSize)), e.metricValueFontWeight != null && (n.metricValueFontWeight = e.metricValueFontWeight | 0), e.sidebar != null) {
			if (!A.isObject(e.sidebar)) throw F(".CustomThemeConfig.sidebar: object expected");
			n.sidebar = U.CustomThemeConfig.fromObject(e.sidebar, t + 1);
		}
		if (e.light != null) {
			if (!A.isObject(e.light)) throw F(".CustomThemeConfig.light: object expected");
			n.light = U.CustomThemeConfig.fromObject(e.light, t + 1);
		}
		if (e.dark != null) {
			if (!A.isObject(e.dark)) throw F(".CustomThemeConfig.dark: object expected");
			n.dark = U.CustomThemeConfig.fromObject(e.dark, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.fontFaces = [], r.chartCategoricalColors = [], r.headingFontWeights = [], r.headingFontSizes = [], r.chartSequentialColors = [], r.fontSources = [], r.chartDivergingColors = []), t.defaults && (r.primaryColor = "", r.secondaryBackgroundColor = "", r.backgroundColor = "", r.textColor = "", r.base = t.enums === I ? "LIGHT" : 0, r.headingFont = "", r.bodyFont = "", r.codeFont = ""), e.primaryColor != null && j.hasOwnProperty.call(e, "primaryColor") && (r.primaryColor = e.primaryColor), e.secondaryBackgroundColor != null && j.hasOwnProperty.call(e, "secondaryBackgroundColor") && (r.secondaryBackgroundColor = e.secondaryBackgroundColor), e.backgroundColor != null && j.hasOwnProperty.call(e, "backgroundColor") && (r.backgroundColor = e.backgroundColor), e.textColor != null && j.hasOwnProperty.call(e, "textColor") && (r.textColor = e.textColor), e.base != null && j.hasOwnProperty.call(e, "base") && (r.base = t.enums === I ? U.CustomThemeConfig.BaseTheme[e.base] === M ? e.base : U.CustomThemeConfig.BaseTheme[e.base] : e.base), e.headingFont != null && j.hasOwnProperty.call(e, "headingFont") && (r.headingFont = e.headingFont), e.bodyFont != null && j.hasOwnProperty.call(e, "bodyFont") && (r.bodyFont = e.bodyFont), e.codeFont != null && j.hasOwnProperty.call(e, "codeFont") && (r.codeFont = e.codeFont), e.fontFaces && e.fontFaces.length) {
			r.fontFaces = B(e.fontFaces.length);
			for (let i = 0; i < e.fontFaces.length; ++i) r.fontFaces[i] = U.FontFace.toObject(e.fontFaces[i], t, n + 1);
		}
		if (e.baseRadius != null && j.hasOwnProperty.call(e, "baseRadius") && (r.baseRadius = e.baseRadius), e.borderColor != null && j.hasOwnProperty.call(e, "borderColor") && (r.borderColor = e.borderColor), e.showWidgetBorder != null && j.hasOwnProperty.call(e, "showWidgetBorder") && (r.showWidgetBorder = e.showWidgetBorder), e.linkColor != null && j.hasOwnProperty.call(e, "linkColor") && (r.linkColor = e.linkColor), e.baseFontSize != null && j.hasOwnProperty.call(e, "baseFontSize") && (r.baseFontSize = e.baseFontSize), e.showSidebarBorder != null && j.hasOwnProperty.call(e, "showSidebarBorder") && (r.showSidebarBorder = e.showSidebarBorder), e.sidebar != null && j.hasOwnProperty.call(e, "sidebar") && (r.sidebar = U.CustomThemeConfig.toObject(e.sidebar, t, n + 1)), e.codeBackgroundColor != null && j.hasOwnProperty.call(e, "codeBackgroundColor") && (r.codeBackgroundColor = e.codeBackgroundColor), e.buttonRadius != null && j.hasOwnProperty.call(e, "buttonRadius") && (r.buttonRadius = e.buttonRadius), e.dataframeBorderColor != null && j.hasOwnProperty.call(e, "dataframeBorderColor") && (r.dataframeBorderColor = e.dataframeBorderColor), e.codeFontSize != null && j.hasOwnProperty.call(e, "codeFontSize") && (r.codeFontSize = e.codeFontSize), e.linkUnderline != null && j.hasOwnProperty.call(e, "linkUnderline") && (r.linkUnderline = e.linkUnderline), e.baseFontWeight != null && j.hasOwnProperty.call(e, "baseFontWeight") && (r.baseFontWeight = e.baseFontWeight), e.dataframeHeaderBackgroundColor != null && j.hasOwnProperty.call(e, "dataframeHeaderBackgroundColor") && (r.dataframeHeaderBackgroundColor = e.dataframeHeaderBackgroundColor), e.codeFontWeight != null && j.hasOwnProperty.call(e, "codeFontWeight") && (r.codeFontWeight = e.codeFontWeight), e.chartCategoricalColors && e.chartCategoricalColors.length) {
			r.chartCategoricalColors = B(e.chartCategoricalColors.length);
			for (let t = 0; t < e.chartCategoricalColors.length; ++t) r.chartCategoricalColors[t] = e.chartCategoricalColors[t];
		}
		if (e.headingFontWeights && e.headingFontWeights.length) {
			r.headingFontWeights = B(e.headingFontWeights.length);
			for (let t = 0; t < e.headingFontWeights.length; ++t) r.headingFontWeights[t] = e.headingFontWeights[t];
		}
		if (e.headingFontSizes && e.headingFontSizes.length) {
			r.headingFontSizes = B(e.headingFontSizes.length);
			for (let t = 0; t < e.headingFontSizes.length; ++t) r.headingFontSizes[t] = e.headingFontSizes[t];
		}
		if (e.chartSequentialColors && e.chartSequentialColors.length) {
			r.chartSequentialColors = B(e.chartSequentialColors.length);
			for (let t = 0; t < e.chartSequentialColors.length; ++t) r.chartSequentialColors[t] = e.chartSequentialColors[t];
		}
		if (e.fontSources && e.fontSources.length) {
			r.fontSources = B(e.fontSources.length);
			for (let i = 0; i < e.fontSources.length; ++i) r.fontSources[i] = U.FontSource.toObject(e.fontSources[i], t, n + 1);
		}
		if (e.redColor != null && j.hasOwnProperty.call(e, "redColor") && (r.redColor = e.redColor), e.orangeColor != null && j.hasOwnProperty.call(e, "orangeColor") && (r.orangeColor = e.orangeColor), e.yellowColor != null && j.hasOwnProperty.call(e, "yellowColor") && (r.yellowColor = e.yellowColor), e.blueColor != null && j.hasOwnProperty.call(e, "blueColor") && (r.blueColor = e.blueColor), e.greenColor != null && j.hasOwnProperty.call(e, "greenColor") && (r.greenColor = e.greenColor), e.violetColor != null && j.hasOwnProperty.call(e, "violetColor") && (r.violetColor = e.violetColor), e.grayColor != null && j.hasOwnProperty.call(e, "grayColor") && (r.grayColor = e.grayColor), e.redBackgroundColor != null && j.hasOwnProperty.call(e, "redBackgroundColor") && (r.redBackgroundColor = e.redBackgroundColor), e.orangeBackgroundColor != null && j.hasOwnProperty.call(e, "orangeBackgroundColor") && (r.orangeBackgroundColor = e.orangeBackgroundColor), e.yellowBackgroundColor != null && j.hasOwnProperty.call(e, "yellowBackgroundColor") && (r.yellowBackgroundColor = e.yellowBackgroundColor), e.blueBackgroundColor != null && j.hasOwnProperty.call(e, "blueBackgroundColor") && (r.blueBackgroundColor = e.blueBackgroundColor), e.greenBackgroundColor != null && j.hasOwnProperty.call(e, "greenBackgroundColor") && (r.greenBackgroundColor = e.greenBackgroundColor), e.violetBackgroundColor != null && j.hasOwnProperty.call(e, "violetBackgroundColor") && (r.violetBackgroundColor = e.violetBackgroundColor), e.grayBackgroundColor != null && j.hasOwnProperty.call(e, "grayBackgroundColor") && (r.grayBackgroundColor = e.grayBackgroundColor), e.redTextColor != null && j.hasOwnProperty.call(e, "redTextColor") && (r.redTextColor = e.redTextColor), e.orangeTextColor != null && j.hasOwnProperty.call(e, "orangeTextColor") && (r.orangeTextColor = e.orangeTextColor), e.yellowTextColor != null && j.hasOwnProperty.call(e, "yellowTextColor") && (r.yellowTextColor = e.yellowTextColor), e.blueTextColor != null && j.hasOwnProperty.call(e, "blueTextColor") && (r.blueTextColor = e.blueTextColor), e.greenTextColor != null && j.hasOwnProperty.call(e, "greenTextColor") && (r.greenTextColor = e.greenTextColor), e.violetTextColor != null && j.hasOwnProperty.call(e, "violetTextColor") && (r.violetTextColor = e.violetTextColor), e.grayTextColor != null && j.hasOwnProperty.call(e, "grayTextColor") && (r.grayTextColor = e.grayTextColor), e.codeTextColor != null && j.hasOwnProperty.call(e, "codeTextColor") && (r.codeTextColor = e.codeTextColor), e.light != null && j.hasOwnProperty.call(e, "light") && (r.light = U.CustomThemeConfig.toObject(e.light, t, n + 1)), e.dark != null && j.hasOwnProperty.call(e, "dark") && (r.dark = U.CustomThemeConfig.toObject(e.dark, t, n + 1)), e.chartDivergingColors && e.chartDivergingColors.length) {
			r.chartDivergingColors = B(e.chartDivergingColors.length);
			for (let t = 0; t < e.chartDivergingColors.length; ++t) r.chartDivergingColors[t] = e.chartDivergingColors[t];
		}
		return e.metricValueFontSize != null && j.hasOwnProperty.call(e, "metricValueFontSize") && (r.metricValueFontSize = e.metricValueFontSize), e.metricValueFontWeight != null && j.hasOwnProperty.call(e, "metricValueFontWeight") && (r.metricValueFontWeight = e.metricValueFontWeight), e.dataframeHeaderTextColor != null && j.hasOwnProperty.call(e, "dataframeHeaderTextColor") && (r.dataframeHeaderTextColor = e.dataframeHeaderTextColor), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/CustomThemeConfig";
	}, e.BaseTheme = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "LIGHT"] = 0, t[e[1] = "DARK"] = 1, t;
	})(), e;
})(), U.FontFace = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.url = "", e.prototype.family = "", e.prototype.weightRange = "", e.prototype.style = "", e.prototype.unicodeRange = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.url != null && j.hasOwnProperty.call(e, "url") && e.url !== "" && t.uint32(10).string(e.url), e.family != null && j.hasOwnProperty.call(e, "family") && e.family !== "" && t.uint32(18).string(e.family), e.style != null && j.hasOwnProperty.call(e, "style") && e.style !== "" && t.uint32(34).string(e.style), e.weightRange != null && j.hasOwnProperty.call(e, "weightRange") && e.weightRange !== "" && t.uint32(42).string(e.weightRange), e.unicodeRange != null && j.hasOwnProperty.call(e, "unicodeRange") && e.unicodeRange !== "" && t.uint32(50).string(e.unicodeRange), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FontFace(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.url = s : delete o.url;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.family = s : delete o.family;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.weightRange = s : delete o.weightRange;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.style = s : delete o.style;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.unicodeRange = s : delete o.unicodeRange;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FontFace) return e;
		if (!A.isObject(e)) throw F(".FontFace: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FontFace();
		return e.url != null && (typeof e.url != "string" || e.url.length) && (n.url = I(e.url)), e.family != null && (typeof e.family != "string" || e.family.length) && (n.family = I(e.family)), e.weightRange != null && (typeof e.weightRange != "string" || e.weightRange.length) && (n.weightRange = I(e.weightRange)), e.style != null && (typeof e.style != "string" || e.style.length) && (n.style = I(e.style)), e.unicodeRange != null && (typeof e.unicodeRange != "string" || e.unicodeRange.length) && (n.unicodeRange = I(e.unicodeRange)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.url = "", r.family = "", r.style = "", r.weightRange = "", r.unicodeRange = ""), e.url != null && j.hasOwnProperty.call(e, "url") && (r.url = e.url), e.family != null && j.hasOwnProperty.call(e, "family") && (r.family = e.family), e.style != null && j.hasOwnProperty.call(e, "style") && (r.style = e.style), e.weightRange != null && j.hasOwnProperty.call(e, "weightRange") && (r.weightRange = e.weightRange), e.unicodeRange != null && j.hasOwnProperty.call(e, "unicodeRange") && (r.unicodeRange = e.unicodeRange), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FontFace";
	}, e;
})(), U.FontSource = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.configName = "", e.prototype.sourceUrl = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.configName != null && j.hasOwnProperty.call(e, "configName") && e.configName !== "" && t.uint32(10).string(e.configName), e.sourceUrl != null && j.hasOwnProperty.call(e, "sourceUrl") && e.sourceUrl !== "" && t.uint32(18).string(e.sourceUrl), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.FontSource(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.configName = s : delete o.configName;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sourceUrl = s : delete o.sourceUrl;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.FontSource) return e;
		if (!A.isObject(e)) throw F(".FontSource: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.FontSource();
		return e.configName != null && (typeof e.configName != "string" || e.configName.length) && (n.configName = I(e.configName)), e.sourceUrl != null && (typeof e.sourceUrl != "string" || e.sourceUrl.length) && (n.sourceUrl = I(e.sourceUrl)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.configName = "", r.sourceUrl = ""), e.configName != null && j.hasOwnProperty.call(e, "configName") && (r.configName = e.configName), e.sourceUrl != null && j.hasOwnProperty.call(e, "sourceUrl") && (r.sourceUrl = e.sourceUrl), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/FontSource";
	}, e;
})(), U.UserInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.installationId = "", e.prototype.installationIdV3 = "", e.prototype.installationIdV4 = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.installationId != null && j.hasOwnProperty.call(e, "installationId") && e.installationId !== "" && t.uint32(10).string(e.installationId), e.installationIdV3 != null && j.hasOwnProperty.call(e, "installationIdV3") && e.installationIdV3 !== "" && t.uint32(42).string(e.installationIdV3), e.installationIdV4 != null && j.hasOwnProperty.call(e, "installationIdV4") && e.installationIdV4 !== "" && t.uint32(50).string(e.installationIdV4), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.UserInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.installationId = s : delete o.installationId;
					continue;
				case 5:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.installationIdV3 = s : delete o.installationIdV3;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.installationIdV4 = s : delete o.installationIdV4;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.UserInfo) return e;
		if (!A.isObject(e)) throw F(".UserInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.UserInfo();
		return e.installationId != null && (typeof e.installationId != "string" || e.installationId.length) && (n.installationId = I(e.installationId)), e.installationIdV3 != null && (typeof e.installationIdV3 != "string" || e.installationIdV3.length) && (n.installationIdV3 = I(e.installationIdV3)), e.installationIdV4 != null && (typeof e.installationIdV4 != "string" || e.installationIdV4.length) && (n.installationIdV4 = I(e.installationIdV4)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.installationId = "", r.installationIdV3 = "", r.installationIdV4 = ""), e.installationId != null && j.hasOwnProperty.call(e, "installationId") && (r.installationId = e.installationId), e.installationIdV3 != null && j.hasOwnProperty.call(e, "installationIdV3") && (r.installationIdV3 = e.installationIdV3), e.installationIdV4 != null && j.hasOwnProperty.call(e, "installationIdV4") && (r.installationIdV4 = e.installationIdV4), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/UserInfo";
	}, e;
})(), U.EnvironmentInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.streamlitVersion = "", e.prototype.pythonVersion = "", e.prototype.serverOs = "", e.prototype.hasDisplay = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.streamlitVersion != null && j.hasOwnProperty.call(e, "streamlitVersion") && e.streamlitVersion !== "" && t.uint32(10).string(e.streamlitVersion), e.pythonVersion != null && j.hasOwnProperty.call(e, "pythonVersion") && e.pythonVersion !== "" && t.uint32(18).string(e.pythonVersion), e.serverOs != null && j.hasOwnProperty.call(e, "serverOs") && e.serverOs !== "" && t.uint32(26).string(e.serverOs), e.hasDisplay != null && j.hasOwnProperty.call(e, "hasDisplay") && e.hasDisplay !== !1 && t.uint32(32).bool(e.hasDisplay), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.EnvironmentInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.streamlitVersion = s : delete o.streamlitVersion;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pythonVersion = s : delete o.pythonVersion;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.serverOs = s : delete o.serverOs;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasDisplay = s : delete o.hasDisplay;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.EnvironmentInfo) return e;
		if (!A.isObject(e)) throw F(".EnvironmentInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.EnvironmentInfo();
		return e.streamlitVersion != null && (typeof e.streamlitVersion != "string" || e.streamlitVersion.length) && (n.streamlitVersion = I(e.streamlitVersion)), e.pythonVersion != null && (typeof e.pythonVersion != "string" || e.pythonVersion.length) && (n.pythonVersion = I(e.pythonVersion)), e.serverOs != null && (typeof e.serverOs != "string" || e.serverOs.length) && (n.serverOs = I(e.serverOs)), e.hasDisplay != null && e.hasDisplay && (n.hasDisplay = L(e.hasDisplay)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.streamlitVersion = "", r.pythonVersion = "", r.serverOs = "", r.hasDisplay = !1), e.streamlitVersion != null && j.hasOwnProperty.call(e, "streamlitVersion") && (r.streamlitVersion = e.streamlitVersion), e.pythonVersion != null && j.hasOwnProperty.call(e, "pythonVersion") && (r.pythonVersion = e.pythonVersion), e.serverOs != null && j.hasOwnProperty.call(e, "serverOs") && (r.serverOs = e.serverOs), e.hasDisplay != null && j.hasOwnProperty.call(e, "hasDisplay") && (r.hasDisplay = e.hasDisplay), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/EnvironmentInfo";
	}, e;
})(), U.SessionStatus = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.runOnSave = !1, e.prototype.scriptIsRunning = !1, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.runOnSave != null && j.hasOwnProperty.call(e, "runOnSave") && e.runOnSave !== !1 && t.uint32(8).bool(e.runOnSave), e.scriptIsRunning != null && j.hasOwnProperty.call(e, "scriptIsRunning") && e.scriptIsRunning !== !1 && t.uint32(16).bool(e.scriptIsRunning), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SessionStatus(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					(s = e.bool()) ? o.runOnSave = s : delete o.runOnSave;
					continue;
				case 2:
					if (a !== 0) break;
					(s = e.bool()) ? o.scriptIsRunning = s : delete o.scriptIsRunning;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SessionStatus) return e;
		if (!A.isObject(e)) throw F(".SessionStatus: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SessionStatus();
		return e.runOnSave != null && e.runOnSave && (n.runOnSave = L(e.runOnSave)), e.scriptIsRunning != null && e.scriptIsRunning && (n.scriptIsRunning = L(e.scriptIsRunning)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.runOnSave = !1, r.scriptIsRunning = !1), e.runOnSave != null && j.hasOwnProperty.call(e, "runOnSave") && (r.runOnSave = e.runOnSave), e.scriptIsRunning != null && j.hasOwnProperty.call(e, "scriptIsRunning") && (r.scriptIsRunning = e.scriptIsRunning), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SessionStatus";
	}, e;
})(), U.PageConfig = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.title = "", e.prototype.favicon = "", e.prototype.layout = 0, e.prototype.initialSidebarState = 0, e.prototype.menuItems = null, e.prototype.initialSidebarWidth = null;
	let t;
	return j.defineProperty(e.prototype, "_initialSidebarWidth", {
		get: A.oneOfGetter(t = ["initialSidebarWidth"]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.title != null && j.hasOwnProperty.call(e, "title") && e.title !== "" && t.uint32(10).string(e.title), e.favicon != null && j.hasOwnProperty.call(e, "favicon") && e.favicon !== "" && t.uint32(18).string(e.favicon), e.layout != null && j.hasOwnProperty.call(e, "layout") && e.layout !== 0 && t.uint32(24).int32(e.layout), e.initialSidebarState != null && j.hasOwnProperty.call(e, "initialSidebarState") && e.initialSidebarState !== 0 && t.uint32(32).int32(e.initialSidebarState), e.menuItems != null && j.hasOwnProperty.call(e, "menuItems") && U.PageConfig.MenuItems.encode(e.menuItems, t.uint32(42).fork(), n + 1).ldelim(), e.initialSidebarWidth != null && j.hasOwnProperty.call(e, "initialSidebarWidth") && U.PageConfig.SidebarWidthConfig.encode(e.initialSidebarWidth, t.uint32(50).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PageConfig(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.title = s : delete o.title;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.favicon = s : delete o.favicon;
					continue;
				case 3:
					if (a !== 0) break;
					(s = e.int32()) ? o.layout = s : delete o.layout;
					continue;
				case 4:
					if (a !== 0) break;
					(s = e.int32()) ? o.initialSidebarState = s : delete o.initialSidebarState;
					continue;
				case 5:
					if (a !== 2) break;
					o.menuItems = U.PageConfig.MenuItems.decode(e, e.uint32(), M, r + 1, o.menuItems);
					continue;
				case 6:
					if (a !== 2) break;
					o.initialSidebarWidth = U.PageConfig.SidebarWidthConfig.decode(e, e.uint32(), M, r + 1, o.initialSidebarWidth), o._initialSidebarWidth = "initialSidebarWidth";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PageConfig) return e;
		if (!A.isObject(e)) throw F(".PageConfig: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PageConfig();
		if (e.title != null && (typeof e.title != "string" || e.title.length) && (n.title = I(e.title)), e.favicon != null && (typeof e.favicon != "string" || e.favicon.length) && (n.favicon = I(e.favicon)), e.layout !== 0 && (typeof e.layout != "string" || U.PageConfig.Layout[e.layout] !== 0)) switch (e.layout) {
			case "CENTERED":
			case 0:
				n.layout = 0;
				break;
			case "WIDE":
			case 1:
				n.layout = 1;
				break;
			case "LAYOUT_UNSET":
			case 2:
				n.layout = 2;
				break;
			default: typeof e.layout == "number" && (e.layout | 0) === e.layout && (n.layout = e.layout);
		}
		if (e.initialSidebarState !== 0 && (typeof e.initialSidebarState != "string" || U.PageConfig.SidebarState[e.initialSidebarState] !== 0)) switch (e.initialSidebarState) {
			case "AUTO":
			case 0:
				n.initialSidebarState = 0;
				break;
			case "EXPANDED":
			case 1:
				n.initialSidebarState = 1;
				break;
			case "COLLAPSED":
			case 2:
				n.initialSidebarState = 2;
				break;
			case "SIDEBAR_UNSET":
			case 3:
				n.initialSidebarState = 3;
				break;
			case "LOCKED":
			case 4:
				n.initialSidebarState = 4;
				break;
			default: typeof e.initialSidebarState == "number" && (e.initialSidebarState | 0) === e.initialSidebarState && (n.initialSidebarState = e.initialSidebarState);
		}
		if (e.menuItems != null) {
			if (!A.isObject(e.menuItems)) throw F(".PageConfig.menuItems: object expected");
			n.menuItems = U.PageConfig.MenuItems.fromObject(e.menuItems, t + 1);
		}
		if (e.initialSidebarWidth != null) {
			if (!A.isObject(e.initialSidebarWidth)) throw F(".PageConfig.initialSidebarWidth: object expected");
			n.initialSidebarWidth = U.PageConfig.SidebarWidthConfig.fromObject(e.initialSidebarWidth, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.title = "", r.favicon = "", r.layout = t.enums === I ? "CENTERED" : 0, r.initialSidebarState = t.enums === I ? "AUTO" : 0, r.menuItems = null), e.title != null && j.hasOwnProperty.call(e, "title") && (r.title = e.title), e.favicon != null && j.hasOwnProperty.call(e, "favicon") && (r.favicon = e.favicon), e.layout != null && j.hasOwnProperty.call(e, "layout") && (r.layout = t.enums === I ? U.PageConfig.Layout[e.layout] === M ? e.layout : U.PageConfig.Layout[e.layout] : e.layout), e.initialSidebarState != null && j.hasOwnProperty.call(e, "initialSidebarState") && (r.initialSidebarState = t.enums === I ? U.PageConfig.SidebarState[e.initialSidebarState] === M ? e.initialSidebarState : U.PageConfig.SidebarState[e.initialSidebarState] : e.initialSidebarState), e.menuItems != null && j.hasOwnProperty.call(e, "menuItems") && (r.menuItems = U.PageConfig.MenuItems.toObject(e.menuItems, t, n + 1)), e.initialSidebarWidth != null && j.hasOwnProperty.call(e, "initialSidebarWidth") && (r.initialSidebarWidth = U.PageConfig.SidebarWidthConfig.toObject(e.initialSidebarWidth, t, n + 1)), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PageConfig";
	}, e.MenuItems = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.getHelpUrl = "", e.prototype.hideGetHelp = !1, e.prototype.reportABugUrl = "", e.prototype.hideReportABug = !1, e.prototype.aboutSectionMd = "", e.prototype.clearAboutMd = !1, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.getHelpUrl != null && j.hasOwnProperty.call(e, "getHelpUrl") && e.getHelpUrl !== "" && t.uint32(10).string(e.getHelpUrl), e.hideGetHelp != null && j.hasOwnProperty.call(e, "hideGetHelp") && e.hideGetHelp !== !1 && t.uint32(16).bool(e.hideGetHelp), e.reportABugUrl != null && j.hasOwnProperty.call(e, "reportABugUrl") && e.reportABugUrl !== "" && t.uint32(26).string(e.reportABugUrl), e.hideReportABug != null && j.hasOwnProperty.call(e, "hideReportABug") && e.hideReportABug !== !1 && t.uint32(32).bool(e.hideReportABug), e.aboutSectionMd != null && j.hasOwnProperty.call(e, "aboutSectionMd") && e.aboutSectionMd !== "" && t.uint32(42).string(e.aboutSectionMd), e.clearAboutMd != null && j.hasOwnProperty.call(e, "clearAboutMd") && e.clearAboutMd !== !1 && t.uint32(48).bool(e.clearAboutMd), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.PageConfig.MenuItems(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.getHelpUrl = s : delete o.getHelpUrl;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.bool()) ? o.hideGetHelp = s : delete o.hideGetHelp;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.reportABugUrl = s : delete o.reportABugUrl;
						continue;
					case 4:
						if (a !== 0) break;
						(s = e.bool()) ? o.hideReportABug = s : delete o.hideReportABug;
						continue;
					case 5:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.aboutSectionMd = s : delete o.aboutSectionMd;
						continue;
					case 6:
						if (a !== 0) break;
						(s = e.bool()) ? o.clearAboutMd = s : delete o.clearAboutMd;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.PageConfig.MenuItems) return e;
			if (!A.isObject(e)) throw F(".PageConfig.MenuItems: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.PageConfig.MenuItems();
			return e.getHelpUrl != null && (typeof e.getHelpUrl != "string" || e.getHelpUrl.length) && (n.getHelpUrl = I(e.getHelpUrl)), e.hideGetHelp != null && e.hideGetHelp && (n.hideGetHelp = L(e.hideGetHelp)), e.reportABugUrl != null && (typeof e.reportABugUrl != "string" || e.reportABugUrl.length) && (n.reportABugUrl = I(e.reportABugUrl)), e.hideReportABug != null && e.hideReportABug && (n.hideReportABug = L(e.hideReportABug)), e.aboutSectionMd != null && (typeof e.aboutSectionMd != "string" || e.aboutSectionMd.length) && (n.aboutSectionMd = I(e.aboutSectionMd)), e.clearAboutMd != null && e.clearAboutMd && (n.clearAboutMd = L(e.clearAboutMd)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.getHelpUrl = "", r.hideGetHelp = !1, r.reportABugUrl = "", r.hideReportABug = !1, r.aboutSectionMd = "", r.clearAboutMd = !1), e.getHelpUrl != null && j.hasOwnProperty.call(e, "getHelpUrl") && (r.getHelpUrl = e.getHelpUrl), e.hideGetHelp != null && j.hasOwnProperty.call(e, "hideGetHelp") && (r.hideGetHelp = e.hideGetHelp), e.reportABugUrl != null && j.hasOwnProperty.call(e, "reportABugUrl") && (r.reportABugUrl = e.reportABugUrl), e.hideReportABug != null && j.hasOwnProperty.call(e, "hideReportABug") && (r.hideReportABug = e.hideReportABug), e.aboutSectionMd != null && j.hasOwnProperty.call(e, "aboutSectionMd") && (r.aboutSectionMd = e.aboutSectionMd), e.clearAboutMd != null && j.hasOwnProperty.call(e, "clearAboutMd") && (r.clearAboutMd = e.clearAboutMd), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/PageConfig.MenuItems";
		}, e;
	})(), e.Layout = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "CENTERED"] = 0, t[e[1] = "WIDE"] = 1, t[e[2] = "LAYOUT_UNSET"] = 2, t;
	})(), e.SidebarState = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "AUTO"] = 0, t[e[1] = "EXPANDED"] = 1, t[e[2] = "COLLAPSED"] = 2, t[e[3] = "SIDEBAR_UNSET"] = 3, t[e[4] = "LOCKED"] = 4, t;
	})(), e.SidebarWidthConfig = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.pixelWidth = null;
		let t;
		return j.defineProperty(e.prototype, "widthSpec", {
			get: A.oneOfGetter(t = ["pixelWidth"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.pixelWidth != null && j.hasOwnProperty.call(e, "pixelWidth") && t.uint32(8).uint32(e.pixelWidth), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.PageConfig.SidebarWidthConfig(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 0) break;
						o.pixelWidth = e.uint32(), o.widthSpec = "pixelWidth";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.PageConfig.SidebarWidthConfig) return e;
			if (!A.isObject(e)) throw F(".PageConfig.SidebarWidthConfig: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.PageConfig.SidebarWidthConfig();
			return e.pixelWidth != null && (n.pixelWidth = e.pixelWidth >>> 0), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.pixelWidth != null && j.hasOwnProperty.call(e, "pixelWidth") && (r.pixelWidth = e.pixelWidth, t.oneofs && (r.widthSpec = "pixelWidth")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/PageConfig.SidebarWidthConfig";
		}, e;
	})(), e;
})(), U.PageInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.queryString = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.queryString != null && j.hasOwnProperty.call(e, "queryString") && e.queryString !== "" && t.uint32(10).string(e.queryString), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PageInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.queryString = s : delete o.queryString;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PageInfo) return e;
		if (!A.isObject(e)) throw F(".PageInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PageInfo();
		return e.queryString != null && (typeof e.queryString != "string" || e.queryString.length) && (n.queryString = I(e.queryString)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.queryString = ""), e.queryString != null && j.hasOwnProperty.call(e, "queryString") && (r.queryString = e.queryString), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PageInfo";
	}, e;
})(), U.PageNotFound = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.pageName = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.pageName != null && j.hasOwnProperty.call(e, "pageName") && e.pageName !== "" && t.uint32(10).string(e.pageName), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PageNotFound(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageName = s : delete o.pageName;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PageNotFound) return e;
		if (!A.isObject(e)) throw F(".PageNotFound: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PageNotFound();
		return e.pageName != null && (typeof e.pageName != "string" || e.pageName.length) && (n.pageName = I(e.pageName)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.pageName = ""), e.pageName != null && j.hasOwnProperty.call(e, "pageName") && (r.pageName = e.pageName), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PageNotFound";
	}, e;
})(), U.PageProfile = (() => {
	let e = function(e) {
		if (this.commands = [], this.config = [], this.attributions = [], this.installedSkills = [], this.installedAgents = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.commands = A.emptyArray, e.prototype.execTime = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.prepTime = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.config = A.emptyArray, e.prototype.uncaughtException = "", e.prototype.attributions = A.emptyArray, e.prototype.os = "", e.prototype.timezone = "", e.prototype.headless = !1, e.prototype.isFragmentRun = !1, e.prototype.serverMode = "", e.prototype.installedSkills = A.emptyArray, e.prototype.installedAgents = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.commands != null && e.commands.length) for (let r = 0; r < e.commands.length; ++r) U.Command.encode(e.commands[r], t.uint32(10).fork(), n + 1).ldelim();
		if (e.execTime != null && j.hasOwnProperty.call(e, "execTime") && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : e.execTime !== 0) && t.uint32(16).int64(e.execTime), e.prepTime != null && j.hasOwnProperty.call(e, "prepTime") && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : e.prepTime !== 0) && t.uint32(24).int64(e.prepTime), e.config != null && e.config.length) for (let n = 0; n < e.config.length; ++n) t.uint32(42).string(e.config[n]);
		if (e.uncaughtException != null && j.hasOwnProperty.call(e, "uncaughtException") && e.uncaughtException !== "" && t.uint32(50).string(e.uncaughtException), e.attributions != null && e.attributions.length) for (let n = 0; n < e.attributions.length; ++n) t.uint32(58).string(e.attributions[n]);
		if (e.os != null && j.hasOwnProperty.call(e, "os") && e.os !== "" && t.uint32(66).string(e.os), e.timezone != null && j.hasOwnProperty.call(e, "timezone") && e.timezone !== "" && t.uint32(74).string(e.timezone), e.headless != null && j.hasOwnProperty.call(e, "headless") && e.headless !== !1 && t.uint32(80).bool(e.headless), e.isFragmentRun != null && j.hasOwnProperty.call(e, "isFragmentRun") && e.isFragmentRun !== !1 && t.uint32(88).bool(e.isFragmentRun), e.serverMode != null && j.hasOwnProperty.call(e, "serverMode") && e.serverMode !== "" && t.uint32(98).string(e.serverMode), e.installedSkills != null && e.installedSkills.length) for (let n = 0; n < e.installedSkills.length; ++n) t.uint32(106).string(e.installedSkills[n]);
		if (e.installedAgents != null && e.installedAgents.length) for (let n = 0; n < e.installedAgents.length; ++n) t.uint32(114).string(e.installedAgents[n]);
		if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.PageProfile(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					o.commands && o.commands.length || (o.commands = []), o.commands.push(U.Command.decode(e, e.uint32(), M, r + 1));
					continue;
				case 2:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.execTime = s : delete o.execTime;
					continue;
				case 3:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.prepTime = s : delete o.prepTime;
					continue;
				case 5:
					if (a !== 2) break;
					o.config && o.config.length || (o.config = []), o.config.push(e.stringVerify());
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.uncaughtException = s : delete o.uncaughtException;
					continue;
				case 7:
					if (a !== 2) break;
					o.attributions && o.attributions.length || (o.attributions = []), o.attributions.push(e.stringVerify());
					continue;
				case 8:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.os = s : delete o.os;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.timezone = s : delete o.timezone;
					continue;
				case 10:
					if (a !== 0) break;
					(s = e.bool()) ? o.headless = s : delete o.headless;
					continue;
				case 11:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFragmentRun = s : delete o.isFragmentRun;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.serverMode = s : delete o.serverMode;
					continue;
				case 13:
					if (a !== 2) break;
					o.installedSkills && o.installedSkills.length || (o.installedSkills = []), o.installedSkills.push(e.stringVerify());
					continue;
				case 14:
					if (a !== 2) break;
					o.installedAgents && o.installedAgents.length || (o.installedAgents = []), o.installedAgents.push(e.stringVerify());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.PageProfile) return e;
		if (!A.isObject(e)) throw F(".PageProfile: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.PageProfile();
		if (e.commands) {
			if (!B.isArray(e.commands)) throw F(".PageProfile.commands: array expected");
			n.commands = B(e.commands.length);
			for (let r = 0; r < e.commands.length; ++r) {
				if (!A.isObject(e.commands[r])) throw F(".PageProfile.commands: object expected");
				n.commands[r] = U.Command.fromObject(e.commands[r], t + 1);
			}
		}
		if (e.execTime != null && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : R(e.execTime) !== 0) && (A.Long ? n.execTime = A.Long.fromValue(e.execTime, !1) : typeof e.execTime == "string" ? n.execTime = V(e.execTime, 10) : typeof e.execTime == "number" ? n.execTime = e.execTime : typeof e.execTime == "object" && (n.execTime = new A.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber())), e.prepTime != null && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : R(e.prepTime) !== 0) && (A.Long ? n.prepTime = A.Long.fromValue(e.prepTime, !1) : typeof e.prepTime == "string" ? n.prepTime = V(e.prepTime, 10) : typeof e.prepTime == "number" ? n.prepTime = e.prepTime : typeof e.prepTime == "object" && (n.prepTime = new A.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber())), e.config) {
			if (!B.isArray(e.config)) throw F(".PageProfile.config: array expected");
			n.config = B(e.config.length);
			for (let t = 0; t < e.config.length; ++t) n.config[t] = I(e.config[t]);
		}
		if (e.uncaughtException != null && (typeof e.uncaughtException != "string" || e.uncaughtException.length) && (n.uncaughtException = I(e.uncaughtException)), e.attributions) {
			if (!B.isArray(e.attributions)) throw F(".PageProfile.attributions: array expected");
			n.attributions = B(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) n.attributions[t] = I(e.attributions[t]);
		}
		if (e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = I(e.os)), e.timezone != null && (typeof e.timezone != "string" || e.timezone.length) && (n.timezone = I(e.timezone)), e.headless != null && e.headless && (n.headless = L(e.headless)), e.isFragmentRun != null && e.isFragmentRun && (n.isFragmentRun = L(e.isFragmentRun)), e.serverMode != null && (typeof e.serverMode != "string" || e.serverMode.length) && (n.serverMode = I(e.serverMode)), e.installedSkills) {
			if (!B.isArray(e.installedSkills)) throw F(".PageProfile.installedSkills: array expected");
			n.installedSkills = B(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) n.installedSkills[t] = I(e.installedSkills[t]);
		}
		if (e.installedAgents) {
			if (!B.isArray(e.installedAgents)) throw F(".PageProfile.installedAgents: array expected");
			n.installedAgents = B(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) n.installedAgents[t] = I(e.installedAgents[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.commands = [], r.config = [], r.attributions = [], r.installedSkills = [], r.installedAgents = []), t.defaults) {
			if (A.Long) {
				let e = new A.Long(0, 0, !1);
				r.execTime = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.execTime = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			if (A.Long) {
				let e = new A.Long(0, 0, !1);
				r.prepTime = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.prepTime = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.uncaughtException = "", r.os = "", r.timezone = "", r.headless = !1, r.isFragmentRun = !1, r.serverMode = "";
		}
		if (e.commands && e.commands.length) {
			r.commands = B(e.commands.length);
			for (let i = 0; i < e.commands.length; ++i) r.commands[i] = U.Command.toObject(e.commands[i], t, n + 1);
		}
		if (e.execTime != null && j.hasOwnProperty.call(e, "execTime") && (r.execTime = H !== void 0 && t.longs === H ? typeof e.execTime == "number" ? H(e.execTime) : A.Long.fromBits(e.execTime.low >>> 0, e.execTime.high >>> 0, !1).toBigInt() : typeof e.execTime == "number" ? t.longs === I ? I(e.execTime) : e.execTime : t.longs === I ? A.Long.prototype.toString.call(e.execTime) : t.longs === R ? new A.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber() : e.execTime), e.prepTime != null && j.hasOwnProperty.call(e, "prepTime") && (r.prepTime = H !== void 0 && t.longs === H ? typeof e.prepTime == "number" ? H(e.prepTime) : A.Long.fromBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0, !1).toBigInt() : typeof e.prepTime == "number" ? t.longs === I ? I(e.prepTime) : e.prepTime : t.longs === I ? A.Long.prototype.toString.call(e.prepTime) : t.longs === R ? new A.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber() : e.prepTime), e.config && e.config.length) {
			r.config = B(e.config.length);
			for (let t = 0; t < e.config.length; ++t) r.config[t] = e.config[t];
		}
		if (e.uncaughtException != null && j.hasOwnProperty.call(e, "uncaughtException") && (r.uncaughtException = e.uncaughtException), e.attributions && e.attributions.length) {
			r.attributions = B(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) r.attributions[t] = e.attributions[t];
		}
		if (e.os != null && j.hasOwnProperty.call(e, "os") && (r.os = e.os), e.timezone != null && j.hasOwnProperty.call(e, "timezone") && (r.timezone = e.timezone), e.headless != null && j.hasOwnProperty.call(e, "headless") && (r.headless = e.headless), e.isFragmentRun != null && j.hasOwnProperty.call(e, "isFragmentRun") && (r.isFragmentRun = e.isFragmentRun), e.serverMode != null && j.hasOwnProperty.call(e, "serverMode") && (r.serverMode = e.serverMode), e.installedSkills && e.installedSkills.length) {
			r.installedSkills = B(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) r.installedSkills[t] = e.installedSkills[t];
		}
		if (e.installedAgents && e.installedAgents.length) {
			r.installedAgents = B(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) r.installedAgents[t] = e.installedAgents[t];
		}
		return r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/PageProfile";
	}, e;
})(), U.Argument = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.k = "", e.prototype.t = "", e.prototype.m = "", e.prototype.p = 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.k != null && j.hasOwnProperty.call(e, "k") && e.k !== "" && t.uint32(10).string(e.k), e.t != null && j.hasOwnProperty.call(e, "t") && e.t !== "" && t.uint32(18).string(e.t), e.m != null && j.hasOwnProperty.call(e, "m") && e.m !== "" && t.uint32(26).string(e.m), e.p != null && j.hasOwnProperty.call(e, "p") && e.p !== 0 && t.uint32(40).int32(e.p), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Argument(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.k = s : delete o.k;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.t = s : delete o.t;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.m = s : delete o.m;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.int32()) ? o.p = s : delete o.p;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Argument) return e;
		if (!A.isObject(e)) throw F(".Argument: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Argument();
		return e.k != null && (typeof e.k != "string" || e.k.length) && (n.k = I(e.k)), e.t != null && (typeof e.t != "string" || e.t.length) && (n.t = I(e.t)), e.m != null && (typeof e.m != "string" || e.m.length) && (n.m = I(e.m)), e.p != null && R(e.p) !== 0 && (n.p = e.p | 0), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.k = "", r.t = "", r.m = "", r.p = 0), e.k != null && j.hasOwnProperty.call(e, "k") && (r.k = e.k), e.t != null && j.hasOwnProperty.call(e, "t") && (r.t = e.t), e.m != null && j.hasOwnProperty.call(e, "m") && (r.m = e.m), e.p != null && j.hasOwnProperty.call(e, "p") && (r.p = e.p), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Argument";
	}, e;
})(), U.Command = (() => {
	let e = function(e) {
		if (this.args = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.name = "", e.prototype.args = A.emptyArray, e.prototype.time = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.args != null && e.args.length) for (let r = 0; r < e.args.length; ++r) U.Argument.encode(e.args[r], t.uint32(18).fork(), n + 1).ldelim();
		if (e.time != null && j.hasOwnProperty.call(e, "time") && (typeof e.time == "object" ? e.time.low || e.time.high : e.time !== 0) && t.uint32(32).int64(e.time), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.Command(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.name = s : delete o.name;
					continue;
				case 2:
					if (a !== 2) break;
					o.args && o.args.length || (o.args = []), o.args.push(U.Argument.decode(e, e.uint32(), M, r + 1));
					continue;
				case 4:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.time = s : delete o.time;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.Command) return e;
		if (!A.isObject(e)) throw F(".Command: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.Command();
		if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.args) {
			if (!B.isArray(e.args)) throw F(".Command.args: array expected");
			n.args = B(e.args.length);
			for (let r = 0; r < e.args.length; ++r) {
				if (!A.isObject(e.args[r])) throw F(".Command.args: object expected");
				n.args[r] = U.Argument.fromObject(e.args[r], t + 1);
			}
		}
		return e.time != null && (typeof e.time == "object" ? e.time.low || e.time.high : R(e.time) !== 0) && (A.Long ? n.time = A.Long.fromValue(e.time, !1) : typeof e.time == "string" ? n.time = V(e.time, 10) : typeof e.time == "number" ? n.time = e.time : typeof e.time == "object" && (n.time = new A.LongBits(e.time.low >>> 0, e.time.high >>> 0).toNumber())), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.args = []), t.defaults) {
			if (r.name = "", A.Long) {
				let e = new A.Long(0, 0, !1);
				r.time = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.time = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
		}
		if (e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.args && e.args.length) {
			r.args = B(e.args.length);
			for (let i = 0; i < e.args.length; ++i) r.args[i] = U.Argument.toObject(e.args[i], t, n + 1);
		}
		return e.time != null && j.hasOwnProperty.call(e, "time") && (r.time = H !== void 0 && t.longs === H ? typeof e.time == "number" ? H(e.time) : A.Long.fromBits(e.time.low >>> 0, e.time.high >>> 0, !1).toBigInt() : typeof e.time == "number" ? t.longs === I ? I(e.time) : e.time : t.longs === I ? A.Long.prototype.toString.call(e.time) : t.longs === R ? new A.LongBits(e.time.low >>> 0, e.time.high >>> 0).toNumber() : e.time), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/Command";
	}, e;
})(), U.ParentMessage = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.message = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.message != null && j.hasOwnProperty.call(e, "message") && e.message !== "" && t.uint32(10).string(e.message), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.ParentMessage(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.message = s : delete o.message;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.ParentMessage) return e;
		if (!A.isObject(e)) throw F(".ParentMessage: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.ParentMessage();
		return e.message != null && (typeof e.message != "string" || e.message.length) && (n.message = I(e.message)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.message = ""), e.message != null && j.hasOwnProperty.call(e, "message") && (r.message = e.message), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/ParentMessage";
	}, e;
})(), U.SessionEvent = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	e.prototype.scriptChangedOnDisk = null, e.prototype.scriptWasManuallyStopped = null, e.prototype.scriptCompilationException = null;
	let t;
	return j.defineProperty(e.prototype, "type", {
		get: A.oneOfGetter(t = [
			"scriptChangedOnDisk",
			"scriptWasManuallyStopped",
			"scriptCompilationException"
		]),
		set: A.oneOfSetter(t)
	}), e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.scriptChangedOnDisk != null && j.hasOwnProperty.call(e, "scriptChangedOnDisk") && t.uint32(8).bool(e.scriptChangedOnDisk), e.scriptWasManuallyStopped != null && j.hasOwnProperty.call(e, "scriptWasManuallyStopped") && t.uint32(16).bool(e.scriptWasManuallyStopped), e.scriptCompilationException != null && j.hasOwnProperty.call(e, "scriptCompilationException") && U.Exception.encode(e.scriptCompilationException, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.SessionEvent(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 0) break;
					o.scriptChangedOnDisk = e.bool(), o.type = "scriptChangedOnDisk";
					continue;
				case 2:
					if (a !== 0) break;
					o.scriptWasManuallyStopped = e.bool(), o.type = "scriptWasManuallyStopped";
					continue;
				case 3:
					if (a !== 2) break;
					o.scriptCompilationException = U.Exception.decode(e, e.uint32(), M, r + 1, o.scriptCompilationException), o.type = "scriptCompilationException";
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.SessionEvent) return e;
		if (!A.isObject(e)) throw F(".SessionEvent: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.SessionEvent();
		if (e.scriptChangedOnDisk != null && (n.scriptChangedOnDisk = L(e.scriptChangedOnDisk)), e.scriptWasManuallyStopped != null && (n.scriptWasManuallyStopped = L(e.scriptWasManuallyStopped)), e.scriptCompilationException != null) {
			if (!A.isObject(e.scriptCompilationException)) throw F(".SessionEvent.scriptCompilationException: object expected");
			n.scriptCompilationException = U.Exception.fromObject(e.scriptCompilationException, t + 1);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return e.scriptChangedOnDisk != null && j.hasOwnProperty.call(e, "scriptChangedOnDisk") && (r.scriptChangedOnDisk = e.scriptChangedOnDisk, t.oneofs && (r.type = "scriptChangedOnDisk")), e.scriptWasManuallyStopped != null && j.hasOwnProperty.call(e, "scriptWasManuallyStopped") && (r.scriptWasManuallyStopped = e.scriptWasManuallyStopped, t.oneofs && (r.type = "scriptWasManuallyStopped")), e.scriptCompilationException != null && j.hasOwnProperty.call(e, "scriptCompilationException") && (r.scriptCompilationException = U.Exception.toObject(e.scriptCompilationException, t, n + 1), t.oneofs && (r.type = "scriptCompilationException")), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/SessionEvent";
	}, e;
})(), U.MetricsEvent = (() => {
	let e = function(e) {
		if (this.commands = [], this.config = [], this.attributions = [], this.installedSkills = [], this.installedAgents = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.event = "", e.prototype.anonymousId = "", e.prototype.machineIdV3 = "", e.prototype.machineIdV4 = "", e.prototype.reportHash = "", e.prototype.dev = !1, e.prototype.source = "", e.prototype.streamlitVersion = "", e.prototype.isHello = !1, e.prototype.appId = "", e.prototype.sessionId = "", e.prototype.pythonVersion = "", e.prototype.serverOs = "", e.prototype.hasDisplay = !1, e.prototype.isWebdriver = !1, e.prototype.hostedAt = "", e.prototype.owner = "", e.prototype.repo = "", e.prototype.branch = "", e.prototype.mainModule = "", e.prototype.creatorId = "", e.prototype.contextPageUrl = "", e.prototype.contextPageTitle = "", e.prototype.contextPagePath = "", e.prototype.contextPageReferrer = "", e.prototype.contextPageSearch = "", e.prototype.contextLocale = "", e.prototype.contextUserAgent = "", e.prototype.label = "", e.prototype.surface = "", e.prototype.commands = A.emptyArray, e.prototype.execTime = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.prepTime = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.config = A.emptyArray, e.prototype.uncaughtException = "", e.prototype.attributions = A.emptyArray, e.prototype.os = "", e.prototype.timezone = "", e.prototype.headless = !1, e.prototype.isFragmentRun = !1, e.prototype.numPages = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.pageScriptHash = "", e.prototype.activeTheme = "", e.prototype.totalLoadTime = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.browserInfo = null, e.prototype.serverMode = "", e.prototype.installedSkills = A.emptyArray, e.prototype.installedAgents = A.emptyArray, e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.event != null && j.hasOwnProperty.call(e, "event") && e.event !== "" && t.uint32(10).string(e.event), e.anonymousId != null && j.hasOwnProperty.call(e, "anonymousId") && e.anonymousId !== "" && t.uint32(18).string(e.anonymousId), e.machineIdV3 != null && j.hasOwnProperty.call(e, "machineIdV3") && e.machineIdV3 !== "" && t.uint32(26).string(e.machineIdV3), e.reportHash != null && j.hasOwnProperty.call(e, "reportHash") && e.reportHash !== "" && t.uint32(34).string(e.reportHash), e.dev != null && j.hasOwnProperty.call(e, "dev") && e.dev !== !1 && t.uint32(40).bool(e.dev), e.source != null && j.hasOwnProperty.call(e, "source") && e.source !== "" && t.uint32(50).string(e.source), e.streamlitVersion != null && j.hasOwnProperty.call(e, "streamlitVersion") && e.streamlitVersion !== "" && t.uint32(58).string(e.streamlitVersion), e.isHello != null && j.hasOwnProperty.call(e, "isHello") && e.isHello !== !1 && t.uint32(64).bool(e.isHello), e.hostedAt != null && j.hasOwnProperty.call(e, "hostedAt") && e.hostedAt !== "" && t.uint32(74).string(e.hostedAt), e.owner != null && j.hasOwnProperty.call(e, "owner") && e.owner !== "" && t.uint32(82).string(e.owner), e.repo != null && j.hasOwnProperty.call(e, "repo") && e.repo !== "" && t.uint32(90).string(e.repo), e.branch != null && j.hasOwnProperty.call(e, "branch") && e.branch !== "" && t.uint32(98).string(e.branch), e.mainModule != null && j.hasOwnProperty.call(e, "mainModule") && e.mainModule !== "" && t.uint32(106).string(e.mainModule), e.creatorId != null && j.hasOwnProperty.call(e, "creatorId") && e.creatorId !== "" && t.uint32(114).string(e.creatorId), e.contextPageUrl != null && j.hasOwnProperty.call(e, "contextPageUrl") && e.contextPageUrl !== "" && t.uint32(122).string(e.contextPageUrl), e.contextPageTitle != null && j.hasOwnProperty.call(e, "contextPageTitle") && e.contextPageTitle !== "" && t.uint32(130).string(e.contextPageTitle), e.contextPagePath != null && j.hasOwnProperty.call(e, "contextPagePath") && e.contextPagePath !== "" && t.uint32(138).string(e.contextPagePath), e.contextPageReferrer != null && j.hasOwnProperty.call(e, "contextPageReferrer") && e.contextPageReferrer !== "" && t.uint32(146).string(e.contextPageReferrer), e.contextPageSearch != null && j.hasOwnProperty.call(e, "contextPageSearch") && e.contextPageSearch !== "" && t.uint32(154).string(e.contextPageSearch), e.contextLocale != null && j.hasOwnProperty.call(e, "contextLocale") && e.contextLocale !== "" && t.uint32(162).string(e.contextLocale), e.contextUserAgent != null && j.hasOwnProperty.call(e, "contextUserAgent") && e.contextUserAgent !== "" && t.uint32(170).string(e.contextUserAgent), e.label != null && j.hasOwnProperty.call(e, "label") && e.label !== "" && t.uint32(178).string(e.label), e.commands != null && e.commands.length) for (let r = 0; r < e.commands.length; ++r) U.Command.encode(e.commands[r], t.uint32(186).fork(), n + 1).ldelim();
		if (e.execTime != null && j.hasOwnProperty.call(e, "execTime") && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : e.execTime !== 0) && t.uint32(192).int64(e.execTime), e.prepTime != null && j.hasOwnProperty.call(e, "prepTime") && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : e.prepTime !== 0) && t.uint32(200).int64(e.prepTime), e.config != null && e.config.length) for (let n = 0; n < e.config.length; ++n) t.uint32(210).string(e.config[n]);
		if (e.uncaughtException != null && j.hasOwnProperty.call(e, "uncaughtException") && e.uncaughtException !== "" && t.uint32(218).string(e.uncaughtException), e.attributions != null && e.attributions.length) for (let n = 0; n < e.attributions.length; ++n) t.uint32(226).string(e.attributions[n]);
		if (e.os != null && j.hasOwnProperty.call(e, "os") && e.os !== "" && t.uint32(234).string(e.os), e.timezone != null && j.hasOwnProperty.call(e, "timezone") && e.timezone !== "" && t.uint32(242).string(e.timezone), e.headless != null && j.hasOwnProperty.call(e, "headless") && e.headless !== !1 && t.uint32(248).bool(e.headless), e.isFragmentRun != null && j.hasOwnProperty.call(e, "isFragmentRun") && e.isFragmentRun !== !1 && t.uint32(256).bool(e.isFragmentRun), e.appId != null && j.hasOwnProperty.call(e, "appId") && e.appId !== "" && t.uint32(266).string(e.appId), e.numPages != null && j.hasOwnProperty.call(e, "numPages") && (typeof e.numPages == "object" ? e.numPages.low || e.numPages.high : e.numPages !== 0) && t.uint32(272).int64(e.numPages), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && e.sessionId !== "" && t.uint32(282).string(e.sessionId), e.pythonVersion != null && j.hasOwnProperty.call(e, "pythonVersion") && e.pythonVersion !== "" && t.uint32(290).string(e.pythonVersion), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && e.pageScriptHash !== "" && t.uint32(298).string(e.pageScriptHash), e.activeTheme != null && j.hasOwnProperty.call(e, "activeTheme") && e.activeTheme !== "" && t.uint32(306).string(e.activeTheme), e.totalLoadTime != null && j.hasOwnProperty.call(e, "totalLoadTime") && (typeof e.totalLoadTime == "object" ? e.totalLoadTime.low || e.totalLoadTime.high : e.totalLoadTime !== 0) && t.uint32(312).int64(e.totalLoadTime), e.browserInfo != null && j.hasOwnProperty.call(e, "browserInfo") && U.BrowserInfo.encode(e.browserInfo, t.uint32(322).fork(), n + 1).ldelim(), e.machineIdV4 != null && j.hasOwnProperty.call(e, "machineIdV4") && e.machineIdV4 !== "" && t.uint32(330).string(e.machineIdV4), e.serverOs != null && j.hasOwnProperty.call(e, "serverOs") && e.serverOs !== "" && t.uint32(338).string(e.serverOs), e.hasDisplay != null && j.hasOwnProperty.call(e, "hasDisplay") && e.hasDisplay !== !1 && t.uint32(344).bool(e.hasDisplay), e.isWebdriver != null && j.hasOwnProperty.call(e, "isWebdriver") && e.isWebdriver !== !1 && t.uint32(352).bool(e.isWebdriver), e.serverMode != null && j.hasOwnProperty.call(e, "serverMode") && e.serverMode !== "" && t.uint32(362).string(e.serverMode), e.installedSkills != null && e.installedSkills.length) for (let n = 0; n < e.installedSkills.length; ++n) t.uint32(370).string(e.installedSkills[n]);
		if (e.installedAgents != null && e.installedAgents.length) for (let n = 0; n < e.installedAgents.length; ++n) t.uint32(378).string(e.installedAgents[n]);
		if (e.surface != null && j.hasOwnProperty.call(e, "surface") && e.surface !== "" && t.uint32(386).string(e.surface), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.MetricsEvent(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.event = s : delete o.event;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.anonymousId = s : delete o.anonymousId;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.machineIdV3 = s : delete o.machineIdV3;
					continue;
				case 41:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.machineIdV4 = s : delete o.machineIdV4;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.reportHash = s : delete o.reportHash;
					continue;
				case 5:
					if (a !== 0) break;
					(s = e.bool()) ? o.dev = s : delete o.dev;
					continue;
				case 6:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.source = s : delete o.source;
					continue;
				case 7:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.streamlitVersion = s : delete o.streamlitVersion;
					continue;
				case 8:
					if (a !== 0) break;
					(s = e.bool()) ? o.isHello = s : delete o.isHello;
					continue;
				case 33:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.appId = s : delete o.appId;
					continue;
				case 35:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.sessionId = s : delete o.sessionId;
					continue;
				case 36:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pythonVersion = s : delete o.pythonVersion;
					continue;
				case 42:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.serverOs = s : delete o.serverOs;
					continue;
				case 43:
					if (a !== 0) break;
					(s = e.bool()) ? o.hasDisplay = s : delete o.hasDisplay;
					continue;
				case 44:
					if (a !== 0) break;
					(s = e.bool()) ? o.isWebdriver = s : delete o.isWebdriver;
					continue;
				case 9:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.hostedAt = s : delete o.hostedAt;
					continue;
				case 10:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.owner = s : delete o.owner;
					continue;
				case 11:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.repo = s : delete o.repo;
					continue;
				case 12:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.branch = s : delete o.branch;
					continue;
				case 13:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.mainModule = s : delete o.mainModule;
					continue;
				case 14:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.creatorId = s : delete o.creatorId;
					continue;
				case 15:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextPageUrl = s : delete o.contextPageUrl;
					continue;
				case 16:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextPageTitle = s : delete o.contextPageTitle;
					continue;
				case 17:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextPagePath = s : delete o.contextPagePath;
					continue;
				case 18:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextPageReferrer = s : delete o.contextPageReferrer;
					continue;
				case 19:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextPageSearch = s : delete o.contextPageSearch;
					continue;
				case 20:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextLocale = s : delete o.contextLocale;
					continue;
				case 21:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.contextUserAgent = s : delete o.contextUserAgent;
					continue;
				case 22:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.label = s : delete o.label;
					continue;
				case 48:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.surface = s : delete o.surface;
					continue;
				case 23:
					if (a !== 2) break;
					o.commands && o.commands.length || (o.commands = []), o.commands.push(U.Command.decode(e, e.uint32(), M, r + 1));
					continue;
				case 24:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.execTime = s : delete o.execTime;
					continue;
				case 25:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.prepTime = s : delete o.prepTime;
					continue;
				case 26:
					if (a !== 2) break;
					o.config && o.config.length || (o.config = []), o.config.push(e.stringVerify());
					continue;
				case 27:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.uncaughtException = s : delete o.uncaughtException;
					continue;
				case 28:
					if (a !== 2) break;
					o.attributions && o.attributions.length || (o.attributions = []), o.attributions.push(e.stringVerify());
					continue;
				case 29:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.os = s : delete o.os;
					continue;
				case 30:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.timezone = s : delete o.timezone;
					continue;
				case 31:
					if (a !== 0) break;
					(s = e.bool()) ? o.headless = s : delete o.headless;
					continue;
				case 32:
					if (a !== 0) break;
					(s = e.bool()) ? o.isFragmentRun = s : delete o.isFragmentRun;
					continue;
				case 34:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.numPages = s : delete o.numPages;
					continue;
				case 37:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.pageScriptHash = s : delete o.pageScriptHash;
					continue;
				case 38:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.activeTheme = s : delete o.activeTheme;
					continue;
				case 39:
					if (a !== 0) break;
					(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.totalLoadTime = s : delete o.totalLoadTime;
					continue;
				case 40:
					if (a !== 2) break;
					o.browserInfo = U.BrowserInfo.decode(e, e.uint32(), M, r + 1, o.browserInfo);
					continue;
				case 45:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.serverMode = s : delete o.serverMode;
					continue;
				case 46:
					if (a !== 2) break;
					o.installedSkills && o.installedSkills.length || (o.installedSkills = []), o.installedSkills.push(e.stringVerify());
					continue;
				case 47:
					if (a !== 2) break;
					o.installedAgents && o.installedAgents.length || (o.installedAgents = []), o.installedAgents.push(e.stringVerify());
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.MetricsEvent) return e;
		if (!A.isObject(e)) throw F(".MetricsEvent: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.MetricsEvent();
		if (e.event != null && (typeof e.event != "string" || e.event.length) && (n.event = I(e.event)), e.anonymousId != null && (typeof e.anonymousId != "string" || e.anonymousId.length) && (n.anonymousId = I(e.anonymousId)), e.machineIdV3 != null && (typeof e.machineIdV3 != "string" || e.machineIdV3.length) && (n.machineIdV3 = I(e.machineIdV3)), e.machineIdV4 != null && (typeof e.machineIdV4 != "string" || e.machineIdV4.length) && (n.machineIdV4 = I(e.machineIdV4)), e.reportHash != null && (typeof e.reportHash != "string" || e.reportHash.length) && (n.reportHash = I(e.reportHash)), e.dev != null && e.dev && (n.dev = L(e.dev)), e.source != null && (typeof e.source != "string" || e.source.length) && (n.source = I(e.source)), e.streamlitVersion != null && (typeof e.streamlitVersion != "string" || e.streamlitVersion.length) && (n.streamlitVersion = I(e.streamlitVersion)), e.isHello != null && e.isHello && (n.isHello = L(e.isHello)), e.appId != null && (typeof e.appId != "string" || e.appId.length) && (n.appId = I(e.appId)), e.sessionId != null && (typeof e.sessionId != "string" || e.sessionId.length) && (n.sessionId = I(e.sessionId)), e.pythonVersion != null && (typeof e.pythonVersion != "string" || e.pythonVersion.length) && (n.pythonVersion = I(e.pythonVersion)), e.serverOs != null && (typeof e.serverOs != "string" || e.serverOs.length) && (n.serverOs = I(e.serverOs)), e.hasDisplay != null && e.hasDisplay && (n.hasDisplay = L(e.hasDisplay)), e.isWebdriver != null && e.isWebdriver && (n.isWebdriver = L(e.isWebdriver)), e.hostedAt != null && (typeof e.hostedAt != "string" || e.hostedAt.length) && (n.hostedAt = I(e.hostedAt)), e.owner != null && (typeof e.owner != "string" || e.owner.length) && (n.owner = I(e.owner)), e.repo != null && (typeof e.repo != "string" || e.repo.length) && (n.repo = I(e.repo)), e.branch != null && (typeof e.branch != "string" || e.branch.length) && (n.branch = I(e.branch)), e.mainModule != null && (typeof e.mainModule != "string" || e.mainModule.length) && (n.mainModule = I(e.mainModule)), e.creatorId != null && (typeof e.creatorId != "string" || e.creatorId.length) && (n.creatorId = I(e.creatorId)), e.contextPageUrl != null && (typeof e.contextPageUrl != "string" || e.contextPageUrl.length) && (n.contextPageUrl = I(e.contextPageUrl)), e.contextPageTitle != null && (typeof e.contextPageTitle != "string" || e.contextPageTitle.length) && (n.contextPageTitle = I(e.contextPageTitle)), e.contextPagePath != null && (typeof e.contextPagePath != "string" || e.contextPagePath.length) && (n.contextPagePath = I(e.contextPagePath)), e.contextPageReferrer != null && (typeof e.contextPageReferrer != "string" || e.contextPageReferrer.length) && (n.contextPageReferrer = I(e.contextPageReferrer)), e.contextPageSearch != null && (typeof e.contextPageSearch != "string" || e.contextPageSearch.length) && (n.contextPageSearch = I(e.contextPageSearch)), e.contextLocale != null && (typeof e.contextLocale != "string" || e.contextLocale.length) && (n.contextLocale = I(e.contextLocale)), e.contextUserAgent != null && (typeof e.contextUserAgent != "string" || e.contextUserAgent.length) && (n.contextUserAgent = I(e.contextUserAgent)), e.label != null && (typeof e.label != "string" || e.label.length) && (n.label = I(e.label)), e.surface != null && (typeof e.surface != "string" || e.surface.length) && (n.surface = I(e.surface)), e.commands) {
			if (!B.isArray(e.commands)) throw F(".MetricsEvent.commands: array expected");
			n.commands = B(e.commands.length);
			for (let r = 0; r < e.commands.length; ++r) {
				if (!A.isObject(e.commands[r])) throw F(".MetricsEvent.commands: object expected");
				n.commands[r] = U.Command.fromObject(e.commands[r], t + 1);
			}
		}
		if (e.execTime != null && (typeof e.execTime == "object" ? e.execTime.low || e.execTime.high : R(e.execTime) !== 0) && (A.Long ? n.execTime = A.Long.fromValue(e.execTime, !1) : typeof e.execTime == "string" ? n.execTime = V(e.execTime, 10) : typeof e.execTime == "number" ? n.execTime = e.execTime : typeof e.execTime == "object" && (n.execTime = new A.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber())), e.prepTime != null && (typeof e.prepTime == "object" ? e.prepTime.low || e.prepTime.high : R(e.prepTime) !== 0) && (A.Long ? n.prepTime = A.Long.fromValue(e.prepTime, !1) : typeof e.prepTime == "string" ? n.prepTime = V(e.prepTime, 10) : typeof e.prepTime == "number" ? n.prepTime = e.prepTime : typeof e.prepTime == "object" && (n.prepTime = new A.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber())), e.config) {
			if (!B.isArray(e.config)) throw F(".MetricsEvent.config: array expected");
			n.config = B(e.config.length);
			for (let t = 0; t < e.config.length; ++t) n.config[t] = I(e.config[t]);
		}
		if (e.uncaughtException != null && (typeof e.uncaughtException != "string" || e.uncaughtException.length) && (n.uncaughtException = I(e.uncaughtException)), e.attributions) {
			if (!B.isArray(e.attributions)) throw F(".MetricsEvent.attributions: array expected");
			n.attributions = B(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) n.attributions[t] = I(e.attributions[t]);
		}
		if (e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = I(e.os)), e.timezone != null && (typeof e.timezone != "string" || e.timezone.length) && (n.timezone = I(e.timezone)), e.headless != null && e.headless && (n.headless = L(e.headless)), e.isFragmentRun != null && e.isFragmentRun && (n.isFragmentRun = L(e.isFragmentRun)), e.numPages != null && (typeof e.numPages == "object" ? e.numPages.low || e.numPages.high : R(e.numPages) !== 0) && (A.Long ? n.numPages = A.Long.fromValue(e.numPages, !1) : typeof e.numPages == "string" ? n.numPages = V(e.numPages, 10) : typeof e.numPages == "number" ? n.numPages = e.numPages : typeof e.numPages == "object" && (n.numPages = new A.LongBits(e.numPages.low >>> 0, e.numPages.high >>> 0).toNumber())), e.pageScriptHash != null && (typeof e.pageScriptHash != "string" || e.pageScriptHash.length) && (n.pageScriptHash = I(e.pageScriptHash)), e.activeTheme != null && (typeof e.activeTheme != "string" || e.activeTheme.length) && (n.activeTheme = I(e.activeTheme)), e.totalLoadTime != null && (typeof e.totalLoadTime == "object" ? e.totalLoadTime.low || e.totalLoadTime.high : R(e.totalLoadTime) !== 0) && (A.Long ? n.totalLoadTime = A.Long.fromValue(e.totalLoadTime, !1) : typeof e.totalLoadTime == "string" ? n.totalLoadTime = V(e.totalLoadTime, 10) : typeof e.totalLoadTime == "number" ? n.totalLoadTime = e.totalLoadTime : typeof e.totalLoadTime == "object" && (n.totalLoadTime = new A.LongBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0).toNumber())), e.browserInfo != null) {
			if (!A.isObject(e.browserInfo)) throw F(".MetricsEvent.browserInfo: object expected");
			n.browserInfo = U.BrowserInfo.fromObject(e.browserInfo, t + 1);
		}
		if (e.serverMode != null && (typeof e.serverMode != "string" || e.serverMode.length) && (n.serverMode = I(e.serverMode)), e.installedSkills) {
			if (!B.isArray(e.installedSkills)) throw F(".MetricsEvent.installedSkills: array expected");
			n.installedSkills = B(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) n.installedSkills[t] = I(e.installedSkills[t]);
		}
		if (e.installedAgents) {
			if (!B.isArray(e.installedAgents)) throw F(".MetricsEvent.installedAgents: array expected");
			n.installedAgents = B(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) n.installedAgents[t] = I(e.installedAgents[t]);
		}
		return n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		if ((t.arrays || t.defaults) && (r.commands = [], r.config = [], r.attributions = [], r.installedSkills = [], r.installedAgents = []), t.defaults) {
			if (r.event = "", r.anonymousId = "", r.machineIdV3 = "", r.reportHash = "", r.dev = !1, r.source = "", r.streamlitVersion = "", r.isHello = !1, r.hostedAt = "", r.owner = "", r.repo = "", r.branch = "", r.mainModule = "", r.creatorId = "", r.contextPageUrl = "", r.contextPageTitle = "", r.contextPagePath = "", r.contextPageReferrer = "", r.contextPageSearch = "", r.contextLocale = "", r.contextUserAgent = "", r.label = "", A.Long) {
				let e = new A.Long(0, 0, !1);
				r.execTime = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.execTime = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			if (A.Long) {
				let e = new A.Long(0, 0, !1);
				r.prepTime = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.prepTime = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			if (r.uncaughtException = "", r.os = "", r.timezone = "", r.headless = !1, r.isFragmentRun = !1, r.appId = "", A.Long) {
				let e = new A.Long(0, 0, !1);
				r.numPages = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.numPages = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			if (r.sessionId = "", r.pythonVersion = "", r.pageScriptHash = "", r.activeTheme = "", A.Long) {
				let e = new A.Long(0, 0, !1);
				r.totalLoadTime = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
			} else r.totalLoadTime = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
			r.browserInfo = null, r.machineIdV4 = "", r.serverOs = "", r.hasDisplay = !1, r.isWebdriver = !1, r.serverMode = "", r.surface = "";
		}
		if (e.event != null && j.hasOwnProperty.call(e, "event") && (r.event = e.event), e.anonymousId != null && j.hasOwnProperty.call(e, "anonymousId") && (r.anonymousId = e.anonymousId), e.machineIdV3 != null && j.hasOwnProperty.call(e, "machineIdV3") && (r.machineIdV3 = e.machineIdV3), e.reportHash != null && j.hasOwnProperty.call(e, "reportHash") && (r.reportHash = e.reportHash), e.dev != null && j.hasOwnProperty.call(e, "dev") && (r.dev = e.dev), e.source != null && j.hasOwnProperty.call(e, "source") && (r.source = e.source), e.streamlitVersion != null && j.hasOwnProperty.call(e, "streamlitVersion") && (r.streamlitVersion = e.streamlitVersion), e.isHello != null && j.hasOwnProperty.call(e, "isHello") && (r.isHello = e.isHello), e.hostedAt != null && j.hasOwnProperty.call(e, "hostedAt") && (r.hostedAt = e.hostedAt), e.owner != null && j.hasOwnProperty.call(e, "owner") && (r.owner = e.owner), e.repo != null && j.hasOwnProperty.call(e, "repo") && (r.repo = e.repo), e.branch != null && j.hasOwnProperty.call(e, "branch") && (r.branch = e.branch), e.mainModule != null && j.hasOwnProperty.call(e, "mainModule") && (r.mainModule = e.mainModule), e.creatorId != null && j.hasOwnProperty.call(e, "creatorId") && (r.creatorId = e.creatorId), e.contextPageUrl != null && j.hasOwnProperty.call(e, "contextPageUrl") && (r.contextPageUrl = e.contextPageUrl), e.contextPageTitle != null && j.hasOwnProperty.call(e, "contextPageTitle") && (r.contextPageTitle = e.contextPageTitle), e.contextPagePath != null && j.hasOwnProperty.call(e, "contextPagePath") && (r.contextPagePath = e.contextPagePath), e.contextPageReferrer != null && j.hasOwnProperty.call(e, "contextPageReferrer") && (r.contextPageReferrer = e.contextPageReferrer), e.contextPageSearch != null && j.hasOwnProperty.call(e, "contextPageSearch") && (r.contextPageSearch = e.contextPageSearch), e.contextLocale != null && j.hasOwnProperty.call(e, "contextLocale") && (r.contextLocale = e.contextLocale), e.contextUserAgent != null && j.hasOwnProperty.call(e, "contextUserAgent") && (r.contextUserAgent = e.contextUserAgent), e.label != null && j.hasOwnProperty.call(e, "label") && (r.label = e.label), e.commands && e.commands.length) {
			r.commands = B(e.commands.length);
			for (let i = 0; i < e.commands.length; ++i) r.commands[i] = U.Command.toObject(e.commands[i], t, n + 1);
		}
		if (e.execTime != null && j.hasOwnProperty.call(e, "execTime") && (r.execTime = H !== void 0 && t.longs === H ? typeof e.execTime == "number" ? H(e.execTime) : A.Long.fromBits(e.execTime.low >>> 0, e.execTime.high >>> 0, !1).toBigInt() : typeof e.execTime == "number" ? t.longs === I ? I(e.execTime) : e.execTime : t.longs === I ? A.Long.prototype.toString.call(e.execTime) : t.longs === R ? new A.LongBits(e.execTime.low >>> 0, e.execTime.high >>> 0).toNumber() : e.execTime), e.prepTime != null && j.hasOwnProperty.call(e, "prepTime") && (r.prepTime = H !== void 0 && t.longs === H ? typeof e.prepTime == "number" ? H(e.prepTime) : A.Long.fromBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0, !1).toBigInt() : typeof e.prepTime == "number" ? t.longs === I ? I(e.prepTime) : e.prepTime : t.longs === I ? A.Long.prototype.toString.call(e.prepTime) : t.longs === R ? new A.LongBits(e.prepTime.low >>> 0, e.prepTime.high >>> 0).toNumber() : e.prepTime), e.config && e.config.length) {
			r.config = B(e.config.length);
			for (let t = 0; t < e.config.length; ++t) r.config[t] = e.config[t];
		}
		if (e.uncaughtException != null && j.hasOwnProperty.call(e, "uncaughtException") && (r.uncaughtException = e.uncaughtException), e.attributions && e.attributions.length) {
			r.attributions = B(e.attributions.length);
			for (let t = 0; t < e.attributions.length; ++t) r.attributions[t] = e.attributions[t];
		}
		if (e.os != null && j.hasOwnProperty.call(e, "os") && (r.os = e.os), e.timezone != null && j.hasOwnProperty.call(e, "timezone") && (r.timezone = e.timezone), e.headless != null && j.hasOwnProperty.call(e, "headless") && (r.headless = e.headless), e.isFragmentRun != null && j.hasOwnProperty.call(e, "isFragmentRun") && (r.isFragmentRun = e.isFragmentRun), e.appId != null && j.hasOwnProperty.call(e, "appId") && (r.appId = e.appId), e.numPages != null && j.hasOwnProperty.call(e, "numPages") && (r.numPages = H !== void 0 && t.longs === H ? typeof e.numPages == "number" ? H(e.numPages) : A.Long.fromBits(e.numPages.low >>> 0, e.numPages.high >>> 0, !1).toBigInt() : typeof e.numPages == "number" ? t.longs === I ? I(e.numPages) : e.numPages : t.longs === I ? A.Long.prototype.toString.call(e.numPages) : t.longs === R ? new A.LongBits(e.numPages.low >>> 0, e.numPages.high >>> 0).toNumber() : e.numPages), e.sessionId != null && j.hasOwnProperty.call(e, "sessionId") && (r.sessionId = e.sessionId), e.pythonVersion != null && j.hasOwnProperty.call(e, "pythonVersion") && (r.pythonVersion = e.pythonVersion), e.pageScriptHash != null && j.hasOwnProperty.call(e, "pageScriptHash") && (r.pageScriptHash = e.pageScriptHash), e.activeTheme != null && j.hasOwnProperty.call(e, "activeTheme") && (r.activeTheme = e.activeTheme), e.totalLoadTime != null && j.hasOwnProperty.call(e, "totalLoadTime") && (r.totalLoadTime = H !== void 0 && t.longs === H ? typeof e.totalLoadTime == "number" ? H(e.totalLoadTime) : A.Long.fromBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0, !1).toBigInt() : typeof e.totalLoadTime == "number" ? t.longs === I ? I(e.totalLoadTime) : e.totalLoadTime : t.longs === I ? A.Long.prototype.toString.call(e.totalLoadTime) : t.longs === R ? new A.LongBits(e.totalLoadTime.low >>> 0, e.totalLoadTime.high >>> 0).toNumber() : e.totalLoadTime), e.browserInfo != null && j.hasOwnProperty.call(e, "browserInfo") && (r.browserInfo = U.BrowserInfo.toObject(e.browserInfo, t, n + 1)), e.machineIdV4 != null && j.hasOwnProperty.call(e, "machineIdV4") && (r.machineIdV4 = e.machineIdV4), e.serverOs != null && j.hasOwnProperty.call(e, "serverOs") && (r.serverOs = e.serverOs), e.hasDisplay != null && j.hasOwnProperty.call(e, "hasDisplay") && (r.hasDisplay = e.hasDisplay), e.isWebdriver != null && j.hasOwnProperty.call(e, "isWebdriver") && (r.isWebdriver = e.isWebdriver), e.serverMode != null && j.hasOwnProperty.call(e, "serverMode") && (r.serverMode = e.serverMode), e.installedSkills && e.installedSkills.length) {
			r.installedSkills = B(e.installedSkills.length);
			for (let t = 0; t < e.installedSkills.length; ++t) r.installedSkills[t] = e.installedSkills[t];
		}
		if (e.installedAgents && e.installedAgents.length) {
			r.installedAgents = B(e.installedAgents.length);
			for (let t = 0; t < e.installedAgents.length; ++t) r.installedAgents[t] = e.installedAgents[t];
		}
		return e.surface != null && j.hasOwnProperty.call(e, "surface") && (r.surface = e.surface), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/MetricsEvent";
	}, e;
})(), U.BrowserInfo = (() => {
	let e = function(e) {
		if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
	};
	return e.prototype.browserName = "", e.prototype.browserVersion = "", e.prototype.deviceType = "", e.prototype.os = "", e.create = function(t) {
		return new e(t);
	}, e.encode = function(e, t, n) {
		if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		if (e.browserName != null && j.hasOwnProperty.call(e, "browserName") && e.browserName !== "" && t.uint32(10).string(e.browserName), e.browserVersion != null && j.hasOwnProperty.call(e, "browserVersion") && e.browserVersion !== "" && t.uint32(18).string(e.browserVersion), e.deviceType != null && j.hasOwnProperty.call(e, "deviceType") && e.deviceType !== "" && t.uint32(26).string(e.deviceType), e.os != null && j.hasOwnProperty.call(e, "os") && e.os !== "" && t.uint32(34).string(e.os), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
		return t;
	}, e.decode = function(e, t, n, r, i) {
		if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
		let a, o, s;
		if (t === M) a = e.len;
		else {
			if (a = e.pos + t, a > e.len) throw P("index out of range");
			t = e.len, e.len = a;
		}
		for (o = i || new U.BrowserInfo(); e.pos < a;) {
			let t = e.pos, i = e.tag();
			if (i === n) {
				n = M;
				break;
			}
			let a = i & 7;
			switch (i >>>= 3) {
				case 1:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.browserName = s : delete o.browserName;
					continue;
				case 2:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.browserVersion = s : delete o.browserVersion;
					continue;
				case 3:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.deviceType = s : delete o.deviceType;
					continue;
				case 4:
					if (a !== 2) break;
					(s = e.stringVerify()).length ? o.os = s : delete o.os;
					continue;
			}
			e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
		}
		if (t !== M) {
			if (e.pos !== a) throw P("index out of range");
			e.len = t;
		}
		if (n !== M) throw N("missing end group");
		return o;
	}, e.fromObject = function(e, t) {
		if (e instanceof U.BrowserInfo) return e;
		if (!A.isObject(e)) throw F(".BrowserInfo: object expected");
		if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
		let n = new U.BrowserInfo();
		return e.browserName != null && (typeof e.browserName != "string" || e.browserName.length) && (n.browserName = I(e.browserName)), e.browserVersion != null && (typeof e.browserVersion != "string" || e.browserVersion.length) && (n.browserVersion = I(e.browserVersion)), e.deviceType != null && (typeof e.deviceType != "string" || e.deviceType.length) && (n.deviceType = I(e.deviceType)), e.os != null && (typeof e.os != "string" || e.os.length) && (n.os = I(e.os)), n;
	}, e.toObject = function(e, t, n) {
		if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
		let r = {};
		return t.defaults && (r.browserName = "", r.browserVersion = "", r.deviceType = "", r.os = ""), e.browserName != null && j.hasOwnProperty.call(e, "browserName") && (r.browserName = e.browserName), e.browserVersion != null && j.hasOwnProperty.call(e, "browserVersion") && (r.browserVersion = e.browserVersion), e.deviceType != null && j.hasOwnProperty.call(e, "deviceType") && (r.deviceType = e.deviceType), e.os != null && j.hasOwnProperty.call(e, "os") && (r.os = e.os), r;
	}, e.prototype.toJSON = function() {
		return e.toObject(this, D.util.toJSONOptions);
	}, e.getTypeUrl = function(e) {
		return e === M && (e = "type.googleapis.com"), e + "/BrowserInfo";
	}, e;
})(), U.openmetrics = (() => {
	let e = {};
	return e.MetricSet = (function() {
		let e = function(e) {
			if (this.metricFamilies = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.metricFamilies = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.metricFamilies != null && e.metricFamilies.length) for (let r = 0; r < e.metricFamilies.length; ++r) U.openmetrics.MetricFamily.encode(e.metricFamilies[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.MetricSet(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.metricFamilies && o.metricFamilies.length || (o.metricFamilies = []), o.metricFamilies.push(U.openmetrics.MetricFamily.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.MetricSet) return e;
			if (!A.isObject(e)) throw F(".openmetrics.MetricSet: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.MetricSet();
			if (e.metricFamilies) {
				if (!B.isArray(e.metricFamilies)) throw F(".openmetrics.MetricSet.metricFamilies: array expected");
				n.metricFamilies = B(e.metricFamilies.length);
				for (let r = 0; r < e.metricFamilies.length; ++r) {
					if (!A.isObject(e.metricFamilies[r])) throw F(".openmetrics.MetricSet.metricFamilies: object expected");
					n.metricFamilies[r] = U.openmetrics.MetricFamily.fromObject(e.metricFamilies[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.metricFamilies = []), e.metricFamilies && e.metricFamilies.length) {
				r.metricFamilies = B(e.metricFamilies.length);
				for (let i = 0; i < e.metricFamilies.length; ++i) r.metricFamilies[i] = U.openmetrics.MetricFamily.toObject(e.metricFamilies[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.MetricSet";
		}, e;
	})(), e.MetricFamily = (function() {
		let e = function(e) {
			if (this.metrics = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.name = "", e.prototype.type = 0, e.prototype.unit = "", e.prototype.help = "", e.prototype.metrics = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.type != null && j.hasOwnProperty.call(e, "type") && e.type !== 0 && t.uint32(16).int32(e.type), e.unit != null && j.hasOwnProperty.call(e, "unit") && e.unit !== "" && t.uint32(26).string(e.unit), e.help != null && j.hasOwnProperty.call(e, "help") && e.help !== "" && t.uint32(34).string(e.help), e.metrics != null && e.metrics.length) for (let r = 0; r < e.metrics.length; ++r) U.Metric.encode(e.metrics[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.MetricFamily(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 0) break;
						(s = e.int32()) ? o.type = s : delete o.type;
						continue;
					case 3:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.unit = s : delete o.unit;
						continue;
					case 4:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.help = s : delete o.help;
						continue;
					case 5:
						if (a !== 2) break;
						o.metrics && o.metrics.length || (o.metrics = []), o.metrics.push(U.Metric.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.MetricFamily) return e;
			if (!A.isObject(e)) throw F(".openmetrics.MetricFamily: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.MetricFamily();
			if (e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.type !== 0 && (typeof e.type != "string" || U.openmetrics.MetricType[e.type] !== 0)) switch (e.type) {
				case "UNKNOWN":
				case 0:
					n.type = 0;
					break;
				case "GAUGE":
				case 1:
					n.type = 1;
					break;
				case "COUNTER":
				case 2:
					n.type = 2;
					break;
				case "STATE_SET":
				case 3:
					n.type = 3;
					break;
				case "INFO":
				case 4:
					n.type = 4;
					break;
				case "HISTOGRAM":
				case 5:
					n.type = 5;
					break;
				case "GAUGE_HISTOGRAM":
				case 6:
					n.type = 6;
					break;
				case "SUMMARY":
				case 7:
					n.type = 7;
					break;
				default: typeof e.type == "number" && (e.type | 0) === e.type && (n.type = e.type);
			}
			if (e.unit != null && (typeof e.unit != "string" || e.unit.length) && (n.unit = I(e.unit)), e.help != null && (typeof e.help != "string" || e.help.length) && (n.help = I(e.help)), e.metrics) {
				if (!B.isArray(e.metrics)) throw F(".openmetrics.MetricFamily.metrics: array expected");
				n.metrics = B(e.metrics.length);
				for (let r = 0; r < e.metrics.length; ++r) {
					if (!A.isObject(e.metrics[r])) throw F(".openmetrics.MetricFamily.metrics: object expected");
					n.metrics[r] = U.Metric.fromObject(e.metrics[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.metrics = []), t.defaults && (r.name = "", r.type = t.enums === I ? "UNKNOWN" : 0, r.unit = "", r.help = ""), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.type != null && j.hasOwnProperty.call(e, "type") && (r.type = t.enums === I ? U.openmetrics.MetricType[e.type] === M ? e.type : U.openmetrics.MetricType[e.type] : e.type), e.unit != null && j.hasOwnProperty.call(e, "unit") && (r.unit = e.unit), e.help != null && j.hasOwnProperty.call(e, "help") && (r.help = e.help), e.metrics && e.metrics.length) {
				r.metrics = B(e.metrics.length);
				for (let i = 0; i < e.metrics.length; ++i) r.metrics[i] = U.Metric.toObject(e.metrics[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.MetricFamily";
		}, e;
	})(), e.MetricType = (function() {
		let e = j.create(null), t = j.create(e);
		return t[e[0] = "UNKNOWN"] = 0, t[e[1] = "GAUGE"] = 1, t[e[2] = "COUNTER"] = 2, t[e[3] = "STATE_SET"] = 3, t[e[4] = "INFO"] = 4, t[e[5] = "HISTOGRAM"] = 5, t[e[6] = "GAUGE_HISTOGRAM"] = 6, t[e[7] = "SUMMARY"] = 7, t;
	})(), e.Metric = (function() {
		let e = function(e) {
			if (this.labels = [], this.metricPoints = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.labels = A.emptyArray, e.prototype.metricPoints = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.labels != null && e.labels.length) for (let r = 0; r < e.labels.length; ++r) U.openmetrics.Label.encode(e.labels[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.metricPoints != null && e.metricPoints.length) for (let r = 0; r < e.metricPoints.length; ++r) U.openmetrics.MetricPoint.encode(e.metricPoints[r], t.uint32(18).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.Metric(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.labels && o.labels.length || (o.labels = []), o.labels.push(U.openmetrics.Label.decode(e, e.uint32(), M, r + 1));
						continue;
					case 2:
						if (a !== 2) break;
						o.metricPoints && o.metricPoints.length || (o.metricPoints = []), o.metricPoints.push(U.openmetrics.MetricPoint.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.Metric) return e;
			if (!A.isObject(e)) throw F(".openmetrics.Metric: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.Metric();
			if (e.labels) {
				if (!B.isArray(e.labels)) throw F(".openmetrics.Metric.labels: array expected");
				n.labels = B(e.labels.length);
				for (let r = 0; r < e.labels.length; ++r) {
					if (!A.isObject(e.labels[r])) throw F(".openmetrics.Metric.labels: object expected");
					n.labels[r] = U.openmetrics.Label.fromObject(e.labels[r], t + 1);
				}
			}
			if (e.metricPoints) {
				if (!B.isArray(e.metricPoints)) throw F(".openmetrics.Metric.metricPoints: array expected");
				n.metricPoints = B(e.metricPoints.length);
				for (let r = 0; r < e.metricPoints.length; ++r) {
					if (!A.isObject(e.metricPoints[r])) throw F(".openmetrics.Metric.metricPoints: object expected");
					n.metricPoints[r] = U.openmetrics.MetricPoint.fromObject(e.metricPoints[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.labels = [], r.metricPoints = []), e.labels && e.labels.length) {
				r.labels = B(e.labels.length);
				for (let i = 0; i < e.labels.length; ++i) r.labels[i] = U.openmetrics.Label.toObject(e.labels[i], t, n + 1);
			}
			if (e.metricPoints && e.metricPoints.length) {
				r.metricPoints = B(e.metricPoints.length);
				for (let i = 0; i < e.metricPoints.length; ++i) r.metricPoints[i] = U.openmetrics.MetricPoint.toObject(e.metricPoints[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.Metric";
		}, e;
	})(), e.Label = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.name = "", e.prototype.value = "", e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(10).string(e.name), e.value != null && j.hasOwnProperty.call(e, "value") && e.value !== "" && t.uint32(18).string(e.value), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.Label(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.name = s : delete o.name;
						continue;
					case 2:
						if (a !== 2) break;
						(s = e.stringVerify()).length ? o.value = s : delete o.value;
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.Label) return e;
			if (!A.isObject(e)) throw F(".openmetrics.Label: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.Label();
			return e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), e.value != null && (typeof e.value != "string" || e.value.length) && (n.value = I(e.value)), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.name = "", r.value = ""), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = e.value), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.Label";
		}, e;
	})(), e.MetricPoint = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.unknownValue = null, e.prototype.gaugeValue = null, e.prototype.counterValue = null, e.prototype.histogramValue = null, e.prototype.stateSetValue = null, e.prototype.infoValue = null, e.prototype.summaryValue = null, e.prototype.timestamp = null;
		let t;
		return j.defineProperty(e.prototype, "value", {
			get: A.oneOfGetter(t = [
				"unknownValue",
				"gaugeValue",
				"counterValue",
				"histogramValue",
				"stateSetValue",
				"infoValue",
				"summaryValue"
			]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.unknownValue != null && j.hasOwnProperty.call(e, "unknownValue") && U.openmetrics.UnknownValue.encode(e.unknownValue, t.uint32(10).fork(), n + 1).ldelim(), e.gaugeValue != null && j.hasOwnProperty.call(e, "gaugeValue") && U.openmetrics.GaugeValue.encode(e.gaugeValue, t.uint32(18).fork(), n + 1).ldelim(), e.counterValue != null && j.hasOwnProperty.call(e, "counterValue") && U.openmetrics.CounterValue.encode(e.counterValue, t.uint32(26).fork(), n + 1).ldelim(), e.histogramValue != null && j.hasOwnProperty.call(e, "histogramValue") && U.openmetrics.HistogramValue.encode(e.histogramValue, t.uint32(34).fork(), n + 1).ldelim(), e.stateSetValue != null && j.hasOwnProperty.call(e, "stateSetValue") && U.openmetrics.StateSetValue.encode(e.stateSetValue, t.uint32(42).fork(), n + 1).ldelim(), e.infoValue != null && j.hasOwnProperty.call(e, "infoValue") && U.openmetrics.InfoValue.encode(e.infoValue, t.uint32(50).fork(), n + 1).ldelim(), e.summaryValue != null && j.hasOwnProperty.call(e, "summaryValue") && U.openmetrics.SummaryValue.encode(e.summaryValue, t.uint32(58).fork(), n + 1).ldelim(), e.timestamp != null && j.hasOwnProperty.call(e, "timestamp") && U.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(66).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.MetricPoint(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.unknownValue = U.openmetrics.UnknownValue.decode(e, e.uint32(), M, r + 1, o.unknownValue), o.value = "unknownValue";
						continue;
					case 2:
						if (a !== 2) break;
						o.gaugeValue = U.openmetrics.GaugeValue.decode(e, e.uint32(), M, r + 1, o.gaugeValue), o.value = "gaugeValue";
						continue;
					case 3:
						if (a !== 2) break;
						o.counterValue = U.openmetrics.CounterValue.decode(e, e.uint32(), M, r + 1, o.counterValue), o.value = "counterValue";
						continue;
					case 4:
						if (a !== 2) break;
						o.histogramValue = U.openmetrics.HistogramValue.decode(e, e.uint32(), M, r + 1, o.histogramValue), o.value = "histogramValue";
						continue;
					case 5:
						if (a !== 2) break;
						o.stateSetValue = U.openmetrics.StateSetValue.decode(e, e.uint32(), M, r + 1, o.stateSetValue), o.value = "stateSetValue";
						continue;
					case 6:
						if (a !== 2) break;
						o.infoValue = U.openmetrics.InfoValue.decode(e, e.uint32(), M, r + 1, o.infoValue), o.value = "infoValue";
						continue;
					case 7:
						if (a !== 2) break;
						o.summaryValue = U.openmetrics.SummaryValue.decode(e, e.uint32(), M, r + 1, o.summaryValue), o.value = "summaryValue";
						continue;
					case 8:
						if (a !== 2) break;
						o.timestamp = U.google.protobuf.Timestamp.decode(e, e.uint32(), M, r + 1, o.timestamp);
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.MetricPoint) return e;
			if (!A.isObject(e)) throw F(".openmetrics.MetricPoint: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.MetricPoint();
			if (e.unknownValue != null) {
				if (!A.isObject(e.unknownValue)) throw F(".openmetrics.MetricPoint.unknownValue: object expected");
				n.unknownValue = U.openmetrics.UnknownValue.fromObject(e.unknownValue, t + 1);
			}
			if (e.gaugeValue != null) {
				if (!A.isObject(e.gaugeValue)) throw F(".openmetrics.MetricPoint.gaugeValue: object expected");
				n.gaugeValue = U.openmetrics.GaugeValue.fromObject(e.gaugeValue, t + 1);
			}
			if (e.counterValue != null) {
				if (!A.isObject(e.counterValue)) throw F(".openmetrics.MetricPoint.counterValue: object expected");
				n.counterValue = U.openmetrics.CounterValue.fromObject(e.counterValue, t + 1);
			}
			if (e.histogramValue != null) {
				if (!A.isObject(e.histogramValue)) throw F(".openmetrics.MetricPoint.histogramValue: object expected");
				n.histogramValue = U.openmetrics.HistogramValue.fromObject(e.histogramValue, t + 1);
			}
			if (e.stateSetValue != null) {
				if (!A.isObject(e.stateSetValue)) throw F(".openmetrics.MetricPoint.stateSetValue: object expected");
				n.stateSetValue = U.openmetrics.StateSetValue.fromObject(e.stateSetValue, t + 1);
			}
			if (e.infoValue != null) {
				if (!A.isObject(e.infoValue)) throw F(".openmetrics.MetricPoint.infoValue: object expected");
				n.infoValue = U.openmetrics.InfoValue.fromObject(e.infoValue, t + 1);
			}
			if (e.summaryValue != null) {
				if (!A.isObject(e.summaryValue)) throw F(".openmetrics.MetricPoint.summaryValue: object expected");
				n.summaryValue = U.openmetrics.SummaryValue.fromObject(e.summaryValue, t + 1);
			}
			if (e.timestamp != null) {
				if (!A.isObject(e.timestamp)) throw F(".openmetrics.MetricPoint.timestamp: object expected");
				n.timestamp = U.google.protobuf.Timestamp.fromObject(e.timestamp, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.timestamp = null), e.unknownValue != null && j.hasOwnProperty.call(e, "unknownValue") && (r.unknownValue = U.openmetrics.UnknownValue.toObject(e.unknownValue, t, n + 1), t.oneofs && (r.value = "unknownValue")), e.gaugeValue != null && j.hasOwnProperty.call(e, "gaugeValue") && (r.gaugeValue = U.openmetrics.GaugeValue.toObject(e.gaugeValue, t, n + 1), t.oneofs && (r.value = "gaugeValue")), e.counterValue != null && j.hasOwnProperty.call(e, "counterValue") && (r.counterValue = U.openmetrics.CounterValue.toObject(e.counterValue, t, n + 1), t.oneofs && (r.value = "counterValue")), e.histogramValue != null && j.hasOwnProperty.call(e, "histogramValue") && (r.histogramValue = U.openmetrics.HistogramValue.toObject(e.histogramValue, t, n + 1), t.oneofs && (r.value = "histogramValue")), e.stateSetValue != null && j.hasOwnProperty.call(e, "stateSetValue") && (r.stateSetValue = U.openmetrics.StateSetValue.toObject(e.stateSetValue, t, n + 1), t.oneofs && (r.value = "stateSetValue")), e.infoValue != null && j.hasOwnProperty.call(e, "infoValue") && (r.infoValue = U.openmetrics.InfoValue.toObject(e.infoValue, t, n + 1), t.oneofs && (r.value = "infoValue")), e.summaryValue != null && j.hasOwnProperty.call(e, "summaryValue") && (r.summaryValue = U.openmetrics.SummaryValue.toObject(e.summaryValue, t, n + 1), t.oneofs && (r.value = "summaryValue")), e.timestamp != null && j.hasOwnProperty.call(e, "timestamp") && (r.timestamp = U.google.protobuf.Timestamp.toObject(e.timestamp, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.MetricPoint";
		}, e;
	})(), e.UnknownValue = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.doubleValue = null, e.prototype.intValue = null;
		let t;
		return j.defineProperty(e.prototype, "value", {
			get: A.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.UnknownValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.value = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.value = "intValue";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.UnknownValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.UnknownValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.UnknownValue();
			return e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.UnknownValue";
		}, e;
	})(), e.GaugeValue = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.doubleValue = null, e.prototype.intValue = null;
		let t;
		return j.defineProperty(e.prototype, "value", {
			get: A.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.GaugeValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.value = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.value = "intValue";
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.GaugeValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.GaugeValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.GaugeValue();
			return e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.value = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.value = "intValue")), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.GaugeValue";
		}, e;
	})(), e.CounterValue = (function() {
		let e = function(e) {
			if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.created = null, e.prototype.exemplar = null;
		let t;
		return j.defineProperty(e.prototype, "total", {
			get: A.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(16).uint64(e.intValue), e.created != null && j.hasOwnProperty.call(e, "created") && U.google.protobuf.Timestamp.encode(e.created, t.uint32(26).fork(), n + 1).ldelim(), e.exemplar != null && j.hasOwnProperty.call(e, "exemplar") && U.openmetrics.Exemplar.encode(e.exemplar, t.uint32(34).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.CounterValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.total = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.uint64(), o.total = "intValue";
						continue;
					case 3:
						if (a !== 2) break;
						o.created = U.google.protobuf.Timestamp.decode(e, e.uint32(), M, r + 1, o.created);
						continue;
					case 4:
						if (a !== 2) break;
						o.exemplar = U.openmetrics.Exemplar.decode(e, e.uint32(), M, r + 1, o.exemplar);
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.CounterValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.CounterValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.CounterValue();
			if (e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !0) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0))), e.created != null) {
				if (!A.isObject(e.created)) throw F(".openmetrics.CounterValue.created: object expected");
				n.created = U.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.exemplar != null) {
				if (!A.isObject(e.exemplar)) throw F(".openmetrics.CounterValue.exemplar: object expected");
				n.exemplar = U.openmetrics.Exemplar.fromObject(e.exemplar, t + 1);
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			return t.defaults && (r.created = null, r.exemplar = null), e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.total = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !0).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber(!0) : e.intValue, t.oneofs && (r.total = "intValue")), e.created != null && j.hasOwnProperty.call(e, "created") && (r.created = U.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.exemplar != null && j.hasOwnProperty.call(e, "exemplar") && (r.exemplar = U.openmetrics.Exemplar.toObject(e.exemplar, t, n + 1)), r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.CounterValue";
		}, e;
	})(), e.HistogramValue = (function() {
		let e = function(e) {
			if (this.buckets = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.count = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.created = null, e.prototype.buckets = A.emptyArray;
		let t;
		return j.defineProperty(e.prototype, "sum", {
			get: A.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.count != null && j.hasOwnProperty.call(e, "count") && (typeof e.count == "object" ? e.count.low || e.count.high : e.count !== 0) && t.uint32(24).uint64(e.count), e.created != null && j.hasOwnProperty.call(e, "created") && U.google.protobuf.Timestamp.encode(e.created, t.uint32(34).fork(), n + 1).ldelim(), e.buckets != null && e.buckets.length) for (let r = 0; r < e.buckets.length; ++r) U.openmetrics.HistogramValue.Bucket.encode(e.buckets[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.HistogramValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.sum = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.sum = "intValue";
						continue;
					case 3:
						if (a !== 0) break;
						(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
						continue;
					case 4:
						if (a !== 2) break;
						o.created = U.google.protobuf.Timestamp.decode(e, e.uint32(), M, r + 1, o.created);
						continue;
					case 5:
						if (a !== 2) break;
						o.buckets && o.buckets.length || (o.buckets = []), o.buckets.push(U.openmetrics.HistogramValue.Bucket.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.HistogramValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.HistogramValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.HistogramValue();
			if (e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : R(e.count) !== 0) && (A.Long ? n.count = A.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = V(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
				if (!A.isObject(e.created)) throw F(".openmetrics.HistogramValue.created: object expected");
				n.created = U.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.buckets) {
				if (!B.isArray(e.buckets)) throw F(".openmetrics.HistogramValue.buckets: array expected");
				n.buckets = B(e.buckets.length);
				for (let r = 0; r < e.buckets.length; ++r) {
					if (!A.isObject(e.buckets[r])) throw F(".openmetrics.HistogramValue.buckets: object expected");
					n.buckets[r] = U.openmetrics.HistogramValue.Bucket.fromObject(e.buckets[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.buckets = []), t.defaults) {
				if (A.Long) {
					let e = new A.Long(0, 0, !0);
					r.count = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
				} else r.count = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
				r.created = null;
			}
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.sum = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.sum = "intValue")), e.count != null && j.hasOwnProperty.call(e, "count") && (r.count = H !== void 0 && t.longs === H ? typeof e.count == "number" ? H(e.count) : A.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? t.longs === I ? I(e.count) : e.count : t.longs === I ? A.Long.prototype.toString.call(e.count) : t.longs === R ? new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && j.hasOwnProperty.call(e, "created") && (r.created = U.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.buckets && e.buckets.length) {
				r.buckets = B(e.buckets.length);
				for (let i = 0; i < e.buckets.length; ++i) r.buckets[i] = U.openmetrics.HistogramValue.Bucket.toObject(e.buckets[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue";
		}, e.Bucket = (function() {
			let e = function(e) {
				if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			};
			return e.prototype.count = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.upperBound = 0, e.prototype.exemplar = null, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				if (e.count != null && j.hasOwnProperty.call(e, "count") && (typeof e.count == "object" ? e.count.low || e.count.high : e.count !== 0) && t.uint32(8).uint64(e.count), e.upperBound != null && j.hasOwnProperty.call(e, "upperBound") && !j.is(e.upperBound, 0) && t.uint32(17).double(e.upperBound), e.exemplar != null && j.hasOwnProperty.call(e, "exemplar") && U.openmetrics.Exemplar.encode(e.exemplar, t.uint32(26).fork(), n + 1).ldelim(), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
				let a, o, s;
				if (t === M) a = e.len;
				else {
					if (a = e.pos + t, a > e.len) throw P("index out of range");
					t = e.len, e.len = a;
				}
				for (o = i || new U.openmetrics.HistogramValue.Bucket(); e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = M;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
							continue;
						case 2:
							if (a !== 1) break;
							j.is(s = e.double(), 0) ? delete o.upperBound : o.upperBound = s;
							continue;
						case 3:
							if (a !== 2) break;
							o.exemplar = U.openmetrics.Exemplar.decode(e, e.uint32(), M, r + 1, o.exemplar);
							continue;
					}
					e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
				}
				if (t !== M) {
					if (e.pos !== a) throw P("index out of range");
					e.len = t;
				}
				if (n !== M) throw N("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof U.openmetrics.HistogramValue.Bucket) return e;
				if (!A.isObject(e)) throw F(".openmetrics.HistogramValue.Bucket: object expected");
				if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
				let n = new U.openmetrics.HistogramValue.Bucket();
				if (e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : R(e.count) !== 0) && (A.Long ? n.count = A.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = V(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.upperBound != null && (j.is(R(e.upperBound), 0) || (n.upperBound = R(e.upperBound))), e.exemplar != null) {
					if (!A.isObject(e.exemplar)) throw F(".openmetrics.HistogramValue.Bucket.exemplar: object expected");
					n.exemplar = U.openmetrics.Exemplar.fromObject(e.exemplar, t + 1);
				}
				return n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				let r = {};
				if (t.defaults) {
					if (A.Long) {
						let e = new A.Long(0, 0, !0);
						r.count = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
					} else r.count = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
					r.upperBound = 0, r.exemplar = null;
				}
				return e.count != null && j.hasOwnProperty.call(e, "count") && (r.count = H !== void 0 && t.longs === H ? typeof e.count == "number" ? H(e.count) : A.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? t.longs === I ? I(e.count) : e.count : t.longs === I ? A.Long.prototype.toString.call(e.count) : t.longs === R ? new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.upperBound != null && j.hasOwnProperty.call(e, "upperBound") && (r.upperBound = t.json && !z(e.upperBound) ? I(e.upperBound) : e.upperBound), e.exemplar != null && j.hasOwnProperty.call(e, "exemplar") && (r.exemplar = U.openmetrics.Exemplar.toObject(e.exemplar, t, n + 1)), r;
			}, e.prototype.toJSON = function() {
				return e.toObject(this, D.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === M && (e = "type.googleapis.com"), e + "/openmetrics.HistogramValue.Bucket";
			}, e;
		})(), e;
	})(), e.Exemplar = (function() {
		let e = function(e) {
			if (this.label = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.value = 0, e.prototype.timestamp = null, e.prototype.label = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.value != null && j.hasOwnProperty.call(e, "value") && !j.is(e.value, 0) && t.uint32(9).double(e.value), e.timestamp != null && j.hasOwnProperty.call(e, "timestamp") && U.google.protobuf.Timestamp.encode(e.timestamp, t.uint32(18).fork(), n + 1).ldelim(), e.label != null && e.label.length) for (let r = 0; r < e.label.length; ++r) U.openmetrics.Label.encode(e.label[r], t.uint32(26).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.Exemplar(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						j.is(s = e.double(), 0) ? delete o.value : o.value = s;
						continue;
					case 2:
						if (a !== 2) break;
						o.timestamp = U.google.protobuf.Timestamp.decode(e, e.uint32(), M, r + 1, o.timestamp);
						continue;
					case 3:
						if (a !== 2) break;
						o.label && o.label.length || (o.label = []), o.label.push(U.openmetrics.Label.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.Exemplar) return e;
			if (!A.isObject(e)) throw F(".openmetrics.Exemplar: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.Exemplar();
			if (e.value != null && (j.is(R(e.value), 0) || (n.value = R(e.value))), e.timestamp != null) {
				if (!A.isObject(e.timestamp)) throw F(".openmetrics.Exemplar.timestamp: object expected");
				n.timestamp = U.google.protobuf.Timestamp.fromObject(e.timestamp, t + 1);
			}
			if (e.label) {
				if (!B.isArray(e.label)) throw F(".openmetrics.Exemplar.label: array expected");
				n.label = B(e.label.length);
				for (let r = 0; r < e.label.length; ++r) {
					if (!A.isObject(e.label[r])) throw F(".openmetrics.Exemplar.label: object expected");
					n.label[r] = U.openmetrics.Label.fromObject(e.label[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.label = []), t.defaults && (r.value = 0, r.timestamp = null), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = t.json && !z(e.value) ? I(e.value) : e.value), e.timestamp != null && j.hasOwnProperty.call(e, "timestamp") && (r.timestamp = U.google.protobuf.Timestamp.toObject(e.timestamp, t, n + 1)), e.label && e.label.length) {
				r.label = B(e.label.length);
				for (let i = 0; i < e.label.length; ++i) r.label[i] = U.openmetrics.Label.toObject(e.label[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.Exemplar";
		}, e;
	})(), e.StateSetValue = (function() {
		let e = function(e) {
			if (this.states = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.states = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.states != null && e.states.length) for (let r = 0; r < e.states.length; ++r) U.openmetrics.StateSetValue.State.encode(e.states[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.StateSetValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.states && o.states.length || (o.states = []), o.states.push(U.openmetrics.StateSetValue.State.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.StateSetValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.StateSetValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.StateSetValue();
			if (e.states) {
				if (!B.isArray(e.states)) throw F(".openmetrics.StateSetValue.states: array expected");
				n.states = B(e.states.length);
				for (let r = 0; r < e.states.length; ++r) {
					if (!A.isObject(e.states[r])) throw F(".openmetrics.StateSetValue.states: object expected");
					n.states[r] = U.openmetrics.StateSetValue.State.fromObject(e.states[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.states = []), e.states && e.states.length) {
				r.states = B(e.states.length);
				for (let i = 0; i < e.states.length; ++i) r.states[i] = U.openmetrics.StateSetValue.State.toObject(e.states[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue";
		}, e.State = (function() {
			let e = function(e) {
				if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			};
			return e.prototype.enabled = !1, e.prototype.name = "", e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				if (e.enabled != null && j.hasOwnProperty.call(e, "enabled") && e.enabled !== !1 && t.uint32(8).bool(e.enabled), e.name != null && j.hasOwnProperty.call(e, "name") && e.name !== "" && t.uint32(18).string(e.name), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
				let a, o, s;
				if (t === M) a = e.len;
				else {
					if (a = e.pos + t, a > e.len) throw P("index out of range");
					t = e.len, e.len = a;
				}
				for (o = i || new U.openmetrics.StateSetValue.State(); e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = M;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(s = e.bool()) ? o.enabled = s : delete o.enabled;
							continue;
						case 2:
							if (a !== 2) break;
							(s = e.stringVerify()).length ? o.name = s : delete o.name;
							continue;
					}
					e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
				}
				if (t !== M) {
					if (e.pos !== a) throw P("index out of range");
					e.len = t;
				}
				if (n !== M) throw N("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof U.openmetrics.StateSetValue.State) return e;
				if (!A.isObject(e)) throw F(".openmetrics.StateSetValue.State: object expected");
				if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
				let n = new U.openmetrics.StateSetValue.State();
				return e.enabled != null && e.enabled && (n.enabled = L(e.enabled)), e.name != null && (typeof e.name != "string" || e.name.length) && (n.name = I(e.name)), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				let r = {};
				return t.defaults && (r.enabled = !1, r.name = ""), e.enabled != null && j.hasOwnProperty.call(e, "enabled") && (r.enabled = e.enabled), e.name != null && j.hasOwnProperty.call(e, "name") && (r.name = e.name), r;
			}, e.prototype.toJSON = function() {
				return e.toObject(this, D.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === M && (e = "type.googleapis.com"), e + "/openmetrics.StateSetValue.State";
			}, e;
		})(), e;
	})(), e.InfoValue = (function() {
		let e = function(e) {
			if (this.info = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		return e.prototype.info = A.emptyArray, e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.info != null && e.info.length) for (let r = 0; r < e.info.length; ++r) U.openmetrics.Label.encode(e.info[r], t.uint32(10).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.InfoValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 2) break;
						o.info && o.info.length || (o.info = []), o.info.push(U.openmetrics.Label.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.InfoValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.InfoValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.InfoValue();
			if (e.info) {
				if (!B.isArray(e.info)) throw F(".openmetrics.InfoValue.info: array expected");
				n.info = B(e.info.length);
				for (let r = 0; r < e.info.length; ++r) {
					if (!A.isObject(e.info[r])) throw F(".openmetrics.InfoValue.info: object expected");
					n.info[r] = U.openmetrics.Label.fromObject(e.info[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.info = []), e.info && e.info.length) {
				r.info = B(e.info.length);
				for (let i = 0; i < e.info.length; ++i) r.info[i] = U.openmetrics.Label.toObject(e.info[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.InfoValue";
		}, e;
	})(), e.SummaryValue = (function() {
		let e = function(e) {
			if (this.quantile = [], e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
		};
		e.prototype.doubleValue = null, e.prototype.intValue = null, e.prototype.count = A.Long ? A.Long.fromBits(0, 0, !0) : 0, e.prototype.created = null, e.prototype.quantile = A.emptyArray;
		let t;
		return j.defineProperty(e.prototype, "sum", {
			get: A.oneOfGetter(t = ["doubleValue", "intValue"]),
			set: A.oneOfSetter(t)
		}), e.create = function(t) {
			return new e(t);
		}, e.encode = function(e, t, n) {
			if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && t.uint32(9).double(e.doubleValue), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && t.uint32(16).int64(e.intValue), e.count != null && j.hasOwnProperty.call(e, "count") && (typeof e.count == "object" ? e.count.low || e.count.high : e.count !== 0) && t.uint32(24).uint64(e.count), e.created != null && j.hasOwnProperty.call(e, "created") && U.google.protobuf.Timestamp.encode(e.created, t.uint32(34).fork(), n + 1).ldelim(), e.quantile != null && e.quantile.length) for (let r = 0; r < e.quantile.length; ++r) U.openmetrics.SummaryValue.Quantile.encode(e.quantile[r], t.uint32(42).fork(), n + 1).ldelim();
			if (e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
			return t;
		}, e.decode = function(e, t, n, r, i) {
			if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
			let a, o, s;
			if (t === M) a = e.len;
			else {
				if (a = e.pos + t, a > e.len) throw P("index out of range");
				t = e.len, e.len = a;
			}
			for (o = i || new U.openmetrics.SummaryValue(); e.pos < a;) {
				let t = e.pos, i = e.tag();
				if (i === n) {
					n = M;
					break;
				}
				let a = i & 7;
				switch (i >>>= 3) {
					case 1:
						if (a !== 1) break;
						o.doubleValue = e.double(), o.sum = "doubleValue";
						continue;
					case 2:
						if (a !== 0) break;
						o.intValue = e.int64(), o.sum = "intValue";
						continue;
					case 3:
						if (a !== 0) break;
						(typeof (s = e.uint64()) == "object" ? s.low || s.high : s !== 0) ? o.count = s : delete o.count;
						continue;
					case 4:
						if (a !== 2) break;
						o.created = U.google.protobuf.Timestamp.decode(e, e.uint32(), M, r + 1, o.created);
						continue;
					case 5:
						if (a !== 2) break;
						o.quantile && o.quantile.length || (o.quantile = []), o.quantile.push(U.openmetrics.SummaryValue.Quantile.decode(e, e.uint32(), M, r + 1));
						continue;
				}
				e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
			}
			if (t !== M) {
				if (e.pos !== a) throw P("index out of range");
				e.len = t;
			}
			if (n !== M) throw N("missing end group");
			return o;
		}, e.fromObject = function(e, t) {
			if (e instanceof U.openmetrics.SummaryValue) return e;
			if (!A.isObject(e)) throw F(".openmetrics.SummaryValue: object expected");
			if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
			let n = new U.openmetrics.SummaryValue();
			if (e.doubleValue != null && (n.doubleValue = R(e.doubleValue)), e.intValue != null && (A.Long ? n.intValue = A.Long.fromValue(e.intValue, !1) : typeof e.intValue == "string" ? n.intValue = V(e.intValue, 10) : typeof e.intValue == "number" ? n.intValue = e.intValue : typeof e.intValue == "object" && (n.intValue = new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber())), e.count != null && (typeof e.count == "object" ? e.count.low || e.count.high : R(e.count) !== 0) && (A.Long ? n.count = A.Long.fromValue(e.count, !0) : typeof e.count == "string" ? n.count = V(e.count, 10) : typeof e.count == "number" ? n.count = e.count : typeof e.count == "object" && (n.count = new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0))), e.created != null) {
				if (!A.isObject(e.created)) throw F(".openmetrics.SummaryValue.created: object expected");
				n.created = U.google.protobuf.Timestamp.fromObject(e.created, t + 1);
			}
			if (e.quantile) {
				if (!B.isArray(e.quantile)) throw F(".openmetrics.SummaryValue.quantile: array expected");
				n.quantile = B(e.quantile.length);
				for (let r = 0; r < e.quantile.length; ++r) {
					if (!A.isObject(e.quantile[r])) throw F(".openmetrics.SummaryValue.quantile: object expected");
					n.quantile[r] = U.openmetrics.SummaryValue.Quantile.fromObject(e.quantile[r], t + 1);
				}
			}
			return n;
		}, e.toObject = function(e, t, n) {
			if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
			let r = {};
			if ((t.arrays || t.defaults) && (r.quantile = []), t.defaults) {
				if (A.Long) {
					let e = new A.Long(0, 0, !0);
					r.count = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
				} else r.count = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
				r.created = null;
			}
			if (e.doubleValue != null && j.hasOwnProperty.call(e, "doubleValue") && (r.doubleValue = t.json && !z(e.doubleValue) ? I(e.doubleValue) : e.doubleValue, t.oneofs && (r.sum = "doubleValue")), e.intValue != null && j.hasOwnProperty.call(e, "intValue") && (r.intValue = H !== void 0 && t.longs === H ? typeof e.intValue == "number" ? H(e.intValue) : A.Long.fromBits(e.intValue.low >>> 0, e.intValue.high >>> 0, !1).toBigInt() : typeof e.intValue == "number" ? t.longs === I ? I(e.intValue) : e.intValue : t.longs === I ? A.Long.prototype.toString.call(e.intValue) : t.longs === R ? new A.LongBits(e.intValue.low >>> 0, e.intValue.high >>> 0).toNumber() : e.intValue, t.oneofs && (r.sum = "intValue")), e.count != null && j.hasOwnProperty.call(e, "count") && (r.count = H !== void 0 && t.longs === H ? typeof e.count == "number" ? H(e.count) : A.Long.fromBits(e.count.low >>> 0, e.count.high >>> 0, !0).toBigInt() : typeof e.count == "number" ? t.longs === I ? I(e.count) : e.count : t.longs === I ? A.Long.prototype.toString.call(e.count) : t.longs === R ? new A.LongBits(e.count.low >>> 0, e.count.high >>> 0).toNumber(!0) : e.count), e.created != null && j.hasOwnProperty.call(e, "created") && (r.created = U.google.protobuf.Timestamp.toObject(e.created, t, n + 1)), e.quantile && e.quantile.length) {
				r.quantile = B(e.quantile.length);
				for (let i = 0; i < e.quantile.length; ++i) r.quantile[i] = U.openmetrics.SummaryValue.Quantile.toObject(e.quantile[i], t, n + 1);
			}
			return r;
		}, e.prototype.toJSON = function() {
			return e.toObject(this, D.util.toJSONOptions);
		}, e.getTypeUrl = function(e) {
			return e === M && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue";
		}, e.Quantile = (function() {
			let e = function(e) {
				if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			};
			return e.prototype.quantile = 0, e.prototype.value = 0, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				if (e.quantile != null && j.hasOwnProperty.call(e, "quantile") && !j.is(e.quantile, 0) && t.uint32(9).double(e.quantile), e.value != null && j.hasOwnProperty.call(e, "value") && !j.is(e.value, 0) && t.uint32(17).double(e.value), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
				let a, o, s;
				if (t === M) a = e.len;
				else {
					if (a = e.pos + t, a > e.len) throw P("index out of range");
					t = e.len, e.len = a;
				}
				for (o = i || new U.openmetrics.SummaryValue.Quantile(); e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = M;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 1) break;
							j.is(s = e.double(), 0) ? delete o.quantile : o.quantile = s;
							continue;
						case 2:
							if (a !== 1) break;
							j.is(s = e.double(), 0) ? delete o.value : o.value = s;
							continue;
					}
					e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
				}
				if (t !== M) {
					if (e.pos !== a) throw P("index out of range");
					e.len = t;
				}
				if (n !== M) throw N("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof U.openmetrics.SummaryValue.Quantile) return e;
				if (!A.isObject(e)) throw F(".openmetrics.SummaryValue.Quantile: object expected");
				if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
				let n = new U.openmetrics.SummaryValue.Quantile();
				return e.quantile != null && (j.is(R(e.quantile), 0) || (n.quantile = R(e.quantile))), e.value != null && (j.is(R(e.value), 0) || (n.value = R(e.value))), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				let r = {};
				return t.defaults && (r.quantile = 0, r.value = 0), e.quantile != null && j.hasOwnProperty.call(e, "quantile") && (r.quantile = t.json && !z(e.quantile) ? I(e.quantile) : e.quantile), e.value != null && j.hasOwnProperty.call(e, "value") && (r.value = t.json && !z(e.value) ? I(e.value) : e.value), r;
			}, e.prototype.toJSON = function() {
				return e.toObject(this, D.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === M && (e = "type.googleapis.com"), e + "/openmetrics.SummaryValue.Quantile";
			}, e;
		})(), e;
	})(), e;
})(), U.google = (() => {
	let e = {};
	return e.protobuf = (function() {
		let e = {};
		return e.Timestamp = (function() {
			let e = function(e) {
				if (e) for (let t = j.keys(e), n = 0; n < t.length; ++n) e[t[n]] != null && t[n] !== "__proto__" && (this[t[n]] = e[t[n]]);
			};
			return e.prototype.seconds = A.Long ? A.Long.fromBits(0, 0, !1) : 0, e.prototype.nanos = 0, e.create = function(t) {
				return new e(t);
			}, e.encode = function(e, t, n) {
				if (t ||= k.create(), n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				if (e.seconds != null && j.hasOwnProperty.call(e, "seconds") && (typeof e.seconds == "object" ? e.seconds.low || e.seconds.high : e.seconds !== 0) && t.uint32(8).int64(e.seconds), e.nanos != null && j.hasOwnProperty.call(e, "nanos") && e.nanos !== 0 && t.uint32(16).int32(e.nanos), e.$unknowns != null && j.hasOwnProperty.call(e, "$unknowns")) for (let n = 0; n < e.$unknowns.length; ++n) t.raw(e.$unknowns[n]);
				return t;
			}, e.decode = function(e, t, n, r, i) {
				if (e instanceof O || (e = O.create(e)), r === M && (r = 0), r > O.recursionLimit) throw N("max depth exceeded");
				let a, o, s;
				if (t === M) a = e.len;
				else {
					if (a = e.pos + t, a > e.len) throw P("index out of range");
					t = e.len, e.len = a;
				}
				for (o = i || new U.google.protobuf.Timestamp(); e.pos < a;) {
					let t = e.pos, i = e.tag();
					if (i === n) {
						n = M;
						break;
					}
					let a = i & 7;
					switch (i >>>= 3) {
						case 1:
							if (a !== 0) break;
							(typeof (s = e.int64()) == "object" ? s.low || s.high : s !== 0) ? o.seconds = s : delete o.seconds;
							continue;
						case 2:
							if (a !== 0) break;
							(s = e.int32()) ? o.nanos = s : delete o.nanos;
							continue;
					}
					e.skipType(a, r, i), e.discardUnknown || (A.makeProp(o, "$unknowns", !1), (o.$unknowns || (o.$unknowns = [])).push(e.raw(t, e.pos)));
				}
				if (t !== M) {
					if (e.pos !== a) throw P("index out of range");
					e.len = t;
				}
				if (n !== M) throw N("missing end group");
				return o;
			}, e.fromObject = function(e, t) {
				if (e instanceof U.google.protobuf.Timestamp) return e;
				if (!A.isObject(e)) throw F(".google.protobuf.Timestamp: object expected");
				if (t === M && (t = 0), t > A.recursionLimit) throw N("max depth exceeded");
				let n = new U.google.protobuf.Timestamp();
				return e.seconds != null && (typeof e.seconds == "object" ? e.seconds.low || e.seconds.high : R(e.seconds) !== 0) && (A.Long ? n.seconds = A.Long.fromValue(e.seconds, !1) : typeof e.seconds == "string" ? n.seconds = V(e.seconds, 10) : typeof e.seconds == "number" ? n.seconds = e.seconds : typeof e.seconds == "object" && (n.seconds = new A.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber())), e.nanos != null && R(e.nanos) !== 0 && (n.nanos = e.nanos | 0), n;
			}, e.toObject = function(e, t, n) {
				if (t ||= {}, n === M && (n = 0), n > A.recursionLimit) throw N("max depth exceeded");
				let r = {};
				if (t.defaults) {
					if (A.Long) {
						let e = new A.Long(0, 0, !1);
						r.seconds = t.longs === I ? e.toString() : t.longs === R ? e.toNumber() : H !== void 0 && t.longs === H ? e.toBigInt() : e;
					} else r.seconds = t.longs === I ? "0" : H !== void 0 && t.longs === H ? H("0") : 0;
					r.nanos = 0;
				}
				return e.seconds != null && j.hasOwnProperty.call(e, "seconds") && (r.seconds = H !== void 0 && t.longs === H ? typeof e.seconds == "number" ? H(e.seconds) : A.Long.fromBits(e.seconds.low >>> 0, e.seconds.high >>> 0, !1).toBigInt() : typeof e.seconds == "number" ? t.longs === I ? I(e.seconds) : e.seconds : t.longs === I ? A.Long.prototype.toString.call(e.seconds) : t.longs === R ? new A.LongBits(e.seconds.low >>> 0, e.seconds.high >>> 0).toNumber() : e.seconds), e.nanos != null && j.hasOwnProperty.call(e, "nanos") && (r.nanos = e.nanos), r;
			}, e.prototype.toJSON = function() {
				return e.toObject(this, D.util.toJSONOptions);
			}, e.getTypeUrl = function(e) {
				return e === M && (e = "type.googleapis.com"), e + "/google.protobuf.Timestamp";
			}, e;
		})(), e;
	})(), e;
})(), U.RootContainer = (() => {
	let e = j.create(null), t = j.create(e);
	return t[e[0] = "MAIN"] = 0, t[e[1] = "SIDEBAR"] = 1, t[e[2] = "EVENT"] = 2, t[e[3] = "BOTTOM"] = 3, t;
})(), Promise.withResolvers === void 0 && (Promise.withResolvers = () => {
	let e, t, n = new Promise((n, r) => {
		e = n, t = r;
	});
	return {
		resolve: e,
		reject: t,
		promise: n
	};
});
function oe(e) {
	let t = document.cookie.match(`\\b${e}=([^;]*)\\b`);
	return t ? t[1] : void 0;
}
function se() {
	let e = "testData";
	try {
		let { localStorage: t } = window;
		t.setItem(e, e), t.getItem(e), t.removeItem(e);
	} catch {
		return !1;
	}
	return !0;
}
function ce(e) {
	return Array.isArray(e) && e.length > 0 && e.every((e) => typeof e == "string" && e.trim().length > 0);
}
function le(e) {
	return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
function ue(e) {
	return Object.freeze(e), Array.isArray(e) ? e.forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && ue(e);
	}) : Object.values(e).forEach((e) => {
		typeof e == "object" && e && !Object.isFrozen(e) && ue(e);
	}), e;
}
var W = (() => {
	let e = window.__streamlit;
	if (e) return ue(le(e));
})(), G = {
	get BACKEND_BASE_URL() {
		return W?.BACKEND_BASE_URL;
	},
	get HOST_CONFIG_BASE_URL() {
		return W?.HOST_CONFIG_BASE_URL;
	},
	get DOWNLOAD_ASSETS_BASE_URL() {
		return W?.DOWNLOAD_ASSETS_BASE_URL;
	},
	get MAIN_PAGE_BASE_URL() {
		return W?.MAIN_PAGE_BASE_URL;
	},
	get CUSTOM_COMPONENT_CLIENT_ID() {
		return W?.CUSTOM_COMPONENT_CLIENT_ID;
	},
	get LIGHT_THEME() {
		return W?.LIGHT_THEME;
	},
	get DARK_THEME() {
		return W?.DARK_THEME;
	},
	get ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION() {
		return W?.ENABLE_RELOAD_BASED_ON_HARDCODED_STREAMLIT_VERSION;
	},
	get HOST_CONFIG() {
		return W?.HOST_CONFIG;
	}
};
function K(e) {
	return e != null;
}
function q(e) {
	return e == null;
}
var de = /\/+$/, fe = /^\/+/;
function J({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	let a = pe(n, i);
	return `${r}//${e}${t ? `:${t}` : ""}/${a}`;
}
function pe(e, t) {
	return e = e.replace(de, "").replace(fe, ""), t = t.replace(de, "").replace(fe, ""), e.length === 0 ? t : `${e}/${t}`;
}
//#endregion
//#region src/StaticConnection.tsx
var me = "https://data.streamlit.io/static.json", he = (0, n.getLogger)("StaticConnection");
async function ge() {
	let e = se(), t = "";
	if (e) {
		let e = window.localStorage.getItem("stStaticAssetUrl");
		if (e) return e;
	}
	try {
		let n = await fetch(me, { signal: AbortSignal.timeout(5e3) });
		n.ok ? (t = (await n.json()).static_url ?? void 0, e && t && window.localStorage.setItem("stStaticAssetUrl", t)) : he.error("Failed to fetch static config url: ", n.status);
	} catch (e) {
		he.error("Failed to fetch static config url:", e);
	}
	return t;
}
async function _e(e, t) {
	let n = `${t}/${e}/protos.pb`, r = await fetch(n, { signal: AbortSignal.timeout(5e3) });
	if (!r.ok) he.error(`Failed to fetch static app protos for id: ${e}`, r.status);
	else return r.arrayBuffer();
	return null;
}
async function ve(e, t, n, r) {
	let i = await _e(e, t);
	if (!i) {
		he.error("Failed to retrieve static app protos"), r({ message: `Failed to retrieve static app protos. Please confirm the id is correct and try again. Given static app id: ${e}` });
		return;
	}
	ae.decode(new Uint8Array(i)).messages.forEach((e) => {
		n(e);
	});
}
async function ye(e, t, n, i, a) {
	t(r.STATIC_CONNECTING);
	let o = await ge();
	a.setStaticConfigUrl(o), ve(e, o, n, i), t(r.STATIC_CONNECTED);
}
//#endregion
//#region src/utils.ts
var be = /\/+$/, xe = /^\/+/;
function Se() {
	let e = G.HOST_CONFIG;
	if (!e) return !1;
	let { allowedOrigins: t, useExternalAuthToken: n } = e, r = !!G.BACKEND_BASE_URL, i = ce(t);
	return r && i && typeof n == "boolean";
}
function Ce(e) {
	let t = window.location.href === "about:blank" ? "http://localhost/" : window.location.href, n = new URL(e ?? t, t);
	return n.pathname = n.pathname.replace(be, "").replace(xe, ""), n;
}
function we() {
	let e = Ce(G.BACKEND_BASE_URL), { pathname: t } = e;
	if (t === "/") return [e];
	let n = t.split("/"), r = [];
	for (; n.length > 0;) {
		let t = new URL(e);
		t.pathname = n.join("/"), r.push(t), n.pop();
	}
	return r.length <= 2 ? r : r.slice(0, 2);
}
function Te({ hostname: e, port: t, pathname: n, protocol: r }, i) {
	return `${r === "https:" ? "wss" : "ws"}://${e}:${t}/${pe(n, i)}`;
}
function Ee(e) {
	if (e != null) switch (typeof e) {
		case "object": return JSON.stringify(e, null, 2);
		case "string":
		case "number":
		case "boolean": return String(e);
		default: return;
	}
}
var Y = class extends Error {
	constructor(e, t, n = {}) {
		super(e), this.name = "FetchError", this.url = t, this.isTimeout = n.isTimeout ?? !1, this.isNetworkError = n.isNetworkError ?? !1, this.isAborted = n.isAborted ?? !1, this.response = n.response;
	}
};
async function De(e, t, n) {
	let r = new AbortController(), i = setTimeout(() => r.abort(), t), a = () => r.abort();
	n && (n.aborted ? r.abort() : n.addEventListener("abort", a));
	let o = () => {
		clearTimeout(i), n?.removeEventListener("abort", a);
	};
	try {
		let t = await fetch(e, { signal: r.signal });
		if (o(), !t.ok) {
			let n;
			try {
				n = await t.json();
			} catch {
				try {
					n = await t.text();
				} catch {
					n = null;
				}
			}
			throw new Y(`Request failed with status ${t.status}`, e, { response: {
				status: t.status,
				statusText: t.statusText,
				data: n
			} });
		}
		let n = await t.text();
		try {
			return {
				data: JSON.parse(n),
				url: e
			};
		} catch {
			return {
				data: n,
				url: e
			};
		}
	} catch (t) {
		throw o(), t instanceof Y ? t : t instanceof DOMException && t.name === "AbortError" ? n?.aborted ? new Y("Request aborted", e, { isAborted: !0 }) : new Y("Connection timed out", e, { isTimeout: !0 }) : t instanceof TypeError ? new Y(t.message || "Network error", e, { isNetworkError: !0 }) : new Y(t instanceof Error ? t.message : "Unknown error", e);
	}
}
//#endregion
//#region src/DoInitPings.tsx
var X = (0, n.getLogger)("DoInitPings"), Oe = class extends Error {
	constructor() {
		super("Ping cancelled");
	}
};
function ke(e, t, n, r, a, c) {
	let { promise: l, resolve: u, reject: f } = Promise.withResolvers(), p = 0, m = 0, h, g = !1, _ = new AbortController(), v = () => {}, y = () => {
		g || (m++, m >= e.length && (m = 0), v());
	}, b = (e) => {
		if (g) return;
		let i = p === 1 ? t : t * 2 ** (p - 1), a = Math.min(n, i), o = p === 1 ? a : Math.floor(a * (.7 + Math.random() * .3));
		r(p, e, o), typeof window < "u" && (h = globalThis.setTimeout(y, o));
	}, x = () => {
		let t = e[m];
		new URL(J(t, "")).hostname === "localhost" ? b({
			message: "Is Streamlit still running? If you accidentally stopped Streamlit, just restart it in your terminal:",
			codeBlock: "streamlit run yourscript.py"
		}) : b({ message: "Streamlit server is not responding. Are you connected to the internet?" });
	}, S = () => {
		b({ message: `Cannot connect to Streamlit (HTTP status: 403).

If you are trying to access a Streamlit app running on another server, this could be due to the app's [CORS](${i}) settings.` });
	}, C = (e) => {
		let t = "DoInitPings";
		if (e) try {
			t = new URL(e).pathname;
		} catch {
			X.error(`unrecognized url: ${e}`);
		}
		return t;
	};
	return v = () => {
		if (g) return;
		let t = e[m], n = J(t, o), r = G.HOST_CONFIG_BASE_URL, i = J(r ? Ce(r) : t, s);
		X.info(`Attempting to connect to ${n}.`), m === 0 && p++, Promise.all([De(n, d, _.signal), De(i, d, _.signal)]).then(([e, t]) => {
			g || (c(t.data), u(m));
		}).catch((e) => {
			if (g) return;
			if (!(e instanceof Y)) {
				let t = e instanceof Error ? e.message : String(e);
				return b({ message: t });
			}
			let t = p >= 6;
			if (e.isTimeout) {
				if (t) {
					let t = C(e.url);
					X.error("Client error: DoInitPings timed out"), a("DoInitPings timed out", "Connection timed out - ECONNABORTED", t);
				}
				return b({ message: "Connection timed out." });
			}
			if (e.response) {
				let { data: n, status: r, statusText: i } = e.response, o = C(e.url);
				if (r === 0) return t && (X.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), a(`Response received with status ${r}`, i, o)), x();
				if (r === 403) return t && (X.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), a(r, i, o)), S();
				t && (X.error(`Client Error: response received with status ${r} when attempting to reach ${o}`), a(r, i, o));
				let s = Ee(n);
				return b({
					message: `Connection failed with status ${r}${s ? ", and response:" : "."}`,
					...s && { codeBlock: s }
				});
			}
			if (e.isNetworkError) {
				if (t) {
					let t = C(e.url);
					X.error(`Client Error in reaching server endpoint - No response received when attempting to reach ${t}`), a("No response received from server", "Network error", t);
				}
				return x();
			}
			if (t) {
				let t = C(e.url);
				X.error(`Client Error in reaching server endpoint - error in setting up request when attempting to reach ${t}`), a("Error setting up request to server", e.message ?? "", t);
			}
			return b({ message: e.message });
		});
	}, v(), {
		promise: l,
		cancel: () => {
			g = !0, K(h) && globalThis.clearTimeout(h), _.abort(), f(new Oe());
		}
	};
}
//#endregion
//#region src/ForwardMessageCache.ts
var Ae = (0, n.getLogger)("ForwardMessageCache"), je = class {
	getAge(e) {
		return e - this.scriptRunCount;
	}
	constructor(e, t, n) {
		this.scriptRunCount = 0, this.encodedMsg = e, this.scriptRunCount = t, this.fragmentId = n;
	}
}, Me = class {
	constructor() {
		this.messages = /* @__PURE__ */ new Map(), this.scriptRunCount = 0;
	}
	incrementRunCount(e, t) {
		this.scriptRunCount += 1, this.messages.forEach((n, r) => {
			t.length > 0 && (!n.fragmentId || !t.includes(n.fragmentId)) || n.getAge(this.scriptRunCount) > e && (Ae.info(`Removing expired ForwardMsg [hash=${r}]`), this.messages.delete(r));
		});
	}
	getCachedMessageHashes() {
		return Array.from(this.messages.keys());
	}
	async processMessagePayload(e, t) {
		if (this.maybeCacheMessage(e, t), e.type !== "refHash") return e;
		let n = this.getCachedMessage(e.refHash, !0);
		if (q(n)) throw Error(`Cached ForwardMsg MISS [hash=${e.refHash}]. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues).`);
		if (Ae.info(`Cached ForwardMsg HIT [hash=${e.refHash}]`), !e.metadata) throw Error("Reference ForwardMsg has no metadata. This is not expected to happen. Please [report this bug](https://github.com/streamlit/streamlit/issues).");
		return n.metadata = e.metadata, n;
	}
	maybeCacheMessage(e, t) {
		if (e.type !== "refHash" && e.metadata?.cacheable) {
			if (!e.hash) {
				Ae.error("ForwardMsg has no hash. This is not expected to happen, please report this bug.", e);
				return;
			}
			this.getCachedMessage(e.hash, !0) === void 0 && (Ae.info(`Caching ForwardMsg [hash=${e.hash}]`), this.messages.set(e.hash, new je(t, this.scriptRunCount, e.delta?.fragmentId ?? void 0)));
		}
	}
	getCachedMessage(e, t) {
		let n = this.messages.get(e);
		if (!q(n)) return t && (n.scriptRunCount = this.scriptRunCount), ie.decode(n.encodedMsg);
	}
}, Z = (0, n.getLogger)("WebsocketConnection"), Q = class {
	constructor(e) {
		this.uriIndex = 0, this.lastDispatchedMessageIndex = -1, this.nextMessageIndex = 0, this.messageQueue = /* @__PURE__ */ new Map(), this.state = r.INITIAL, this.reconnectAttempt = 0, this.args = e, this.cache = new Me(), this.stepFsm("INITIALIZED");
	}
	getBaseUriParts() {
		if (this.state === r.CONNECTED) return this.args.baseUriPartsList[this.uriIndex];
	}
	disconnect() {
		this.setFsmState(r.DISCONNECTED_FOREVER);
	}
	reconnect() {
		this.state === r.CONNECTED && (this.closeConnection(), this.stepFsm("CONNECTION_CLOSED"));
	}
	setFsmState(e, t, n = 0) {
		switch (Z.info(`New state: ${e}`), this.state = e, this.state) {
			case r.PINGING_SERVER:
				this.schedulePingServer(n);
				break;
			case r.CONNECTED: this.reconnectAttempt = 0, this.clearReconnectDelayTimeout(), this.connectedUriIndex = this.socketUriIndex ?? this.uriIndex, this.uriIndex = this.connectedUriIndex;
		}
		switch (this.args.onConnectionStateChange(e, t), this.state) {
			case r.CONNECTING:
				this.connectToWebSocket();
				break;
			case r.DISCONNECTED_FOREVER: this.closeConnection();
		}
	}
	stepFsm(e, t) {
		if (Z.info(`State: ${this.state}; Event: ${e}`), e === "FATAL_ERROR" && this.state !== r.DISCONNECTED_FOREVER) {
			Z.error(`Client Error: Websocket connection encountered fatal error - ${t}`), this.args.sendClientError("Websocket connection fatal error encountered", t, "Websocket Connection"), this.setFsmState(r.DISCONNECTED_FOREVER, { message: t || "Unknown error" });
			return;
		}
		switch (this.state) {
			case r.INITIAL:
				if (e === "INITIALIZED") {
					this.args.enableBypass ? (this.setFsmState(r.CONNECTING), this.pingServerInBackground()) : this.setFsmState(r.PINGING_SERVER);
					return;
				}
				break;
			case r.CONNECTING:
				if (e === "CONNECTION_SUCCEEDED") {
					this.setFsmState(r.CONNECTED);
					return;
				}
				if (e === "CONNECTION_TIMED_OUT" || e === "CONNECTION_ERROR" || e === "CONNECTION_CLOSED") {
					this.setFsmState(r.PINGING_SERVER, void 0, this.nextReconnectDelayMs());
					return;
				}
				break;
			case r.CONNECTED:
				if (e === "CONNECTION_CLOSED" || e === "CONNECTION_ERROR") {
					this.setFsmState(r.PINGING_SERVER, void 0, this.nextReconnectDelayMs());
					return;
				}
				break;
			case r.PINGING_SERVER:
				if (e === "SERVER_PING_SUCCEEDED") {
					this.setFsmState(r.CONNECTING);
					return;
				}
				break;
			case r.DISCONNECTED_FOREVER:
				Z.warn(`Discarding ${e} while in ${r.DISCONNECTED_FOREVER}`);
				return;
		}
		throw Error(`Unsupported state transition.
State: ${this.state}\nEvent: ${e}`);
	}
	nextReconnectDelayMs() {
		this.reconnectAttempt += 1;
		let e = Math.min(l, 500 * 2 ** (this.reconnectAttempt - 1)), t = this.reconnectAttempt === 1 ? 250 : e / 2;
		return Math.floor(t + Math.random() * (e - t));
	}
	schedulePingServer(e) {
		if (this.clearReconnectDelayTimeout(), e <= 0) {
			this.pingServer();
			return;
		}
		this.reconnectDelayTimeout = globalThis.setTimeout(() => {
			this.reconnectDelayTimeout = void 0, this.state === r.PINGING_SERVER && this.pingServer();
		}, e);
	}
	clearReconnectDelayTimeout() {
		K(this.reconnectDelayTimeout) && (globalThis.clearTimeout(this.reconnectDelayTimeout), this.reconnectDelayTimeout = void 0);
	}
	getBaseUrisToProbe() {
		return this.connectedUriIndex === void 0 ? this.args.baseUriPartsList : [this.args.baseUriPartsList[this.connectedUriIndex]];
	}
	async pingServer() {
		let e = ke(this.getBaseUrisToProbe(), 100, c, this.args.onRetry, this.args.sendClientError, this.args.onHostConfigResp);
		this.pingRequest = e;
		try {
			let t = await e.promise;
			this.uriIndex = this.connectedUriIndex ?? t, this.pingRequest === e && (this.pingRequest = void 0), this.stepFsm("SERVER_PING_SUCCEEDED");
		} catch (e) {
			e instanceof Oe ? Z.info("Ping cancelled") : this.stepFsm("FATAL_ERROR", e instanceof Error ? e.message : String(e));
		} finally {
			this.pingRequest === e && (this.pingRequest = void 0);
		}
	}
	async pingServerInBackground() {
		let e = ke(this.args.baseUriPartsList, 100, c, this.args.onRetry, this.args.sendClientError, this.args.onHostConfigResp);
		this.pingRequest = e;
		try {
			let t = await e.promise;
			this.connectedUriIndex === void 0 && (this.uriIndex = t), Z.info("Background pings completed successfully");
		} catch (e) {
			e instanceof Oe ? Z.info("Background pings cancelled") : this.stepFsm("FATAL_ERROR", e instanceof Error ? e.message : String(e));
		} finally {
			this.pingRequest === e && (this.pingRequest = void 0);
		}
	}
	async getSessionTokens() {
		let e = await this.args.claimHostAuthToken(), t = oe("_streamlit_xsrf");
		this.args.resetHostAuthToken();
		let n = this.args.getLastSessionId();
		return [e ?? t ?? "PLACEHOLDER_AUTH_TOKEN", ...n ? [n] : []];
	}
	async connectToWebSocket() {
		this.socketUriIndex = this.uriIndex;
		let e = Te(this.args.baseUriPartsList[this.socketUriIndex], a);
		if (K(this.websocket)) throw Error("Websocket already exists");
		Z.info("creating WebSocket");
		let t = await this.getSessionTokens();
		this.websocket = new WebSocket(e, ["streamlit", ...t]), this.websocket.binaryType = "arraybuffer", this.setConnectionTimeout(e);
		let n = this.websocket, r = () => n === this.websocket;
		this.websocket.addEventListener("message", (e) => {
			r() && this.handleMessage(e.data).catch((e) => {
				let t = `Failed to process a Websocket message. ${String(e)}`;
				Z.error(t), this.stepFsm("FATAL_ERROR", t);
			});
		}), this.websocket.addEventListener("open", () => {
			r() && (Z.info("WebSocket onopen"), this.stepFsm("CONNECTION_SUCCEEDED"));
		}), this.websocket.addEventListener("close", () => {
			r() && (Z.warn("WebSocket onclose"), this.closeConnection(), this.stepFsm("CONNECTION_CLOSED"));
		}), this.websocket.addEventListener("error", (e) => {
			r() && (Z.error("Client Error: WebSocket onerror"), this.args.sendClientError("Websocket connection onerror triggered", `Error: ${e}`, "Websocket Connection"), this.closeConnection(), this.stepFsm("CONNECTION_ERROR"));
		});
	}
	setConnectionTimeout(e) {
		if (K(this.wsConnectionTimeout)) throw Error("WS timeout is already set");
		let t = this.websocket;
		this.wsConnectionTimeout = globalThis.setTimeout(() => {
			if (t !== this.websocket) return;
			if (q(this.wsConnectionTimeout)) {
				Z.warn("Timeout fired after cancellation");
				return;
			}
			let n = this.websocket;
			if (q(n)) {
				this.closeConnection(), this.stepFsm("FATAL_ERROR", "Null Websocket in setConnectionTimeout");
				return;
			}
			n.readyState === 0 && (Z.info(`Client error: ${e} timed out`), this.args.sendClientError("Websocket connection timed out", `${e} timed out`, "Websocket Connection"), this.closeConnection(), this.stepFsm("CONNECTION_TIMED_OUT"));
		}, u), Z.info(`Set WS timeout ${Number(this.wsConnectionTimeout)}`);
	}
	closeConnection() {
		this.websocket &&= (this.websocket.close(), void 0), K(this.wsConnectionTimeout) && (Z.info(`Clearing WS timeout ${Number(this.wsConnectionTimeout)}`), globalThis.clearTimeout(this.wsConnectionTimeout), this.wsConnectionTimeout = void 0), this.clearReconnectDelayTimeout(), this.pingRequest &&= (this.pingRequest.cancel(), void 0);
	}
	sendMessage(e) {
		if (!this.websocket) return;
		let t = re.create(e), n = re.encode(t).finish(), r = new Uint8Array(n.buffer, n.byteOffset, n.byteLength);
		this.websocket.send(r);
	}
	incrementMessageCacheRunCount(e, t) {
		this.cache.incrementRunCount(e, t);
	}
	getCachedMessageHashes() {
		return this.cache.getCachedMessageHashes();
	}
	async handleMessage(e) {
		let t = this.nextMessageIndex;
		this.nextMessageIndex += 1;
		let n = new Uint8Array(e), r = ie.decode(n);
		this.messageQueue.set(t, await this.cache.processMessagePayload(r, n));
		let i = this.messageQueue.get(this.lastDispatchedMessageIndex + 1);
		for (; i !== void 0;) {
			let e = this.lastDispatchedMessageIndex + 1;
			this.args.onMessage(i), this.messageQueue.delete(e), this.lastDispatchedMessageIndex = e, i = this.messageQueue.get(e + 1);
		}
	}
}, Ne = (0, n.getLogger)("ConnectionManager"), Pe = class {
	constructor(e) {
		this.connectionState = r.INITIAL, this.setConnectionState = (e, t) => {
			this.connectionState !== e && (this.connectionState === r.CONNECTED && e !== r.CONNECTED && this.clearHeartbeatAckTimeout(), this.connectionState = e, this.props.connectionStateChanged(e)), t && this.props.onConnectionError(t);
		}, this.showRetryError = (e, t, n) => {
			e >= 6 && this.props.onConnectionError(t);
		}, this.props = e, this.connect();
	}
	isConnected() {
		return this.connectionState === r.CONNECTED;
	}
	getBaseUriParts() {
		if (this.websocketConnection instanceof Q) return this.websocketConnection.getBaseUriParts();
	}
	sendMessage(e) {
		this.websocketConnection instanceof Q && this.isConnected() ? this.websocketConnection.sendMessage(e) : Ne.error(`Cannot send message when server is disconnected: ${e.type ?? "unknown"}`);
	}
	incrementMessageCacheRunCount(e, t) {
		this.websocketConnection instanceof Q && this.websocketConnection.incrementMessageCacheRunCount(e, t);
	}
	getCachedMessageHashes() {
		return this.websocketConnection instanceof Q ? this.websocketConnection?.getCachedMessageHashes() ?? [] : [];
	}
	checkStaticConnection() {
		return new URLSearchParams(document.location.search).get("staticAppId");
	}
	async connect() {
		let e = this.checkStaticConnection();
		if (e) ye(e, this.setConnectionState, this.props.onMessage, this.props.onConnectionError, this.props.endpoints), this.websocketConnection = null;
		else try {
			this.websocketConnection = await this.connectToRunningServer();
		} catch (e) {
			let t = e instanceof Error ? e : /* @__PURE__ */ Error(`${e}`);
			Ne.error(`Client Error: Websocket connection - ${t.message}`), this.props.sendClientError("Failed to establish websocket connection", t.message, "Connection Manager"), this.setConnectionState(r.DISCONNECTED_FOREVER, { message: t.message });
		}
	}
	disconnect() {
		this.clearHeartbeatAckTimeout(), this.websocketConnection?.disconnect();
	}
	onHeartbeatSent(e) {
		this.clearHeartbeatAckTimeout(), e && (this.heartbeatAckTimeoutId = setTimeout(() => {
			Ne.warn("Heartbeat ack not received within timeout, connection may be unhealthy"), this.heartbeatAckTimeoutId = void 0, this.isConnected() && this.reconnect();
		}, e));
	}
	reconnect() {
		this.clearHeartbeatAckTimeout(), this.websocketConnection?.reconnect();
	}
	onHeartbeatAckReceived() {
		this.clearHeartbeatAckTimeout();
	}
	clearHeartbeatAckTimeout() {
		this.heartbeatAckTimeoutId !== void 0 && (clearTimeout(this.heartbeatAckTimeoutId), this.heartbeatAckTimeoutId = void 0);
	}
	connectToRunningServer() {
		let e = we(), t = Se();
		return new Q({
			getLastSessionId: this.props.getLastSessionId,
			endpoints: this.props.endpoints,
			baseUriPartsList: e,
			onMessage: this.props.onMessage,
			onConnectionStateChange: this.setConnectionState,
			onRetry: this.showRetryError,
			claimHostAuthToken: this.props.claimHostAuthToken,
			resetHostAuthToken: this.props.resetHostAuthToken,
			sendClientError: this.props.sendClientError,
			onHostConfigResp: this.props.onHostConfigResp,
			enableBypass: t
		});
	}
}, $ = (0, n.getLogger)("DefaultStreamlitEndpoints"), Fe = "/media", Ie = "/app/static/", Le = "/_stcore/upload_file", Re = "/component", ze = "/_stcore/bidi-components", Be = class {
	constructor(e) {
		this.getServerUri = e.getServerUri, this.csrfEnabled = e.csrfEnabled, this.sendClientError = e.sendClientError, this.staticConfigUrl = null;
	}
	setStaticConfigUrl(e) {
		this.staticConfigUrl = e;
	}
	sendClientErrorToHost(e, t, n, r, i) {
		this.sendClientError(e, t, n, r, i);
	}
	async checkSourceUrlResponse(e, t, n) {
		let r = n ? `${t} ${n}` : t;
		try {
			let i = await fetch(e);
			i.ok || ($.error(`Client Error: ${r} source error - ${i.status}`), this.sendClientErrorToHost(t, i.status, i.statusText, e, n));
		} catch (i) {
			let a = i instanceof Error ? i.message : "Unknown Error";
			$.error(`Client Error: ${r} fetch error - ${a}`), this.sendClientErrorToHost(t, "Error fetching source", a, e, n);
		}
	}
	buildComponentURL(e, t) {
		return J(this.requireServerUri(), `${Re}/${e}/${t}`);
	}
	buildBidiComponentURL(e, t) {
		return J(this.requireServerUri(), `${ze}/${e}/${t}`);
	}
	setFileUploadClientConfig({ prefix: e, headers: t }) {
		this.fileUploadClientConfig = {
			prefix: e,
			headers: t
		};
	}
	buildStaticUrl(e) {
		let t = new URLSearchParams(document.location.search).get("staticAppId");
		return `${this.staticConfigUrl}/${t}${e}`;
	}
	buildMediaURL(e) {
		return this.staticConfigUrl && (e.startsWith(Fe) || e.startsWith(Ie)) ? this.buildStaticUrl(e) : e.startsWith(Fe) || e.startsWith(Ie) ? J(this.requireServerUri(), e) : e;
	}
	buildDownloadUrl(e) {
		if (!e.startsWith(Fe)) return e;
		let t = G.DOWNLOAD_ASSETS_BASE_URL;
		return J(t ? Ce(t) : this.requireServerUri(), e);
	}
	buildFileUploadURL(e) {
		return this.fileUploadClientConfig ? pe(this.fileUploadClientConfig.prefix, e) : e.startsWith(Le) ? J(this.requireServerUri(), e) : e;
	}
	buildAppPageURL(e, t) {
		let n = t.urlPathname, r = t.isDefault ? "" : n;
		if (typeof e == "string" && e.length > 0) return `${e}/${r}`;
		let { port: i, protocol: a } = window.location, { pathname: o, hostname: s } = this.requireServerUri();
		return `${a}//${s}${i ? `:${i}` : ""}${o === "/" ? "/" : `${o}/`}${r}`;
	}
	async uploadFileUploaderFile(e, t, n, r, i) {
		let a = new FormData(), { name: o, webkitRelativePath: s } = t, c = s || o;
		a.append(o, t, c);
		let l = this.getAdditionalHeaders(), u = this.buildFileUploadURL(e);
		try {
			await this.csrfRequest(u, {
				signal: i,
				method: "PUT",
				data: a,
				responseType: "text",
				headers: l,
				onUploadProgress: r
			});
		} catch (e) {
			$.error(`Client Error: File uploader error on file upload - ${e}`);
			let t = e instanceof Error ? e.message : "Unknown Error";
			throw this.sendClientErrorToHost("File Uploader", "Error uploading file", t, u), e;
		}
	}
	getAdditionalHeaders() {
		let e = {};
		return this.fileUploadClientConfig && (e = {
			...e,
			...this.fileUploadClientConfig.headers
		}), e;
	}
	async deleteFileAtURL(e, t) {
		let n = this.getAdditionalHeaders(), r = this.buildFileUploadURL(e);
		try {
			await this.csrfRequest(r, {
				method: "DELETE",
				data: { sessionId: t },
				headers: n
			});
		} catch (e) {
			$.error(`Client Error: File uploader error on file delete - ${e}`);
			let t = e instanceof Error ? e.message : "Unknown Error";
			throw this.sendClientErrorToHost("File Uploader", "Error deleting file", t, r), e;
		}
	}
	requireServerUri() {
		let e = this.getServerUri();
		if (K(e)) return this.cachedServerUri = e, e;
		let t = this.cachedServerUri;
		if (K(t)) return t;
		throw Error("not connected to a server!");
	}
	async csrfRequest(e, t) {
		if (t.url = e, this.csrfEnabled) {
			let e = oe("_streamlit_xsrf");
			K(e) && (t.headers = {
				"X-Xsrftoken": e,
				...t.headers
			}, t.withCredentials = !0);
		}
		let { default: n } = await import("./axios-L2MRYZE0.js");
		return n.request(t);
	}
};
//#endregion
//#region src/testUtils.ts
function Ve(e = {}) {
	return {
		setStaticConfigUrl: vi.fn(),
		sendClientErrorToHost: vi.fn(),
		checkSourceUrlResponse: vi.fn(),
		buildComponentURL: vi.fn(),
		buildBidiComponentURL: vi.fn(),
		buildMediaURL: vi.fn(),
		buildDownloadUrl: vi.fn(),
		buildFileUploadURL: vi.fn(),
		buildAppPageURL: vi.fn().mockImplementation((e, t, n) => `http://mock/app/page/${t.pageName}.${n}`),
		uploadFileUploaderFile: vi.fn().mockRejectedValue(/* @__PURE__ */ Error("unimplemented mock endpoint")),
		deleteFileAtURL: vi.fn().mockRejectedValue(/* @__PURE__ */ Error("unimplemented mock endpoint")),
		...e
	};
}
//#endregion
export { Pe as ConnectionManager, r as ConnectionState, Be as DefaultStreamlitEndpoints, f as IS_DEV_ENV, Se as isHostConfigBypassEnabled, Ve as mockEndpoints, Ce as parseUriIntoBaseParts };
